(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("wix", [], factory);
	else if(typeof exports === 'object')
		exports["wix"] = factory();
	else
		root["wix"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 433);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _RMI = new WeakMap();
var _contextId = new WeakMap();
var _compId = new WeakMap();
var _controllerId = new WeakMap();
var _role = new WeakMap();
var _wixSelector = new WeakMap();
var _emitter = new WeakMap();
var _type = new WeakMap();
var _styleInstance = new WeakMap();
var _compNickname = new WeakMap();

exports._RMI = _RMI;
exports._contextId = _contextId;
exports._compId = _compId;
exports._controllerId = _controllerId;
exports._role = _role;
exports._wixSelector = _wixSelector;
exports._emitter = _emitter;
exports._type = _type;
exports._styleInstance = _styleInstance;
exports._compNickname = _compNickname;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isValueInRange = exports.validateArrayContainsItemsWithIds = exports.validateByType = exports.validateValueFromEnum = exports.validateArrayContainsItem = exports.validateMaximum = exports.validateMinimum = exports.validateRange = exports.validate = exports.TYPES = undefined;

var _compSchemas = __webpack_require__(232);

var _compSchemas2 = _interopRequireDefault(_compSchemas);

var _errors = __webpack_require__(12);

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

var _forEach = __webpack_require__(46);

var _forEach2 = _interopRequireDefault(_forEach);

var _pickBy = __webpack_require__(194);

var _pickBy2 = _interopRequireDefault(_pickBy);

var _has = __webpack_require__(85);

var _has2 = _interopRequireDefault(_has);

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _includes = __webpack_require__(53);

var _includes2 = _interopRequireDefault(_includes);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _isString = __webpack_require__(36);

var _isString2 = _interopRequireDefault(_isString);

var _isNaN = __webpack_require__(413);

var _isNaN2 = _interopRequireDefault(_isNaN);

var _isNumber = __webpack_require__(122);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _isBoolean = __webpack_require__(410);

var _isBoolean2 = _interopRequireDefault(_isBoolean);

var _isDate = __webpack_require__(411);

var _isDate2 = _interopRequireDefault(_isDate);

var _isFunction = __webpack_require__(29);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isArray = __webpack_require__(6);

var _isArray2 = _interopRequireDefault(_isArray);

var _isObject = __webpack_require__(14);

var _isObject2 = _interopRequireDefault(_isObject);

var _isInteger = __webpack_require__(412);

var _isInteger2 = _interopRequireDefault(_isInteger);

var _findIndex = __webpack_require__(84);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _countBy = __webpack_require__(403);

var _countBy2 = _interopRequireDefault(_countBy);

var _regexValidations = __webpack_require__(136);

var _regexValidations2 = _interopRequireDefault(_regexValidations);

var _urlUtils = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TYPES = {
    NUMBER: 'number',
    STRING: 'string',
    BOOLEAN: 'boolean',
    DATE: 'date',
    FUNCTION: 'function',
    ARRAY: 'array',
    OBJECT: 'object',
    URL: 'url',
    INTEGER: 'integer',
    UUID: 'uuid'
};

function validateArrayContainsItemsWithIds(items) {
    var res = true;

    if (!(0, _isArray2.default)(items)) {
        return false;
    }

    var idCounts = (0, _countBy2.default)(items, '_id');

    (0, _forEach2.default)(items, function (item) {
        if (!item._id) {
            _reporter2.default.reportSdkError(_errors.generateError.error_mandatory_id());
            res = false;
        }

        if (idCounts[item._id] !== 1) {
            _reporter2.default.reportSdkWarning(_errors.generateError.warning_duplicate_item({ functionName: 'data', _id: item._id }));
        }
    });

    return res;
}

function validateArrayContainsItem(functionName, propertyName, item, arr) {
    var index = (0, _findIndex2.default)(arr, item);
    if (index > -1) {
        return true;
    }
    _reporter2.default.reportSdkError(_errors.generateError.error_item_not_found({
        functionName: functionName,
        propertyName: propertyName,
        wrongValue: item[propertyName]
    }));
    return false;
}

function reportHttpUrls(value, propertyName, functionName) {
    var isHttpSiteReg = /(http):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
    if (isHttpSiteReg.test(value)) {
        _reporter2.default.reportSdkWarning(_errors.generateError.warning_http_format({
            propertyName: propertyName,
            functionName: functionName
        }));
    }
}

function validateByType(value, expectedType) {
    switch (expectedType) {
        case TYPES.NUMBER:
            return (0, _isNumber2.default)(value) && !(0, _isNaN2.default)(value);
        case TYPES.STRING:
            return (0, _isString2.default)(value);
        case TYPES.BOOLEAN:
            return (0, _isBoolean2.default)(value);
        case TYPES.DATE:
            return (0, _isDate2.default)(value) && !(0, _isNaN2.default)(value.getTime());
        case TYPES.FUNCTION:
            return (0, _isFunction2.default)(value);
        case TYPES.ARRAY:
            return (0, _isArray2.default)(value);
        case TYPES.OBJECT:
            return (0, _isObject2.default)(value) && !(0, _isArray2.default)(value) && !(0, _isFunction2.default)(value);
        case TYPES.URL:
            return (0, _urlUtils.isExternalUrl)(value);
        case TYPES.INTEGER:
            return (0, _isInteger2.default)(value);
        case TYPES.UUID:
            return _regexValidations2.default.validateUUIDFormat(value);
        default:
            return true;
    }
}

function validateMandatoryFieldsAndReportIfNeeded(compType, functionName, dataToValidate, itemIndex) {
    var validationRes = { isValid: true };
    var expectedSchema = (0, _compSchemas2.default)(compType);
    if (!expectedSchema) {
        return validationRes;
    }
    var mandatoryFields = (0, _pickBy2.default)(expectedSchema, { mandatory: true });
    (0, _forEach2.default)(mandatoryFields, function (v, k) {
        if (!(0, _has2.default)(dataToValidate, k)) {
            validationRes = { isValid: false, prop: k };
            return;
        }
    });

    if (!validationRes.isValid) {
        var error = !(0, _isNil2.default)(itemIndex) ? _errors.generateError.error_mandatory_val_with_index : _errors.generateError.error_mandatory_val;
        _reporter2.default.reportSdkError(error({
            propertyName: validationRes.prop,
            functionName: functionName,
            index: itemIndex
        }));
    }

    return validationRes.isValid;
}

function validateLength(functionName, propertyName, value, minLen, maxLen, itemIndex, acceptNil) {
    var valid = isValueInRange((0, _get2.default)(value, 'length'), minLen, maxLen, acceptNil);
    if (!valid) {
        _reporter2.default.reportSdkError(getLengthError(minLen, maxLen, itemIndex)({
            functionName: functionName,
            propertyName: propertyName,
            wrongValue: value,
            minLength: minLen,
            maxLength: maxLen,
            acceptedLength: maxLen,
            index: itemIndex
        }));
    }
    return valid;
}

function getLengthError(minLength, maxLength, itemIndex) {
    var error = isActualNumber(itemIndex) ? _errors.generateError.error_length_in_range_with_index : _errors.generateError.error_length_in_range;
    if (!isActualNumber(minLength) || !isActualNumber(maxLength)) {
        return error;
    }

    if (minLength === maxLength) {
        error = isActualNumber(itemIndex) ? _errors.generateError.error_length_accept_single_value_with_index : _errors.generateError.error_length_accept_single_value;
    } else if (minLength === 0 && maxLength > 0) {
        error = isActualNumber(itemIndex) ? _errors.generateError.error_length_exceeds_with_index : _errors.generateError.error_length_exceeds;
    }
    return error;
}

function validateMinimum(functionName, propertyName, value, minVal, acceptNil) {
    if (acceptNil && (0, _isNil2.default)(value)) {
        return true;
    }
    if (!isActualNumber(value) || !isActualNumber(minVal) || value < minVal) {
        _reporter2.default.reportSdkError(_errors.generateError.error_larger_than({
            functionName: functionName,
            propertyName: propertyName,
            wrongValue: value,
            minValue: minVal
        }));
        return false;
    }
    return true;
}

function validateMaximum(functionName, propertyName, value, maxValue, acceptNil) {
    if (acceptNil && (0, _isNil2.default)(value)) {
        return true;
    }
    if (!isActualNumber(value) || !isActualNumber(maxValue) || maxValue < value) {
        _reporter2.default.reportSdkError(_errors.generateError.error_less_than({
            functionName: functionName,
            propertyName: propertyName,
            wrongValue: value,
            maxValue: maxValue
        }));
        return false;
    }
    return true;
}

function validateRange(functionName, propertyName, value, minValue, maxValue, itemIndex, acceptNil) {
    var valid = isValueInRange(value, minValue, maxValue, acceptNil);
    if (!valid) {
        _reporter2.default.reportSdkError(getRangeError(minValue, maxValue, itemIndex)({
            functionName: functionName,
            propertyName: propertyName,
            wrongValue: value,
            minValue: minValue,
            maxValue: maxValue,
            acceptedValue: minValue,
            index: itemIndex
        }));
    }
    return valid;
}

function isValueInRange(value, minValue, maxValue, acceptNil) {
    if (acceptNil && (0, _isNil2.default)(value)) {
        return true;
    }
    if (!isActualNumber(maxValue) || !isActualNumber(value) || !isActualNumber(minValue) || maxValue < value || value < minValue) {
        return false;
    }
    return true;
}

function isActualNumber(value) {
    return (0, _isNumber2.default)(value) && !(0, _isNaN2.default)(value);
}

function getRangeError(minValue, maxValue, itemIndex) {
    var error = isActualNumber(itemIndex) ? _errors.generateError.error_range_with_index : _errors.generateError.error_range;
    if (!isActualNumber(minValue) || !isActualNumber(maxValue) || minValue < maxValue) {
        return error;
    } else if (minValue === maxValue) {
        error = isActualNumber(itemIndex) ? _errors.generateError.error_accept_single_value_with_index : _errors.generateError.error_accept_single_value;
    } else if (minValue > maxValue) {
        error = isActualNumber(itemIndex) ? _errors.generateError.error_empty_component_with_index : _errors.generateError.error_empty_component;
    }
    return error;
}

function validateType(compType, functionName, propertyName, value, expectedType, warnIfNil, acceptNil, shouldCheckMandatoryFields, itemIndex) {
    if ((0, _isNil2.default)(value)) {
        if (warnIfNil) {
            var error = !(0, _isNil2.default)(itemIndex) ? _errors.generateError.warning_not_null_with_index : _errors.generateError.warning_not_null;
            _reporter2.default.reportSdkWarning(error({
                propertyName: propertyName,
                functionName: functionName,
                index: itemIndex
            }));
        }
        if (acceptNil) {
            return true;
        }
    }

    var isValidByType = false;
    var actualType = void 0;
    expectedType.forEach(function (type) {
        if (validateByType(value, type)) {
            isValidByType = true;
            actualType = type;
        }
    });
    if (!isValidByType) {
        var _error = !(0, _isNil2.default)(itemIndex) ? _errors.generateError.error_type_with_index : _errors.generateError.error_type;
        _reporter2.default.reportSdkError(_error({
            functionName: functionName,
            propertyName: propertyName,
            wrongValue: value,
            expectedType: expectedType.join(','),
            index: itemIndex
        }));
        return false;
    }

    if (actualType === 'url' && (0, _includes2.default)(expectedType, 'url')) {
        reportHttpUrls(value, propertyName, functionName);
    }

    if (actualType === 'object' && (0, _includes2.default)(expectedType, 'object')) {
        var newObjType = (0, _isArray2.default)(compType) ? compType.concat([propertyName]) : [compType, propertyName];
        return validate(newObjType, functionName, value, shouldCheckMandatoryFields, itemIndex);
    }

    return true;
}

function validateValueFromEnum(functionName, propertyName, value, enumValues, itemIndex, acceptNil) {
    if ((0, _isNil2.default)(value) && acceptNil) {
        return true;
    }
    if (!(0, _includes2.default)(enumValues, value)) {
        var error = !(0, _isNil2.default)(itemIndex) ? _errors.generateError.error_type_with_index : _errors.generateError.error_type;
        _reporter2.default.reportSdkError(error({
            functionName: functionName,
            propertyName: propertyName,
            wrongValue: value,
            expectedType: 'from (' + enumValues.join(',') + ')',
            index: itemIndex
        }));
        return false;
    }
    return true;
}

function validateRegexForValue(functionName, propertyName, value, validationExpressions) {
    if (!_regexValidations2.default[validationExpressions](value)) {
        _reporter2.default.reportSdkError(_errors.generateError.error_bad_format({
            functionName: functionName,
            propertyName: propertyName,
            wrongValue: value
        }));
        return false;
    }
    return true;
}

function validateRegex(functionName, propertyName, value, validationExpressions) {
    if (_regexValidations2.default[validationExpressions]) {
        if ((0, _isArray2.default)(value)) {
            return (0, _forEach2.default)(value, function (val) {
                return validateRegexForValue(functionName, propertyName, val, validationExpressions);
            });
        }
        return validateRegexForValue(functionName, propertyName, value, validationExpressions);
    }
    return true;
}

function validate(compType, functionName, dataToValidate, shouldCheckMandatoryFields, itemIndex) {
    var res = true;
    var expectedSchema = (0, _compSchemas2.default)(compType);
    if (!expectedSchema) {
        return true;
    }
    if (shouldCheckMandatoryFields) {
        if (!validateMandatoryFieldsAndReportIfNeeded(compType, functionName, dataToValidate, itemIndex)) {
            return false;
        }
    }
    (0, _forEach2.default)(dataToValidate, function (v, k) {
        if (!res) {
            return;
        }
        var expectedSchema = (0, _compSchemas2.default)(compType)[k];
        if (!expectedSchema) {
            res = true;
            return;
        }
        var validations = expectedSchema.validations || {};

        if (validations.type) {
            if (!validateType(compType, functionName, k, v, expectedSchema.schemaType, expectedSchema.warnIfNil, expectedSchema.acceptNil, shouldCheckMandatoryFields, itemIndex)) {
                res = false;
                return;
            }
            if (expectedSchema.enum && !validateValueFromEnum(functionName, k, v, expectedSchema.enum, itemIndex, expectedSchema.acceptNil)) {
                res = false;
                return;
            }
        }
        if (validations.range) {
            if (!validateRange(functionName, k, v, expectedSchema.minVal, expectedSchema.maxVal, itemIndex, expectedSchema.acceptNil)) {
                res = false;
                return;
            }
        }
        if (validations.length) {
            if (!validateLength(functionName, k, v, expectedSchema.minLength, expectedSchema.maxLength, itemIndex, expectedSchema.acceptNil)) {
                res = false;
                return;
            }
        }
        if (validations.regex) {
            if (!validateRegex(functionName, k, v, expectedSchema.validationExpressions)) {
                res = false;
                return;
            }
        }

        if (validations.minimum) {
            if (!validateMinimum(functionName, k, v, expectedSchema.minVal, expectedSchema.acceptNil)) {
                res = false;
                return;
            }
        }

        if (validations.maximum) {
            if (!validateMaximum(functionName, k, v, expectedSchema.maxVal, expectedSchema.acceptNil)) {
                res = false;
                return;
            }
        }
    });
    return res;
}

exports.TYPES = TYPES;
exports.validate = validate;
exports.validateRange = validateRange;
exports.validateMinimum = validateMinimum;
exports.validateMaximum = validateMaximum;
exports.validateArrayContainsItem = validateArrayContainsItem;
exports.validateValueFromEnum = validateValueFromEnum;
exports.validateByType = validateByType;
exports.validateArrayContainsItemsWithIds = validateArrayContainsItemsWithIds;
exports.isValueInRange = isValueInRange;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (receiver, supplier) {

    var propsNames = Object.getOwnPropertyNames(supplier);
    propsNames.forEach(function (property) {
        if (supplier.hasOwnProperty(property) && property !== 'constructor') {
            Object.defineProperty(receiver, property, Object.getOwnPropertyDescriptor(supplier, property));
        }
    });

    return receiver;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(74);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HiddenMixin = __webpack_require__(281);

var _HiddenMixin2 = _interopRequireDefault(_HiddenMixin);

var _CollapsedMixin = __webpack_require__(280);

var _CollapsedMixin2 = _interopRequireDefault(_CollapsedMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin HiddenCollapsedMixin
 * @summary Provides functionality for all elements that can be hidden or collapsed.
 * @mixes $w.HiddenMixin
 * @mixes $w.CollapsedMixin
 * @memberof $w
 */
var HiddenCollapsedMixin = function HiddenCollapsedMixin() {
  _classCallCheck(this, HiddenCollapsedMixin);
};

(0, _mixin2.default)(HiddenCollapsedMixin.prototype, _HiddenMixin2.default.prototype);
(0, _mixin2.default)(HiddenCollapsedMixin.prototype, _CollapsedMixin2.default.prototype);
exports.default = HiddenCollapsedMixin;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Node2 = __webpack_require__(66);

var _Node3 = _interopRequireDefault(_Node2);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _ViewportMixin = __webpack_require__(144);

var _ViewportMixin2 = _interopRequireDefault(_ViewportMixin);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @mixin Element
 * @summary Provides basic functionality for elements.
 * @mixes $w.Node
 * @mixes $w.ViewportMixin
 * @memberof $w
 */
var Element = function (_Node) {
    _inherits(Element, _Node);

    function Element() {
        _classCallCheck(this, Element);

        return _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).apply(this, arguments));
    }

    _createClass(Element, [{
        key: 'onMouseIn',


        // METHODS:

        /**
         * @function onMouseIn
         * @syntax
         * function onMouseIn(handler: MouseEventHandler): Element
         * callback MouseEventHandler(event: MouseEvent, $w: Function): void
         * @summary Adds an event handler that runs when the mouse pointer is moved
         *  onto the element.
         * @param {$w.MouseEventHandler} handler The name of the function or
         *  the function expression to run when the mouse pointer is moved onto the
         *  element.
         * @returns {$w.Element} The element to which the event handler was added.
         * @snippet [Element-onMouseIn.es6=Get the mouse event info when the mouse enters an element]
         * @eventtype mouseenter
         * @memberof $w.Element
         * @eventhandler
         */
        value: function onMouseIn(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'onMouseIn', { onMouseIn: cb })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().MOUSE_IN, controllerId, cb);
            return this;
        }

        /**
         * @function onMouseOut
         * @syntax
         * function onMouseOut(handler: MouseEventHandler): Element
         * callback MouseEventHandler(event: MouseEvent, $w: Function): void
         * @summary Adds an event handler that runs when the mouse pointer is moved
         *  off of the element.
         * @param {$w.MouseEventHandler} handler The name of the function or
         *  the function expression to run when the mouse pointer is moved off of
         *  the element.
         * @returns {$w.Element} The element to which the event handler was added.
         * @snippet [Element-onMouseOut.es6=Get the mouse event info when the mouse exits an element]
         * @eventtype mouseleave
         * @memberof $w.Element
         * @eventhandler
         */

    }, {
        key: 'onMouseOut',
        value: function onMouseOut(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'onMouseOut', { onMouseOut: cb })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().MOUSE_OUT, controllerId, cb);
            return this;
        }
    }, {
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered;

            return { id: id, type: type, global: global, rendered: rendered };
        }
    }, {
        key: 'rendered',


        // PROPERTIES:

        /**
         * @member rendered
         * @label property
         * @syntax
         * get rendered(): boolean
         * @summary Indicates if an element is currently displayed.
         * @description
         *  If `rendered` is `true`, the element is in the current DOM structure and
         *  can be used.
         *
         *  If `rendered` is `false` the element is not in the current DOM structure.
         *
         *  Some reasons the element might not be in the DOM inclue:
         *    + It is in a [slide]($w.Slide.html) which is not currently showing.
         *    + It is in a mode which is not currently active. For example, it is in
         *      the hover mode of a [hover box]($w.HoverBox.html).
         * @type {external:Boolean}
         * @default `false`
         * @memberof $w.Element
         * @see [collapsed]($w.HiddenMixin.html#collapsed)
         * @see [hidden]($w.HiddenMixin.html#hidden)
         * @see [isVisible]($w.HiddenMixin.html#isVisible)
         * @readonly
         */
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getComp(compId).isDisplayed;
        }
    }]);

    return Element;
}(_Node3.default);

(0, _mixin2.default)(Element.prototype, _ViewportMixin2.default.prototype);

exports.default = Element;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin ClickableMixin
 * @description Provides functionality for elements that can be be clicked.
 * @memberof $w
 */
var ClickableMixin = function () {
    function ClickableMixin() {
        _classCallCheck(this, ClickableMixin);
    }

    _createClass(ClickableMixin, [{
        key: 'onClick',


        /**
         * @function onClick
         * @syntax
         * function onClick(handler: MouseEventHandler): Element
         * callback MouseEventHandler(event: MouseEvent, $w: Function): void
         * @summary Adds an event handler that runs when the element is clicked.
         * @description
         *  An element receives a `click` event when a user clicks on the element
         *  and releases.
         *
         *  When a user double-clicks an element, two `click` events are fired
         *  before a `doubleClick` event is also fired.
         * @param {$w.MouseEventHandler} handler The name of the function or
         *  the function expression to run when the element is clicked.
         * @returns {$w.Element} The element to which the event handler was added.
         * @snippet [ClickableMixin-onClick.es6=Get the ID of the element that was clicked]
         * @snippet [onClick-get_coordinates.es6=Get a mouse click's coordinates]
         * @eventtype click
         * @see [onDblClick( )](#onDblClick)
         * @memberof $w.ClickableMixin
         * @eventhandler
         */
        value: function onClick(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'onClick', { onClick: cb })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().CLICK, controllerId, cb);
            return this;
        }

        /**
         * @function onDblClick
         * @syntax
         * function onDblClick(handler: MouseEventHandler): Element
         * callback MouseEventHandler(event: MouseEvent, $w: Function): void
         * @summary Adds an event handler that runs when the element is double-clicked.
         * @description
         *  An element receives a `dblClick` event when a user double-clicks on the element
         *  and releases.
         *
         *  When a user double-clicks an element, two `click` events are fired
         *  before a `doubleClick` event is also fired.
         * @param {$w.MouseEventHandler} handler The name of the function or
         *  the function expression to run when the element is clicked.
         * @returns {$w.Element} The element to which the event handler was added.
         * @snippet [ClickableMixin-onClick.es6=Get the ID of the element that was double-clicked]
         * @see [onClick( )](#onClick)
         * @memberof $w.ClickableMixin
         * @eventtype dblClick
         * @eventhandler
         */

    }, {
        key: 'onDblClick',
        value: function onDblClick(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'onDblClick', { onDblClick: cb })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().DBL_CLICK, controllerId, cb);
            return this;
        }
    }]);

    return ClickableMixin;
}();

exports.default = ClickableMixin;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.types = exports.capitalize = exports.isNilOrEmptyString = exports.isWorker = exports.getIndexOrUndefined = exports.nullIfNil = exports.emptyStringIfNil = exports.allPropertiesFor = exports.shallowCloneObject = exports.getInstanceValue = undefined;

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _isString = __webpack_require__(36);

var _isString2 = _interopRequireDefault(_isString);

var _urlUtils = __webpack_require__(24);

var urlUtils = _interopRequireWildcard(_urlUtils);

var _findIndex2 = __webpack_require__(84);

var _findIndex3 = _interopRequireDefault(_findIndex2);

var _types = __webpack_require__(226);

var _types2 = _interopRequireDefault(_types);

var _typesData = __webpack_require__(227);

var _typesData2 = _interopRequireDefault(_typesData);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getDecodedInstance(queryParameters) {
    var instanceStr = urlUtils.getQueryParameter("instance", queryParameters);
    var encodedInstance = instanceStr.substring(instanceStr.indexOf(".") + 1);
    return JSON.parse(atob(encodedInstance));
}

function getInstanceValue(key, queryParameters) {
    var decodedInstance = getDecodedInstance(queryParameters);
    if (decodedInstance) {
        return decodedInstance[key] || null;
    }
    return null;
}

function shallowCloneObject(obj, ignoreKeys) {
    var newObj = {};
    for (var p in obj) {
        if (obj.hasOwnProperty(p) && ignoreKeys.indexOf(p) === -1) {
            newObj[p] = obj[p];
        }
    }
    return newObj;
}

function allPropertiesFor(obj) {
    var propNames = {};
    var objProto = Object.getPrototypeOf(obj);
    while (objProto !== Object.prototype) {
        Object.getOwnPropertyNames(objProto).forEach(function (prop) {
            propNames[prop] = true;
        });
        objProto = Object.getPrototypeOf(objProto);
    }
    delete propNames.constructor;
    return Object.keys(propNames);
}

function emptyStringIfNil(value) {
    if (typeof value === 'undefined' || value === null) {
        return '';
    }
    return value;
}

function nullIfNil(value) {
    if (typeof value === 'undefined' || value === null) {
        return null;
    }
    return value;
}

function getIndexOrUndefined(collection, key, value) {
    var index = (0, _findIndex3.default)(collection, _defineProperty({}, key, value));
    return index !== -1 ? index : undefined;
}

function isWorker() {
    return typeof Window === 'undefined';
}

function isNilOrEmptyString(value) {
    return (0, _isNil2.default)(value) || value === '';
}

function capitalize(str) {
    if (!(0, _isString2.default)(str)) {
        return '';
    }
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

var types = new _types2.default(_typesData2.default);

exports.getInstanceValue = getInstanceValue;
exports.shallowCloneObject = shallowCloneObject;
exports.allPropertiesFor = allPropertiesFor;
exports.emptyStringIfNil = emptyStringIfNil;
exports.nullIfNil = nullIfNil;
exports.getIndexOrUndefined = getIndexOrUndefined;
exports.isWorker = isWorker;
exports.isNilOrEmptyString = isNilOrEmptyString;
exports.capitalize = capitalize;
exports.types = types;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reportSdkError(errorMessage) {
    if ((0, _get2.default)(self, 'console.error')) {
        self.console.error('Wix code SDK error: ' + errorMessage);
    }
}

function reportSdkMsg(message) {
    if ((0, _get2.default)(self, 'console.error')) {
        self.console.log('Wix code SDK message: ' + message);
    }
}

function reportSdkWarning(message) {
    if ((0, _get2.default)(self, 'console.warn')) {
        self.console.warn('Wix code SDK Warning: ' + message);
    }
}

exports.default = {
    reportSdkError: reportSdkError,
    reportSdkMsg: reportSdkMsg,
    reportSdkWarning: reportSdkWarning
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(70),
    copyObject = __webpack_require__(44),
    createAssigner = __webpack_require__(166),
    isArrayLike = __webpack_require__(22),
    isPrototype = __webpack_require__(59),
    keys = __webpack_require__(31);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.userErrors = exports.generateError = exports.errors = undefined;

var _template = __webpack_require__(196);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generateError = {
    warning_not_null: (0, _template2.default)('The <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to null or undefined.'),
    warning_not_null_with_index: (0, _template2.default)('The <%=propertyName%> parameter of item at index <%=index%> that is passed to the <%=functionName%> method cannot be set to null or undefined.'),
    warning_invalid_option: (0, _template2.default)('The <%=propertyName%> parameter at index <%=index%> that is passed to the options function cannot be set to <%=wrongValue=>. Options must contain at least a non-null value or non-null label.'),
    warning_http_format: (0, _template2.default)('The <%=propertyName%> that  passed to the <%=functionName%> recommended format should be HTTPS and not HTTP'),
    warning_value_changed: (0, _template2.default)('The <%=propertyName%> of <%=compNickname%> was set to <%=newValue%>, which is less than <%=compNickname%>\'s <%=changedProperty%> value. <%=compNickname%> cannot have a <%=changedProperty%> value which is greater than its <%=propertyName%> value. The value of <%=changedProperty%> has therefore been set to <%=newValue%>.'),
    warning_duplicate_item: (0, _template2.default)('The data that was passed to <%=functionName%> contained at least two items with the same ID: <%=_id%>. Only the first item was accepted.'),
    warning_non_existing_item: (0, _template2.default)('The data that was passed to <%=functionName%> contained non existing item with the ID: <%=_id%> .'),
    warning_deprecated_effect_name: (0, _template2.default)('The "<%=functionName%>" function  called on "<%=compNickname%>" was called with the following deprecated effect: "<%=effectName%>". Read more about effects: http://'),
    warning_deprecated_effect_with_options: (0, _template2.default)('The "<%=functionName%>" function  called on "<%=compNickname%>" was executed without the specified effect options because it was called with the following deprecated effect: "<%=effectName%>". Read more about effects: http://'),
    warning_invalid_effect_name: (0, _template2.default)('The "<%=functionName%>" function called on "<%=compNickname%>" was executed without the "<%=effectName%>" effect because it is an invalid effectName value. Read more about effects: http://'),
    warning_effect_options_not_set: (0, _template2.default)('The "<%=functionName%>" function called on "<%=compNickname%>" was executed without the specified effect options because it was called without an effect. Read more about effects: http://'),
    warning_invalid_effect_options: (0, _template2.default)('The "<%=functionName%>" function called on "<%=compNickname%>" was executed without the "<%=effectName%>" effect because it was called with the following invalid effectOptions <%=wrongProperty%>: <%=wrongValue%> . Read more about the effectOptions object: http://'),
    warning_invalid_type_effect_options: (0, _template2.default)('The "<%=functionName%>" function called on "<%=compNickname%>" was executed without the "<%=effectName%>" effect because the it was called with the following invalid effectOptions "<%=wrongValue%>". The effectOptions must be of type Object. Read more about the effectOptions object: http://'),
    warning_color_casting_performed: (0, _template2.default)('The <%=propertyName%> property of <%=compNickname%> expects an rgbColor value, but was set to an rgbaColor value. The color value has been set, but the alpha (opacity) information has been ignored. Read more about rgbColor values: http://'),
    error_mandatory_val: (0, _template2.default)('The <%=propertyName%> parameter is required for <%=functionName%> method.'),
    error_mandatory_val_with_index: (0, _template2.default)('The <%=propertyName%> parameter of item at index <%=index%> is required for <%=functionName%> method.'),
    error_mandatory_id: (0, _template2.default)('Each item in the items array must have a member named `_id` which contains a unique value identifying the item.'),
    error_type: (0, _template2.default)('The <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value <%=wrongValue%>. It must be of type <%=expectedType%>.'),
    error_type_with_index: (0, _template2.default)('The <%=propertyName%> parameter of item at index <%=index%> that is passed to the <%=functionName%> method cannot be set to the value <%=wrongValue%>. It must be of type <%=expectedType%>.'),
    error_range: (0, _template2.default)('The value of <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>". It must be between <%=minValue%> and <%=maxValue%>.'),
    error_range_with_index: (0, _template2.default)('The <%=propertyName%> parameter of item at index <%=index%> that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>". It must be between <%=minValue%> and <%=maxValue%>.'),
    error_empty_component: (0, _template2.default)('The value of <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>" because the component is empty.'),
    error_empty_component_with_index: (0, _template2.default)('The <%=propertyName%> parameter of item at index <%=index%> that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>" because the component is empty.'),
    error_accept_single_value: (0, _template2.default)('The value of <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>". It must be <%=acceptedValue%>.'),
    error_accept_single_value_with_index: (0, _template2.default)('The <%=propertyName%> parameter of item at index <%=index%> that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>". It must be <%=acceptedValue%>.'),
    error_length_in_range: (0, _template2.default)('The value of <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>". Its length must be between <%=minLength%> and <%=maxLength%>.'),
    error_length_in_range_with_index: (0, _template2.default)('The <%=propertyName%> parameter of item at index <%=index%> that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>". Its length must be between <%=minLength%> and <%=maxLength%>.'),
    error_length_accept_single_value: (0, _template2.default)('The value of <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>". Its length must be <%=acceptedLength%>.'),
    error_length_accept_single_value_with_index: (0, _template2.default)('The <%=propertyName%> parameter of item at index <%=index%> that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>". Its length must be <%=acceptedLength%>.'),
    error_length_exceeds: (0, _template2.default)('The value of <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>" because its length exceeds <%=maxLength%>.'),
    error_length_exceeds_with_index: (0, _template2.default)('The <%=propertyName%> parameter of item at index <%=index%> that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>" because its length exceeds <%=maxLength%>.'),
    error_item_not_found: (0, _template2.default)('The <%=propertyName%> parameter with value <%=wrongValue%> that is passed to the <%=functionName%> method is not found'),
    error_larger_than: (0, _template2.default)('The value of <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value <%=wrongValue%>. It must be larger than <%=minValue%>.'),
    error_less_than: (0, _template2.default)('The value of <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value <%=wrongValue%>. It must be less than <%=maxValue%>.'),
    error_bad_image_format: (0, _template2.default)('The "<%=propertyName%>" property cannot be set to "<%=wrongValue%>". It must be a valid URL starting with "http://", "https://", or "image://".'),
    error_bad_image_format_with_index: (0, _template2.default)('The "<%=propertyName%>" property of the item at index <%=index%> cannot be set to "<%=wrongValue%>". It must be a valid URL starting with "http://", "https://", or "image://".'),
    error_bad_svg_format: (0, _template2.default)('The "<%=propertyName%>" property cannot be set to "<%=wrongValue%>". It must be a valid SVG source starting with "wix:vector://v1/".'),
    error_bad_svg_format_with_index: (0, _template2.default)('The "<%=propertyName%>" property of the item at index <%=index%> cannot be set to "<%=wrongValue%>". It must be a valid SVG source starting with "wix:vector://v1/".'),
    error_bad_menu_item_format: (0, _template2.default)('The "<%=propertyName%>" property cannot be set to "<%=wrongValue%>". It must be a valid URL starting with "http://", "https://", "image://", "wix:image://v1" or "wix:vector://v1/svgshape.v2".'),
    error_bad_menu_item_format_with_index: (0, _template2.default)('The "<%=propertyName%>" property of the item at index <%=index%> cannot be set to "<%=wrongValue%>". It must be a valid URL starting with "http://", "https://", "image://", "wix:image://v1" or "wix:vector://v1/svgshape.v2".'),
    error_bad_item_id_format: (0, _template2.default)('Error setting the data property of <%=repeaterId%>. The data array contains the invalid ID "<%=wrongValue%>" at index <%=index%>. IDs must be composed of only alphanumeric characters and dashes.'),
    error_bad_format: (0, _template2.default)('The value of <%=propertyName%> parameter that is passed to the <%=functionName%> method cannot be set to the value <%=wrongValue%>. Bad format'),
    error_bad_format_with_index: (0, _template2.default)('The "<%=propertyName%>" property of the item at index <%=index%> cannot be set to "<%=wrongValue%>". Bad format'),
    error_only_getter: (0, _template2.default)('Cannot set property <%=propertyName%> of <%=compType%> which has only a getter'),
    error_menu_can_have_two_levels: (0, _template2.default)('The <%=propertyName%> parameter of item at index <%=index%> that is passed to the <%=functionName%> method cannot contains items as well - currently  we support menus with two levels only'),
    error_bad_link: (0, _template2.default)('Failed to create link because <%=error%>'),
    error_post_message: (0, _template2.default)('Failed to post message because <%=error%>'),
    error_unsupported_link: (0, _template2.default)('The link property that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>" as this is not a supported link type.'),
    error_unsupported_link_with_index: (0, _template2.default)('The link property of the item at index <%=index%> that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>" as this is not a supported link type.'),
    error_unsupported_target: (0, _template2.default)('The target property that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>" as this is not a supported target. It must be one of the following supported values: <%=supportedValues=>.'),
    error_unsupported_target_with_index: (0, _template2.default)('The target property of the item at index <%=index%> that is passed to the <%=functionName%> method cannot be set to the value "<%=wrongValue%>" as this is not a supported target. It must be one of the following supported values: <%=supportedValues=>.'),
    error_bad_background_format: (0, _template2.default)('The "<%=propertyName%>" property cannot be set to "<%=wrongValue%>". It must be a valid image URL starting with "http://", "https://", "wix:image://", or "image://". or valid Video url starting with wix:video://'),
    error_api_with_name_before_page_ready: (0, _template2.default)('<%=apiName%> cannot be used before the page is ready.'),
    error_function_throws_error: (0, _template2.default)('The "<%=functionName%>" function of "<%=compNickname%>" threw the following error: <%=errorMessage%>'),
    error_slide_input: (0, _template2.default)('The "<%=propertyName%>" parameter that is passed to the "<%=functionName%>" method cannot be set to the value <%=wrongValue%>. It must be a slide from the "<%=slideshowID%>" slideshow or an index between <%=minValue%> and <%=maxValue%>'),
    error_invalid_css_value: (0, _template2.default)('The "<%=propertyName%>" property of "<%=compNickname%>" was set to an invalid "<%=cssProperty%>" value. The value is expected in the following format:"<%=exampleFormat%>". Read more about "<%=cssProperty%>" values: "<%=infoLink%>"'),
    error_invalid_css_value_multiple_expected_formats: (0, _template2.default)('The "<%=propertyName%>" property of "<%=compNickname%>" was set to an invalid "<%=cssProperty%>" value. The value is expected in one of the following formats:"<%=exampleFormats%>". Read more about "<%=cssProperty%>" values: "<%=infoLink%>"')
};

var errors = {
    ERROR_API_BEFORE_PAGE_READY: 'Some APIs cannot be used before the page is ready.'
};

var userErrors = {
    CLOSE_DIALOG: 'The user closed the login dialog',
    NO_LOGGED_IN: 'No user is currently logged in',
    AWAITING_APPROVAL: 'Member login request has been sent and is awaiting approval'
};

exports.errors = errors;
exports.generateError = generateError;
exports.userErrors = userErrors;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _mapValues = __webpack_require__(414);

var _mapValues2 = _interopRequireDefault(_mapValues);

var _errors = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _RMI = void 0;
var _RGI = void 0;
var _wixSelector = void 0;
var _staticEventHandlers = {};
var _linkUtils = void 0;
var _backgroundUtils = void 0;
var _videoUrlsUtils = void 0;
var _repeaterUtils = void 0;
var _typeUtils = void 0;
var _componentsHooks = void 0;
var _uriUtils = void 0;
var _widgetUtils = void 0;
var _richTextUtils = void 0;
var _contextId = void 0;

var initGlobals = function initGlobals(platformUtils) {
    _RGI = platformUtils.RGI;
};

var init = function init(platformUtils, wixSelector, onUpdateCallback) {
    platformUtils.RMI.setUpdateCallback(onUpdateCallback);
    _RMI = platformUtils.RMI;
    _linkUtils = platformUtils.linkUtils;
    _backgroundUtils = platformUtils.backgroundUtils;
    _videoUrlsUtils = platformUtils.videoUrlsUtils;
    _repeaterUtils = platformUtils.repeaterUtils;
    _typeUtils = platformUtils.typeUtils;
    _componentsHooks = platformUtils.componentsHooks;
    _uriUtils = platformUtils.uriUtils;
    _widgetUtils = platformUtils.widgetUtils;
    _richTextUtils = platformUtils.richTextUtils;
    _wixSelector = wixSelector;
};

var setStaticEventHandlers = function setStaticEventHandlers(eventHandlers, contextId) {
    _staticEventHandlers = (0, _mapValues2.default)(eventHandlers, function (callback) {
        return { contextId: contextId, controllerId: contextId, callback: callback };
    });
};

var setContextId = function setContextId(contextId) {
    _contextId = contextId;
};

var throwIfMissing = function throwIfMissing(param, apiName) {
    if (!param) {
        var errorMessage = apiName ? _errors.generateError.error_api_with_name_before_page_ready({ apiName: apiName }) : _errors.errors.ERROR_API_BEFORE_PAGE_READY;
        throw new Error(errorMessage);
    }
    return param;
};

var getStaticEventHandler = function getStaticEventHandler(name, onlyCallback) {
    var staticEventHandler = _staticEventHandlers[name]; // TODO - backward compatibility - remove after worker next release
    if (!staticEventHandler) {
        return null;
    } else if (onlyCallback) {
        return staticEventHandler.callback;
    }

    return staticEventHandler;
};

var getRMI = function getRMI(apiName) {
    return throwIfMissing(_RMI, apiName);
};

var getRGI = function getRGI() {
    return _RGI;
};

var getWixSelector = function getWixSelector(apiName) {
    return throwIfMissing(_wixSelector, apiName);
};

var getLinkUtils = function getLinkUtils() {
    return _linkUtils;
};

var getBackgroundUtils = function getBackgroundUtils() {
    return _backgroundUtils;
};

var getVideoUrlUtils = function getVideoUrlUtils() {
    return _videoUrlsUtils;
};

var getRepeaterUtils = function getRepeaterUtils() {
    return _repeaterUtils;
};

var getTypeUtils = function getTypeUtils() {
    return _typeUtils;
};

var getComponentsHooks = function getComponentsHooks() {
    return _componentsHooks;
};

var getUriUtils = function getUriUtils() {
    return _uriUtils;
};

var getWidgetUtils = function getWidgetUtils() {
    return _widgetUtils;
};

var getRichTextUtils = function getRichTextUtils() {
    return _richTextUtils;
};

var getContextId = function getContextId() {
    return _contextId;
};

module.exports = {
    initGlobals: initGlobals,
    init: init,
    getWixSelector: getWixSelector,
    setStaticEventHandlers: setStaticEventHandlers,
    setContextId: setContextId,
    getRMI: getRMI,
    getRGI: getRGI,
    getLinkUtils: getLinkUtils,
    getStaticEventHandler: getStaticEventHandler,
    getVideoUrlUtils: getVideoUrlUtils,
    getTypeUtils: getTypeUtils,
    getRepeaterUtils: getRepeaterUtils,
    getBackgroundUtils: getBackgroundUtils,
    getComponentsHooks: getComponentsHooks,
    getUriUtils: getUriUtils,
    getWidgetUtils: getWidgetUtils,
    getRichTextUtils: getRichTextUtils,
    getContextId: getContextId
};

/***/ }),
/* 14 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clearValidations = exports.getValidationMessage = exports.runValidationsAndSyncAfterChange = exports.runValidationsAfterChange = exports.hideValidityIndication = exports.showValidityIndication = exports.isValid = exports.getValidity = exports.runValidationsAndSync = exports.runValidations = exports.onCustomValidation = exports.initValidationsService = undefined;

var _isUndefined = __webpack_require__(30);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _validationsServiceState = __webpack_require__(234);

var _valueValidation = __webpack_require__(228);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var customValidations = {};

var initValidationsService = function initValidationsService() {
    customValidations = {};
    (0, _validationsServiceState.initValidationsServiceState)();
};

var ELEMENT_TYPES = {
    TEXT_INPUT: 'TextInput',
    TEXT_AREA: 'TextAreaInput',
    SELECT_INPUT: 'SelectableList',
    RADIO_GROUP: 'RadioGroup',
    CHECKBOX: 'CheckboxInput',
    DATE_PICKER: 'DatePicker',
    UPLOAD_BUTTON: 'FileUploader'
};

var getValueByInputType = function getValueByInputType(RMI, compId) {
    var compData = RMI.getData(compId);

    switch (compData.type) {
        case ELEMENT_TYPES.CHECKBOX:
            return compData.checked;
        case ELEMENT_TYPES.DATE_PICKER:
            return RMI.getState(compId).selectedDate;
        case ELEMENT_TYPES.UPLOAD_BUTTON:
            return RMI.getState(compId).value;
        default:
            return compData.value;
    }
};

var onCustomValidation = function onCustomValidation(RMI, compId, validator) {
    customValidations[compId] = validator;

    runValidations(RMI, compId);
};

var checkCustomValidity = function checkCustomValidity(compId, value) {
    var customValidator = customValidations[compId];
    var customValidity = '';

    var reject = function reject(message) {
        customValidity = message;
    };

    if (customValidator) {
        customValidator(value, reject);
    }

    return customValidity;
};

var updateValidityIndication = function updateValidityIndication(RMI, compId, indicationValue) {
    var state = RMI.getState(compId);
    var shouldShowValidationIndication = (0, _get2.default)(state, 'shouldShowValidationIndication', false);

    if (shouldShowValidationIndication !== indicationValue) {
        RMI.updateModel(_defineProperty({}, compId, {
            state: {
                shouldShowValidationIndication: indicationValue
            }
        }));

        RMI.executeCompBehavior(compId, 'updateValidityIndication', { value: indicationValue, requiresDom: null });
    }
};

var showValidityIndication = function showValidityIndication(RMI, compId) {
    return updateValidityIndication(RMI, compId, true);
};
var hideValidityIndication = function hideValidityIndication(RMI, compId) {
    return updateValidityIndication(RMI, compId, false);
};

var runValidations = function runValidations(RMI, compId, value) {
    value = !(0, _isUndefined2.default)(value) ? value : getValueByInputType(RMI, compId);
    var validationState = (0, _validationsServiceState.getCompValidationState)(compId);
    var prevCustomValidity = (0, _valueValidation.getCustomValidity)(validationState);
    var compData = RMI.getFullDataWithOverrides(compId);
    var compProps = RMI.getProps(compId);
    var compState = RMI.getState(compId);

    var validateData = (0, _valueValidation.validateValue)(value, compData, compProps, compState);
    var customValidity = checkCustomValidity(compId, value);

    if (customValidity) {
        validateData = (0, _valueValidation.addCustomValidityToValidateData)(validateData, customValidity);
    }

    (0, _validationsServiceState.setCompValidationState)(compId, validateData);

    if (customValidity !== prevCustomValidity) {
        RMI.executeCompBehavior(compId, RMI.getEventTypes().SET_CUSTOM_VALIDITY, { customValidity: customValidity, requiresDom: null });
    }
};

var clearValidations = function clearValidations(RMI, compId) {
    (0, _validationsServiceState.unsetCompValidationState)(compId);
};

var runValidationsAfterChange = function runValidationsAfterChange(RMI, compId, value) {
    runValidations(RMI, compId, value);
    showValidityIndication(RMI, compId);
};

var runValidationsAndSync = function runValidationsAndSync(RMI, compId, value) {
    value = !(0, _isUndefined2.default)(value) ? value : getValueByInputType(RMI, compId);
    var compData = RMI.getFullDataWithOverrides(compId);
    var compProps = RMI.getProps(compId);
    var compState = RMI.getState(compId);

    var validateData = (0, _valueValidation.validateValue)(value, compData, compProps, compState);
    var customValidity = checkCustomValidity(compId, value);

    if (customValidity) {
        validateData = (0, _valueValidation.addCustomValidityToValidateData)(validateData, customValidity);
    }

    (0, _validationsServiceState.setCompValidationState)(compId, validateData);

    RMI.executeCompBehavior(compId, RMI.getEventTypes().SYNC_VALIDATION_DATA, { validateData: validateData, requiresDom: null });
};

var runValidationsAndSyncAfterChange = function runValidationsAndSyncAfterChange(RMI, compId, value) {
    runValidationsAndSync(RMI, compId, value);
    showValidityIndication(RMI, compId);
};

var getValidity = function getValidity(compId) {
    return (0, _get2.default)((0, _validationsServiceState.getCompValidationState)(compId), 'validity');
};

var isValid = function isValid(compId) {
    return (0, _get2.default)((0, _validationsServiceState.getCompValidationState)(compId), 'validity.valid', true);
};

var getValidationMessage = function getValidationMessage(compId) {
    return (0, _get2.default)((0, _validationsServiceState.getCompValidationState)(compId), 'validationMessage', '');
};

exports.initValidationsService = initValidationsService;
exports.onCustomValidation = onCustomValidation;
exports.runValidations = runValidations;
exports.runValidationsAndSync = runValidationsAndSync;
exports.getValidity = getValidity;
exports.isValid = isValid;
exports.showValidityIndication = showValidityIndication;
exports.hideValidityIndication = hideValidityIndication;
exports.runValidationsAfterChange = runValidationsAfterChange;
exports.runValidationsAndSyncAfterChange = runValidationsAndSyncAfterChange;
exports.getValidationMessage = getValidationMessage;
exports.clearValidations = clearValidations;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(319),
    baseMatchesProperty = __webpack_require__(320),
    identity = __webpack_require__(86),
    isArray = __webpack_require__(6),
    property = __webpack_require__(419);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 17 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.unregisterEventListener = exports.registerEventListener = exports.onMessage = exports.callEventListeners = exports.Intent = exports.MessageTypes = exports.sendMessage = undefined;

var _isString = __webpack_require__(36);

var _isString2 = _interopRequireDefault(_isString);

var _isObject = __webpack_require__(14);

var _isObject2 = _interopRequireDefault(_isObject);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _set = __webpack_require__(37);

var _set2 = _interopRequireDefault(_set);

var _urlUtils = __webpack_require__(24);

var urlUtils = _interopRequireWildcard(_urlUtils);

var _utils = __webpack_require__(9);

var utils = _interopRequireWildcard(_utils);

var _eventService = __webpack_require__(220);

var _eventService2 = _interopRequireDefault(_eventService);

var _platformUtils = __webpack_require__(13);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(12);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Intent = {
    WIX_CODE_SITE_API: 'WIX_CODE_SITE_API',
    WIX_CODE_APP_API: 'WIX_CODE_APP_API',
    WIX_CODE_RESPONSE: 'WIX_CODE_RESPONSE',
    WIX_CODE: 'WIX_CODE',
    WIX_CODE_WARMUP: 'WIX_CODE_WARMUP',
    BROWSER_API: 'BROWSER_API'
};

var MessageTypes = {
    NAVIGATE_TO: 'navigateTo',
    SITE_INFO: 'siteInfo',
    SM_CURRENT_USER_EMAIL: 'smCurrentUserEmail',
    SM_REQUEST_LOGIN: 'smRequestLogin',
    SM_LOGOUT: 'smLogout',
    SM_FORGOT_PASSWORD: 'smForgotPassword',
    WINDOW_BOUNDING_RECT: 'windowBoundingRect',
    SCROLL_TO: 'scrollTo',
    SCROLL_TO_COMP: 'scrollToComponent',
    SCROLL_BY: 'scrollBy',
    GET_APP_API: 'getAppAPI',
    INVOKE_APP_FN: 'invokeAppFn',
    INVOKE_APP_ON: 'invokeAppOn',
    SET_TO_STORAGE: 'setToStorage',
    STORAGE_UPDATE: 'storageWasUpdated',
    POST_HTML_MESSAGE: 'postHtmlMessage',
    OPEN_LIGHTBOX: 'openLightbox',
    CLOSE_LIGHTBOX: 'closeLightbox',
    START_UPLOAD: 'startFileUpload',
    GET_ROUTERS_SITEMAP: 'getRoutersSiteMap',
    GET_CURRENT_GEOLOCATION: 'getCurrentGeolocation',
    SET_WARMUP_DATA: 'setWarmupData',
    GOOGLE_ANALYTICS: 'googleAnalytics',
    TRACK_EVENT: 'trackEvent',
    OPEN_MODAL: 'openModal',
    SEND_MESSAGE_TO_PARENT: 'sendMessageToParent'
};

var callbackId = 1;

var registeredEventListeners = {};

var callbacks = {};

var postMessage = function postMessage(message, ports) {
    var _self;

    var args = [message];
    if (!utils.isWorker()) {
        args.push('*');
    }
    if (ports) {
        args.push(ports);
    }
    (_self = self).postMessage.apply(_self, args);
};

var msgSenders = {
    WIX_CODE_WARMUP: sendWarmupCommandMessage,
    WIX_CODE: sendCompCommandMessage,
    BROWSER_API: sendBrowserCommandMessage,
    WIX_CODE_SITE_API: sendGeneralViewerCommandMessage,
    WIX_CODE_APP_API: sendGeneralViewerCommandMessage
};

var EventsCallbacks = {};

function sendMessage(intent) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    (msgSenders[intent] || sendGeneralViewerCommandMessage).apply(undefined, [intent].concat(args));
}

function sendBrowserCommandMessage(intent, msgType, params) {
    if (!msgType) {
        return;
    }

    postMessage({
        intent: intent,
        type: msgType,
        data: params
    });
}

function sendGeneralViewerCommandMessage(intent, msgType, params, callback) {
    if (!msgType) {
        return;
    }

    var callbackId = getCallbackId();
    if (callback) {
        callbacks[callbackId] = callback;
    }

    postMessage({
        callbackId: callbackId,
        intent: intent,
        type: msgType,
        contextId: _platformUtils2.default.getContextId(),
        deviceType: urlUtils.getQueryParameter('deviceType') || 'desktop',
        data: params
    });
}

function sendWarmupCommandMessage(intent, command, params) {
    intent = 'WIX_CODE';
    try {
        postMessage({
            intent: intent,
            type: 'wix_code_warmup_data',
            deviceType: urlUtils.getQueryParameter('deviceType') || 'desktop',
            data: params,
            command: command
        });
    } catch (error) {
        _reporter2.default.reportSdkError(_errors.generateError.error_post_message({ error: error }));
    }
}

function sendCompCommandMessage(intent, command, compId, contextId, params, callback) {
    //validations
    var callbackId = getCallbackId();
    if (callback) {
        callbacks[callbackId] = callback;
    }

    postMessage({
        callbackId: callbackId,
        intent: intent,
        type: 'wix_code_iframe_command',
        deviceType: urlUtils.getQueryParameter('deviceType') || 'desktop',
        data: params,
        compId: compId,
        contextId: contextId,
        command: command
    });
}

function onMessage(event) {
    if (!event || !event.data) {
        return;
    }

    var data = {};
    try {
        if ((0, _isString2.default)(event.data)) {
            data = JSON.parse(event.data);
        } else if ((0, _isObject2.default)(event.data)) {
            data = event.data;
        }
    } catch (e) {
        return;
    }

    switch (data.intent) {
        case 'WIX_CODE_RESPONSE':
            var callback = data.callbackId && callbacks[data.callbackId];
            if (callback) {
                if (!(0, _isNil2.default)(data.result)) {
                    var dataToPassToCallback = data.result;
                    if (data.type === MessageTypes.INVOKE_APP_ON) {
                        dataToPassToCallback = (0, _eventService2.default)(data.result);
                    } else if (data.result.command === 'propsChanged') {
                        dataToPassToCallback = null;
                    }
                    callback.call(this, dataToPassToCallback);
                } else {
                    callback(data.result, data.error);
                }

                if (data.type !== MessageTypes.INVOKE_APP_ON) {
                    delete callbacks[data.callbackId];
                }
            }
            break;

        case 'addEventListener':
            callEventListeners(data);
            break;

        case 'WIX_CODE':
            var RGI = _platformUtils2.default.getRGI();

            if (data.type === 'update_site_member') {
                RGI.addSiteMemberData(data.updates);
                break;
            }

            if (data.type === 'update_apps_data') {
                RGI.addAppsData(data.updates);
                break;
            }

            if (data.type === 'update_navigation') {
                RGI.addNavigation(data.updates);
                break;
            }

            if (data.type === 'update_session_info') {
                RGI.addSessionInfoProp(data.updates);
                break;
            }

            var RMI = void 0;
            try {
                RMI = _platformUtils2.default.getRMI();
            } catch (e) {
                return; //Ignore events before we have a model in here.
            }

            if (data.type === 'update') {
                RMI.updateModel(data.updates);
                break;
            }

            // TODO: should have a check for data.type
            var funcRef = data.callbackId;
            var compId = data.compId;
            var dynamicCallback = RMI.getCallbackById(funcRef, true);
            var staticCallback = _platformUtils2.default.getStaticEventHandler(funcRef);

            var _RMI$getRepeaterItemC = RMI.getRepeaterItemContext(compId),
                itemId = _RMI$getRepeaterItemC.itemId;

            if (itemId) {
                (0, _set2.default)(data, 'event.context', { itemId: itemId });
            }

            if (dynamicCallback) {
                var selector = _platformUtils2.default.getWixSelector().getScopedSelector(compId, dynamicCallback.contextId, dynamicCallback.controllerId);
                dynamicCallback.callback.call(this, (0, _eventService2.default)(data, dynamicCallback.controllerId), selector);
            }
            if (staticCallback) {

                var _selector = _platformUtils2.default.getWixSelector().getScopedSelector(compId, staticCallback.contextId, staticCallback.controllerId);
                staticCallback.callback.call(this, (0, _eventService2.default)(data, staticCallback.controllerId), _selector);
            }

            break;
    }

    if (registeredEventListeners[data.type]) {
        registeredEventListeners[data.type](data);
    }
}

function registerEventListener(msgType, listener) {
    registeredEventListeners[msgType] = listener;
}

function unregisterEventListener(msgType) {
    delete registeredEventListeners[msgType];
}

function callEventListeners(data, typeOfCall) {
    if (EventsCallbacks[data.eventType]) {
        EventsCallbacks[data.eventType].forEach(function (callbackHandler) {
            callbackHandler.callback.call(this, data.params, typeOfCall);
        });
    }
}

function getCallbackId() {
    return callbackId++;
}

exports.sendMessage = sendMessage;
exports.MessageTypes = MessageTypes;
exports.Intent = Intent;
exports.callEventListeners = callEventListeners;
exports.onMessage = onMessage;
exports.registerEventListener = registerEventListener;
exports.unregisterEventListener = unregisterEventListener;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(170);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(34),
    baseIteratee = __webpack_require__(16),
    baseMap = __webpack_require__(318),
    isArray = __webpack_require__(6);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(50),
    getRawTag = __webpack_require__(353),
    objectToString = __webpack_require__(382);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(29),
    isLength = __webpack_require__(121);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(109),
    getTag = __webpack_require__(79),
    isArguments = __webpack_require__(87),
    isArray = __webpack_require__(6),
    isArrayLike = __webpack_require__(22),
    isBuffer = __webpack_require__(63),
    isPrototype = __webpack_require__(59),
    isTypedArray = __webpack_require__(89);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUrlFromRGI = exports.isExternalUrl = exports.parseUrl = exports.addQueryParameters = exports.setQueryParameters = exports.getQueryParameter = undefined;

var _isArray = __webpack_require__(6);

var _isArray2 = _interopRequireDefault(_isArray);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parameterMap = {};

function addQueryParameters(params) {
    (0, _assign2.default)(parameterMap, params);
}

function setQueryParameters(params) {
    parameterMap = params; //should it really override and not merge?
}

function getQueryParameter(parameterName) {
    return parameterMap[parameterName] || null;
}

function parseUrlParams(queryString) {
    var re = /([^&=]+)=([^&]*)/g;
    var param = void 0;
    var query = {};

    while ((param = re.exec(queryString)) !== null) {
        var key = decodeURIComponent(param[1]);
        var val = decodeURIComponent(param[2]);
        if (!query[key]) {
            // first value for key, keep as string
            query[key] = val;
        } else if ((0, _isArray2.default)(query[key])) {
            // more than one value already, push to the array
            query[key].push(val);
        } else {
            // the 2nd value for the key, turn into an array
            query[key] = [query[key], val];
        }
    }

    return query;
}

function parseUrl(url) {
    if (!url) {
        return {};
    }
    var urlRe = /((https?)\:\/\/)?([^\?\:\/#]+)(\:([0-9]+))?(\/[^\?\#]*)?(\?([^#]*))?(#.*)?/i;
    var match = url.match(urlRe);
    var port = match[5] || '';
    var search = match[8] ? '?' + match[8] : '';
    var ret = {
        full: url,
        protocol: match[2] || 'http:',
        host: port ? match[3] + ':' + port : match[3],
        hostname: match[3],
        port: port,
        path: match[6] || '/',
        search: search,
        hash: match[9] || ''
    };

    // fix empty hash
    if (ret.hash === '#' || ret.hash === '#!') {
        ret.hash = '';
    }

    ret.query = parseUrlParams(match[8]);
    return ret;
}

function isExternalUrl(url) {
    return (/^(?:(?:https?:)\/\/)(?:(?:[\u0400-\uA69F\w][\u0400-\uA69F\w-]*)?[\u0400-\uA69F\w]\.)+(?:[\u0400-\uA69Fa-z]+|\d{1,3})(?::[\d]{1,5})?(?:[/?#].*)?$/i.test(url)
    );
}

function getUrlFromRGI(RGI) {
    var navigation = RGI.getNavigationInfo();
    return navigation.currentPageFullUrl || navigation.baseUrl;
}

exports.getQueryParameter = getQueryParameter;
exports.setQueryParameters = setQueryParameters;
exports.addQueryParameters = addQueryParameters;
exports.parseUrl = parseUrl;
exports.isExternalUrl = isExternalUrl;
exports.getUrlFromRGI = getUrlFromRGI;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEvents = exports.onEvent = exports.getFullDataWithOverrides = exports.getData = exports.setDataWithoutUpdate = exports.setData = exports.getProp = exports.setProp = exports.getRMI = undefined;

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function getRMI(instance) {
    return members._RMI.get(instance);
}

function getCompId(instance) {
    return members._compId.get(instance);
}

function getControllerId(instance) {
    return members._controllerId.get(instance);
}

function getContextId(instance) {
    return members._contextId.get(instance);
}

function setProp(instance, value) {
    getRMI(instance).setProps(getCompId(instance), value);
}

function getProp(instance, valueName) {
    return getRMI(instance).getProps(getCompId(instance))[valueName];
}

function setData(instance, value) {
    getRMI(instance).setData(getCompId(instance), value);
}

function setDataWithoutUpdate(instance, value) {
    getRMI(instance).setDataWithoutUpdate(getCompId(instance), value);
}

function getData(instance, valueName) {
    return getRMI(instance).getData(getCompId(instance))[valueName];
}

function getFullDataWithOverrides(instance, valueName) {
    return getRMI(instance).getFullDataWithOverrides(getCompId(instance))[valueName];
}

function onEvent(instance, eventName, cb) {
    getRMI(instance).registerEvent(getContextId(instance), getCompId(instance), eventName, getControllerId(instance), cb);
    return instance;
}

function getEvents(instance) {
    return getRMI(instance).getEvents(getCompId(instance));
}

exports.getRMI = getRMI;
exports.setProp = setProp;
exports.getProp = getProp;
exports.setData = setData;
exports.setDataWithoutUpdate = setDataWithoutUpdate;
exports.getData = getData;
exports.getFullDataWithOverrides = getFullDataWithOverrides;
exports.onEvent = onEvent;
exports.getEvents = getEvents;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _componentsBatchFunctions = __webpack_require__(93);

var _componentsBatchFunctions2 = _interopRequireDefault(_componentsBatchFunctions);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin ContainableMixin
 * @summary Provides functionality for elements that can contain other elements.
 *  Some elements, such as pages, headers, footers, and boxes, can contain
 *  other elements. This occurs when you drag an element onto a container
 *  element and <a href="https://www.wix.com/support/html5/article/attaching-elements-to-a-box" target="_blank">attach it</a>.
 *  These attached elements are considered the parent element's children. Some
 *  actions performed on the parent, such as [`hiding`]($w.HiddenMixin.html#hide),
 *  will affect the element's children as well.
 * @memberof $w
 */
var ContainableMixin = function () {
    function ContainableMixin() {
        _classCallCheck(this, ContainableMixin);
    }

    _createClass(ContainableMixin, [{
        key: 'children',


        /**
         * @member children
         * @label property
         * @syntax
         * get children(): Element[]
         * @summary Gets an array of the elements that are contained within the element.
         * @description
         *  Some elements, such as pages, headers, footers, and boxes, can contain
         *  other elements. This occurs when you drag an element onto a container
         *  element and <a href="https://www.wix.com/support/html5/article/attaching-elements-to-a-box" target="_blank">attach it</a>.
         *  These attached elements are considered the parent element's children.
         * @type {$w.Element[]}
         * @default An empty array
         * @snippet [Containable-children.es6=Get an element's children]
         * @see [parent]($w.Node.html#parent)
         * @memberof $w.ContainableMixin
         * @readonly
         */
        get: function get() {
            var compId = members._compId.get(this);
            if (compId === 'default') {
                return;
            }
            var childElements = [];
            var RMI = members._RMI.get(this);
            var wixSelector = members._wixSelector.get(this);
            var controllerId = members._controllerId.get(this);
            var childrenIds = RMI.getChildren(compId);
            var children = childrenIds.map(RMI.getComp.bind(RMI));

            children.forEach(function (child, index) {
                childElements.push(wixSelector.getInstance(RMI, child.type, childrenIds[index], controllerId));
            }, this);
            return _componentsBatchFunctions2.default.expose(childElements);
        }
    }]);

    return ContainableMixin;
}();

exports.default = ContainableMixin;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin DisabledMixin
 * @description Provides functionality for elements that can be disabled.
 * @memberof $w
 */
var DisabledMixin = function () {
    function DisabledMixin() {
        _classCallCheck(this, DisabledMixin);
    }

    _createClass(DisabledMixin, [{
        key: 'disable',


        /**
         * @function disable
         * @syntax
         * function disable(): Promise&lt;void&gt;
         * @summary Disables the element and sets its `enabled` property to `false`.
         * @description
         *  The `disable()` function returns a Promise that is resolved when the
         *  element's [`enabled`](#enabled) property has been set to `false`.
         *
         *  To learn about the behavior of a disabled element,
         *  see the [`enabled`](#enabled) property.
         * @returns {Promise}
         * @fulfill {void} When the element's `enabled` property has been set to `false`.
         * @snippet [DisabledMixin-disable.es6=Disable an element]
         * @snippet [DisabledMixin-disable_then.es6=Disable an element and log a message when done]
         * @snippet [DisabledMixin_toggle_enabled.es6=Toggle an element's enabled state]
         * @see [enable( )](#enable)
         * @see [enabled](#enabled)
         * @memberof $w.DisabledMixin
         */
        value: function disable() {
            var _this = this;

            return new Promise(function (resolve) {
                var RMI = members._RMI.get(_this);
                var compId = members._compId.get(_this);

                RMI.setProps(compId, {
                    isDisabled: true
                }, resolve);
            });
        }

        /**
         * @function enable
         * @syntax
         * function disable(): Promise&lt;void&gt;
         * @summary Enables the element and sets its `enabled` property to `true`.
         * @description
         *  The `enable()` function returns a Promise that is resolved when the
         *  element's [`enabled`](#enabled) property has been set to `true`.
         *
         *  To learn about the behavior of an enabled element,
         *  see the [`enabled`](#enabled) property.
         * @returns {Promise}
         * @fulfill {void} When the element's `enabled` property has been set to `true`.
         * @snippet [DisabledMixin-enable.es6=Enable an element]
         * @snippet [DisabledMixin-enable_then.es6=Enable an element and log a message when done]
         * @snippet [DisabledMixin_toggle_enabled.es6=Toggle an element's enabled state]
         * @see [disable( )](#disable)
         * @see [enabled](#enabled)
         * @memberof $w.DisabledMixin
         */

    }, {
        key: 'enable',
        value: function enable() {
            var _this2 = this;

            return new Promise(function (resolve) {
                var RMI = members._RMI.get(_this2);
                var compId = members._compId.get(_this2);

                RMI.setProps(compId, {
                    isDisabled: false
                }, resolve);
            });
        }

        /**
         * @member enabled
         * @label property
         * @syntax
         * get enabled(): boolean
         * @summary Indicates if the element is enabled or disabled.
         * @description
         *  If `enabled` is `true`, users can interact with the element.
         *
         *  If `enabled` is `false`, users cannot interact with the element.
         *
         *  When an element is disabled:
         *
         *  + Its color is faded or grayed out.
         *  + Animations that the element normally exhibits when being interacting
         *    with will not occur.
         *  + Actions that the element has been configured to perform, such as
         *    opening a link, will not occur.
         *  + Event handlers that have been bound to the element, such as with
         *    {@link $w.Element.onMouseIn|onMouseIn}, will not run.
         *  + If the element is an input element, such as a dropdown or text box,
         *    users cannot interact with it.
         *
         *
         *  To set the `enabled` property of an element, use the element's
         *  [`enable()`](#enable) or [`disable()`](#disable) functions.
         *
         *  The `enabled` property can also be set in the Editor using the Properties panel.
         * @snippet [DisabledMixin-enabled.es6=Get an element's enabled status]
         * @snippet [DisabledMixin_toggle_enabled.es6=Toggle an element's enabled state]
         * @type {external:Boolean}
         * @default `true`
         * @see [disable( )](#disable)
         * @see [enable( )](#enable)
         * @memberof $w.DisabledMixin
         * @attr {external:Boolean} enabled
         * @readonly
         */

    }, {
        key: 'enabled',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var props = RMI.getProps(compId);
            return !props.isDisabled || props.isDisabled === false;
        }
    }]);

    return DisabledMixin;
}();

exports.default = DisabledMixin;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _multiMixin = __webpack_require__(223);

var _multiMixin2 = _interopRequireDefault(_multiMixin);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _styleConstants = __webpack_require__(48);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @namespace $w.Style
 * @summary An object representing an element's styles.
 */

var Style = function Style(RMI, compId, type, compNickname, styleMixins) {
    _classCallCheck(this, Style);

    members._RMI.set(this, RMI);
    members._compId.set(this, compId);
    members._type.set(this, type);
    members._compNickname.set(this, compNickname);
    (0, _multiMixin2.default)(Style.prototype, styleMixins);
};
/**
 * @class StyleMixin
 * @summary Provides functionality for elements that can be styled.
 * @memberof $w
 * @tagname styleMixin
 */


var StyleMixin = function () {
    function StyleMixin() {
        _classCallCheck(this, StyleMixin);
    }

    _createClass(StyleMixin, [{
        key: 'style',

        /**
         * @member style
         * @label property
         * @syntax
         * get style(): Style
         * @summary Gets an object containing information about the element's styles.
         * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
         * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
         * @type {$w.Style}
         * @memberof $w.StyleMixin
         * @readonly
         */
        get: function get() {
            var styleInstance = members._styleInstance.get(this);
            if (styleInstance) {
                return styleInstance;
            }

            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var type = members._type.get(this);
            var styleMixins = _styleConstants.SUPPORTED_STYLES[type.compType];
            var compNickname = this.id;

            styleInstance = new Style(RMI, compId, type, compNickname, styleMixins);
            members._styleInstance.set(this, styleInstance);
            return styleInstance;
        }
    }]);

    return StyleMixin;
}();

exports.default = StyleMixin;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(21),
    isObject = __webpack_require__(14);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(149),
    baseKeys = __webpack_require__(109),
    isArrayLike = __webpack_require__(22);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin FocusMixin
 * @summary Provides functionality for elements that can set and lose focus.
 *
 *  The element on the page that is currently active is the element in focus.
 *  Only one element on the page can have focus at any given moment.
 *  Typically, an element exhibits a visual cue, such as a subtle outline,
 *  indicating that it is in focus. The element in focus receives keystroke
 *  events if the user causes any.
 *
 *  An element receives focus and loses focus (blurs) through user actions,
 *  such as clicking and tabbing, or programmatically, using the
 *  [focus( )](#focus) and [blur( )](#blur) functions.
 * @memberof $w
 */
var FocusMixin = function () {
    function FocusMixin() {
        _classCallCheck(this, FocusMixin);
    }

    _createClass(FocusMixin, [{
        key: 'focus',


        /**
         * @function focus
         * @syntax
         * function focus(): void
         * @summary Places focus on the element.
         * @description
         *  The `focus()` function places focus on the element and fires a `focus`
         *  event.
         *
         *  The `focus` event handlers set on this element by the [onFocus( )](#onFocus)
         *  function or in the Editor will called.
         *
         *  Receiving focus through a call to this function is equivalent to
         *  a user clicking on or tabbing to the element manually.
         * @snippet [FocusMixin-focus.es6=Place focus on an element]
         * @see [onFocus( )](#onFocus)
         * @see [blur( )](#blur)
         * @see [onBlur( )](#onBlur)
         * @memberof $w.FocusMixin
         */
        value: function focus() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);

            RMI.executeCompBehavior(compId, 'focus', [], function () {});
        }

        /**
         * @function blur
         * @syntax
         * function blur(): void
         * @summary Removes focus from the element.
         * @description
         *  The `blur()` function removes focus from the element and fires a `blur`
         *  event.
         *
         *  The `blur` event handlers set on this element by the [onBlur( )](#onBlur)
         *  function or in the Editor will called.
         *
         *  Removing focus through a call to this function is equivalent to a user
         *  clicking on another element or tabbing out of the element manually.
         *
         *  If blur() is called on an element that is not in focus, it has no effect.
         *  The element in focus remains in focus and the `onBlur` event handlers
         *  are not called.
         * @snippet [FocusMixin-blur.es6=Remove focus from an element]
         * @see [onBlur( )](#onBlur)
         * @see [focus( )](#focus)
         * @see [onFocus( )](#onFocus)
         * @memberof $w.FocusMixin
         */

    }, {
        key: 'blur',
        value: function blur() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);

            RMI.executeCompBehavior(compId, 'blur', [], function () {});
        }

        /**
         * @function onFocus
         * @syntax
         * function onFocus(handler: EventHandler): Element
         * callback EventHandler(event: Event, $w: Function): void
         * @summary Adds an event handler that runs when the element receives focus.
         * @description
         *  An element receives focus through user actions,
         *  such as clicking and tabbing, or programmatically, using the
         *  [focus( )](#focus) function.
         *
         * @note `onFocus()` has no effect when applied to [RadioButtonGroup]($w.RadioButtonGroup.html) elements.
         * @param {$w.EventHandler} handler The name of the function or
         *  the function expression to run when the element receives focus.
         * @returns {$w.Element} The element on which the event is now registered.
         * @snippet [FocusMixin-onFocus.es6=Get the ID of the element that has received focus]
         * @see [focus( )](#focus)
         * @see [onBlur( )](#onBlur)
         * @see [blur( )](#blur)
         * @memberof $w.FocusMixin
         * @eventtype focus
         * @eventhandler
         */

    }, {
        key: 'onFocus',
        value: function onFocus(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'onFocus', { onFocus: cb })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var controllerId = members._controllerId.get(this);
            var contextId = members._contextId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().FOCUS, controllerId, cb);
            return this;
        }

        /**
         * @function onBlur
         * @syntax
         * function onBlur(handler: EventHandler): Element
         * callback EventHandler(event: Event, $w: Function): void
         * @summary Adds an event handler that runs when the element loses focus.
         * @description
         *  An element loses focus (blurs) through user actions,
         *  such as clicking and tabbing, or programmatically, using the
         *  [blur( )](#blur) function.
         *
         * @note `onBlur()` has no effect when applied to [RadioButtonGroup]($w.RadioButtonGroup.html) elements.
         * @param {$w.EventHandler} handler The name of the function or
         *  the function expression to run when the element losed focus.
         * @returns {$w.Element} The element on which the event is now registered.
         * @snippet [FocusMixin-onBlur.es6=Get the ID of the element that has lost focus]
         * @see [blur( )](#blur)
         * @see [onFocus( )](#onFocus)
         * @see [focus( )](#focus)
         * @memberof $w.FocusMixin
         * @eventtype blur
         * @eventhandler
         */

    }, {
        key: 'onBlur',
        value: function onBlur(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'onBlur', { onBlur: cb })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().BLUR, controllerId, cb);
            return this;
        }
    }]);

    return FocusMixin;
}();

exports.default = FocusMixin;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _ValidatableMixin = __webpack_require__(282);

var _ValidatableMixin2 = _interopRequireDefault(_ValidatableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _valueSanitzationAlgorithm = __webpack_require__(54);

var _valueSanitzationAlgorithm2 = _interopRequireDefault(_valueSanitzationAlgorithm);

var _validation = __webpack_require__(1);

var _validationsService = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @mixin FormElement
 * @summary Provides functionality related to user input elements.
 * @mixes $w.Element
 * @mixes $w.ValidatableMixin
 * @memberof $w
 */
var FormElement = function (_Element) {
    _inherits(FormElement, _Element);

    function FormElement(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, FormElement);

        var _this = _possibleConstructorReturn(this, (FormElement.__proto__ || Object.getPrototypeOf(FormElement)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(FormElement.prototype, _ValidatableMixin2.default.prototype);
        return _this;
    }

    // PROPERTIES:

    /**
     * @member value
     * @label property
     * @syntax
     * get value(): string
     * set value(value: string): void
     * @summary Sets or gets an element's value.
     * @description
     *  To reset the form element's value, set the `value` property to `null` or
     *  `undefined`.
     *
     * @note
     *  If an element is connected to a dataset, setting the element's `value`
     *  in code does not set the value of the connected field in the dataset.
     *  That means if you use the dataset to perform a submit, the value changed
     *  in code is not reflected in the submitted item.
     *
     *  To submit the new value using a dataset, set the field's value using the
     *  [`setFieldValue()`](wix-dataset.html#setFieldValue) function before
     *  performing the submit.
     * @snippet [FormElement-value_get.es6=Get an element's value]
     * @snippet [FormElement-value_set.es6=Set an element's value]
     * @type {external:String}
     * @memberof $w.FormElement
     */


    _createClass(FormElement, [{
        key: 'onChange',


        // METHODS:

        /**
         * @function onChange
         * @syntax
         * function onChange(handler: EventHandler): Element
         * callback EventHandler(event: Event, $w: Function): void
         * @summary Adds an event handler that runs when an input element's value
         *  is changed.
         * @description
         *  An element receives a `change` event when a user changes the value
         *  in an input element.
         *
         *  A `change` event is not triggered when you change an element's value using
         *  the element's [`value`](#value) property.
         * @param {$w.EventHandler} handler The name of the function or
         *  the function expression to run when the element's value changes.
         * @returns {$w.Element} The element on which the event is now registered.
         * @snippet [FormElement-onChange.es6=Get the value of the element that was changed]
         * @memberof $w.FormElement
         * @eventtype change
         * @eventhandler
         */
        value: function onChange(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'onChange', { onChange: cb })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().CHANGE, controllerId, cb);
            return this;
        }
    }, {
        key: 'value',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getData(compId).value;
        }

        /**
         * @param {external:String} val The input element's new value.
         * @ignore
         */
        ,
        set: function set(val) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getFullDataWithOverrides(compId);
            var compType = members._type.get(this).compType;
            var value = (0, _valueSanitzationAlgorithm2.default)(compData, val);
            var isValid = (0, _validation.validate)(compType, 'value', { value: value });

            if (!isValid) {
                return;
            }

            (0, _validationsService.runValidationsAfterChange)(RMI, compId, value);
            RMI.setData(compId, { value: value });
        }
    }]);

    return FormElement;
}(_Element3.default);

exports.default = FormElement;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__(297),
    baseEvery = __webpack_require__(304),
    baseIteratee = __webpack_require__(16),
    isArray = __webpack_require__(6),
    isIterateeCall = __webpack_require__(80);

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(21),
    isArray = __webpack_require__(6),
    isObjectLike = __webpack_require__(17);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(161);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.valueValidatableClearance = exports.valueValidatableInitialize = undefined;

var _validationsService = __webpack_require__(15);

var validationsEventHandler = function validationsEventHandler(RMI) {
    return function (e) {
        var value = e.target.value;
        var compId = e.syntheticEvent.id;

        (0, _validationsService.runValidationsAfterChange)(RMI, compId, value);
    };
};

var updateValidationState = function updateValidationState(RMI, compId) {
    return (0, _validationsService.runValidations)(RMI, compId);
};

var valueValidatableInitialize = function valueValidatableInitialize(RMI, contextId, compId) {
    RMI.registerEvent(contextId, compId, RMI.getEventTypes().CHANGE, null, validationsEventHandler(RMI));
    updateValidationState(RMI, compId);
};

var valueValidatableClearance = function valueValidatableClearance(RMI, contextId, compId) {
    return (0, _validationsService.clearValidations)(compId);
};

exports.valueValidatableInitialize = valueValidatableInitialize;
exports.valueValidatableClearance = valueValidatableClearance;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _defaults = __webpack_require__(60);

var _defaults2 = _interopRequireDefault(_defaults);

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _omitBy = __webpack_require__(193);

var _omitBy2 = _interopRequireDefault(_omitBy);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _isUndefined = __webpack_require__(30);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _urlUtils = __webpack_require__(24);

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(12);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _linkGenerator = __webpack_require__(65);

var _linkGenerator2 = _interopRequireDefault(_linkGenerator);

var _validation = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEPRECATED_MEDIA_SRC_REGEX = /^image:\/\/v1\/([^\/]+)\/([0-9]+)_([0-9]+)\/(.*)/;
var MEDIA_SRC_REGEX = /^wix:image:\/\/v1\/([^\/]+)\/([^\/]+)#originWidth=([0-9]+)&originHeight=([0-9]+)(.*)/;

function buildFullUrl(src, width, height, title) {
    if (MEDIA_SRC_REGEX.test(src) || DEPRECATED_MEDIA_SRC_REGEX.test(src)) {
        return src;
    }
    return buildFullUrlFromUri(src, width, height, title);
}

function isValidImage(src) {
    return MEDIA_SRC_REGEX.test(src) || DEPRECATED_MEDIA_SRC_REGEX.test(src) || (0, _validation.validateByType)(src, _validation.TYPES.URL);
}

function extractModelDataFromSrc(src) {
    if (MEDIA_SRC_REGEX.test(src)) {
        var _ref = src.match(MEDIA_SRC_REGEX) || [0, src],
            _ref2 = _slicedToArray(_ref, 5),
            uri = _ref2[1],
            filename = _ref2[2],
            width = _ref2[3],
            height = _ref2[4];

        var title = convertFilenameToTitle(filename);
        return { uri: uri, width: parseInt(width, 10), height: parseInt(height, 10), title: title };
    }

    if (DEPRECATED_MEDIA_SRC_REGEX.test(src)) {
        var _ref3 = src.match(DEPRECATED_MEDIA_SRC_REGEX) || [0, src],
            _ref4 = _slicedToArray(_ref3, 5),
            _uri = _ref4[1],
            _width = _ref4[2],
            _height = _ref4[3],
            _title = _ref4[4];

        return { uri: _uri, width: parseInt(_width, 10), height: parseInt(_height, 10), title: _title };
    }

    if ((0, _validation.validateByType)(src, _validation.TYPES.URL)) {
        return { uri: src };
    }

    return null;
}

function buildFullUrlFromMediaRef(mediaRef) {
    return buildFullUrlFromUri(mediaRef.uri, mediaRef.width, mediaRef.height, mediaRef.title);
}

function convertFilenameToTitle(filename) {
    var decodedFilename = decodeURI(filename);
    return decodedFilename.startsWith('_.') ? '' : decodedFilename;
}

function convertTitleToFilename(title, extension) {
    if (!title) {
        return '_.' + extension;
    }

    var titleHasExtension = title.split('.').length === 2;

    if (!titleHasExtension) {
        return title + '.' + extension;
    }

    return title;
}

function convertImageToModelFormatAndReportIfError(src, propertyName, functionName, index) {
    var imageData = extractModelDataFromSrc(src);
    (0, _assign2.default)(imageData, { type: 'Image' });
    if (!imageData) {
        var error = !(0, _isNil2.default)(index) ? _errors.generateError.error_bad_image_format_with_index : _errors.generateError.error_bad_image_format;
        _reporter2.default.reportSdkError(error({
            propertyName: propertyName,
            functionName: functionName,
            index: index,
            wrongValue: src
        }));
        return null;
    }
    return imageData;
}

function buildFullUrlFromUri(uri, width, height, title) {
    if (!uri) {
        return null;
    }

    if ((0, _urlUtils.isExternalUrl)(uri)) {
        return uri;
    }

    var extension = uri.split('.').pop();
    var filename = encodeURI(convertTitleToFilename(title, extension));

    if (!isNaN(height) && !isNaN(width)) {
        return 'wix:image://v1/' + uri + '/' + filename + '#originWidth=' + width + '&originHeight=' + height;
    }

    return uri;
}

function convertModelToUserFormat(imageData) {
    var height = (0, _isUndefined2.default)(imageData.height) ? imageData.height : Number(imageData.height);
    var width = (0, _isUndefined2.default)(imageData.width) ? imageData.width : Number(imageData.width);
    var title = imageData.title;
    var src = buildFullUrl(imageData.uri || imageData.src, width, height, title);
    var result = (0, _omitBy2.default)({
        description: imageData.description,
        alt: imageData.alt,
        title: title,
        height: height,
        width: width,
        link: _linkGenerator2.default.convertLinkToUrlAndReportIfError(imageData.link, imageData.target, 'items'),
        target: (0, _get2.default)(imageData, 'link.target')
    }, _isUndefined2.default);

    result.src = src;

    return result;
}

function convertUserToModelFormat(imageData, imageIndex) {
    var uri = imageData.uri || imageData.src;
    var dataFromSrc = {};

    if ((0, _isNil2.default)(uri)) {
        dataFromSrc.uri = uri;
    } else {
        dataFromSrc = convertImageToModelFormatAndReportIfError(uri, 'src', 'items', imageIndex);
        if (!dataFromSrc) {
            dataFromSrc = { uri: '' };
        }
    }

    var result = (0, _omitBy2.default)((0, _defaults2.default)({
        type: 'Image',
        description: imageData.description,
        title: imageData.title,
        alt: imageData.alt,
        id: imageData.id,
        link: _linkGenerator2.default.convertLinkToModelFormatAndReportIfError(imageData.link, imageData.target, 'items', imageIndex),
        width: imageData.width,
        height: imageData.height
    }, dataFromSrc), _isUndefined2.default);

    result.uri = dataFromSrc.uri;

    return result;
}

function checkImageValidation(imageData, imageIndex) {
    var imageType = 'Image';
    return (0, _validation.validate)(imageType, 'items', imageData, true, imageIndex);
}

exports.default = {
    isValidImage: isValidImage,
    buildFullUrl: buildFullUrl,
    buildFullUrlFromMediaRef: buildFullUrlFromMediaRef,
    extractModelDataFromSrc: extractModelDataFromSrc,
    buildFullUrlFromUri: buildFullUrlFromUri,
    checkImageValidation: checkImageValidation,
    convertImageToModelFormatAndReportIfError: convertImageToModelFormatAndReportIfError,
    dataFormat: {
        toUser: convertModelToUserFormat,
        toModel: convertUserToModelFormat
    }
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @callback $w.EventHandler
 * @description Handles events.
 * @param {$w.Event} event The event that occurred.
 * @param {$w.$w} $w A selector function. The $w function enables event handlers
 *  to work with elements in [repeaters]($w.Repeater.html#repeating-callback-selector)
 *  and in the [global scope]($w.Repeater.html#regular-callback-selector).
 */

/**
 * @class Event
 * @summary Events are fired when certain actions occur to elements.
 * @description
 *  Events can be caused by user interactions, such as clicking the mouse or
 *  pressing a key, or generated programmatically, such as hiding or showing an
 *  element using the [hide()]($w.HiddenMixin.html#hide) and
 *  [show()]($w.HiddenMixin.html#hide) functions.
 * @memberof $w
 */
var WixEvent = function WixEvent(target, event) {
  _classCallCheck(this, WixEvent);

  this.target = target;
  this.type = (0, _get2.default)(event, 'action') || (0, _get2.default)(event, 'type');
  this.syntheticEvent = event;

  var context = (0, _get2.default)(event, 'context');
  if (context) {
    this.context = context;
  }
}

/**
 * @member {$w.Element} target
 * @label property
 * @syntax
 * get target(): string
 * @summary Gets the element that the event was fired on.
 * @note
 *  When using the target to get the `value` of a text input or text box in an [`onKeyPress`]($w.TextInputMixin.html#onKeyPress)
 *  event handler, you may receive the value of the element before the key
 *  was pressed. To get the text input or text box's updated value, use the [`updatedTargetValue`]($w.KeyboardEvent.html#updatedTargetValue)
 *  property of the event handler's `event` parameter.
 * @snippet [Event-target.es6=Get the ID of the target element]
 * @memberof $w.Event
 * @readonly
 */

/**
 * @member {external:String} type
 * @label property
 * @syntax
 * get type(): string
 * @summary Gets the type of event that was fired.
 * @snippet [Event-type.es6=Get the type of the event]
 * @memberof $w.Event
 * @readonly
 */

/**
 * @member {external:Object} context
 * @label property
 * @syntax
 * get context(): Object
 * @summary Gets the context of the event on a repeated element.
 * @description
 *  The context property only appears in events on repeated elements.
 *
 *  It contains an object with one key:value pair. The key is "itemId" and
 *  the value is the ID of the repeated item on which the event occurred.
 * @snippet [Event-context.es6=Get the context of the event]
 * @memberof $w.Event
 * @readonly
 */

;

exports.default = WixEvent;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Utils = __webpack_require__(25);

var Utils = _interopRequireWildcard(_Utils);

var _validation = __webpack_require__(1);

var _validationsService = __webpack_require__(15);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin RequiredMixin
 * @summary Provides functionality for input elements can be required to have a value.
 * @memberof $w
 */
var RequiredMixin = function () {
    function RequiredMixin() {
        _classCallCheck(this, RequiredMixin);
    }

    _createClass(RequiredMixin, [{
        key: 'required',


        /**
         * @member required
         * @label property
         * @syntax
         * get required(): boolean
         * set required(value: boolean): void
         * @summary Sets or gets whether an input element is required to have a value.
         * @description
         *  Setting the `required` property to `true` causes the
         *  element to be [invalid]($w.ValidatableMixin.html#.validity) if it
         *  doesn't contain a value. Setting it to false allows the element to be
         *  valid even if it doesn't contain a value. The validity of the element
         *  can be checked using it's [`validity`]($w.ValidatableMixin.html#.validity)
         *  property.
         *
         *  Getting the value of the `required` property returns whether the element
         *  is required.
         *
         *  You can also set an input element to be required
         *  by using the element's Settings pane in the Editor.
         * @snippet [RequiredMixin-required_set.es6=Set an element to be required]
         * @snippet [RequiredMixin-required_get.es6=Get whether an element is required]
         * @type {external:Boolean}
         * @see [validity]($w.ValidatableMixin.html#validity)
         * @memberof $w.RequiredMixin
         * @attr {external:Boolean}
         */
        get: function get() {
            return Utils.getProp(this, 'required') || false;
        }

        /**
         * @param {external:Boolean} required
         * @ignore
         */
        ,
        set: function set(required) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'required', { required: required })) {
                return;
            }
            Utils.setProp(this, { required: required });
            (0, _validationsService.runValidationsAndSyncAfterChange)(RMI, compId);
        }
    }]);

    return RequiredMixin;
}();

exports.default = RequiredMixin;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(108),
    createBaseEach = __webpack_require__(342);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(86),
    overRest = __webpack_require__(181),
    setToString = __webpack_require__(183);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(70),
    baseAssignValue = __webpack_require__(72);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(315),
    getValue = __webpack_require__(354);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(103),
    baseEach = __webpack_require__(42),
    castFunction = __webpack_require__(330),
    isArray = __webpack_require__(6);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(162);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StyleProperties = exports.SUPPORTED_STYLES = undefined;

var _BackgroundColorMixin = __webpack_require__(283);

var _BackgroundColorMixin2 = _interopRequireDefault(_BackgroundColorMixin);

var _BorderWidthMixin = __webpack_require__(286);

var _BorderWidthMixin2 = _interopRequireDefault(_BorderWidthMixin);

var _BorderColorMixin = __webpack_require__(284);

var _BorderColorMixin2 = _interopRequireDefault(_BorderColorMixin);

var _BorderRadiusMixin = __webpack_require__(285);

var _BorderRadiusMixin2 = _interopRequireDefault(_BorderRadiusMixin);

var _TextColorMixin = __webpack_require__(287);

var _TextColorMixin2 = _interopRequireDefault(_TextColorMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SUPPORTED_STYLES = {
    Button: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype, _BorderWidthMixin2.default.prototype, _BorderRadiusMixin2.default.prototype, _TextColorMixin2.default.prototype],
    Box: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype, _BorderWidthMixin2.default.prototype],
    Checkbox: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype, _BorderWidthMixin2.default.prototype, _BorderRadiusMixin2.default.prototype],
    UploadButton: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype, _BorderWidthMixin2.default.prototype, _BorderRadiusMixin2.default.prototype, _TextColorMixin2.default.prototype],
    TextInput: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype, _BorderWidthMixin2.default.prototype, _BorderRadiusMixin2.default.prototype, _TextColorMixin2.default.prototype],
    TextBox: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype, _BorderWidthMixin2.default.prototype, _BorderRadiusMixin2.default.prototype, _TextColorMixin2.default.prototype],
    Shape: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype, _BorderWidthMixin2.default.prototype],
    RadioButtonGroup: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype, _BorderWidthMixin2.default.prototype, _BorderRadiusMixin2.default.prototype, _TextColorMixin2.default.prototype],
    Header: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype],
    Footer: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype],
    Dropdown: [_BackgroundColorMixin2.default.prototype, _BorderColorMixin2.default.prototype, _BorderWidthMixin2.default.prototype, _BorderRadiusMixin2.default.prototype, _TextColorMixin2.default.prototype]
};

var StyleProperties = {
    BORDER_RADIUS: 'borderRadius',
    BORDER_WIDTH: 'borderWidth',
    BORDER_COLOR: 'borderColor',
    BACKGROUND_COLOR: 'backgroundColor',
    COLOR: 'color'
};

exports.SUPPORTED_STYLES = SUPPORTED_STYLES;
exports.StyleProperties = StyleProperties;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _mediaUtils = __webpack_require__(133);

var _mediaUtils2 = _interopRequireDefault(_mediaUtils);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _get2 = __webpack_require__(3);

var _get3 = _interopRequireDefault(_get2);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _validation = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function mergedCompDesign(compDesign, mediaData) {
    return (0, _assign2.default)({}, compDesign, {
        type: 'MediaContainerDesignData',
        background: (0, _assign2.default)({}, compDesign.background, {
            mediaRef: mediaData,
            type: 'BackgroundMedia'
        })
    });
}

/**
 * @class Background
 * @summary Provides functionality for background images in certain elements.
 * @memberof $w
 */

var Background = function (_Element) {
    _inherits(Background, _Element);

    function Background() {
        _classCallCheck(this, Background);

        return _possibleConstructorReturn(this, (Background.__proto__ || Object.getPrototypeOf(Background)).apply(this, arguments));
    }

    _createClass(Background, [{
        key: 'background',


        /**
         * @typedef $w.Background~BackgroundOptions
         * @summary An object used by the `background` property that contains the background options.
         * @description
         *  Setting the `src` property of the `BackgroundOptions` object changes the
         *  displayed image or video to the image or video found at the new `src` value.
         *
         *  Getting the `src` property of the `BackgroundOptions` object returns the
         *  location of the current image or video file.
         *
         *  Images can either be from the <a href="https://support.wix.com/en/article/about-the-media-manager" target="_blank">Media Manager</a>
         *  or an external image from any web location. Videos must come from the
         *  <a href="https://support.wix.com/en/article/about-the-media-manager" target="_blank">Media Manager</a>.
         *
         *  The URL formats supported are:
         *  + Images from the Media Manager:
         *    `wix:image://v1/<uri>/<filename>/#originWidth=<width>&originHeight=<height>[&watermark=<watermark_manifest_string>]`
         *  + Videos from the Media Manager:
         *    `wix:video://v1/<video_uri>/<filename>/#posterUri=<poster_uri>&posterWidth=<width>&posterHeight=<height>`
         *  + Vector images from the Media Manager:
         *    `wix:vector://v1/<vector_uri>/<filename>`
         *  + Images from the web:
         *    `http(s)://<image url>`
         * @property {external:String} src The file location of the background image or video.
         * @snippet [Background-background_get.es6=Get the background information]
         * @snippet [Background-background_set_wix.es6=Set the background image to be an image from the Media Manager]
         * @snippet [Background-background_set_web.es6=Set the background image to be an image from the web]
         * @see [background](#background)
         */

        /**
         * @member background
         * @label property
         * @syntax
         * get background(): BackgroundOptions
         * @summary Gets an object containing information about the element's background.
         * @snippet [Background-background_get.es6=Get the background information]
         * @snippet [Background-background_set_wix.es6=Set the background image to be an image from the Media Manager]
         * @snippet [Background-background_set_web.es6=Set the background image to be an image from the web]
         * @type {$w.Background~BackgroundOptions}
         * @memberof $w.Background
         * @readonly
         */
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var type = members._type.get(this);
            return new BackgroundOptions(RMI, compId, type);
        }
    }]);

    return Background;
}(_Element3.default);

exports.default = Background;

var BackgroundOptions = function () {
    function BackgroundOptions(RMI, compId, type) {
        _classCallCheck(this, BackgroundOptions);

        members._RMI.set(this, RMI);
        members._compId.set(this, compId);
        members._type.set(this, type);
    }

    _createClass(BackgroundOptions, [{
        key: 'src',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var mediaRef = (0, _get3.default)(RMI.getDesign(compId), 'background.mediaRef') || {};

            return _mediaUtils2.default.buildFullUrlFromMediaRef(mediaRef);
        },
        set: function set(value) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'src', { src: value })) {
                return;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compDesign = RMI.getDesign(compId) || {};

            if ((0, _isNil2.default)(value)) {
                RMI.setDesign(compId, mergedCompDesign(compDesign, null));
                return;
            }

            var currentMediaRef = (0, _get3.default)(compDesign, 'background.mediaRef');
            var mediaData = _mediaUtils2.default.getMediaDataFromSrc(value);
            if (!mediaData) {
                return;
            }
            if (currentMediaRef && currentMediaRef.opacity) {
                (0, _assign2.default)(mediaData, { opacity: currentMediaRef.opacity });
            }

            _mediaUtils2.default.getFullMediaData(mediaData, function (fullMediaRefData) {
                if (!fullMediaRefData) {
                    return;
                }
                /*setDesignAsync with all media data*/
                var updatedCompDesign = RMI.getDesign(compId) || {};
                (0, _assign2.default)(updatedCompDesign.background.mediaRef, fullMediaRefData);
                RMI.setDesign(compId, updatedCompDesign);
            });
            RMI.setDesign(compId, mergedCompDesign(compDesign, mediaData));
        }
    }]);

    return BackgroundOptions;
}();

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(19);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(6),
    isKey = __webpack_require__(116),
    stringToPath = __webpack_require__(397),
    toString = __webpack_require__(47);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(88);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(156),
    isArrayLike = __webpack_require__(22),
    isString = __webpack_require__(36),
    toInteger = __webpack_require__(90),
    values = __webpack_require__(200);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ELEMENT_TYPES$TEXT_I, _ELEMENT_TYPE_TO_SANI;

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _flow = __webpack_require__(118);

var _flow2 = _interopRequireDefault(_flow);

var _isFinite = __webpack_require__(189);

var _isFinite2 = _interopRequireDefault(_isFinite);

var _isString = __webpack_require__(36);

var _isString2 = _interopRequireDefault(_isString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SANITIZE_TYPES = {
    'TEXT_INPUT_TEXT': 'TEXT_INPUT_TEXT',
    'TEXT_INPUT_PASSWORD': 'TEXT_INPUT_PASSWORD',
    'TEXT_INPUT_NUMBER': 'TEXT_INPUT_NUMBER',
    'TEXT_INPUT_EMAIL': 'TEXT_INPUT_EMAIL',
    'TEXT_INPUT_URL': 'TEXT_INPUT_URL',
    'TEXT_INPUT_TEL': 'TEXT_INPUT_TEL',
    'TEXT_AREA': 'TEXT_AREA',
    'SELECT_INPUT': 'SELECT_INPUT',
    'RADIO_GROUP': 'RADIO_GROUP',
    'CHECKBOX': 'CHECKBOX'
};
var ELEMENT_TYPES = {
    TEXT_INPUT: 'TextInput',
    TEXT_AREA: 'TextAreaInput',
    SELECT_INPUT: 'SelectableList',
    RADIO_GROUP: 'RadioGroup',
    CHECKBOX: 'CheckboxInput'
};
var TEXT_INPUT_TYPES = {
    TEXT: 'text',
    PASSWORD: 'password',
    NUMBER: 'number',
    EMAIL: 'email',
    URL: 'url',
    TEL: 'tel'
};
var ELEMENT_TYPE_TO_SANITIZE_TYPE = (_ELEMENT_TYPE_TO_SANI = {}, _defineProperty(_ELEMENT_TYPE_TO_SANI, ELEMENT_TYPES.TEXT_INPUT, (_ELEMENT_TYPES$TEXT_I = {}, _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.TEXT, SANITIZE_TYPES.TEXT_INPUT_TEXT), _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.PASSWORD, SANITIZE_TYPES.TEXT_INPUT_PASSWORD), _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.NUMBER, SANITIZE_TYPES.TEXT_INPUT_NUMBER), _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.EMAIL, SANITIZE_TYPES.TEXT_INPUT_EMAIL), _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.URL, SANITIZE_TYPES.TEXT_INPUT_URL), _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.TEL, SANITIZE_TYPES.TEXT_INPUT_TEL), _ELEMENT_TYPES$TEXT_I)), _defineProperty(_ELEMENT_TYPE_TO_SANI, ELEMENT_TYPES.TEXT_AREA, SANITIZE_TYPES.TEXT_AREA), _defineProperty(_ELEMENT_TYPE_TO_SANI, ELEMENT_TYPES.SELECT_INPUT, SANITIZE_TYPES.SELECT_INPUT), _defineProperty(_ELEMENT_TYPE_TO_SANI, ELEMENT_TYPES.RADIO_GROUP, SANITIZE_TYPES.RADIO_GROUP), _defineProperty(_ELEMENT_TYPE_TO_SANI, ELEMENT_TYPES.CHECKBOX, SANITIZE_TYPES.CHECKBOX), _ELEMENT_TYPE_TO_SANI);

var validFloatingPointNumberRegExp = /^-?(\d+|\d+\.\d+|\.\d+)([eE][-+]?\d+)?$/;

var numberToString = function numberToString(value) {
    return (0, _isFinite2.default)(value) ? value.toString() : value;
};
var emptyStringIfNotString = function emptyStringIfNotString(value) {
    return (0, _isString2.default)(value) ? value : '';
};
var removeLineBreaks = function removeLineBreaks(value) {
    return value.replace(/(\r\n|\n|\r)/gm, "");
};
var removeLeadingAndTrailingWhitespace = function removeLeadingAndTrailingWhitespace(value) {
    return value.trim();
};
var validFloatingPointNumber = function validFloatingPointNumber(value) {
    return validFloatingPointNumberRegExp.test(value) ? value : '';
};
var forceMaxLength = function forceMaxLength(compData) {
    return function (value) {
        var maxLength = (0, _get2.default)(compData, 'maxLength', null);

        return maxLength ? value.substr(0, maxLength) : value;
    };
};

var getSanitizerByType = function getSanitizerByType(sanitizeType, compData) {
    switch (sanitizeType) {
        case SANITIZE_TYPES.TEXT_INPUT_TEXT:
            return (0, _flow2.default)([numberToString, emptyStringIfNotString, removeLineBreaks, forceMaxLength(compData)]);
        case SANITIZE_TYPES.TEXT_INPUT_PASSWORD:
            return (0, _flow2.default)([numberToString, emptyStringIfNotString, removeLineBreaks, forceMaxLength(compData)]);
        case SANITIZE_TYPES.TEXT_INPUT_NUMBER:
            return (0, _flow2.default)([numberToString, emptyStringIfNotString, validFloatingPointNumber]);
        case SANITIZE_TYPES.TEXT_INPUT_EMAIL:
            return (0, _flow2.default)([numberToString, emptyStringIfNotString, removeLineBreaks, removeLeadingAndTrailingWhitespace]);
        case SANITIZE_TYPES.TEXT_INPUT_URL:
            return (0, _flow2.default)([numberToString, emptyStringIfNotString, removeLineBreaks, removeLeadingAndTrailingWhitespace]);
        case SANITIZE_TYPES.TEXT_INPUT_TEL:
            return (0, _flow2.default)([numberToString, emptyStringIfNotString, removeLineBreaks]);
        case SANITIZE_TYPES.TEXT_AREA:
            return (0, _flow2.default)([numberToString, emptyStringIfNotString, forceMaxLength(compData)]);
        case SANITIZE_TYPES.SELECT_INPUT:
            return (0, _flow2.default)([numberToString, emptyStringIfNotString]);
        case SANITIZE_TYPES.RADIO_GROUP:
            return (0, _flow2.default)([numberToString, emptyStringIfNotString]);
        case SANITIZE_TYPES.CHECKBOX:
            return (0, _flow2.default)([numberToString, emptyStringIfNotString]);
        default:
            return function (value) {
                return value;
            };
    }
};

var getSanitizer = function getSanitizer(compData) {
    var elementType = compData.type;

    if (elementType === ELEMENT_TYPES.TEXT_INPUT) {
        elementType += '.' + compData.textType;
    }

    var sanitizeType = (0, _get2.default)(ELEMENT_TYPE_TO_SANITIZE_TYPE, elementType);

    return getSanitizerByType(sanitizeType, compData);
};

var valueSanitzationAlgorithm = function valueSanitzationAlgorithm(compData, value) {
    var sanitizer = getSanitizer(compData);

    return sanitizer(value);
};

exports.default = valueSanitzationAlgorithm;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _endsWith = __webpack_require__(406);

var _endsWith2 = _interopRequireDefault(_endsWith);

var _parseInt = __webpack_require__(417);

var _parseInt2 = _interopRequireDefault(_parseInt);

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _isString = __webpack_require__(36);

var _isString2 = _interopRequireDefault(_isString);

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(12);

var _colorKeywords = __webpack_require__(207);

var _colorKeywords2 = _interopRequireDefault(_colorKeywords);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var colorTypes = {
    RGBA: {
        type: 'rgbaColor',
        isValid: isValidRgbOrRgba,
        exampleFormats: '"red", "#FF0000", "#FF000000", "rgb(225, 0, 0)" or "rgba(225, 0, 0, 0)"',
        link: 'http://rgba.com'
    },
    RGB: {
        type: 'rgbColor',
        isValid: isValidRgb,
        exampleFormats: '"red", "#FF0000", or "rgb(225, 0, 0)"',
        link: 'http://rgb.com'
    }
};

var HexadecimalLengths = {
    HEXA: { LONG: 9, SHORT: 5 },
    HEX: { LONG: 7, SHORT: 4 }
};

function extractNumericalValues(string) {
    return string.replace(/[^\d,]/g, '').split(',');
}

function isHexColor(colorToValidate) {
    var validHexColor = /^#(([0-9|a-f|A-F]){3}){1,2}$/;
    return validHexColor.test(colorToValidate);
}

function isHexaColor(colorToValidate) {
    var validHexaColor = /^#([a-f0-9]{8}|[a-f0-9]{4})\b$/gi;
    return validHexaColor.test(colorToValidate);
}

function isRgbaColor(colorToValidate) {
    /*from : https://eddyerburgh.me/validate-rgb-or-rgba-value-in-javascript*/
    var rxValidRgba = /\b([R][G][B][A][(]\s*([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])\s*,\s*([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])\s*,\s*([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])(\s*,\s*((0\.[0-9]{1})|(1\.0)|(1)|(0)))?[)])/i;
    return rxValidRgba.test(colorToValidate);
}

function isRgbColor(colorToValidate) {
    var rxValidRgb = /\b([R][G][B][(]\s*([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])\s*,\s*([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])\s*,\s*([01]?[0-9]?[0-9]|2[0-4][0-9]|25[0-5])(\s*)[)])/i;
    return rxValidRgb.test(colorToValidate);
}

function isKeyword(colorToValidate) {
    return (0, _get2.default)(_colorKeywords2.default, colorToValidate);
}

function isValidRgbOrRgba(colorToValidate) {
    return isValidRgba(colorToValidate) || isValidRgb(colorToValidate);
}

function isValidRgba(colorToValidate) {
    return isRgbaColor(colorToValidate) || isHexaColor(colorToValidate);
}

function isValidRgb(colorToValidate) {
    return isRgbColor(colorToValidate) || isHexColor(colorToValidate) || isKeyword(colorToValidate);
}

function rgbaToRgbCast(color) {
    if (isHexaColor(color)) {
        if (color.length === HexadecimalLengths.HEXA.LONG) {
            return color.slice(0, HexadecimalLengths.HEX.LONG);
        }

        if (color.length === HexadecimalLengths.HEXA.SHORT) {
            return color.slice(0, HexadecimalLengths.HEX.SHORT);
        }
    }

    if (isRgbaColor(color)) {
        var _extractNumericalValu = extractNumericalValues(color),
            _extractNumericalValu2 = _slicedToArray(_extractNumericalValu, 3),
            red = _extractNumericalValu2[0],
            green = _extractNumericalValu2[1],
            blue = _extractNumericalValu2[2];

        return 'rgb(' + red + ', ' + green + ', ' + blue + ')';
    }
}

function validateColorAndPerformCastingIfNecessary(colorToValidate, opacitySupport, propertyName, compNickname) {
    var colorType = opacitySupport ? colorTypes.RGBA : colorTypes.RGB;
    if (colorType.isValid(colorToValidate)) {
        return colorToValidate;
    }

    if (!opacitySupport && isValidRgba(colorToValidate)) {
        _reporter2.default.reportSdkWarning(_errors.generateError.warning_color_casting_performed({
            propertyName: propertyName,
            compNickname: compNickname
        }));
        return rgbaToRgbCast(colorToValidate);
    }

    _reporter2.default.reportSdkError(_errors.generateError.error_invalid_css_value_multiple_expected_formats({
        propertyName: propertyName,
        compNickname: compNickname,
        cssProperty: colorType.type,
        exampleFormats: colorType.exampleFormats,
        infoLink: colorType.link
    }));
    return false;
}

function validatePixel(value, propertyName, compNickname, cssProperty) {
    var res = false;

    if ((0, _isString2.default)(value)) {
        var endsWithPx = (0, _endsWith2.default)(value, 'px');
        var integerToValidate = value.slice(0, value.length - 2);
        var containsOnlyNumbers = /^\d*$/.test(integerToValidate);
        res = endsWithPx && containsOnlyNumbers && (0, _parseInt2.default)(integerToValidate);
    }

    if (!res) {
        _reporter2.default.reportSdkError(_errors.generateError.error_invalid_css_value({
            propertyName: propertyName,
            compNickname: compNickname,
            cssProperty: cssProperty,
            exampleFormat: '1px',
            infoLink: 'http://'
        }));
    }

    return res;
}

module.exports = {
    validateColorAndPerformCastingIfNecessary: validateColorAndPerformCastingIfNecessary,
    validatePixel: validatePixel
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _platformUtils = __webpack_require__(13);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _clone = __webpack_require__(83);

var _clone2 = _interopRequireDefault(_clone);

var _isPlainObject = __webpack_require__(123);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* TURNED OFF JSDOC FOR THIS BLOCK; I DON'T THINK THIS IS BEING USED IN THE SDK:
 * @typedef $w.Link
 * @summary An object that describes the link set on linkable items.
 * @description In the Wix Platform, a link can be a link to a site page, a document, an email, or an external web page.
 * @property {$w.LinkType} type The type of link
 * @property {external:String} [pageId] The ID of the page to link to if the `LinkType` is `PAGE`
 * @property {external:String} [url] The URL to link to if the `LinkType` is `EXTERNAL`
 * @property {external:String} [target] The target of the link, either `_blank` or `_self`
 * @property {external:String} [emailAddress] The email address to open if the `LinkType` is `EMAIL`
 * @property {external:String} [emailSubject] The subject of the email if the `LinkType` is `EMAIL`
 * @property {external:String} [documentUrl] The URL of the document to link to if the `LinkType` is `DOCUMENT`. The document must be hosted on Wix.
 */

var Link = function () {
    function _formatLinkItem(linkItem) {
        var linkUtils = _platformUtils2.default.getLinkUtils();
        var formattedLinkItem = (0, _clone2.default)(linkItem);
        if (formattedLinkItem.anchorDataId) {
            formattedLinkItem.anchorDataId = linkUtils.getAnchorDataId(formattedLinkItem);
        }
        if (formattedLinkItem.pageId) {
            formattedLinkItem.pageId = linkUtils.getPageId(formattedLinkItem);
        }
        return formattedLinkItem;
    }

    function _extractAnchorName(linkItem) {
        var formattedLinkItem = (0, _clone2.default)(linkItem);
        if ((0, _isPlainObject2.default)(linkItem.anchorDataId)) {
            var RMI = _platformUtils2.default.getRMI('Link');
            var anchorCompId = linkItem.anchorDataId.compId;
            var anchorComp = RMI.getComp(anchorCompId);
            formattedLinkItem.anchorDataId = anchorComp ? anchorComp.id : linkItem.anchorDataId.id;
        }
        return formattedLinkItem;
    }

    function LinkFromString(value, target) {
        var siteStructure = _platformUtils2.default.getRMI().getSiteStructure();
        this._linkObject = _platformUtils2.default.getLinkUtils().convertUrlToLinkObject(siteStructure.prefixes, value, target, siteStructure.pages);
        this._link = value;
    }

    function LinkFromItem(linkItem) {
        if (linkItem.pageId && (0, _isPlainObject2.default)(linkItem.pageId)) {
            linkItem.pageId = '#' + linkItem.pageId.id;
        }
        var linkUtils = _platformUtils2.default.getLinkUtils();
        var updatedLinkItem = _extractAnchorName(linkItem);
        var siteStructure = _platformUtils2.default.getRMI().getSiteStructure();
        this._link = linkUtils.convertLinkObjectToUrl(siteStructure.prefixes, updatedLinkItem, siteStructure.pages);
        this._linkObject = _formatLinkItem(updatedLinkItem);
    }

    function Link(value, target) {
        switch (typeof value === 'undefined' ? 'undefined' : _typeof(value)) {
            case 'string':
                LinkFromString.call(this, value, target);
                break;
            case 'object':
                LinkFromItem.call(this, value, target);
                break;
        }
    }

    Link.prototype.getValue = function getValue() {
        return this._link;
    };

    Link.prototype.getData = function getData() {
        return this._linkObject;
    };

    return Link;
}();

exports.default = Link;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _set = __webpack_require__(37);

var _set2 = _interopRequireDefault(_set);

var _platformUtils = __webpack_require__(13);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function setStyle(styleParam, value) {
    var RMI = members._RMI.get(this);
    var compId = members._compId.get(this);
    var viewerType = members._type.get(this).viewerType;

    var style = RMI.getStyle(compId);
    var param = _platformUtils2.default.getWidgetUtils().convertStyleParamForViewerType(viewerType, styleParam);

    var updateStyle = (0, _set2.default)(style, 'style.properties.' + param, value);
    return RMI.setStyle(compId, updateStyle);
}

function getStyleParamValue(styleParam) {
    var RMI = members._RMI.get(this);
    var compId = members._compId.get(this);
    var compStyle = RMI.getStyle(compId);
    var viewerType = members._type.get(this).viewerType;
    var param = _platformUtils2.default.getWidgetUtils().convertStyleParamForViewerType(viewerType, styleParam);
    return (0, _get2.default)(compStyle, 'style.properties.' + param);
}

exports.default = {
    setStyle: setStyle, getStyleParamValue: getStyleParamValue
};

/***/ }),
/* 58 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 59 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(102),
    assignInWith = __webpack_require__(185),
    baseRest = __webpack_require__(43),
    customDefaultsAssignIn = __webpack_require__(167);

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = baseRest(function(args) {
  args.push(undefined, customDefaultsAssignIn);
  return apply(assignInWith, undefined, args);
});

module.exports = defaults;


/***/ }),
/* 61 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(344),
    findIndex = __webpack_require__(84);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(19),
    stubFalse = __webpack_require__(423);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(126)(module)))

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(34),
    baseClone = __webpack_require__(151),
    baseUnset = __webpack_require__(111),
    castPath = __webpack_require__(51),
    copyObject = __webpack_require__(44),
    customOmitClone = __webpack_require__(347),
    flatRest = __webpack_require__(113),
    getAllKeysIn = __webpack_require__(114);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Link = __webpack_require__(56);

var _Link2 = _interopRequireDefault(_Link);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _isError = __webpack_require__(120);

var _isError2 = _interopRequireDefault(_isError);

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isEmptyString(value) {
    return value === '';
}

function convertLinkToModelFormatAndReportIfError(link, target, functionName, index) {
    var convertedLink = convertLinkToObjectAndReportIfError(link, target, functionName, index);
    if (isEmptyString(convertedLink)) {
        return convertedLink;
    }

    if ((0, _isError2.default)(convertedLink) || (0, _isNil2.default)(convertedLink)) {
        return;
    }

    return convertedLink.getData();
}

function convertLinkToUrlAndReportIfError(link, target, functionName, index) {
    var convertedLink = convertLinkToObjectAndReportIfError(link, target, functionName, index);
    if (isEmptyString(convertedLink)) {
        return convertedLink;
    }

    if ((0, _isError2.default)(convertedLink) || (0, _isNil2.default)(convertedLink)) {
        return;
    }

    return convertedLink.getValue();
}

function convertLinkToObjectAndReportIfError(link, target, functionName, index) {
    if (!link) {
        return link;
    }

    try {
        return new _Link2.default(link, target);
    } catch (e) {
        var ERROR_TYPE = {
            UnsupportedLinkTypeError: 'error_unsupported_link',
            UnsupportedTargetValueError: 'error_unsupported_target'
        };

        var error = !(0, _isNil2.default)(index) ? (0, _get2.default)(_errors.generateError, ERROR_TYPE[e.name] + '_with_index') : (0, _get2.default)(_errors.generateError, ERROR_TYPE[e.name]);
        _reporter2.default.reportSdkError(error({
            functionName: functionName,
            index: index,
            wrongValue: link,
            supportedTargets: e.supportedTargets
        }));
        return e;
    }
}

exports.default = {
    convertLinkToModelFormatAndReportIfError: convertLinkToModelFormatAndReportIfError,
    convertLinkToUrlAndReportIfError: convertLinkToUrlAndReportIfError
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _postMessage = __webpack_require__(18);

var postMessage = _interopRequireWildcard(_postMessage);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _utils = __webpack_require__(9);

var _isUndefined = __webpack_require__(30);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _isNull = __webpack_require__(190);

var _isNull2 = _interopRequireDefault(_isNull);

var _isObject = __webpack_require__(14);

var _isObject2 = _interopRequireDefault(_isObject);

var _last = __webpack_require__(191);

var _last2 = _interopRequireDefault(_last);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin Node
 * @summary Provides basic functionality for all Wix objects, including objects
 *  that are not [elements]($w.Element.html).
 * @memberof $w
 */

var Node = function () {
    function Node(RMI, compId, contextId, wixSelector, controllerId, role, type, emitter) {
        _classCallCheck(this, Node);

        members._RMI.set(this, RMI);
        members._contextId.set(this, contextId);
        members._compId.set(this, compId);
        members._role.set(this, role);
        members._controllerId.set(this, controllerId);
        members._wixSelector.set(this, wixSelector);
        members._type.set(this, type);
        members._emitter.set(this, emitter);
    }

    /**
     * @member id
     * @label property
     * @syntax
     * get id(): string
     * @summary Gets the elements's ID.
     * @description
     *  The ID is the element's unique identifier. It is used when selecting
     *  elements using the [`$w()`]($w.html#w) function.
     *
     *  An element's `id` is set in the Editor using the <a href="https://support.wix.com/en/article/how-do-i-use-the-properties-panel" target="_blank">Properties panel</a>.
     * @snippet [Node-id.es6=Get the ID]
     * @type {external:String}
     * @memberof $w.Node
     * @readonly
     */


    _createClass(Node, [{
        key: 'scrollTo',


        /**
         * @function scrollTo
         * @syntax
         * function scrollTo(): Promise&lt;void&gt;
         * @summary Scrolls the page to the element using an animation.
         * @description
         *  The `scrollTo()` function returns a Promise that is resolved when the
         *  animated scroll is complete and the element is now in view.
         *
         *  To scroll to a specific location on the page, see the `wix-window`
         *  [`scrollTo()`](wix-window.html#scrollTo) function.
         *
         *  Calling the `scrollTo()` function on an element in a repeated item that
         *  is selected from the [global scope]($w.Repeater.html#global-scope) causes
         *  an error.
         * @snippet [Node-scrollTo.es6=Scroll the page to an element]
         * @snippet [Node-scrollTo_then.es6=Scroll the page to an element and log message when done]
         * @returns {Promise}
         * @fulfill {void} When the scroll is complete.
         * @memberof $w.Node
         */
        value: function scrollTo() {
            var _this = this;

            return new Promise(function (resolve, reject) {
                var compId = members._compId.get(_this);
                var RMI = members._RMI.get(_this);
                var rendered = RMI.getComp(compId).isDisplayed;
                if (rendered) {
                    postMessage.sendMessage(postMessage.Intent.WIX_CODE_SITE_API, postMessage.MessageTypes.SCROLL_TO_COMP, { compId: compId, requiresDom: { compId: compId } }, function (data, err) {
                        if (err) {
                            reject(err);
                        } else {
                            resolve(data);
                        }
                    });
                } else {
                    reject({ error: 'component is not rendered thus can\'t be scrollTo' });
                }
            });
        }
    }, {
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global;

            return { id: id, type: type, global: global };
        }
    }, {
        key: 'id',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getId(compId);
        }

        /*
         * --- THIS METHOD IS INTENTIONALLY UNDOCUMENTED ---
         * @member connectionConfig
         * @label property
         * @syntax
         * let controllerConfig = $w("#myController").connectionConfig;
         * @summary Gets the controller's config.
         * @attr {external:String}
         * @config {external:String}
         * @memberof $w.Node
         * @readonly
         */

    }, {
        key: 'connectionConfig',
        get: function get() {
            var compId = members._compId.get(this);
            var role = members._role.get(this);
            var RMI = members._RMI.get(this);
            return RMI.getConfig(compId, role);
        }
    }, {
        key: 'uniqueId',
        get: function get() {
            return members._compId.get(this);
        }

        /**
         * @member parent
         * @label property
         * @syntax
         * get parent(): Node
         * @summary Gets the element's parent element.
         * @description
         *  Some elements can contain other elements. This occurs when you drag
         *  an element onto a container element. The container is the `parent` of
         *  all the elements it contains.
         *
         *  [`Page`]($w.Page.html), [`Header`]($w.Header.html), and
         *  [`Footer`]($w.Footer.html) are top-level elements and have no parent.
         * @snippet [Node-parent.es6=Get the parent element and the parent's ID]
         * @type {$w.Node}
         * @default `null`
         * @see [children](#children)
         * @memberof $w.Node
         * @readonly
         */

    }, {
        key: 'parent',
        get: function get() {
            var RMI = members._RMI.get(this);
            var wixSelector = members._wixSelector.get(this);
            var compId = members._compId.get(this);
            var controllerId = members._controllerId.get(this);

            if ((0, _isUndefined2.default)(compId) || compId === 'default') {
                return;
            }

            var parentId = RMI.getParent(compId);
            var parent = RMI.getComp(parentId);
            if ((0, _isUndefined2.default)(parent) || (0, _isNull2.default)(parent)) {
                return;
            }

            return wixSelector.getInstance(RMI, parent.type, parentId, controllerId);
        }

        /**
         * @member global
         * @label property
         * @syntax
         * get global(): boolean
         * @summary Indicates if an element appears on all pages or only on the current page.
         * @description
         *  If `global` is `true`, the element appears on all pages.
         *
         *  If `global` is `false`, the element only appears on the current page.
         * @snippet [Node-global_get.es6=Get whether an element is displayed on all pages]
         * @type {external:Boolean}
         * @default `false`
         * @memberof $w.Node
         * @readonly
         */

    }, {
        key: 'global',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var MASTER_PAGE_ID = "masterPage";
            var rootId = null;
            var parentId = compId;

            do {
                parentId = RMI.getParent(parentId);
                rootId = parentId || rootId;
            } while (parentId);

            return !rootId || rootId === MASTER_PAGE_ID;
        }

        /**
         * @member type
         * @label property
         * @syntax
         * get type(): string
         * @summary Gets the element's type.
         * @snippet [Node-type.es6=Get the element's type]
         * @type {external:String}
         * @memberof $w.Node
         * @readonly
         */

    }, {
        key: 'type',
        get: function get() {
            var type = members._type.get(this);
            if ((0, _isObject2.default)(type)) {
                var compType = type.compType && type.compType !== _utils.types.getDefaultSdkType() ? type.compType : (0, _last2.default)(type.viewerType.split('.'));
                return '$w.' + compType;
            }
            return '$w.' + type;
        }
    }]);

    return Node;
}();

exports.default = Node;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Link = __webpack_require__(56);

var _Link2 = _interopRequireDefault(_Link);

var _find = __webpack_require__(62);

var _find2 = _interopRequireDefault(_find);

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

var _pagesDataManipulation = __webpack_require__(224);

var pagesDataManipulation = _interopRequireWildcard(_pagesDataManipulation);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(1);

var _platformUtils = __webpack_require__(13);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _linkGenerator = __webpack_require__(65);

var _linkGenerator2 = _interopRequireDefault(_linkGenerator);

var _utils = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin LinkableMixin
 * @summary Provides functionality for elements that can acts as links.
 * @memberof $w
 */
var LinkableMixin = function () {
    function LinkableMixin() {
        _classCallCheck(this, LinkableMixin);
    }

    _createClass(LinkableMixin, [{
        key: 'link',


        /**
         * @member link
         * @label property
         * @syntax
         * get link(): string
         * set link(value: string): void
         * @summary Sets or gets the element's link.
         * @description
         *  When the element is clicked, the browser navigates to the `link` location.
         *
         *  The different types of links you can use are:
         *
         *  + `/localPageURL` — another page on your site
         *  + `/` — your site's home page
         *  + `http(s)://<url>` — an external web address
         *  + `wix:document://<location>` - a document stored in the Media Manager
         *  + `mailto:<email-address>?subject=<subject>` - an email
         *  + `tel:<phone number>` - a phone number
         *
         *
         *  The `link` property will attempt to properly encode the URL value that
         *  you set. For example, `.../some page` will be encoded to `.../some%20page`.
         *  However, some URLs do not have one unambiguous encoding. In those cases
         *  it is up to you to encode the URL to reflect your intentions. Because of
         *  these situations, it is a best practice to always encode URLs before you
         *  set them as the value of the `link` property. Regardless of how you set
         *  the `link` property, when you get its value, it returns an encoded URL.
         *
         *  Note that Wix URLs do not contain spaces. A page which has spaces in its
         *  name has its spaces replaced with dashes (`-`). Similarly, a <a href="https://support.wix.com/en/article/understanding-dynamic-page-urls" target="_black">dynamic page URL</a>
         *  which contains the value of a field in your collection with spaces will
         *  have its spaces replaced with dashes (`-`).
         * @type {external:String}
         * @default An empty string
         * @snippet [LinkableMixin-link_get.es6=Get the link URL from an element]
         * @snippet [LinkableMixin-link_set_local.es6=Set an element to open a local link]
         * @snippet [LinkableMixin-link_set_weblink.es6=Set an element to open an external web link]
         * @snippet [LinkableMixin-link_set_weblink_new_page.es6=Set an element to open an external web link in a new browser page when clicked]
         * @snippet [LinkableMixin-link_set_mailto.es6=Set an element to open a new email window when clicked]
         * @snippet [LinkableMixin-link_set_document.es6=Set an element to open a document]
         * @snippet [LinkableMixin-link_set_telephone.es6=Set an element to make a phone call when clicked]
         * @see [target](#target)
         * @memberof $w.LinkableMixin
         * @attr {external:String}
         * @attr {external:String} target
         */
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var link = RMI.getData(compId).link;
            return (0, _utils.emptyStringIfNil)(link && (link.link || new _Link2.default(link).getValue()));
        }

        /**
         * @param {external:String} [link] The new link for the element.
         * @ignore
         */
        ,
        set: function set(value) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;

            var isValid = (0, _validation.validate)(compType, 'link', { link: value });
            if (!isValid) {
                return;
            }

            if (!(0, _utils.isNilOrEmptyString)(value)) {
                var linkObject = _linkGenerator2.default.convertLinkToModelFormatAndReportIfError(value, this.target, 'link');

                if (!linkObject) {
                    return;
                }

                if (linkObject && linkObject.pageId === '#masterPage' && linkObject.queryParams) {
                    _reporter2.default.reportSdkWarning('Same page Anchor link can not accept query Params');
                    delete linkObject.queryParams;
                }
                RMI.setData(compId, {
                    link: linkObject
                });
            } else {
                RMI.setData(compId, { link: null });
            }
        }

        /**
         * @member target
         * @label property
         * @syntax
         * get target(): string
         * set target(value: string): void
         * @summary Sets or gets the target of the element's link.
         * @description
         *  An element's `target` determines where its [link](#link) opens. The
         *  target can be set so the [link](#link) opens in the current page or
         *  in a new page.
         *
         *  Supported values are:
         *  + `"_blank"` — The link opens in a new tab or window.
         *  + `"_self"` — The link opens in the tab or window.
         *
         * @note
         *  Link targets are only supported for external web links
         *  (e.g. `http://www.wix.com`).
         * @type {external:String}
         * @default `"_blank"`
         * @snippet [LinkableMixin-target_get.es6=Get the link target from an element]
         * @snippet [LinkableMixin-target_set.es6=Set the link target for an element]
         * @snippet [LinkableMixin-link_set_weblink_new_page.es6=Set an element to open an external web link in a new browser page when clicked]
         * @see [link](#link)
         * @memberof $w.LinkableMixin
         * @attr {external:String} target
         */

    }, {
        key: 'target',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var link = RMI.getData(compId).link;

            return link && link.target ? link.target : '_blank';
        }

        /**
         * @param {external:String} [target].
         * @ignore
         */
        ,
        set: function set(target) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'target', { target: target })) {
                return;
            }
            var RMI = members._RMI.get(this);
            var RGI = _platformUtils2.default.getRGI();
            var compId = members._compId.get(this);
            var link = RMI.getData(compId).link;

            if (!link) {
                var siteStructure = RMI.getSiteStructure() || {};
                var navigation = RGI.getNavigationInfo();
                var pageData = RMI.getPageData();
                var currentPageSiteStructureData = (0, _find2.default)(siteStructure.pages, { id: navigation.currentPageId });
                var currentPageUri = pagesDataManipulation.getPageURI(currentPageSiteStructureData, pageData.currentNavigationInfo);

                link = _linkGenerator2.default.convertLinkToModelFormatAndReportIfError(currentPageUri, this.target, 'target');
                if (!link) {
                    return;
                }
            }
            link.target = target;
            RMI.setData(compId, { link: link });
        }
    }]);

    return LinkableMixin;
}();

exports.default = LinkableMixin;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(368),
    listCacheDelete = __webpack_require__(369),
    listCacheGet = __webpack_require__(370),
    listCacheHas = __webpack_require__(371),
    listCacheSet = __webpack_require__(372);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(100),
    setCacheAdd = __webpack_require__(387),
    setCacheHas = __webpack_require__(388);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(72),
    eq = __webpack_require__(61);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(61);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(168);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(51),
    toKey = __webpack_require__(52);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 75 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 76 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(365);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(180);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(291),
    Map = __webpack_require__(99),
    Promise = __webpack_require__(293),
    Set = __webpack_require__(145),
    WeakMap = __webpack_require__(147),
    baseGetTag = __webpack_require__(21),
    toSource = __webpack_require__(184);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(61),
    isArrayLike = __webpack_require__(22),
    isIndex = __webpack_require__(58),
    isObject = __webpack_require__(14);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(45);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 82 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(151);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(153),
    baseIteratee = __webpack_require__(16),
    toInteger = __webpack_require__(90);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(307),
    hasPath = __webpack_require__(175);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 86 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(310),
    isObjectLike = __webpack_require__(17);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(21),
    isObjectLike = __webpack_require__(17);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(316),
    baseUnary = __webpack_require__(75),
    nodeUtil = __webpack_require__(179);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(197);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var IMAGE_CLICK_ACTIONS = {
    none: 'disabled',
    expand: 'zoomMode',
    link: 'goToLink'
};

var EFFECTS = {
    //TODO WEED-8265
    // CURRENT_EDITOR_EFFECT: {
    //     name: 'currentEditorEffect'
    // },
    HIDE: {
        suffix: 'Out',
        noSuffixPresets: ['conceal'],
        deprecatedValues: ['ArcOut', 'BounceOut', 'CollapseOut', 'Conceal', 'FadeOut', 'FlipOut', 'FloatOut', 'FlyOut', 'FoldOut', 'GlideOut', 'PopOut', 'SlideOut', 'SpinOut', 'TurnOut']
    },
    SHOW: {
        suffix: 'In',
        noSuffixPresets: ['reveal'],
        deprecatedValues: ['ArcIn', 'BounceIn', 'DropIn', 'ExpandIn', 'FadeIn', 'FlipIn', 'FloatIn', 'FlyIn', 'FoldIn', 'GlideIn', 'Reveal', 'SlideIn', 'SpinIn', 'TurnIn']
    }
};

exports.default = {
    IMAGE_CLICK_ACTIONS: IMAGE_CLICK_ACTIONS,
    EFFECTS: EFFECTS
};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var currentDeviceType = void 0;

function getDeviceType() {
    return currentDeviceType || 'desktop';
}

function init(deviceType) {
    currentDeviceType = deviceType;
}

exports.default = { init: init, getDeviceType: getDeviceType };

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(9);

var _intersection = __webpack_require__(409);

var _intersection2 = _interopRequireDefault(_intersection);

var _map = __webpack_require__(20);

var _map2 = _interopRequireDefault(_map);

var _uniqBy = __webpack_require__(199);

var _uniqBy2 = _interopRequireDefault(_uniqBy);

var _first2 = __webpack_require__(407);

var _first3 = _interopRequireDefault(_first2);

var _isUndefined = __webpack_require__(30);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _isFunction = __webpack_require__(29);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _without = __webpack_require__(201);

var _without2 = _interopRequireDefault(_without);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var singleCompFunction = {
    'scrollTo': true
};

function isPropertyFunction(object, property) {
    var descriptor = getDescriptorRecursively(object, property);

    return (0, _isFunction2.default)(descriptor.value);
}

function getDescriptorRecursively(object, property) {
    var prototype = Object.getPrototypeOf(object);

    if ((0, _isUndefined2.default)(prototype)) {
        return undefined;
    }
    var descriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(object), property);

    return descriptor ? descriptor : getDescriptorRecursively(prototype, property);
}

function getBatchedResultsFor(batch, property, argumentsForProperty) {
    if ((0, _get2.default)(singleCompFunction, property)) {
        var _first;

        return (_first = (0, _first3.default)(batch))[property].apply(_first, _toConsumableArray(argumentsForProperty));
    }

    return (0, _map2.default)(batch, function (batchItem) {
        return batchItem[property].apply(batchItem, _toConsumableArray(argumentsForProperty));
    });
}

function setterFunctionFor(batch, property) {
    return function (value) {
        batch.forEach(function (batchItem) {
            batchItem[property] = value;
        });
    };
}

function getterFunctionFor(batch, property) {
    if (property === 'style') {
        var batchForDeepProperty = (0, _without2.default)((0, _map2.default)(batch, function (component) {
            return (0, _get2.default)(component, property);
        }), undefined);
        exposeBatch(batchForDeepProperty);

        return function () {
            return batchForDeepProperty;
        };
    }

    return function () {
        return (0, _first3.default)(batch)[property];
    };
}

function defineGetterSetterFor(batch, property, descriptor) {
    var desc = {};

    if (descriptor.get) {
        desc.get = getterFunctionFor(batch, property);
    }

    if (descriptor.set) {
        desc.set = setterFunctionFor(batch, property);
    }

    Object.defineProperty(batch, property, desc);
}

function defineGetterSetter(batch, batchItem, property) {
    var descriptor = getDescriptorRecursively(batchItem, property);

    if (descriptor) {
        defineGetterSetterFor(batch, property, descriptor);
    }
}

function defineBatchFunction(batch, property) {
    batch[property] = function batchFunction() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return (0, _first3.default)(getBatchedResultsFor(batch, property, args));
    };
}

function defineBatchFunctionWithMultipleResults(batch, property) {
    batch[property] = function batchFunction() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return getBatchedResultsFor(batch, property, args);
    };
}

function exposeBatchAPI(batch, batchItem, prop) {
    if (prop === 'toJSON') {
        defineBatchFunctionWithMultipleResults(batch, prop);
    } else if (isPropertyFunction(batchItem, prop)) {
        defineBatchFunction(batch, prop);
    } else {
        defineGetterSetter(batch, batchItem, prop);
    }
}

function exposeBatch(batch) {
    var componentTypes = (0, _uniqBy2.default)(batch, 'type');
    var properties = void 0;
    if (componentTypes.length > 1) {
        var propertiesPerType = [];
        componentTypes.forEach(function (compType) {
            var propertiesForType = (0, _utils.allPropertiesFor)(compType);
            propertiesPerType.push(propertiesForType);
        });
        properties = _intersection2.default.apply(undefined, propertiesPerType);
    } else {
        properties = (0, _utils.allPropertiesFor)((0, _first3.default)(batch));
    }
    properties.forEach(exposeBatchAPI.bind(null, batch, (0, _first3.default)(batch)));
}

function expose(components) {
    if ((0, _isEmpty2.default)(components)) {
        return components;
    }

    exposeBatch(components);
    return components;
}

exports.default = {
    expose: expose
};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Link = __webpack_require__(56);

var _Link2 = _interopRequireDefault(_Link);

var _find = __webpack_require__(62);

var _find2 = _interopRequireDefault(_find);

var _defaults = __webpack_require__(60);

var _defaults2 = _interopRequireDefault(_defaults);

var _omit = __webpack_require__(64);

var _omit2 = _interopRequireDefault(_omit);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _has = __webpack_require__(85);

var _has2 = _interopRequireDefault(_has);

var _map = __webpack_require__(20);

var _map2 = _interopRequireDefault(_map);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _template = __webpack_require__(196);

var _template2 = _interopRequireDefault(_template);

var _forEach = __webpack_require__(46);

var _forEach2 = _interopRequireDefault(_forEach);

var _reduce = __webpack_require__(125);

var _reduce2 = _interopRequireDefault(_reduce);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _errors = __webpack_require__(12);

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

var _validation = __webpack_require__(1);

var _imageUtils = __webpack_require__(39);

var _imageUtils2 = _interopRequireDefault(_imageUtils);

var _vectorImageUtils = __webpack_require__(135);

var _vectorImageUtils2 = _interopRequireDefault(_vectorImageUtils);

var _linkGenerator = __webpack_require__(65);

var _linkGenerator2 = _interopRequireDefault(_linkGenerator);

var _LinkType = __webpack_require__(221);

var _LinkType2 = _interopRequireDefault(_LinkType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dataItemToUserFormatPropsMap = {
    label: 'label',
    items: 'items',
    link: 'link',
    isVisible: 'visibleOnDesktop',
    isVisibleMobile: 'visibleOnMobile',
    icon: 'iconRef',
    displayCount: 'displayCount'
};

var BasicMenuItemType = 'BasicMenuItem';
var compiled = (0, _template2.default)('<%= menuItemIndex %>,<%= subItemIndex %>');

function convertIconToModelFormat(icon, functionName, menuItemIndex) {
    var isValidSvg = _vectorImageUtils2.default.VECTOR_MEDIA_SRC_REGEX.test(icon);
    if (isValidSvg) {
        var model = _vectorImageUtils2.default.extractModelDataFromSrc(icon);
        return (0, _assign2.default)(model, { type: 'VectorImage' });
    }

    var isValidImage = _imageUtils2.default.isValidImage(icon);
    if (isValidImage) {
        var _model = _imageUtils2.default.extractModelDataFromSrc(icon);
        return (0, _assign2.default)(_model, { type: 'Image' });
    }

    var error = !(0, _isNil2.default)(menuItemIndex) ? _errors.generateError.error_bad_menu_item_format_with_index : _errors.generateError.error_bad_menu_item_format;
    _reporter2.default.reportSdkError(error({
        propertyName: 'icon',
        functionName: functionName,
        index: menuItemIndex,
        wrongValue: icon
    }));

    return null;
}

function convertIconRefToUserFormat(iconRef) {
    if (iconRef.svgId) {
        return _vectorImageUtils2.default.buildFullUrlFromSvgId(iconRef.svgId, iconRef.title);
    }
    return _imageUtils2.default.buildFullUrlFromUri(iconRef.uri, iconRef.width, iconRef.height, iconRef.title);
}

function convertMenuItemToModelFormat(RMI, menuItem, menuItemIndex, functionName, labelOptional) {
    var menuItemModelFormat = {};
    var originalLink = menuItem.link;
    var link = _linkGenerator2.default.convertLinkToModelFormatAndReportIfError(menuItem.link, null, functionName, menuItemIndex);
    if (link) {
        menuItemModelFormat.link = link;
    }
    if (!(0, _isNil2.default)(menuItem.label) && (0, _validation.validateByType)(menuItem.label, _validation.TYPES.STRING)) {
        menuItemModelFormat.label = menuItem.label;
    }
    if (!(0, _isNil2.default)(menuItem.visibleOnDesktop) && (0, _validation.validateByType)(menuItem.visibleOnDesktop, _validation.TYPES.BOOLEAN)) {
        menuItemModelFormat.isVisible = menuItem.visibleOnDesktop;
    }
    if (!(0, _isNil2.default)(menuItem.visibleOnMobile) && (0, _validation.validateByType)(menuItem.visibleOnMobile, _validation.TYPES.BOOLEAN)) {
        menuItemModelFormat.isVisibleMobile = menuItem.visibleOnMobile;
    }
    if (!(0, _isNil2.default)(menuItem.items) && (0, _validation.validateByType)(menuItem.items, _validation.TYPES.ARRAY)) {
        if (!(0, _isEmpty2.default)(menuItem.items)) {
            menuItemModelFormat.items = (0, _map2.default)(menuItem.items, function (subItem, subItemIndex) {
                return convertMenuItemToModelFormat(RMI, subItem, compiled({
                    menuItemIndex: menuItemIndex,
                    subItemIndex: subItemIndex
                }), functionName);
            });
        } else {
            menuItemModelFormat.items = menuItem.items;
        }
    }
    if (!(0, _isNil2.default)(menuItem.icon)) {
        var iconData = convertIconToModelFormat(menuItem.icon, functionName, menuItemIndex);
        if (iconData) {
            menuItemModelFormat.iconRef = iconData;
        }
    }
    if ((0, _has2.default)(menuItem, 'displayCount') && ((0, _isNil2.default)(menuItem.displayCount) || (0, _validation.validateByType)(menuItem.displayCount, _validation.TYPES.NUMBER))) {
        menuItemModelFormat.displayCount = menuItem.displayCount;
    }
    if (!(0, _isNil2.default)(menuItem.label) && (0, _validation.validateByType)(menuItem.label, _validation.TYPES.STRING)) {
        menuItemModelFormat.label = menuItem.label;
    }
    if (!labelOptional && menuItemModelFormat.link && menuItemModelFormat.link.type === _LinkType2.default.PAGE && !menuItemModelFormat.label) {
        var siteStructure = RMI.getSiteStructure() || {};
        var item = (0, _find2.default)(siteStructure.pages, { url: originalLink });
        menuItemModelFormat.label = item.name;
    }
    if (!labelOptional && !menuItemModelFormat.label) {
        _reporter2.default.reportSdkWarning(_errors.generateError.warning_not_null_with_index({
            propertyName: 'label',
            functionName: functionName,
            index: menuItemIndex
        }));
    }
    (0, _defaults2.default)(menuItemModelFormat, {
        type: BasicMenuItemType,
        isVisible: true,
        isVisibleMobile: true,
        items: []
    });
    return menuItemModelFormat;
}

function convertMenuItemToUserFormat(menuItem) {
    return (0, _reduce2.default)(menuItem, function (res, val, key) {
        if ((0, _isNil2.default)(val)) {
            return res;
        }
        var prop = dataItemToUserFormatPropsMap[key];
        if (prop) {
            res[prop] = val;
        }
        if (key === 'link') {
            var link = new _Link2.default(val);
            res.link = link ? link.getValue() : null;
        }
        if (key === 'iconRef' && !(0, _isEmpty2.default)(val)) {
            res.icon = convertIconRefToUserFormat(val);
        }
        if (key === 'items' && !(0, _isEmpty2.default)(val)) {
            res.items = (0, _map2.default)(val, convertMenuItemToUserFormat);
        }
        return res;
    }, {});
}

function removeUnsupportedProps(navItem, additionalUnsupportedProps) {
    return (0, _omit2.default)(navItem, ['items', 'type'].concat(additionalUnsupportedProps || []));
}

function convertNavItemToUserFormat(navItem, unsupportedProps) {
    var userFormatNavItem = convertMenuItemToUserFormat(navItem);
    return removeUnsupportedProps(userFormatNavItem, unsupportedProps);
}

function removeNonValidMenuLevelsAndReport(menuItem, menuItemIndex, functionName) {
    if ((0, _isEmpty2.default)(menuItem.items)) {
        return true;
    }
    var hasMoreThanTwoLevels = false;
    var index = void 0;

    (0, _forEach2.default)(menuItem.items, function (subItem, subItemIndex) {
        if ((0, _isEmpty2.default)(subItem.items)) {
            return true;
        }
        hasMoreThanTwoLevels = true;
        index = compiled({ menuItemIndex: menuItemIndex, subItemIndex: subItemIndex });
        delete subItem.items;
    });

    if (hasMoreThanTwoLevels) {
        _reporter2.default.reportSdkError(_errors.generateError.error_menu_can_have_two_levels({
            propertyName: 'label',
            functionName: functionName,
            index: index
        }));
    }
}

function checkMenuItemValidation(menuItem, menuIndex, functionName) {
    var isValid = (0, _validation.validate)(BasicMenuItemType, functionName, menuItem, true, menuIndex);
    removeNonValidMenuLevelsAndReport(menuItem, menuIndex, functionName);

    return isValid;
}

function checkMenuItemsValidation(menuItems, functionName) {
    (0, _forEach2.default)(menuItems, function (menuItem, menuItemIndex) {
        delete menuItem.icon; //TODO : remove once the add the icon support
        checkMenuItemValidation(menuItem, menuItemIndex, functionName);
        (0, _forEach2.default)(menuItem.items, function (subItem, subItemIndex) {
            delete subItem.icon; //TODO : remove once the add the icon support
            checkMenuItemValidation(subItem, compiled({ menuItemIndex: menuItemIndex, subItemIndex: subItemIndex }), functionName);
        });
    });
}

function checkUserProfileItemsValidation(navItems, functionName, additionalUnsupportedProps) {
    return (0, _reduce2.default)(navItems, function (res, navItem, navItemIndex) {
        var navItemWithSupportedProps = removeUnsupportedProps(navItem, additionalUnsupportedProps);
        checkMenuItemValidation(navItemWithSupportedProps, navItemIndex, functionName);
        res.push(navItemWithSupportedProps);
        return res;
    }, []);
}

function checkUserProfileNavBarItemsValidation(navItems, functionName) {
    return checkUserProfileItemsValidation(navItems, functionName, ['label']);
}

function checkUserProfileTinuMenuNavBarItemsValidation(navItems, functionName) {
    return checkUserProfileItemsValidation(navItems, functionName, ['visibleOnDesktop']);
}

function checkUserProfileTinyMenuItemsValidation(navItems, functionName) {
    return checkUserProfileItemsValidation(navItems, functionName, ['icon', 'visibleOnDesktop']);
}

function checkUserProfileMenuItemsValidation(navItems, functionName) {
    return checkUserProfileItemsValidation(navItems, functionName, ['icon']);
}

exports.default = {
    convertMenuItemToModelFormat: convertMenuItemToModelFormat,
    convertMenuItemToUserFormat: convertMenuItemToUserFormat,
    convertNavItemToUserFormat: convertNavItemToUserFormat,
    checkMenuItemsValidation: checkMenuItemsValidation,
    checkUserProfileMenuItemsValidation: checkUserProfileMenuItemsValidation,
    checkUserProfileTinyMenuItemsValidation: checkUserProfileTinyMenuItemsValidation,
    checkUserProfileNavBarItemsValidation: checkUserProfileNavBarItemsValidation,
    checkUserProfileTinuMenuNavBarItemsValidation: checkUserProfileTinuMenuNavBarItemsValidation
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTypes = exports.Video = exports.VerticalMenu = exports.VectorImage = exports.UploadButton = exports.TextInput = exports.TextBox = exports.Text = exports.Table = exports.ToggleSwitch = exports.Switch = exports.Slideshow = exports.Slide = exports.Shape = exports.Repeater = exports.RadioButtonGroup = exports.Pagination = exports.Page = exports.Node = exports.MobileMenu = exports.Image = exports.IFrame = exports.HtmlComponent = exports.HoverBox = exports.HiddenCollapsedElement = exports.Header = exports.GoogleMap = exports.Gallery = exports.Footer = exports.Element = exports.Dropdown = exports.DatePicker = exports.MediaContainer = exports.Container = exports.ColumnStrip = exports.Column = exports.Checkbox = exports.Button = exports.Box = exports.Background = exports.AppController = exports.Anchor = exports.AccountNavBar = undefined;

var _AccountNavBar = __webpack_require__(238);

var _AccountNavBar2 = _interopRequireDefault(_AccountNavBar);

var _Anchor = __webpack_require__(239);

var _Anchor2 = _interopRequireDefault(_Anchor);

var _AppController = __webpack_require__(240);

var _AppController2 = _interopRequireDefault(_AppController);

var _Background = __webpack_require__(49);

var _Background2 = _interopRequireDefault(_Background);

var _Box = __webpack_require__(241);

var _Box2 = _interopRequireDefault(_Box);

var _Button = __webpack_require__(242);

var _Button2 = _interopRequireDefault(_Button);

var _Checkbox = __webpack_require__(243);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Column = __webpack_require__(244);

var _Column2 = _interopRequireDefault(_Column);

var _Columns = __webpack_require__(245);

var _Columns2 = _interopRequireDefault(_Columns);

var _Container = __webpack_require__(246);

var _Container2 = _interopRequireDefault(_Container);

var _DatePicker = __webpack_require__(247);

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _DropDown = __webpack_require__(248);

var _DropDown2 = _interopRequireDefault(_DropDown);

var _Element = __webpack_require__(7);

var _Element2 = _interopRequireDefault(_Element);

var _Footer = __webpack_require__(249);

var _Footer2 = _interopRequireDefault(_Footer);

var _Gallery = __webpack_require__(250);

var _Gallery2 = _interopRequireDefault(_Gallery);

var _GoogleMap = __webpack_require__(251);

var _GoogleMap2 = _interopRequireDefault(_GoogleMap);

var _Header = __webpack_require__(252);

var _Header2 = _interopRequireDefault(_Header);

var _HiddenCollapsedElement = __webpack_require__(138);

var _HiddenCollapsedElement2 = _interopRequireDefault(_HiddenCollapsedElement);

var _HoverBox = __webpack_require__(253);

var _HoverBox2 = _interopRequireDefault(_HoverBox);

var _HtmlComponent = __webpack_require__(254);

var _HtmlComponent2 = _interopRequireDefault(_HtmlComponent);

var _IFrame = __webpack_require__(139);

var _IFrame2 = _interopRequireDefault(_IFrame);

var _Image = __webpack_require__(255);

var _Image2 = _interopRequireDefault(_Image);

var _MobileMenu = __webpack_require__(256);

var _MobileMenu2 = _interopRequireDefault(_MobileMenu);

var _Node = __webpack_require__(66);

var _Node2 = _interopRequireDefault(_Node);

var _Page = __webpack_require__(257);

var _Page2 = _interopRequireDefault(_Page);

var _Pagination = __webpack_require__(258);

var _Pagination2 = _interopRequireDefault(_Pagination);

var _RadioButtonGroup = __webpack_require__(260);

var _RadioButtonGroup2 = _interopRequireDefault(_RadioButtonGroup);

var _Repeater = __webpack_require__(261);

var _Repeater2 = _interopRequireDefault(_Repeater);

var _Shape = __webpack_require__(262);

var _Shape2 = _interopRequireDefault(_Shape);

var _Slide = __webpack_require__(140);

var _Slide2 = _interopRequireDefault(_Slide);

var _Slideshow = __webpack_require__(263);

var _Slideshow2 = _interopRequireDefault(_Slideshow);

var _Switch = __webpack_require__(264);

var _Switch2 = _interopRequireDefault(_Switch);

var _Table = __webpack_require__(265);

var _Table2 = _interopRequireDefault(_Table);

var _Text = __webpack_require__(266);

var _Text2 = _interopRequireDefault(_Text);

var _TextBox = __webpack_require__(267);

var _TextBox2 = _interopRequireDefault(_TextBox);

var _TextInput = __webpack_require__(268);

var _TextInput2 = _interopRequireDefault(_TextInput);

var _UploadButton = __webpack_require__(270);

var _UploadButton2 = _interopRequireDefault(_UploadButton);

var _VectorImage = __webpack_require__(271);

var _VectorImage2 = _interopRequireDefault(_VectorImage);

var _VerticalMenu = __webpack_require__(272);

var _VerticalMenu2 = _interopRequireDefault(_VerticalMenu);

var _Video = __webpack_require__(273);

var _Video2 = _interopRequireDefault(_Video);

var _Types = __webpack_require__(269);

var _Types2 = _interopRequireDefault(_Types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AccountNavBar = _AccountNavBar2.default;
exports.Anchor = _Anchor2.default;
exports.AppController = _AppController2.default;
exports.Background = _Background2.default;
exports.Box = _Box2.default;
exports.Button = _Button2.default;
exports.Checkbox = _Checkbox2.default;
exports.Column = _Column2.default;
exports.ColumnStrip = _Columns2.default;
exports.Container = _Container2.default;
exports.MediaContainer = _Container2.default;
exports.DatePicker = _DatePicker2.default;
exports.Dropdown = _DropDown2.default;
exports.Element = _Element2.default;
exports.Footer = _Footer2.default;
exports.Gallery = _Gallery2.default;
exports.GoogleMap = _GoogleMap2.default;
exports.Header = _Header2.default;
exports.HiddenCollapsedElement = _HiddenCollapsedElement2.default;
exports.HoverBox = _HoverBox2.default;
exports.HtmlComponent = _HtmlComponent2.default;
exports.IFrame = _IFrame2.default;
exports.Image = _Image2.default;
exports.MobileMenu = _MobileMenu2.default;
exports.Node = _Node2.default;
exports.Page = _Page2.default;
exports.Pagination = _Pagination2.default;
exports.RadioButtonGroup = _RadioButtonGroup2.default;
exports.Repeater = _Repeater2.default;
exports.Shape = _Shape2.default;
exports.Slide = _Slide2.default;
exports.Slideshow = _Slideshow2.default;
exports.Switch = _Switch2.default;
exports.ToggleSwitch = _Switch2.default;
exports.Table = _Table2.default;
exports.Text = _Text2.default;
exports.TextBox = _TextBox2.default;
exports.TextInput = _TextInput2.default;
exports.UploadButton = _UploadButton2.default;
exports.VectorImage = _VectorImage2.default;
exports.VerticalMenu = _VerticalMenu2.default;
exports.Video = _Video2.default;
exports.getTypes = _Types2.default;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Utils = __webpack_require__(25);

var Utils = _interopRequireWildcard(_Utils);

var _validation = __webpack_require__(1);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin ReadOnlyMixin
 * @summary Provides functionality for input elements which support readonly mode.
 * @memberof $w
 */
var ReadOnlyMixin = function () {
    function ReadOnlyMixin() {
        _classCallCheck(this, ReadOnlyMixin);
    }

    _createClass(ReadOnlyMixin, [{
        key: 'readOnly',


        /**
         * @member readOnly
         * @label property
         * @syntax
         * let isElementReadOnly = $w("#myFormElement").readOnly;
         * $w("#myFormElement").readOnly = isElementReadOnly;
         * @summary Sets or gets if a user can modify the value of the input element.
         * @description
         *  Setting the value of the `readOnly` property to `true` prevents users
         *  from changing the element's value. However, it does not limit your
         *  ability to change the value programmatically. Setting it to `false`
         *  allows users to change the element's value.
         *
         *  Getting the value of the `readonly` property returns whether a user
         *  can modify the value of the input element.
         *
         *  You can also set an element's `readonly` property in the Editor using the Settings pane:
         *  ![Input Settings pane](images/input_settings-read_only.png)
         * @snippet [ReadOnlyMixin-readonly_get.es6=Get whether the element is readOnly]
         * @snippet [ReadOnlyMixin-readonly_set.es6=Set an element to be readOnly]
         * @type {external:Boolean}
         * @memberof $w.ReadOnlyMixin
         */
        get: function get() {
            return Utils.getProp(this, 'readOnly') || false;
        }

        /**
         * @param {external:Boolean} readonly `true` if read-only.
         * @ignore
         */
        ,
        set: function set(readonly) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'readonly', { readonly: readonly })) {
                return;
            }
            Utils.setProp(this, { readOnly: readonly });
        }
    }]);

    return ReadOnlyMixin;
}();

exports.default = ReadOnlyMixin;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(73),
    baseLodash = __webpack_require__(110);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(73),
    baseLodash = __webpack_require__(110);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(45),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(373),
    mapCacheDelete = __webpack_require__(374),
    mapCacheGet = __webpack_require__(375),
    mapCacheHas = __webpack_require__(376),
    mapCacheSet = __webpack_require__(377);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(68),
    stackClear = __webpack_require__(390),
    stackDelete = __webpack_require__(391),
    stackGet = __webpack_require__(392),
    stackHas = __webpack_require__(393),
    stackSet = __webpack_require__(394);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 102 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 103 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(156);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 105 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 106 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 107 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(306),
    keys = __webpack_require__(31);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(59),
    nativeKeys = __webpack_require__(380);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 110 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(51),
    last = __webpack_require__(191),
    parent = __webpack_require__(383),
    toKey = __webpack_require__(52);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(146);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(408),
    overRest = __webpack_require__(181),
    setToString = __webpack_require__(183);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(155),
    getSymbolsIn = __webpack_require__(174),
    keysIn = __webpack_require__(124);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(148),
    stubArray = __webpack_require__(195);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(6),
    isSymbol = __webpack_require__(88);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(148),
    baseFilter = __webpack_require__(305),
    baseIteratee = __webpack_require__(16),
    isArray = __webpack_require__(6);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var createFlow = __webpack_require__(345);

/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */
var flow = createFlow();

module.exports = flow;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(22),
    isObjectLike = __webpack_require__(17);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(21),
    isObjectLike = __webpack_require__(17),
    isPlainObject = __webpack_require__(123);

/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    errorTag = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == errorTag || tag == domExcTag ||
    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
}

module.exports = isError;


/***/ }),
/* 121 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(21),
    isObjectLike = __webpack_require__(17);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(21),
    getPrototype = __webpack_require__(78),
    isObjectLike = __webpack_require__(17);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(149),
    baseKeysIn = __webpack_require__(317),
    isArrayLike = __webpack_require__(22);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(107),
    baseEach = __webpack_require__(42),
    baseIteratee = __webpack_require__(16),
    baseReduce = __webpack_require__(324),
    isArray = __webpack_require__(6);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = {

    FieldType: Object.freeze({
        STRING: 'string',
        DATE: 'date',
        NUMBER: 'number',
        IMAGE: 'image',
        BOOLEAN: 'bool',
        RICH_TEXT: 'richText'
    }),

    SortDirection: Object.freeze({
        ASC: 'asc',
        DESC: 'desc',
        NONE: 'none'
    }),

    UserSelectionType: Object.freeze({
        NONE: 'none',
        CELL: 'cell',
        ROW: 'row'
    }),

    LinkTargetType: Object.freeze({
        SELF: '_self',
        BLANK: '_blank'
    }),

    DataSourceType: Object.freeze({
        DYNAMIC: 'dynamic',
        STATIC: 'static'
    }),

    PaginationType: Object.freeze({
        NONE: 'normal',
        PAGES: 'pagination',
        SCROLL: 'virtual'
    }),

    HeightLayout: Object.freeze({
        MANUAL: 'manual',
        AUTO: 'auto'
    }),

    ColumnLayout: Object.freeze({
        EQUAL: 'equal',
        FIT_CONTENT: 'fitContent',
        MANUAL: 'manual'
    }),

    HorizontalAlignment: Object.freeze({
        LEFT: 'left',
        CENTER: 'center',
        RIGHT: 'right'
    }),

    RowModification: Object.freeze({
        UPDATE: 'update',
        ADD: 'add',
        REMOVE: 'remove'
    }),

    filtering: {
        NumericOperator: Object.freeze({
            EQUALS: 'EQUALS',
            NOT_EQUALS: 'NOT_EQUALS',
            LESS_THAN: 'LESS_THAN',
            LESS_OR_EQUALS: 'LESS_OR_EQUALS',
            GREATER_THAN: 'GREATER_THAN',
            GREATER_OR_EQUALS: 'GREATER_OR_EQUALS'
        }),

        StringOperator: Object.freeze({
            EQUALS: 'EQUALS',
            NOT_EQUALS: 'NOT_EQUALS',
            CONTAINS: 'CONTAINS',
            STARTS_WITH: 'STARTS_WITH',
            ENDS_WITH: 'ENDS_WITH'
        }),

        DateOperator: Object.freeze({
            LAST_X_DAYS: 'LAST_X_DAYS',
            LAST_X_WEEKS: 'LAST_X_WEEKS',
            LAST_X_MONTHS: 'LAST_X_MONTHS'
        })
    }
};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _forEach = __webpack_require__(46);

var _forEach2 = _interopRequireDefault(_forEach);

var _textInputInitialize = __webpack_require__(218);

var _comboBoxInputInitialize = __webpack_require__(214);

var _textAreaInputInitialize = __webpack_require__(217);

var _booleanInputInitialize = __webpack_require__(213);

var _radioGroupInitialize = __webpack_require__(216);

var _datePickerInitialize = __webpack_require__(215);

var _uploadButtonInitialize = __webpack_require__(219);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var compTypeToInitializeMethod = {
    'wysiwyg.viewer.components.inputs.TextInput': _textInputInitialize.textInputInitialize,
    'wysiwyg.viewer.components.inputs.ComboBoxInput': _comboBoxInputInitialize.comboBoxInputInitialize,
    'wysiwyg.viewer.components.inputs.TextAreaInput': _textAreaInputInitialize.textAreaInputInitialize,
    'wysiwyg.viewer.components.inputs.Checkbox': _booleanInputInitialize.booleanInputInitialize,
    'wysiwyg.viewer.components.inputs.RadioGroup': _radioGroupInitialize.radioGroupInitialize,
    'wysiwyg.viewer.components.inputs.DatePicker': _datePickerInitialize.datePickerInitialize,
    'wysiwyg.viewer.components.inputs.FileUploader': _uploadButtonInitialize.uploadButtonInitialize,
    'wixui.ToggleSwitch': _booleanInputInitialize.booleanInputInitialize
};

var compTypeToRemovalMethod = {
    'wysiwyg.viewer.components.inputs.TextInput': _textInputInitialize.textInputClearance,
    'wysiwyg.viewer.components.inputs.ComboBoxInput': _comboBoxInputInitialize.comboBoxInputClearance,
    'wysiwyg.viewer.components.inputs.TextAreaInput': _textAreaInputInitialize.textAreaInputClearance,
    'wysiwyg.viewer.components.inputs.Checkbox': _booleanInputInitialize.booleanInputClearance,
    'wysiwyg.viewer.components.inputs.RadioGroup': _radioGroupInitialize.radioGroupClearance,
    'wysiwyg.viewer.components.inputs.DatePicker': _datePickerInitialize.datePickerClearance,
    'wysiwyg.viewer.components.inputs.FileUploader': _uploadButtonInitialize.uploadButtonClearance,
    'wixui.ToggleSwitch': _booleanInputInitialize.booleanInputClearance
};

var componentsInitialize = function componentsInitialize(RMI, contextId, components) {
    (0, _forEach2.default)(components, function (comp, compId) {
        var initializeMethod = compTypeToInitializeMethod[comp.type];

        if (initializeMethod) {
            initializeMethod(RMI, contextId, compId);
        }
    });
};

var componentsRemoval = function componentsRemoval(RMI, contextId, components) {
    (0, _forEach2.default)(components, function (comp, compId) {
        var removalMethod = compTypeToRemovalMethod[comp.type];

        if (removalMethod) {
            removalMethod(RMI, contextId, compId);
        }
    });
};

exports.default = {
    componentsInitialize: componentsInitialize,
    componentsRemoval: componentsRemoval
};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _validationsService = __webpack_require__(15);

var validationsEventHandler = function validationsEventHandler(RMI) {
    return function (e) {
        var value = e.target.value;
        var compId = e.syntheticEvent.id;

        (0, _validationsService.runValidationsAndSyncAfterChange)(RMI, compId, value);
    };
};

var updateValidationState = function updateValidationState(RMI, contextId, compId) {
    return (0, _validationsService.runValidationsAndSync)(RMI, compId);
};

var validatableWithSyncInitialize = function validatableWithSyncInitialize(RMI, contextId, compId) {
    RMI.registerEvent(contextId, compId, RMI.getEventTypes().CHANGE, null, validationsEventHandler(RMI));
    updateValidationState(RMI, contextId, compId);
};

exports.default = validatableWithSyncInitialize;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _lightboxContext = void 0;

var setLightboxContext = exports.setLightboxContext = function setLightboxContext(context) {
  _lightboxContext = context;
};

var getLightboxContext = exports.getLightboxContext = function getLightboxContext() {
  return _lightboxContext;
};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onReady = onReady;
exports.triggerOnReady = triggerOnReady;
exports.onRender = onRender;
exports.triggerOnRender = triggerOnRender;

var _isFunction = __webpack_require__(29);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isUndefined = __webpack_require__(30);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _defer = __webpack_require__(404);

var _defer2 = _interopRequireDefault(_defer);

var _forEach = __webpack_require__(46);

var _forEach2 = _interopRequireDefault(_forEach);

var _remove = __webpack_require__(420);

var _remove2 = _interopRequireDefault(_remove);

var _has = __webpack_require__(85);

var _has2 = _interopRequireDefault(_has);

var _urlUtils = __webpack_require__(24);

var urlUtils = _interopRequireWildcard(_urlUtils);

var _postMessage = __webpack_require__(18);

var pm = _interopRequireWildcard(_postMessage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onReadyCallbacks = [];
var onRenderCallbacks = [];
var ready = new Set();

function wrapCallbackWithTimer(callback, id) {
    return function () {
        var startTime = Date.now();
        var result = callback();
        if (result instanceof Promise) {
            result.then(function () {
                console.log(id + ' was delayed by ' + (Date.now() - startTime) + 'ms due to code');
            });
        }
        return result;
    };
}

function safeRun(callback) {
    try {
        return callback();
    } catch (e) {
        console.error(e);
        return null;
    }
}

function on(callback, callbacksArr, log, type) {
    if (!(0, _isFunction2.default)(callback)) {
        throw new Error(callback + ' is invalid. You can\'t select components before the document is ready.');
    }

    var actualCallback = log ? wrapCallbackWithTimer(callback, log) : callback;
    if (ready.has(type)) {
        (0, _defer2.default)(function () {
            return safeRun(actualCallback);
        });
    }

    callbacksArr.push(actualCallback);
}

function trigger(success, callbacksArr) {
    var allReady = Promise.all(callbacksArr.map(function (cb) {
        return safeRun(cb);
    })).then(function (res) {
        var items = (0, _remove2.default)(res, function (item) {
            return !((0, _isUndefined2.default)(item) || (0, _has2.default)(item, 'controllerId'));
        });
        (0, _forEach2.default)(items, function (data) {
            return pm.sendMessage(pm.Intent.WIX_CODE_WARMUP, pm.MessageTypes.SET_WARMUP_DATA, {
                controllerId: 'wix-code',
                data: data
            });
        });
    }).catch(function (reason) {
        console.error(reason);
    });
    if (success) {
        allReady.then(function () {
            return success();
        });
    }

    callbacksArr.length = 0;
}

function onReady(callback, log) {
    on(callback, onReadyCallbacks, log, 'ready');
}

function triggerOnReady(success) {
    ready.add('ready');
    onReadyCallbacks.push(function () {
        urlUtils.addQueryParameters({ renderCycle: NaN });
    });
    trigger(success, onReadyCallbacks);
}

function onRender(callback, log) {
    on(callback, onRenderCallbacks, log, 'render');
}

function triggerOnRender(success) {
    ready.add('render');
    trigger(success, onRenderCallbacks);
}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _includes = __webpack_require__(53);

var _includes2 = _interopRequireDefault(_includes);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isAllowedComponentAPI = function isAllowedComponentAPI(type, api) {
    var apis = _utils.types.supportedComponentAPIs[type] || [];
    return (0, _includes2.default)(apis, api);
};

exports.default = isAllowedComponentAPI;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _videoUtils = __webpack_require__(229);

var _videoUtils2 = _interopRequireDefault(_videoUtils);

var _imageUtils = __webpack_require__(39);

var _imageUtils2 = _interopRequireDefault(_imageUtils);

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(12);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getMediaDataFromSrc(value) {
    var mediaData = void 0;
    if (_videoUtils2.default.isVideoUrl(value)) {
        mediaData = _videoUtils2.default.extractModelDataFromSrc(value);
        if (mediaData) {
            (0, _assign2.default)(mediaData, { type: 'WixVideo' });
        }
    } else {
        mediaData = _imageUtils2.default.extractModelDataFromSrc(value);
        if (mediaData) {
            (0, _assign2.default)(mediaData, { type: 'Image' });
        }
    }
    if (!(0, _isNil2.default)(value) && !mediaData) {
        _reporter2.default.reportSdkError(_errors.generateError.error_bad_background_format({
            propertyName: 'src',
            functionName: 'background',
            wrongValue: value
        }));
        return null;
    }
    return mediaData || {};
}

function getFullMediaData(mediaData, callback) {
    if (mediaData.videoId) {
        _videoUtils2.default.getFullVideoData(mediaData.videoId, callback);
        return;
    }
    callback();
}

function buildFullUrlFromMediaRef(mediaData) {
    if (mediaData.videoId) {
        return _videoUtils2.default.buildFullUrlFromMediaRef(mediaData);
    }
    return _imageUtils2.default.buildFullUrlFromMediaRef(mediaData);
}

exports.default = {
    buildFullUrlFromMediaRef: buildFullUrlFromMediaRef,
    getMediaDataFromSrc: getMediaDataFromSrc,
    getFullMediaData: getFullMediaData
};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateOption = exports.optionsToDisplay = exports.emptyStringIfNotInOptions = exports.getOptionsFromFull = undefined;

var _some = __webpack_require__(422);

var _some2 = _interopRequireDefault(_some);

var _every = __webpack_require__(35);

var _every2 = _interopRequireDefault(_every);

var _filter = __webpack_require__(117);

var _filter2 = _interopRequireDefault(_filter);

var _values = __webpack_require__(200);

var _values2 = _interopRequireDefault(_values);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _pick = __webpack_require__(418);

var _pick2 = _interopRequireDefault(_pick);

var _errors = __webpack_require__(12);

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

var _Utils = __webpack_require__(25);

var Utils = _interopRequireWildcard(_Utils);

var _utils = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PERMITTED_KEYS = ['label', 'value'];

function getOptionsFromFull() {
    return Utils.getFullDataWithOverrides(this, 'options').map(function (option) {
        return {
            label: option.label,
            value: option.value
        };
    });
}

var emptyStringIfNotInOptions = function emptyStringIfNotInOptions(options, value) {
    return (0, _some2.default)(options, { value: value }) ? value : '';
};

var isValidOption = function isValidOption(option) {
    var optionPermittedKeys = (0, _pick2.default)(option, PERMITTED_KEYS);
    var optionProperties = (0, _values2.default)(optionPermittedKeys);
    var everyPropertyIsNilOrEmpty = (0, _every2.default)(optionProperties, function (prop) {
        return (0, _utils.isNilOrEmptyString)(prop);
    });
    var isValidEmptyOption = (0, _every2.default)(PERMITTED_KEYS, function (key) {
        return optionPermittedKeys[key] === '';
    });

    return !(0, _isEmpty2.default)(optionPermittedKeys) && !everyPropertyIsNilOrEmpty || isValidEmptyOption;
};

var optionsToDisplay = function optionsToDisplay(options) {
    return (0, _filter2.default)(options, function (option) {
        return isValidOption(option);
    });
};

var validateOption = function validateOption(option, index, propertyName) {
    if (!isValidOption(option)) {
        _reporter2.default.reportSdkWarning(_errors.generateError.warning_invalid_option({
            propertyName: propertyName,
            index: index,
            wrongValue: option
        }));
    }
    return true;
};

exports.getOptionsFromFull = getOptionsFromFull;
exports.emptyStringIfNotInOptions = emptyStringIfNotInOptions;
exports.optionsToDisplay = optionsToDisplay;
exports.validateOption = validateOption;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(12);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VECTOR_MEDIA_SRC_REGEX = /^wix:vector:\/\/v1\/([^\/]+)\/([^\/]+)?$/;

function extractModelDataFromSrc(src) {
    if (VECTOR_MEDIA_SRC_REGEX.test(src)) {
        var _ref = src.match(VECTOR_MEDIA_SRC_REGEX) || [0, src],
            _ref2 = _slicedToArray(_ref, 3),
            svgId = _ref2[1],
            title = _ref2[2];

        var decodedTitle = title ? decodeURIComponent(title) : '';
        return { svgId: svgId, title: decodedTitle };
    }

    return null;
}

function convertToModelFormatAndReportIfError(src, propertyName, functionName, index) {
    var svgData = extractModelDataFromSrc(src);
    if (!svgData) {
        var error = !(0, _isNil2.default)(index) ? _errors.generateError.error_bad_svg_format_with_index : _errors.generateError.error_bad_svg_format;
        _reporter2.default.reportSdkError(error({
            propertyName: propertyName,
            functionName: functionName,
            index: index,
            wrongValue: src
        }));
        return null;
    }
    return svgData;
}

function buildFullUrlFromSvgId(svgId, title) {
    if (!svgId) {
        return null;
    }
    var encodedTitle = title ? encodeURIComponent(title) : '';
    return 'wix:vector://v1/' + svgId + '/' + encodedTitle;
}

exports.default = {
    VECTOR_MEDIA_SRC_REGEX: VECTOR_MEDIA_SRC_REGEX,
    extractModelDataFromSrc: extractModelDataFromSrc,
    convertToModelFormatAndReportIfError: convertToModelFormatAndReportIfError,
    buildFullUrlFromSvgId: buildFullUrlFromSvgId
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _validationExpressions = __webpack_require__(233);

var _validationExpressions2 = _interopRequireDefault(_validationExpressions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validateVideoUrlFormats(val) {
    return _validationExpressions2.default.validYouTubeLongUrlReg.test(val) || _validationExpressions2.default.validYouTubeShortUrlReg.test(val) || _validationExpressions2.default.validVimeoUrlReg.test(val) || _validationExpressions2.default.validDailymotionUrlReg.test(val) || _validationExpressions2.default.validFacebookUrlReg.test(val);
}

function validateRepeaterItemIdFormat(val) {
    return _validationExpressions2.default.validRepeaterItemId.test(val);
}

function validateUUIDFormat(val) {
    return _validationExpressions2.default.validUUID.test(val);
}

exports.default = {
    validateVideoUrlFormats: validateVideoUrlFormats,
    validateRepeaterItemIdFormat: validateRepeaterItemIdFormat,
    validateUUIDFormat: validateUUIDFormat
};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _map = __webpack_require__(20);

var _map2 = _interopRequireDefault(_map);

var _get2 = __webpack_require__(3);

var _get3 = _interopRequireDefault(_get2);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _isUndefined = __webpack_require__(30);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _omit = __webpack_require__(64);

var _omit2 = _interopRequireDefault(_omit);

var _size = __webpack_require__(421);

var _size2 = _interopRequireDefault(_size);

var _includes = __webpack_require__(53);

var _includes2 = _interopRequireDefault(_includes);

var _omitBy = __webpack_require__(193);

var _omitBy2 = _interopRequireDefault(_omitBy);

var _isNull = __webpack_require__(190);

var _isNull2 = _interopRequireDefault(_isNull);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _every = __webpack_require__(35);

var _every2 = _interopRequireDefault(_every);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _PlayableMixin = __webpack_require__(142);

var _PlayableMixin2 = _interopRequireDefault(_PlayableMixin);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _imageUtils = __webpack_require__(39);

var _imageUtils2 = _interopRequireDefault(_imageUtils);

var _componentAPISupport = __webpack_require__(132);

var _componentAPISupport2 = _interopRequireDefault(_componentAPISupport);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _validation = __webpack_require__(1);

var _constants = __webpack_require__(91);

var _constants2 = _interopRequireDefault(_constants);

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function reportUnsupportedAPI(api, type) {
    _reporter2.default.reportSdkWarning('\'' + api + '\' is not supported for an element of type: ' + type + '.');
}

function getShowANavigationButtonsPropertyName(viewerType) {
    if ((0, _includes2.default)(['tpa.viewer.components.StripShowcase', 'tpa.viewer.components.Thumbnails'], viewerType)) {
        return 'arrowMode';
    }

    return 'showNavigation';
}

function executeApiIfSupported(comp, apiName, apiImplementation) {
    var viewerType = members._type.get(comp).viewerType;
    if ((0, _componentAPISupport2.default)(viewerType, apiName)) {
        return apiImplementation();
    }
    reportUnsupportedAPI(apiName, viewerType); //todo Shimi_Liderman 21/05/2017 18:53 Seems very strange to print out the viewer type!
}

/**
 * @typedef {external:Object} $w.Gallery~GalleryCapabilities
 * @summary An object used by the `galleryCapabilities` property that contains the capabilities of a gallery.
 * @property {external:Boolean} isPlayable Indicates if the gallery supports play operations.
 * @property {external:Boolean} hasCurrentItem Indicates if the gallery supports the notion of a current item.
 * @property {external:Boolean} hasNavigationButtons Indicates if the gallery supports navigation buttons.
 * @snippet [Gallery-galleryCapabilities_get.es6=Get the gallery's capabilities]
 * @see [`galleryCapabilities`](#galleryCapabilities)
 */

/**
 * @typedef {external:Object} $w.Gallery~GalleryItem
 * @summary An object used by the Gallery properties `items` and `currentItem` to represent a single item in a gallery.
 * @property {external:String} src The item's URL.
 * @property {external:String} [description] The item's description. Descriptions over 100 characters will be truncated.
 * @property {external:String} [title] The item's title.
 * @property {external:String} [link] The URL of the item's clickable link. See [here]($w.LinkableMixin.html#link) for more information about links.
 * @property {external:String} [target] The target of the link, either `"_blank"` or `"_self"`
 * @description
 *  The `src` property of a `GalleryItem` for a Pro Gallery can be:
 *  + An image from the <a href="https://support.wix.com/en/article/about-the-media-manager" target="_blank">Media Manager</a>
 *  + An external image from any web location
 *  + A video from the <a href="https://support.wix.com/en/article/about-the-media-manager" target="_blank">Media Manager</a>
 *
 *
 *  The `src` property of a `GalleryItem` for a standard gallery can be:
 *  + An image from the <a href="https://support.wix.com/en/article/about-the-media-manager" target="_blank">Media Manager</a>
 *  + An external image from any web location (some galleries do not support external images)
 *
 *
 *  To determine if your gallery is a Pro Gallery or a standard gallery, hover
 *  over the gallery while it is not selected. The gallery type appears above
 *  the upper left corner of the gallery. If the type is "Wix Pro Gallery", then
 *  your gallery is a Pro Gallery. If the type is anything other than "Wix Pro
 *  Gallery", your gallery gallery is a standard gallery.
 *
 *  The URL formats supported are:
 *  + Images from the Media Manager:
 *    `wix:image://v1/<uri>/<filename>/#originWidth=<width>&originHeight=<height>[&watermark=<watermark_manifest_string>]`
 *  + Videos from the Media Manager:
 *    `wix:video://v1/<video_uri>/<filename>/#posterUri=<poster_uri>&posterWidth=<width>&posterHeight=<height>`
 *  + Images from the web:
 *    `http(s)://<image url>`
 * @see [items](#items)
 * @see [currentItem](#currentItem)
 */

/**
 * @class Gallery
 * @summary A gallery for displaying multiple items.
 * @classdesc
 *  There are many different types and styles of galleries, some of which do not
 *  support all of the properties and functions described below. To determine
 *  what functionality a specific gallery supports, use its
 *  [`galleryCapabilities`](#galleryCapabilities) property to identify its
 *  capabilities. Then use the list below to determine what functionality is
 *  supported by the gallery.
 *
 *  + All galleries
 *    + [`clickAction`](#clickAction)
 *    + [`collapsed`](#collapsed)
 *    + [`galleryCapabilities`](#galleryCapabilities)
 *    + [`global`](#global)
 *    + [`hidden`](#hidden)
 *    + [`id`](#id)
 *    + [`items`](#items)
 *    + [`isVisible`](#isVisible)
 *    + [`parent`](#parent)
 *    + [`rendered`](#rendered)
 *    + [`type`](#type)
 *    + [`collapse()`](#collapse)
 *    + [`expand()`](#expand)
 *    + [`hide()`](#hide)
 *    + [`onClick()`](#onClick)
 *    + [`onDblClick()`](#onDblClick)
 *    + [`onItemClicked()`](#onItemClicked)
 *    + [`onMouseIn()`](#onMouseIn)
 *    + [`onMouseOut()`](#onMouseOut)
 *    + [`onViewportEnter()`](#onViewportEnter)
 *    + [`onViewportLeave()`](#onViewportLeave)
 *    + [`scrollTo()`](#scrollTo)
 *    + [`show()`](#show)
 *  + Galleries where `hasCurrentItem` is `true`
 *    + [`currentIndex`](#currentIndex)
 *    + [`currentItem`](#currentItem)
 *    + [`onCurrentItemChanged()`](#onCurrentItemChanged)
 *  + Galleries where `isPlayable` is `true`
 *    + [`isPlaying`](#isPlaying)
 *    + [`next()`](#next)
 *    + [`onPause()`](#onPause)
 *    + [`onPlay()`](#onPlay)
 *    + [`pause()`](#pause)
 *    + [`play()`](#play)
 *    + [`previous()`](#previous)
 *  + Galleries where `hasNavigationButtons` is `true`
 *    + [`showNavigationButtons`](#showNavigationButtons)
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.PlayableMixin
 * @mixes $w.ClickableMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.SlideShowGallery
 * @viewername wysiwyg.viewer.components.SliderGallery
 * @viewername wysiwyg.viewer.components.MatrixGallery
 * @viewername wysiwyg.viewer.components.PaginatedGridGallery
 * @viewername tpa.viewer.components.Thumbnails
 * @viewername tpa.viewer.components.StripShowcase
 * @viewername tpa.viewer.components.StripSlideshow
 * @viewername tpa.viewer.components.Collage
 * @viewername tpa.viewer.components.Masonry
 * @viewername tpa.viewer.components.Honeycomb
 * @viewername tpa.viewer.components.Accordion
 * @viewername wysiwyg.viewer.components.tpapps.TPA3DCarousel
 * @viewername wysiwyg.viewer.components.tpapps.TPA3DGallery
 * @viewername tpa.viewer.components.Impress
 * @viewername tpa.viewer.components.Freestyle

 * @tagname gallery
 */

var Gallery = function (_Element) {
    _inherits(Gallery, _Element);

    function Gallery(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, Gallery);

        var _this = _possibleConstructorReturn(this, (Gallery.__proto__ || Object.getPrototypeOf(Gallery)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(Gallery.prototype, _HiddenCollapsedMixin2.default.prototype);
        (0, _mixin2.default)(Gallery.prototype, _PlayableMixin2.default.prototype);
        (0, _mixin2.default)(Gallery.prototype, _ClickableMixin2.default.prototype);
        return _this;
    }

    /**
     * @member clickAction
     * @label property
     * @syntax
     * get clickAction(): string
     * set clickAction(value: String): void
     * @summary Sets or gets the action that occurs when an item in the gallery is clicked.
     * @description
     *  Setting the `clickAction` property sets what happens when
     *  an item in the gallery is clicked.
     *
     *  The value can be set to:
     *  + `"none"`: Nothing happens.
     *  + `"expand"`: The item opens in a pop-up.
     *  + `"link"`: The item's link opens.
     *
     *  Getting the `clickAction` property returns what happens when
     *  an item in the gallery is clicked.
     * @snippet [Gallery-clickAction_get.es6=Get the action that occurs when an item in the gallery is clicked]
     * @snippet [Gallery-clickAction_set.es6=Set the action that occurs when an item in the gallery is clicked]
     * @type {external:String}
     * @memberof $w.Gallery
     * @instance
     */


    _createClass(Gallery, [{
        key: 'onCurrentItemChanged',


        /**
         * @function onCurrentItemChanged
         * @syntax
         * function onCurrentItemChanged(handler: GalleryChangeEventHandler): Gallery
         * callback GalleryChangeEventHandler(event: GalleryItemChangedEvent, $w: Function): void
         * @summary Adds an event handler that runs when a gallery's current item changes.
         * @description
         *  A gallery's current item changes through playing or certain user
         *  interactions.
         *
         * @note
         *  The `onCurrentItemChanged()` function is supported by galleries where
         *  the `hasCurrentItem` [capability](#GalleryCapabilities) is `true`.
         *
         *  If you [change the gallery's type](https://www.wix.com/support/html5/article/changing-the-gallery-type)
         *  to one that doesn't support `hasCurrentItem` and you try to use it, your
         *  code may no longer function correctly.
         * @param {$w.GalleryItemChangedEventHandler} handler The name of the
         *  function or the function expression to run when the gallery's current
         *  item changes.
         * @returns {$w.Gallery} The gallery that triggered the event.
         * @snippet [Gallery-onCurrentItemChanged.es6=Get the information of the item that changed]
         * @memberof $w.Gallery
         * @eventtype imageChanged
         * @eventhandler
         */
        value: function onCurrentItemChanged(cb) {
            var _this2 = this;

            executeApiIfSupported(this, 'onCurrentItemChanged', function () {
                var compType = members._type.get(_this2).compType;
                if ((0, _validation.validate)(compType, 'onCurrentItemChanged', { onChange: cb })) {
                    var RMI = members._RMI.get(_this2);
                    var contextId = members._contextId.get(_this2);
                    var controllerId = members._controllerId.get(_this2);
                    var compId = members._compId.get(_this2);
                    RMI.registerEvent(contextId, compId, RMI.getEventTypes().IMAGE_CHANGED, controllerId, cb);
                }
            });
            return this;
        }

        /**
         * @function onItemClicked
         * @syntax
         * function onItemClicked(handler: GalleryItemClickedEventHandler): Gallery
         * callback GalleryItemClickedEventHandler(event: GalleryItemClickedEvent, $w: Function): void
         * @summary Adds an event handler that runs when an item in a gallery is
         *  clicked.
         * @param {$w.GalleryItemClickedEventHandler} handler The name of the
         *  function or the function expression to run when a gallery item is
         *  clicked.
         * @returns {$w.Gallery} The gallery that triggered the event.
         * @snippet [Gallery-onItemClicked.es6=Get the information of the item that was clicked]
         * @see [clickAction](#clickAction)
         * @memberof $w.Gallery
         * @eventtype itemClicked
         * @eventhandler
         */

    }, {
        key: 'onItemClicked',
        value: function onItemClicked(cb) {
            var _this3 = this;

            executeApiIfSupported(this, 'onItemClicked', function () {
                var compType = members._type.get(_this3).compType;
                if ((0, _validation.validate)(compType, 'onItemClicked', { onItemClicked: cb })) {
                    var RMI = members._RMI.get(_this3);
                    var contextId = members._contextId.get(_this3);
                    var controllerId = members._controllerId.get(_this3);
                    var compId = members._compId.get(_this3);
                    RMI.registerEvent(contextId, compId, RMI.getEventTypes().ITEM_CLICKED, controllerId, cb);
                }
            });
            return this;
        }

        /**
         * @member showNavigationButtons
         * @label property
         * @syntax
         * get showNavigationButtons(): boolean
         * set showNavigationButtons(value: boolean): void
         * @summary Determines if a gallery's navigation arrows are shown.
         * @description
         *  A gallery's navigation arrows allow a user to click through the items in
         *  the gallery.
         * @note
         *  The `showNavigationButtons` property is supported by galleries where
         *  the `hasNavigationButtons` [capability](#GalleryCapabilities) is `true`.
         *
         *  If you [change the gallery's type](https://www.wix.com/support/html5/article/changing-the-gallery-type)
         *  to one that doesn't support `hasNavigationButtons` and you try to use
         *  it, your code may no longer function correctly.
         * @type {external:Boolean}
         * @memberof $w.Gallery
         * @instance
         */

    }, {
        key: 'toJSON',
        value: function toJSON() {
            var viewerType = members._type.get(this).viewerType;
            var possibleProperties = {
                clickAction: (0, _componentAPISupport2.default)(viewerType, 'clickAction') ? this.clickAction : null,
                currentIndex: (0, _componentAPISupport2.default)(viewerType, 'currentIndex') ? this.currentIndex : null,
                currentItem: (0, _componentAPISupport2.default)(viewerType, 'currentItem') ? this.currentItem : null,
                showNavigationButtons: (0, _componentAPISupport2.default)(viewerType, 'showNavigationButtons') ? this.showNavigationButtons : null,
                items: (0, _componentAPISupport2.default)(viewerType, 'items') ? this.items : null
            };
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered;

            var result = (0, _assign2.default)({
                id: id,
                type: type,
                global: global,
                rendered: rendered
            }, possibleProperties);

            return (0, _omitBy2.default)(result, _isNull2.default);
        }
    }, {
        key: 'clickAction',
        get: function get() {
            var _this4 = this;

            return executeApiIfSupported(this, 'clickAction', function () {
                var RMI = members._RMI.get(_this4);
                var compId = members._compId.get(_this4);
                var galleryImageClickAction = RMI.getProps(compId).galleryImageOnClickAction;
                for (var action in _constants2.default.IMAGE_CLICK_ACTIONS) {
                    if (_constants2.default.IMAGE_CLICK_ACTIONS[action] === galleryImageClickAction) {
                        return action;
                    }
                }
            });
        }

        /**
         * @param {external:String} action The action that occurs when an item in the gallery is clicked.
         * @ignore
         */
        ,
        set: function set(action) {
            var _this5 = this;

            return executeApiIfSupported(this, 'clickAction', function () {
                var compType = members._type.get(_this5).compType;
                if ((0, _validation.validate)(compType, 'clickAction', { galleryImageOnClickAction: action })) {
                    var galleryImageClickAction = (0, _isNil2.default)(action) ? _constants2.default.IMAGE_CLICK_ACTIONS.none : _constants2.default.IMAGE_CLICK_ACTIONS[action];
                    if (galleryImageClickAction) {
                        var RMI = members._RMI.get(_this5);
                        var compId = members._compId.get(_this5);
                        RMI.setProps(compId, { galleryImageOnClickAction: galleryImageClickAction });
                    }
                }
            });
        }

        /**
         * @member currentIndex
         * @label property
         * @syntax
         * get currentIndex(): Number
         * @summary Gets the index of the gallery's current item.
         * @description
         *  The indices of the items in a gallery are zero-based. For example, if
         *  the third item is currently being displayed, then `currentIndex`
         *  returns `2`.
         *
         * @note
         *  The `currentIndex` property is supported by galleries where the
         *  `hasCurrentItem` [capability](#GalleryCapabilities) is `true`.
         *
         *  If you [change the gallery's type](https://www.wix.com/support/html5/article/changing-the-gallery-type)
         *  to one that doesn't support `currentIndex` and you try to use it, your code may no longer function correctly.
         * @snippet [Gallery-currentIndex_get.es6=Get the index of the gallery's current item]
         * @type {external:Number}
         * @memberof $w.Gallery
         * @instance
         * @readonly
         */

    }, {
        key: 'currentIndex',
        get: function get() {
            var _this6 = this;

            return executeApiIfSupported(this, 'currentIndex', function () {
                var RMI = members._RMI.get(_this6);
                var compId = members._compId.get(_this6);
                var compState = RMI.getState(compId);
                return compState.currentIndex;
            });
        }

        /**
         * @member items
         * @label property
         * @syntax
         * get items(): GalleryItem[]
         * set items(value: GalleryItem[]): void
         * @summary Sets or gets the items in a gallery.
         * @description
         *  Setting the `items` property sets the
         *  [gallery items](#GalleryItem) that make up the gallery.
         *
         *  Set `items` to an empty array (`[]`) to remove the current gallery items.
         *
         *  Getting the `items` property returns the current
         *  list of [gallery items](#GalleryItem) that make up the gallery.
         *
         *  You cannot modify the gallery item array in-place. To add, change, or
         *  remove individual [gallery items](#GalleryItem):
         *    1. Store the value of the `items` property in a variable.
         *    1. Make changes to the [gallery items](#GalleryItem) array.
         *    1. Reset the `items` property with the modified array.
         *
         *
         * @note You can only get the items of a Pro Gallery using the `items` property
         *  if you set its items using the `items` property or connect the gallery
         *  to a dataset first. If you set the gallery's items in the Editor, you
         *  will not be able to retrieve them with the `items` property. This limitation
         *  does not apply to standard galleries.
         *
         *  To determine if your gallery is a Pro Gallery, hover over the gallery while
         *  it is not selected. The gallery type appears above the upper left corner
         *  of the gallery. If the type is "Wix Pro Gallery", then your gallery is a
         *  Pro Gallery. If the type is anything other than "Wix Pro Gallery", the
         *  limitation described above does not apply to your gallery.
         * @snippet [Gallery-items_get.es6=Get the list of items and the first item's information]
         * @snippet [Gallery-items_set.es6=Set the list of items for a gallery]
         * @snippet [Gallery-add.es6=Add an item to a gallery]
         *  This example retrieves the items of a gallery, adds a new
         *  item, and then overwrites the old items.
         * @type {$w.Gallery~GalleryItem[]}
         * @memberof $w.Gallery
         * @instance
         */

    }, {
        key: 'items',
        get: function get() {
            var _this7 = this;

            return executeApiIfSupported(this, 'items', function () {
                var RMI = members._RMI.get(_this7);
                var compId = members._compId.get(_this7);
                var data = RMI.getData(compId);
                return (0, _map2.default)(data.items, _imageUtils2.default.dataFormat.toUser);
            });
        }

        /**
         * @ignore
         */
        ,
        set: function set(items) {
            var _this8 = this;

            return executeApiIfSupported(this, 'items', function () {
                var compType = members._type.get(_this8).compType;
                if (!(0, _validation.validate)(compType, 'items', { items: items })) {
                    return _this8;
                }
                var isImagesDataValid = (0, _every2.default)(items, _imageUtils2.default.checkImageValidation);
                if (isImagesDataValid) {
                    var RMI = members._RMI.get(_this8);
                    var newItems = (0, _map2.default)(items, _imageUtils2.default.dataFormat.toModel);
                    RMI.setData(members._compId.get(_this8), { items: newItems });
                }
            });
        }
    }, {
        key: 'showNavigationButtons',
        get: function get() {
            var _this9 = this;

            return executeApiIfSupported(this, 'showNavigationButtons', function () {
                var RMI = members._RMI.get(_this9);
                var compId = members._compId.get(_this9);
                var props = RMI.getProps(compId);
                var viewerType = members._type.get(_this9).viewerType;
                var navButtonsPropName = getShowANavigationButtonsPropertyName(viewerType);
                return props[navButtonsPropName];
            });
        }

        /**
         * @param {external:Boolean} value `true` to show navigation arrows, `false` to hide them.
         * @ignore
         */
        ,
        set: function set(value) {
            var _this10 = this;

            return executeApiIfSupported(this, 'showNavigationButtons', function () {
                var compType = members._type.get(_this10).compType;
                var viewerType = members._type.get(_this10).viewerType;
                var navButtonsPropName = getShowANavigationButtonsPropertyName(viewerType);
                if ((0, _validation.validate)(compType, 'showNavigationButtons', _defineProperty({}, navButtonsPropName, value))) {
                    var RMI = members._RMI.get(_this10);
                    var compId = members._compId.get(_this10);
                    RMI.setProps(compId, _defineProperty({}, navButtonsPropName, value));
                }
            });
        }

        /**
         * @member currentItem
         * @label property
         * @syntax
         * get currentItem(): GalleryItem
         * @summary Gets an object containing information about the current item.
         * @note
         *  The `currentItem` property is supported by galleries where the
         *  `hasCurrentItem` [capability](#GalleryCapabilities) is `true`.
         *
         *  If you [change the gallery's type](https://www.wix.com/support/html5/article/changing-the-gallery-type)
         *  to one that doesn't support `hasCurrentItem` and you try to use
         *  it, your code may no longer function correctly.
         * @type {$w.Gallery~GalleryItem}
         * @memberof $w.Gallery
         * @instance
         * @readonly
         */

    }, {
        key: 'currentItem',
        get: function get() {
            var _this11 = this;

            return executeApiIfSupported(this, 'currentItem', function () {
                var RMI = members._RMI.get(_this11);
                var compId = members._compId.get(_this11);
                var compState = RMI.getState(compId);
                var currentIndex = compState.currentIndex;
                var items = (0, _get3.default)(RMI.getData(compId), 'items');
                if ((0, _isUndefined2.default)(items) || (0, _isUndefined2.default)(currentIndex) || (0, _size2.default)(items) === 0) {
                    return undefined;
                }
                var image = _imageUtils2.default.dataFormat.toUser(items[currentIndex]);
                return (0, _omit2.default)(image, 'id');
            });
        }

        /**
         * @member galleryCapabilities
         * @label property
         * @syntax
         * get galleryCapabilities(): GalleryCapabilities
         * @summary Gets an object containing information about the gallery's capabilities.
         * @snippet [Gallery-galleryCapabilities_get.es6=Get the gallery's capabilities]
         * @type {$w.Gallery~GalleryCapabilities}
         * @memberof $w.Gallery
         * @instance
         * @readonly
         */

    }, {
        key: 'galleryCapabilities',
        get: function get() {
            var viewerType = members._type.get(this).viewerType;
            return Object.freeze({
                isPlayable: (0, _componentAPISupport2.default)(viewerType, 'play'),
                hasCurrentItem: (0, _componentAPISupport2.default)(viewerType, 'currentItem'),
                hasNavigationButtons: (0, _componentAPISupport2.default)(viewerType, 'showNavigationButtons')
            });
        }
    }]);

    return Gallery;
}(_Element3.default);

exports.default = Gallery;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @mixin HiddenCollapsedElement
 * @summary Provides functionality for all elements that can be hidden or collapsed.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof $w
 */
var HiddenCollapsedElement = function (_Element) {
  _inherits(HiddenCollapsedElement, _Element);

  function HiddenCollapsedElement(RMI, compId, contextId, wixSelector, controllerId, role, type) {
    _classCallCheck(this, HiddenCollapsedElement);

    var _this = _possibleConstructorReturn(this, (HiddenCollapsedElement.__proto__ || Object.getPrototypeOf(HiddenCollapsedElement)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

    (0, _mixin2.default)(HiddenCollapsedElement.prototype, _HiddenCollapsedMixin2.default.prototype);
    return _this;
  }

  _createClass(HiddenCollapsedElement, [{
    key: 'toJSON',
    value: function toJSON() {
      var id = this.id,
          type = this.type,
          global = this.global,
          rendered = this.rendered;

      return { id: id, type: type, global: global, rendered: rendered };
    }
  }]);

  return HiddenCollapsedElement;
}(_Element3.default);

exports.default = HiddenCollapsedElement;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _isFunction = __webpack_require__(29);

var _isFunction2 = _interopRequireDefault(_isFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @mixin IFrame
 * @summary Provides functionality for iframe-based elements, such as `HtmlComponent`. 
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof $w
 * @tagname IFrame
 */
var IFrame = function (_Element) {
    _inherits(IFrame, _Element);

    function IFrame(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, IFrame);

        var _this = _possibleConstructorReturn(this, (IFrame.__proto__ || Object.getPrototypeOf(IFrame)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(IFrame.prototype, _HiddenCollapsedMixin2.default.prototype);

        var publicAPI = RMI.getPublicAPI(compId);
        if ((0, _isFunction2.default)(publicAPI)) {
            var controllerData = RMI.getData(compId);
            (0, _assign2.default)(_this, publicAPI(RMI.getCurrentScope(), wixSelector.scoped$W(controllerData.id)));
        } else if (publicAPI) {
            (0, _assign2.default)(_this, publicAPI);
        }
        return _this;
    }

    return IFrame;
}(_Element3.default);

exports.default = IFrame;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _Background2 = __webpack_require__(49);

var _Background3 = _interopRequireDefault(_Background2);

var _ContainableMixin = __webpack_require__(26);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Slide
 * @summary A `Slide` from a `Slideshow` that can contain other elements.
 * @mixes $w.Element
 * @mixes $w.Background
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.BoxSlideShowSlide
 */
var Slide = function (_Background) {
    _inherits(Slide, _Background);

    function Slide(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, Slide);

        var _this = _possibleConstructorReturn(this, (Slide.__proto__ || Object.getPrototypeOf(Slide)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(Slide.prototype, _ContainableMixin2.default.prototype);
        return _this;
    }
    /**
     * @member name
     * @label property
     * @syntax
     * get name(): string
     * @summary Gets the name of the slide.
     * @description
     *  A slide's `name` is used as a label for the slide.
     *
     *  A slide's `name` is set in the Editor using the <a href="https://support.wix.com/en/article/manage-slides" target="_blank">Manage Slides panel</a>.
     *  ![Manage Slides](images/manage_slides.png "Manage Slides")
     * @snippet [Slide-name.es6=Get a slide's name]
     * @type {external:String}
     * @memberof $w.Slide
     * @readonly
     * @instance
     */


    _createClass(Slide, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                background = this.background,
                rendered = this.rendered,
                name = this.name;

            return { id: id, type: type, global: global, background: background.src, rendered: rendered, name: name };
        }
    }, {
        key: 'name',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getData(compId).title;
        }
    }]);

    return Slide;
}(_Background3.default);

exports.default = Slide;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _WixEvent2 = __webpack_require__(40);

var _WixEvent3 = _interopRequireDefault(_WixEvent2);

var _imageUtils = __webpack_require__(39);

var _imageUtils2 = _interopRequireDefault(_imageUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getImageData(event) {
    var image = void 0;

    try {
        if ((0, _get2.default)(event, 'item')) {
            image = _imageUtils2.default.dataFormat.toUser(event.item);
        }
    } catch (e) {/*do nothing*/
    }

    return image;
}

/**
 * @callback $w.GalleryItemChangedEventHandler
 * @summary Handles events fired when a gallery moves to a new image.
 * @param {$w.GalleryItemChangedEvent} event The event that occurred.
 * @param {$w.$w} $w A selector function. The $w function enables event handlers
 *  to work with elements in [repeaters]($w.Repeater.html#repeating-callback-selector)
 *  and in the [global scope]($w.Repeater.html#regular-callback-selector).
 */

/**
 * @class GalleryItemChangedEvent
 * @summary Event that is fired when a gallery moves to a new image.
 * @memberof $w
 * @mixes $w.Event
 */

var GalleryItemChangedEvent = function (_WixEvent) {
    _inherits(GalleryItemChangedEvent, _WixEvent);

    function GalleryItemChangedEvent(target, event) {
        _classCallCheck(this, GalleryItemChangedEvent);

        var _this = _possibleConstructorReturn(this, (GalleryItemChangedEvent.__proto__ || Object.getPrototypeOf(GalleryItemChangedEvent)).call(this, target, event));

        _this.item = getImageData(event);
        _this.itemIndex = event.imageIndex;

        return _this;
    }

    /**
     * @member item
     * @label property
     * @syntax
     * get item(): GalleryItem
     * @summary Gets the gallery item.
     * @snippet [GalleryEvent-item.es6=Get the event's image properties]
     * @type {$w.Gallery~GalleryItem}
     * @memberof $w.GalleryItemChangedEvent
     * @readonly
     */

    /**
     * @member itemIndex
     * @label property
     * @syntax
     * get itemIndex(): Number
     * @summary Gets the gallery item's index.
     * @type {external:Number}
     * @snippet [GalleryEvent-itemIndex.es6=Get the event's image properties]
     * @memberof $w.GalleryItemChangedEvent
     * @readonly
     */


    return GalleryItemChangedEvent;
}(_WixEvent3.default);

exports.default = GalleryItemChangedEvent;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _componentAPISupport = __webpack_require__(132);

var _componentAPISupport2 = _interopRequireDefault(_componentAPISupport);

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

var _validation = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin PlayableMixin
 * @summary Provides functionality for elements that can be played.
 * @memberof $w
 */
var autoPlayOverrides = {
    '$w.Slideshow': 'autoPlay'
};

function reportUnsupportedAPI(api, type) {
    _reporter2.default.reportSdkWarning('\'' + api + '\' is not supported for an element of type: ' + type + '.');
}

function executeApiIfSupported(comp, apiName, apiToInvoke) {
    var viewerType = members._type.get(comp).viewerType;
    if ((0, _componentAPISupport2.default)(viewerType, apiName)) {
        return apiToInvoke();
    }
    reportUnsupportedAPI(apiName, viewerType); //todo Shimi_Liderman 21/05/2017 18:53 Seems very strange to print out the viewer type!
}

function setAutoplay(comp, autoplay) {
    var compType = members._type.get(comp).compType;
    if ((0, _validation.validate)(compType, 'autoplay', { autoplay: autoplay })) {
        var RMI = members._RMI.get(comp);
        var compId = members._compId.get(comp);
        var obj = {};
        obj[autoPlayOverrides[comp.type] ? autoPlayOverrides[comp.type] : 'autoplay'] = autoplay;
        RMI.setProps(compId, obj);
    }
}

var PlayableMixin = function () {
    function PlayableMixin() {
        _classCallCheck(this, PlayableMixin);
    }

    _createClass(PlayableMixin, [{
        key: 'onPause',


        // METHODS:

        /**
         * @function onPause
         * @syntax
         * function onPause(handler: EventHandler): Gallery | Slideshow
         * callback EventHandler(event: Event, $w: Function): void
         * @summary Adds an event handler that runs when playback is paused.
         * @description
         *  An element can be paused by a user clicking the gallery or slideshow's
         *  pause button or by calling its [`pause()`](#pause) function
         *
         * @note
         *  When using `onPause()` on a [gallery]($w.Gallery.html), make sure the
         *  [gallery]($w.Gallery.html) is one where the `isPlayable`
         *  [capability](#GalleryCapabilities) is `true`.
         *
         *  If you [change a gallery's type](https://www.wix.com/support/html5/article/changing-the-gallery-type)
         *  to one that doesn't support `onPause()`, your code may longer function correctly.
         * @snippet [PlayableMixin-onPause.es6=Get the ID of the element that has been paused]
         * @param {$w.EventHandler} handler The name of the function or
         *  the function expression to run when the element is paused.
         * @returns {$w.Gallery|$w.Slideshow} The gallery or slideshow that triggered the event.
         * @see [pause( )](#pause)
         * @memberof $w.PlayableMixin
         * @eventtype autoplayOff
         * @eventhandler
         */
        value: function onPause(cb) {
            var _this = this;

            executeApiIfSupported(this, 'onPause', function () {
                var compType = members._type.get(_this).compType;
                if ((0, _validation.validate)(compType, 'onPause', { onPause: cb })) {
                    var RMI = members._RMI.get(_this);
                    var contextId = members._contextId.get(_this);
                    var controllerId = members._controllerId.get(_this);
                    var compId = members._compId.get(_this);
                    RMI.registerEvent(contextId, compId, RMI.getEventTypes().AUTOPLAY_OFF, controllerId, cb);
                }
            });
            return this;
        }

        /**
         * @function onPlay
         * @syntax
         * function onPlay(handler: EventHandler): Gallery | Slideshow
         * callback EventHandler(event: Event, $w: Function): void
         * @summary Adds an event handler that runs when playback is started or restarted.
         * @description
         *  An element can be played by a user clicking the gallery or slideshow's
         *  play button, by calling its [`play()`](#play) function.
         * @note
         *  When using `onPlay()` on a [gallery]($w.Gallery.html), make sure the
         *  [gallery]($w.Gallery.html) is one where the `isPlayable`
         *  [capability](#GalleryCapabilities) is `true`.
         *
         *  If you [change a gallery's type](https://www.wix.com/support/html5/article/changing-the-gallery-type)
         *  to one that doesn't support `onPlay()`, your code may longer function correctly.
         * @snippet [PlayableMixin-onPlay.es6=Get the ID of the element that has is playing]
         * @param {$w.EventHandler} handler The name of the function or
         *  the function expression to run when the element is played.
         * @returns {$w.Gallery|$w.Slideshow} The gallery or slideshow that triggered the event.
         * @see [play( )](#play)
         * @memberof $w.PlayableMixin
         * @eventtype autoplayOn
         * @eventhandler
         */

    }, {
        key: 'onPlay',
        value: function onPlay(cb) {
            var _this2 = this;

            executeApiIfSupported(this, 'onPlay', function () {
                var compType = members._type.get(_this2).compType;
                if ((0, _validation.validate)(compType, 'onPlay', { onPlay: cb })) {
                    var RMI = members._RMI.get(_this2);
                    var contextId = members._contextId.get(_this2);
                    var controllerId = members._controllerId.get(_this2);
                    var compId = members._compId.get(_this2);
                    RMI.registerEvent(contextId, compId, RMI.getEventTypes().AUTOPLAY_ON, controllerId, cb);
                }
            });
            return this;
        }

        /**
         * @function pause
         * @syntax
         * function pause(): void;
         * @summary Pauses playback.
         * @description
         *  The `pause()` function pauses a slideshow or playable gallery and fires a `pause` event.
         *
         *  The `pause` event handlers set on this element by the [onPause( )](#onPause)
         *  function or in the Editor will called.
         *
         * @note
         *  When using `pause()` on a [gallery]($w.Gallery.html), make sure the
         *  [gallery]($w.Gallery.html) is one where the `isPlayable`
         *  [capability](#GalleryCapabilities) is `true`.
         *
         *  If you [change a gallery's type](https://www.wix.com/support/html5/article/changing-the-gallery-type)
         *  to one that doesn't support `pause()`, your code may longer function correctly.
         * @snippet [PlayableMixin-pause.es6=Pauses playback]
         * @snippet [PlayableMixin_toggle_isPlaying.es6=Toggle an element's current playing state]
         * @see [play( )](#play)
         * @see [onPause( )](#onPause)
         * @memberof $w.PlayableMixin
         */

    }, {
        key: 'pause',
        value: function pause() {
            var _this3 = this;

            executeApiIfSupported(this, 'pause', function () {
                setAutoplay(_this3, false);
            });
            return this;
        }

        /**
         * @function play
         * @syntax
         * function play(): void;
         * @summary Begins or resumes playback.
         * @description
         *  The `play()` function plays a slideshow or playable gallery and fires a `play` event.
         *
         *  The `play` event handlers set on this element by the [onPlay( )](#onPlay)
         *  function or in the Editor will called.
         *
         * @note
         *  When using `play()` on a [gallery]($w.Gallery.html), make sure the
         *  [gallery]($w.Gallery.html) is one where the `isPlayable`
         *  [capability](#GalleryCapabilities) is `true`.
         *
         *  If you [change a gallery's type](https://www.wix.com/support/html5/article/changing-the-gallery-type)
         *  to one that doesn't support `play()`, your code may longer function correctly.
         * @snippet [PlayableMixin-play.es6=Begins or resumes playback]
         * @snippet [PlayableMixin_toggle_isPlaying.es6=Toggle an element's current playing state]
         * @see [pause( )](#pause)
         * @see [onPlay( )](#onPlay)
         * @memberof $w.PlayableMixin
         */

    }, {
        key: 'play',
        value: function play() {
            var _this4 = this;

            executeApiIfSupported(this, 'play', function () {
                setAutoplay(_this4, true);
            });
            return this;
        }

        /**
         * @function next
         * @syntax
         * function next(): Promise&lt;Element&gt;
         * @summary Moves to the next item.
         * @description
         *  The `next()` function returns a Promise that is resolved when the next
         *  item is completely rendered. Calling `next()` when on the last item,
         *  moves to the first item.
         *
         * @note
         *  When using `next()` on a [gallery]($w.Gallery.html), make sure the
         *  [gallery]($w.Gallery.html) is one where the `isPlayable`
         *  [capability](#GalleryCapabilities) is `true`.
         *
         *  If you [change a gallery's type](https://www.wix.com/support/html5/article/changing-the-gallery-type)
         *  to one that doesn't support `next()`, your code may longer function correctly.
         * @snippet [PlayableMixin-next.es6=Move to the next item]
         * @snippet [PlayableMixin-next_then.es6=Move to the next item and log a message when done]
         * @returns {external:Promise}
         * @fulfill {$w.Element} The newly displayed image or slide.
         * @see [previous( )](#previous)
         * @see [play( )](#play)
         * @see [pause( )](#pause)
         * @memberof $w.PlayableMixin
         */

    }, {
        key: 'next',
        value: function next() {
            var _this5 = this;

            var viewerType = members._type.get(this).viewerType;
            return executeApiIfSupported(this, 'next', function () {
                return new Promise(function (resolve) {
                    var RMI = members._RMI.get(_this5);
                    var compId = members._compId.get(_this5);
                    RMI.executeCompBehavior(compId, 'nextSlide', {}, function () {
                        resolve();
                    });
                });
            }) || Promise.reject('Next is not supported for an element of type: ' + viewerType + '.');
        }

        /**
         * @function previous
         * @syntax
         * function previous(): Promise&lt;Element&gt;
         * @summary Moves to the previous image or slide.
         * @description
         *  The `previous()` function returns a Promise that is resolved when the previous
         *  image or slide is completely rendered. Calling `previous()` when on the first item,
         *  moves to the last item.
         *
         * @note
         *  When using `previous()` on a [gallery]($w.Gallery.html), make sure the
         *  [gallery]($w.Gallery.html) is one where the `isPlayable`
         *  [capability](#GalleryCapabilities) is `true`.
         *
         *  If you [change a gallery's type](https://www.wix.com/support/html5/article/changing-the-gallery-type)
         *  to one that doesn't support `previous()`, your code may longer function correctly.
         * @snippet [PlayableMixin-previous.es6=Move to the previous item]
         * @snippet [PlayableMixin-previous_then.es6=Move to the previous item and log a message when done]
         * @returns {external:Promise}
         * @fulfill {$w.Element} The newly displayed image or slide.
         * @see [next( )](#next)
         * @memberof $w.PlayableMixin
         */

    }, {
        key: 'previous',
        value: function previous() {
            var _this6 = this;

            var viewerType = members._type.get(this).viewerType;
            return executeApiIfSupported(this, 'previous', function () {
                return new Promise(function (resolve) {
                    var RMI = members._RMI.get(_this6);
                    var compId = members._compId.get(_this6);
                    RMI.executeCompBehavior(compId, 'prevSlide', {}, function () {
                        resolve();
                    });
                });
            }) || Promise.reject('Previous is not supported for an element of type: ' + viewerType + '.');
        }
    }, {
        key: 'isPlaying',


        // PROPERTIES:

        /**
         * @member isPlaying
         * @label property
         * @syntax
         * get isPlaying(): boolean
         * @summary Indicates if the element is currently playing.
         * @description
         *  To set the `isPlaying` property on an element, use the element's
         *  [`play()`](#play) and [`pause()`](#pause) functions.
         *
         *  If you select **Autoplays on loading** in the element's Settings panel
         *  in the Editor, the `isPlaying` property is set to `true` when the page loads.
         * @snippet [PlayableMixin-isPlaying.es6=Get an element's current playing status]
         * @snippet [PlayableMixin_toggle_isPlaying.es6=Toggle an element's current playing state]
         * @type {external:Boolean}
         * @see [play( )](#play)
         * @see [pause( )](#pause)
         * @memberof $w.PlayableMixin
         * @readonly
         */
        get: function get() {
            var _this7 = this;

            return executeApiIfSupported(this, 'isPlaying', function () {
                var RMI = members._RMI.get(_this7);
                var compId = members._compId.get(_this7);
                return RMI.getState(compId).isPlaying;
            });
        }
    }]);

    return PlayableMixin;
}();

exports.default = PlayableMixin;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _utils = __webpack_require__(9);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _validation = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin TextInputMixin
 * @summary Provides functionality for elements that accept text as input.
 * @memberof $w
 */
var TextInputMixin = function () {
    function TextInputMixin() {
        _classCallCheck(this, TextInputMixin);
    }

    _createClass(TextInputMixin, [{
        key: 'onKeyPress',


        /**
         * @function onKeyPress
         * @syntax
         * function onKeyPress(handler: KeyboardEventHandler): Element
         * callback KeyboardEventHandler(event: Event, $w: Function): void
         * @summary Adds an event handler that runs when the cursor is inside the
         *  input element and a key is pressed.
         * @description
         *  A text input receives a `keyPress` event when a user presses a key on
         *  the keyboard while the cursor is inside the input element.
         *  @note Some browsers do not issue a key press event for certain keys,
         *  such as arrow keys or the shift key.
         * @param {$w.KeyboardEventHandler} eventHandler The name of the function or
         *  the function expression to run when a key is pressed.
         * @returns {$w.Element} The element on which the event is now registered.
         * @snippet [TextInputElement-onKeyPress.es6=Get the key that was pressed]
         * @snippet [KeyboardEvent-all.es6=Get all of the keyboard event's properties]
         * @memberof $w.TextInputMixin
         * @eventtype keyPress
         * @eventhandler
         */
        value: function onKeyPress(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'onKeyPress', { onKeyPress: cb })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var controllerId = members._controllerId.get(this);
            var contextId = members._contextId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().KEY_PRESS, controllerId, cb);
            return this;
        }
    }, {
        key: 'placeholder',

        /**
         * @member placeholder
         * @label property
         * @syntax
         * get placeholder(): string
         * set placeholder(value: string): void
         * @summary Sets or gets the element's placeholder text.
         * @description
         *  Placeholder text is typically used to provide a
         *  hint to the user of what to enter into a input element that accepts
         *  text. When the user begins to enter text, the placeholder text disappears.
         * @snippet [TextInputElement-placeholder_get.es6=Get an element's placeholder text]
         * @snippet [TextInputElement-placeholder_set.es6=Set an element's placeholder text]
         * @type {external:String}
         * @memberof $w.TextInputMixin
         * @attr {external:String}
         */
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compProps = RMI.getProps(compId);

            return compProps && compProps.placeholder;
        }

        /**
         * @param {external:String} newPlaceholder The placeholder value.
         * @ignore
         */
        ,
        set: function set(newPlaceholder) {
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)(compType, 'placeholder', { placeholder: newPlaceholder });
            if (newPlaceholder && !isValid) {
                return;
            }
            newPlaceholder = (0, _utils.emptyStringIfNil)(newPlaceholder);
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);

            RMI.setProps(compId, {
                placeholder: newPlaceholder
            });
        }

        /**
         * @member maxLength
         * @label property
         * @syntax
         * get maxLength(): Number
         * set maxLength(value: Number): void
         * @summary Sets or gets the maximum number of characters that can be entered.
         * @description
         *  Setting the `maxLength` property of an input element to a
         *  positive number restricts user input, by manual entry or pasting, to
         *  text that does not exceed the `maxLength`. However, it does not limit
         *  your ability to change the element's value to one that exceeds
         *  `maxLength` programmatically.
         *
         *  To remove the maximum length restriction that has been set on the input
         *  element, set `maxLength` to `0`.
         *
         *  Getting the `maxLength` property returns the element's
         *  current `maxLength` setting.
         *
         *  The number of characters is calculated by <a href="https://en.wikipedia.org/wiki/Code_point"
         *  target="_blank">Unicode code points</a>.
         * @snippet [TextInputMixin-maxlength_get.es6=Get an element's maximum length]
         * @snippet [TextInputMixin-maxlength_set.es6=Set an element's maximum length]
         * @snippet [TextInputMixin-maxlength_reset.es6=Remove an element's maximum length restriction]
         * @type {external:Number}
         * @memberof $w.TextInputMixin
         */

    }, {
        key: 'maxLength',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getData(compId);
            return compData && compData.maxLength;
        }

        /**
         * @param {external:Number} len The max length value.
         * @ignore
         */
        ,
        set: function set(len) {
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)(compType, 'maxlength', { maxlength: len });
            if (!(0, _isNil2.default)(len) && !isValid) {
                return;
            }
            len = (0, _utils.nullIfNil)(len);
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);

            RMI.setData(compId, {
                maxLength: len
            });
        }
    }]);

    return TextInputMixin;
}();

exports.default = TextInputMixin;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin ViewportMixin
 * @summary Provides functionality for elements that can be scrolled into and out
 *  of view.
 * @memberof $w
 */
var ViewportMixin = function () {
    function ViewportMixin() {
        _classCallCheck(this, ViewportMixin);
    }

    _createClass(ViewportMixin, [{
        key: 'onViewportEnter',


        /**
         * @function onViewportEnter
         * @syntax
         * function onViewportEnter(handler: EventHandler): Element
         * callback EventHandler(event: Event, $w: Function): void
         * @summary Adds an event handler that runs when an element is displayed
         *  in the viewable part of the current window.
         * @description
         *  An element enters the viewport when the page is scrolled to show any
         *  part of the element. An element also enters the viewport if it was
         *  [hidden]($w.HiddenMixin.html#hidden) or [collapsed]($w.CollapsedMixin.html#collapsed)
         *  and is then shown or expanded in the viewable part of the current window.
         * @param {$w.EventHandler} handler The name of the function or
         *  the function expression to run when the element enters the viewport.
         * @returns {$w.Element} The element on which the event is now registered.
         * @snippet [ViewportMixin-onViewportEnter.es6=Get the ID of the element that has entered the viewport]
         * @see [onViewportLeave( )](#onViewportLeave)
         * @memberof $w.ViewportMixin
         * @eventtype viewportEnter
         * @eventhandler
         */
        value: function onViewportEnter(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'onViewportEnter', { onViewportEnter: cb })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().VIEWPORT_ENTER, controllerId, cb);
            return this;
        }

        /**
         * @function onViewportLeave
         * @syntax
         * function onViewportLeave(handler: EventHandler): Element
         * callback EventHandler(event: Event, $w: Function): void
         * @summary Adds an event handler that runs when an element is no longer
         *  displayed in the viewable part of the current window.
         * @description
         *  An element leaves the viewport when the page is scrolled so that the
         *  elements is completely out of view. An element also leaves the viewport
         *  if it was shown or expanded and is then [hidden]($w.HiddenMixin.html#hidden)
         *  or [collapsed]($w.CollapsedMixin.html#collapsed) from the viewable part
         *  of the current window.
         * @param {$w.EventHandler} handler The name of the function or
         *  the function expression to run when the element leaves the viewport.
         * @returns {$w.Element} The element on which the event is now registered.
         * @snippet [ViewportMixin-onViewportLeave.es6=Get the ID of the element that has entered the viewport]
         * @see [ViewportMixin-onViewportEnter( )](#onViewportEnter)
         * @memberof $w.ViewportMixin
         * @eventtype viewportLeave
         * @eventhandler
         */

    }, {
        key: 'onViewportLeave',
        value: function onViewportLeave(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'onViewportLeave', { onViewportLeave: cb })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().VIEWPORT_LEAVE, controllerId, cb);
            return this;
        }
    }]);

    return ViewportMixin;
}();

exports.default = ViewportMixin;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(45),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(19);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(45),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 148 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(328),
    isArguments = __webpack_require__(87),
    isArray = __webpack_require__(6),
    isBuffer = __webpack_require__(63),
    isIndex = __webpack_require__(58),
    isTypedArray = __webpack_require__(89);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 150 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(101),
    arrayEach = __webpack_require__(103),
    assignValue = __webpack_require__(70),
    baseAssign = __webpack_require__(300),
    baseAssignIn = __webpack_require__(301),
    cloneBuffer = __webpack_require__(331),
    copyArray = __webpack_require__(165),
    copySymbols = __webpack_require__(338),
    copySymbolsIn = __webpack_require__(339),
    getAllKeys = __webpack_require__(171),
    getAllKeysIn = __webpack_require__(114),
    getTag = __webpack_require__(79),
    initCloneArray = __webpack_require__(361),
    initCloneByTag = __webpack_require__(362),
    initCloneObject = __webpack_require__(363),
    isArray = __webpack_require__(6),
    isBuffer = __webpack_require__(63),
    isObject = __webpack_require__(14),
    keys = __webpack_require__(31);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(69),
    arrayIncludes = __webpack_require__(104),
    arrayIncludesWith = __webpack_require__(105),
    arrayMap = __webpack_require__(34),
    baseUnary = __webpack_require__(75),
    cacheHas = __webpack_require__(76);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 153 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(106),
    isFlattenable = __webpack_require__(364);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(106),
    isArray = __webpack_require__(6);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(153),
    baseIsNaN = __webpack_require__(314),
    strictIndexOf = __webpack_require__(395);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(312),
    isObjectLike = __webpack_require__(17);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(74),
    baseSet = __webpack_require__(161),
    castPath = __webpack_require__(51);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 159 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 160 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(70),
    castPath = __webpack_require__(51),
    isIndex = __webpack_require__(58),
    isObject = __webpack_require__(14),
    toKey = __webpack_require__(52);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(50),
    arrayMap = __webpack_require__(34),
    isArray = __webpack_require__(6),
    isSymbol = __webpack_require__(88);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(69),
    arrayIncludes = __webpack_require__(104),
    arrayIncludesWith = __webpack_require__(105),
    cacheHas = __webpack_require__(76),
    createSet = __webpack_require__(346),
    setToArray = __webpack_require__(82);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(34);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 165 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(43),
    isIterateeCall = __webpack_require__(80);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(61);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
 * of source objects to the destination object for all destination properties
 * that resolve to `undefined`.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to assign.
 * @param {Object} object The parent object of `objValue`.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsAssignIn(objValue, srcValue, key, object) {
  if (objValue === undefined ||
      (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
    return srcValue;
  }
  return objValue;
}

module.exports = customDefaultsAssignIn;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(45);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(69),
    arraySome = __webpack_require__(150),
    cacheHas = __webpack_require__(76);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(432)))

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(155),
    getSymbols = __webpack_require__(115),
    keys = __webpack_require__(31);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(379),
    noop = __webpack_require__(192);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(386);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(106),
    getPrototype = __webpack_require__(78),
    getSymbols = __webpack_require__(115),
    stubArray = __webpack_require__(195);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(51),
    isArguments = __webpack_require__(87),
    isArray = __webpack_require__(6),
    isIndex = __webpack_require__(58),
    isLength = __webpack_require__(121),
    toKey = __webpack_require__(52);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 177 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 178 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(170);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(126)(module)))

/***/ }),
/* 180 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(102);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 182 */
/***/ (function(module, exports) {

/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

module.exports = reInterpolate;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(325),
    shortOut = __webpack_require__(389);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 184 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(44),
    createAssigner = __webpack_require__(166),
    keysIn = __webpack_require__(124);

/**
 * This method is like `_.assignIn` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extendWith
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignInWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
  copyObject(source, keysIn(source), object, customizer);
});

module.exports = assignInWith;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var escapeHtmlChar = __webpack_require__(350),
    toString = __webpack_require__(47);

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"']/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/**
 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
 * corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape(string) {
  string = toString(string);
  return (string && reHasUnescapedHtml.test(string))
    ? string.replace(reUnescapedHtml, escapeHtmlChar)
    : string;
}

module.exports = escape;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(308),
    hasPath = __webpack_require__(175);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

module.exports = head;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(19);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = root.isFinite;

/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */
function isFinite(value) {
  return typeof value == 'number' && nativeIsFinite(value);
}

module.exports = isFinite;


/***/ }),
/* 190 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

module.exports = isNull;


/***/ }),
/* 191 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 192 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(16),
    negate = __webpack_require__(416),
    pickBy = __webpack_require__(194);

/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return pickBy(object, negate(baseIteratee(predicate)));
}

module.exports = omitBy;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(34),
    baseIteratee = __webpack_require__(16),
    basePickBy = __webpack_require__(158),
    getAllKeysIn = __webpack_require__(114);

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


/***/ }),
/* 195 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var assignInWith = __webpack_require__(185),
    attempt = __webpack_require__(401),
    baseValues = __webpack_require__(164),
    customDefaultsAssignIn = __webpack_require__(167),
    escapeStringChar = __webpack_require__(351),
    isError = __webpack_require__(120),
    isIterateeCall = __webpack_require__(80),
    keys = __webpack_require__(31),
    reInterpolate = __webpack_require__(182),
    templateSettings = __webpack_require__(424),
    toString = __webpack_require__(47);

/** Used to match empty string literals in compiled template source. */
var reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

/**
 * Used to match
 * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
 */
var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

/** Used to ensure capturing order of template delimiters. */
var reNoMatch = /($^)/;

/** Used to match unescaped characters in compiled string literals. */
var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

/**
 * Creates a compiled template function that can interpolate data properties
 * in "interpolate" delimiters, HTML-escape interpolated data properties in
 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
 * properties may be accessed as free variables in the template. If a setting
 * object is given, it takes precedence over `_.templateSettings` values.
 *
 * **Note:** In the development build `_.template` utilizes
 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
 * for easier debugging.
 *
 * For more information on precompiling templates see
 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
 *
 * For more information on Chrome extension sandboxes see
 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The template string.
 * @param {Object} [options={}] The options object.
 * @param {RegExp} [options.escape=_.templateSettings.escape]
 *  The HTML "escape" delimiter.
 * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
 *  The "evaluate" delimiter.
 * @param {Object} [options.imports=_.templateSettings.imports]
 *  An object to import into the template as free variables.
 * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
 *  The "interpolate" delimiter.
 * @param {string} [options.sourceURL='templateSources[n]']
 *  The sourceURL of the compiled template.
 * @param {string} [options.variable='obj']
 *  The data object variable name.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the compiled template function.
 * @example
 *
 * // Use the "interpolate" delimiter to create a compiled template.
 * var compiled = _.template('hello <%= user %>!');
 * compiled({ 'user': 'fred' });
 * // => 'hello fred!'
 *
 * // Use the HTML "escape" delimiter to escape data property values.
 * var compiled = _.template('<b><%- value %></b>');
 * compiled({ 'value': '<script>' });
 * // => '<b>&lt;script&gt;</b>'
 *
 * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the internal `print` function in "evaluate" delimiters.
 * var compiled = _.template('<% print("hello " + user); %>!');
 * compiled({ 'user': 'barney' });
 * // => 'hello barney!'
 *
 * // Use the ES template literal delimiter as an "interpolate" delimiter.
 * // Disable support by replacing the "interpolate" delimiter.
 * var compiled = _.template('hello ${ user }!');
 * compiled({ 'user': 'pebbles' });
 * // => 'hello pebbles!'
 *
 * // Use backslashes to treat delimiters as plain text.
 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
 * compiled({ 'value': 'ignored' });
 * // => '<%- value %>'
 *
 * // Use the `imports` option to import `jQuery` as `jq`.
 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the `sourceURL` option to specify a custom sourceURL for the template.
 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
 * compiled(data);
 * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
 *
 * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
 * compiled.source;
 * // => function(data) {
 * //   var __t, __p = '';
 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
 * //   return __p;
 * // }
 *
 * // Use custom template delimiters.
 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
 * var compiled = _.template('hello {{ user }}!');
 * compiled({ 'user': 'mustache' });
 * // => 'hello mustache!'
 *
 * // Use the `source` property to inline compiled templates for meaningful
 * // line numbers in error messages and stack traces.
 * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
 *   var JST = {\
 *     "main": ' + _.template(mainText).source + '\
 *   };\
 * ');
 */
function template(string, options, guard) {
  // Based on John Resig's `tmpl` implementation
  // (http://ejohn.org/blog/javascript-micro-templating/)
  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
  var settings = templateSettings.imports._.templateSettings || templateSettings;

  if (guard && isIterateeCall(string, options, guard)) {
    options = undefined;
  }
  string = toString(string);
  options = assignInWith({}, options, settings, customDefaultsAssignIn);

  var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
      importsKeys = keys(imports),
      importsValues = baseValues(imports, importsKeys);

  var isEscaping,
      isEvaluating,
      index = 0,
      interpolate = options.interpolate || reNoMatch,
      source = "__p += '";

  // Compile the regexp to match each delimiter.
  var reDelimiters = RegExp(
    (options.escape || reNoMatch).source + '|' +
    interpolate.source + '|' +
    (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
    (options.evaluate || reNoMatch).source + '|$'
  , 'g');

  // Use a sourceURL for easier debugging.
  var sourceURL = 'sourceURL' in options ? '//# sourceURL=' + options.sourceURL + '\n' : '';

  string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
    interpolateValue || (interpolateValue = esTemplateValue);

    // Escape characters that can't be included in string literals.
    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

    // Replace delimiters with snippets.
    if (escapeValue) {
      isEscaping = true;
      source += "' +\n__e(" + escapeValue + ") +\n'";
    }
    if (evaluateValue) {
      isEvaluating = true;
      source += "';\n" + evaluateValue + ";\n__p += '";
    }
    if (interpolateValue) {
      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
    }
    index = offset + match.length;

    // The JS engine embedded in Adobe products needs `match` returned in
    // order to produce the correct `offset` value.
    return match;
  });

  source += "';\n";

  // If `variable` is not specified wrap a with-statement around the generated
  // code to add the data object to the top of the scope chain.
  var variable = options.variable;
  if (!variable) {
    source = 'with (obj) {\n' + source + '\n}\n';
  }
  // Cleanup code by stripping empty strings.
  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
    .replace(reEmptyStringMiddle, '$1')
    .replace(reEmptyStringTrailing, '$1;');

  // Frame code as the function body.
  source = 'function(' + (variable || 'obj') + ') {\n' +
    (variable
      ? ''
      : 'obj || (obj = {});\n'
    ) +
    "var __t, __p = ''" +
    (isEscaping
       ? ', __e = _.escape'
       : ''
    ) +
    (isEvaluating
      ? ', __j = Array.prototype.join;\n' +
        "function print() { __p += __j.call(arguments, '') }\n"
      : ';\n'
    ) +
    source +
    'return __p\n}';

  var result = attempt(function() {
    return Function(importsKeys, sourceURL + 'return ' + source)
      .apply(undefined, importsValues);
  });

  // Provide the compiled function's source by its `toString` method or
  // the `source` property as a convenience for inlining compiled templates.
  result.source = source;
  if (isError(result)) {
    throw result;
  }
  return result;
}

module.exports = template;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(425);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(103),
    baseCreate = __webpack_require__(73),
    baseForOwn = __webpack_require__(108),
    baseIteratee = __webpack_require__(16),
    getPrototype = __webpack_require__(78),
    isArray = __webpack_require__(6),
    isBuffer = __webpack_require__(63),
    isFunction = __webpack_require__(29),
    isObject = __webpack_require__(14),
    isTypedArray = __webpack_require__(89);

/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */
function transform(object, iteratee, accumulator) {
  var isArr = isArray(object),
      isArrLike = isArr || isBuffer(object) || isTypedArray(object);

  iteratee = baseIteratee(iteratee, 4);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor : [];
    }
    else if (isObject(object)) {
      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
    }
    else {
      accumulator = {};
    }
  }
  (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
    return iteratee(accumulator, value, index, object);
  });
  return accumulator;
}

module.exports = transform;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(16),
    baseUniq = __webpack_require__(163);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(164),
    keys = __webpack_require__(31);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(152),
    baseRest = __webpack_require__(43),
    isArrayLikeObject = __webpack_require__(119);

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, values)
    : [];
});

module.exports = without;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getScopedGlobalApis = exports.ga = exports.onReady = exports.emitter = exports.getStorage = exports.getSelector = exports.ui = exports.__INTERNAL__ = exports.user = exports.window = exports.location = exports.site = undefined;

var _users = __webpack_require__(288);

var _users2 = _interopRequireDefault(_users);

var _site = __webpack_require__(237);

var _site2 = _interopRequireDefault(_site);

var _wixSelector2 = __webpack_require__(290);

var _wixSelector3 = _interopRequireDefault(_wixSelector2);

var _location = __webpack_require__(211);

var _location2 = _interopRequireDefault(_location);

var _window = __webpack_require__(289);

var _window2 = _interopRequireDefault(_window);

var _postMessage = __webpack_require__(18);

var pm = _interopRequireWildcard(_postMessage);

var _platformUtils = __webpack_require__(13);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _analytics = __webpack_require__(212);

var _analytics2 = _interopRequireDefault(_analytics);

var _ui = __webpack_require__(95);

var ui = _interopRequireWildcard(_ui);

var _Emitter = __webpack_require__(208);

var _Emitter2 = _interopRequireDefault(_Emitter);

var _Storage = __webpack_require__(209);

var _Storage2 = _interopRequireDefault(_Storage);

var _formFactor = __webpack_require__(92);

var _formFactor2 = _interopRequireDefault(_formFactor);

var _readyManager = __webpack_require__(131);

var _contextService = __webpack_require__(130);

var _compInitializeService = __webpack_require__(128);

var _compInitializeService2 = _interopRequireDefault(_compInitializeService);

var _validationsService = __webpack_require__(15);

var _urlUtils = __webpack_require__(24);

var urlUtils = _interopRequireWildcard(_urlUtils);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storage = void 0;
var _wixSelector = new _wixSelector3.default();
var emitter = new _Emitter2.default();

var location = new _location2.default();
var window = new _window2.default();
var site = new _site2.default();
var user = new _users2.default();

var getStorage = function getStorage(appId, storageValue) {
    if (!storage) {
        storage = new _Storage2.default();
    }
    return storage.createScopedStorage(appId, storageValue);
};
/**
 * @namespace $w
 * @summary The `$w` namespace contains everything you need in order to work
 *  with your site's components. It contains all of the UI elements, nodes, and
 *  events that make up your site. It also includes the [`$w()`](#w),
 *  [`onReady()`](#onReady) function.
 *
 *  The APIs in `$w` can only be used in front-end code.
 *
 *  You do not need to import `$w`.
 */

/**
 * @function $w
 * @memberof $w
 * @syntax
 * function $w(selector: string): Element | Element[]
 * @summary Selects and returns elements from a page.
 * @description
 *  The `$w()` function selects single or multiple elements by ID or type.
 *
 *  To select by ID, pass a selector string with the hash symbol
 *  (`#`) followed by the ID of the item you want to select (e.g. `"#myElement"`).
 *  The function will return the selected element object.
 *
 *  To select by type, pass a selector string with the name of
 *  the type without the preceding `#` (e.g. `"Button"`). The function will return
 *  an array of the selected element objects. An array is returned even if one
 *  or no elements are selected.
 *
 *  To select using multiple selectors, pass a selector string with
 *  multiple selectors separated by commas. The selectors in the
 *  comma-separated string can be ID selectors, type selectors, or a mixture of
 *  the two. The function will return an array of the selected element objects.
 *  An array is returned even if one or no elements are selected. If two or more
 *  selectors select the same element, it will still be returned only once in
 *  the array.
 * @param {external:String} getWixSelector A selector or multiple comma-separated selectors.
 * @returns {$w.Element|$w.Element[]} A single element or an array of elements.
 * @snippet [$w-select_by_name.es6=Select an element using its ID]
 * @snippet [$w-select_by_type.es6=Select elements by type]
 * @snippet [$w-select_images.es6=Select all the images on the page]
 * @snippet [$w-select_combo.es6=Select elements using a multiple selectors]
 * @snippet [$w-select_and_run.es6=Hide all the page's images]
 */

/**
 * @callback $w.ReadyHandler
 * @summary Function that runs when all page elements have finished loading.
 * @returns {Promise}
 * @fulfill {void} When the `onReady` function has completed.
 */

/**
 * @function onReady
 * @syntax
   * function onReady(initFunction: ReadyHandler): void
   * callback ReadyHandler(): Promise&lt;void&gt;
 * @summary Sets the function that runs when all the page elements have finished loading.
 * @description
 *  Use the `onReady()` function for code you want to run before the user starts
 *  interacting with your page.
 *
 *  The following code should be placed inside the `onReady()` event handler:
 *
 *  + Initialization of element properties - Example: setting a text element's initial text value.
 *  + Function calls on elements to set their initial state - Example: disabling a button.
 *  + Dynamic event handlers that you want bound when the page loads - Example: setting an event handler to be called when the mouse pointer enters an element.
 *
 *
 *  Return a Promise from the handler function to force the page to wait for your
 *  Promise to resolve before displaying the page to users.
 *
 *  For example, suppose you are using a query to retrieve data that you want to
 *  display in a table. If you don't return the query promise the table might show
 *  without your data until the query's Promise resolves. Instead return the query
 *  Promise so that the page doesn't load for users until the query returns results
 *  and the table is populated.
 *
 *  Static event handlers, those that are wired in the Properties panel
 *  in the Editor, are not placed inside inside the `onReady()` event handler.
 *
 *  The `onReady()` function in the **Site** tab is called before the
 *  `onReady()` function in the **Page** tab.
 *
 * @note
 *  In certain circumstances the `onReady()` event handler is called twice, once
 *  server-side and once client-side. You can use this behavior to improve your
 *  page's load time. However, you need to be aware that if your `onReady()` code
 *  causes a side effect, such as inserting an item into a collection, that side
 *  effect might happen twice. To learn more about the rendering process, see
 *  [here](https://support.wix.com/en/article/about-the-page-rendering-process).
 * @param {$w.ReadyHandler} initFunction The name of the function or the function expression to run when the page has finished loading.
 * @snippet [$w-onReady-anonymous-long.es6=Run code in an anonymous function when the page loads]
 * @snippet [$w-onReady-promise.es6=Wait for a Promise to resolve]
 *  This example demonstrates the technique of returning a Promise so that the
 *  page doesn't load until the Promise resolves. Here, we wait for the query to
 *  finish and populate a table before displaying the page to users.
 * @snippet [$w-onReady-full.es6=Where to place code]
 *  This example demonstrates which code should be placed inside the `onReady()`
 *  event handler.
 * @see [$w( )](#w)
 * @memberof $w
 */

var getSelector = function getSelector(controllerId, logName) {
    var $w = _wixSelector.scoped$W(controllerId, logName);
    (0, _assign2.default)($w, emitter.createScopedEmitter(controllerId));

    $w.onReady = function (callback) {
        (0, _readyManager.onReady)(callback, logName);
    };
    $w.onRender = function (callback) {
        (0, _readyManager.onRender)(callback, logName);
    };
    return $w;
};

var getScopedGlobalApis = function getScopedGlobalApis(appDefId) {
    return {
        user: new _users2.default(appDefId),
        location: new _location2.default(appDefId),
        window: new _window2.default(appDefId),
        site: new _site2.default(appDefId)
    };
};

var __INTERNAL__ = function () {

    function validateGlobalsParameters(platformUtils) {
        if (!platformUtils) {
            throw new Error('invalid parameter value for platformUtils: ' + platformUtils);
        }

        if (!platformUtils.RGI) {
            throw new Error('invalid parameter value for remoteGlobalsInterface: ' + platformUtils.RGI);
        }
    }

    function validateParameters(platformUtils, siteInfo, contextId) {
        if (!platformUtils) {
            throw new Error('invalid parameter value for platformUtils: ' + platformUtils);
        }

        if (!platformUtils.RMI) {
            throw new Error('invalid parameter value for remoteModelInterface: ' + platformUtils.RMI);
        }

        if (!platformUtils.linkUtils) {
            throw new Error('invalid parameter value for linkUtils: ' + platformUtils.linkUtils);
        }

        if (!platformUtils.typeUtils) {
            throw new Error('invalid parameter value for typeUtils: ' + platformUtils.typeUtils);
        }

        if (!siteInfo) {
            throw new Error('invalid parameter value for siteInfo: ' + siteInfo);
        }

        if (!contextId) {
            throw new Error('invalid parameter value for contextId: ' + contextId);
        }
    }

    function dumpModel() {
        return {
            RMI: _platformUtils2.default.getRMI('dumpModel').toJson(),
            RGI: _platformUtils2.default.getRGI().toJson()
        };
    }

    function getDefaultUpdateHandler(contextId) {
        return function delegateCommandToViewer(compId, type, changes, callback) {
            switch (type) {
                case 'executeBatch':
                    pm.sendMessage(pm.Intent.WIX_CODE, 'executeBatch', compId, contextId, changes, callback);
                    break;
                case 'registerEvent':
                    pm.sendMessage(pm.Intent.WIX_CODE, 'registerEvent', compId, contextId, changes, callback);
                    break;
                case 'unregisterAll':
                    pm.sendMessage(pm.Intent.WIX_CODE, 'unregisterAll', compId, contextId, changes, callback);
                    break;
                case 'behavior':
                    pm.sendMessage(pm.Intent.WIX_CODE, 'executeBehavior', compId, contextId, changes, callback);
                    break;
                default:
                    pm.sendMessage(pm.Intent.WIX_CODE, type + 'Changed', compId, contextId, changes, callback);
                    break;
            }
        };
    }

    function initGlobals(platformUtilities) {
        validateGlobalsParameters(platformUtilities);
        _platformUtils2.default.initGlobals(platformUtilities);
    }

    function initModel() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        validateParameters.apply(undefined, args);
        var platformUtilities = args[0],
            siteInfo = args[1],
            contextId = args[2],
            onUpdateHandler = args[3];

        var RMI = platformUtilities.RMI;
        var componentsHooks = platformUtilities.componentsHooks;
        var HOOKS = RMI.getHooks();
        RMI.registerHook(HOOKS.data, 'wysiwyg.viewer.components.Repeater', componentsHooks.repeaters.updateRepeaterItems);
        RMI.registerHook(HOOKS.all, null, componentsHooks.repeaters.syncRepeaterItemData);
        _formFactor2.default.init(siteInfo.deviceType);
        _wixSelector.initialize(RMI, contextId, emitter);
        _platformUtils2.default.init(platformUtilities, _wixSelector, onUpdateHandler || getDefaultUpdateHandler(contextId));

        (0, _validationsService.initValidationsService)();
        _compInitializeService2.default.componentsInitialize(RMI, contextId, RMI.getComponents());
    }

    function setStaticEventHandlers(eventHandlers, contextId) {
        _platformUtils2.default.setStaticEventHandlers(eventHandlers, contextId);
    }

    function getEventHandler(name) {
        return _platformUtils2.default.getStaticEventHandler(name, true);
    }

    function onMessage(event) {
        pm.onMessage(event);
    }

    function initEnv(queryParameters) {
        window.init(queryParameters);
    }

    function addEnvParams(params) {
        urlUtils.addQueryParameters(params);
    }

    function setContextId(contextId) {
        _platformUtils2.default.setContextId(contextId);
    }

    function setWarmupData(controllerId, data) {
        pm.sendMessage(pm.Intent.WIX_CODE_WARMUP, pm.MessageTypes.SET_WARMUP_DATA, { controllerId: controllerId, data: data });
    }

    function getWarmupData(controllerId) {
        var uw = urlUtils.getQueryParameter("userWarmup");
        return uw && uw[controllerId];
    }

    return {
        dumpModel: dumpModel,
        initGlobals: initGlobals,
        initModel: initModel,
        setStaticEventHandlers: setStaticEventHandlers,
        getEventHandler: getEventHandler,
        onMessage: onMessage,
        addEnvParams: addEnvParams,
        initEnv: initEnv,
        setWarmupData: setWarmupData,
        getWarmupData: getWarmupData,
        setContextId: setContextId,
        triggerOnReady: _readyManager.triggerOnReady,
        triggerOnRender: _readyManager.triggerOnRender,
        setLightboxContext: _contextService.setLightboxContext
    };
}();

self['wix-location'] = location;
self['wix-window'] = window;
self['wix-site'] = site;
self['wix-users'] = user;

exports.site = site;
exports.location = location;
exports.window = window;
exports.user = user;
exports.__INTERNAL__ = __INTERNAL__;
exports.ui = ui;
exports.getSelector = getSelector;
exports.getStorage = getStorage;
exports.emitter = emitter;
exports.onReady = _readyManager.onReady;
exports.ga = _analytics2.default;
exports.getScopedGlobalApis = getScopedGlobalApis;

/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports = {"roll":{"In":"reveal","Out":"conceal"},"puff":{"In":"drop","Out":"pop"},"zoom":{"In":"expand","Out":"collapse"}}

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports = {"arc":{"duration":1.2,"delay":0,"direction":"left"},"bounce":{"duration":1.2,"delay":0,"direction":"topLeft","bounce":"medium"},"puff":{"duration":1.2,"delay":0},"zoom":{"duration":1.2,"delay":0},"fade":{"duration":1.2,"delay":0},"flip":{"duration":1.2,"delay":0,"direction":"left"},"float":{"duration":1.2,"delay":0,"direction":"left"},"fly":{"duration":1.2,"delay":0,"direction":"left"},"fold":{"duration":1.2,"delay":0,"direction":"left"},"glide":{"duration":1.2,"delay":0,"angle":0,"distance":0},"roll":{"duration":1.2,"delay":0,"direction":"left"},"slide":{"duration":1.2,"delay":0,"direction":"left"},"spin":{"duration":1.2,"delay":0,"direction":"cw","cycles":5},"turn":{"duration":1.2,"delay":0,"direction":"right"}}

/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports = {"bounce":{"keys":{"intensity":"bounce"},"values":{"direction":{"topLeft":"top left","topRight":"top right","bottomLeft":"bottom left","bottomRight":"bottom right"},"duration":{"convertMsToSecs":true},"delay":{"convertMsToSecs":true}}},"ALL":{"values":{"duration":{"convertMsToSecs":true},"delay":{"convertMsToSecs":true}}}}

/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports = {"arc":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"direction":{"type":"string","enum":["left","right"]}},"bounce":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"direction":{"type":"string","enum":["topLeft","topRight","bottomRight","bottomLeft","center"]},"intensity":{"type":"string","enum":["soft","medium","hard"]}},"puff":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":4000}}},"zoom":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":4000}}},"fade":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":4000}}},"flip":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"direction":{"type":"string","enum":["left","right","top","bottom"]}},"float":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"direction":{"type":"string","enum":["left","right","top","bottom"]}},"fly":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"direction":{"type":"string","enum":["left","right","top","bottom"]}},"fold":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"direction":{"type":"string","enum":["left","right","top","bottom"]}},"glide":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"angle":{"type":"integer","range":{"minValue":0,"maxValue":360}},"distance":{"type":"integer","range":{"minValue":0,"maxValue":300}}},"roll":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"direction":{"type":"string","default":"left","enum":["left","right","top","bottom"]}},"slide":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"direction":{"type":"string","enum":["left","right","top","bottom"]}},"spin":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"direction":{"type":"string","enum":["cw","ccw"]},"cycles":{"type":"integer","default":5,"range":{"minValue":1,"maxValue":15}}},"turn":{"duration":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"delay":{"type":"integer","range":{"minValue":0,"maxValue":4000}},"direction":{"type":"string","default":"right","enum":["right","left"]}}}

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_assign__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_assign__);


const cssLevel1 = {
    black: '#000000',
    silver: '#c0c0c0',
    gray: '#808080',
    white: '#ffffff',
    maroon: '#800000',
    red: '#ff0000',
    purple: '#800080',
    fuchsia: '#ff00ff',
    green: '#008000',
    lime: '#00ff00',
    olive: '#808000',
    yellow: '#ffff00',
    navy: '#000080',
    blue: '#0000ff',
    teal: '#008080',
    aqua: '#00ffff'
};

const cssLevel2 = {
    orange: '#ffa500',
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    blanchedalmond: '#ffebcd',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    gold: '#ffd700',
    goldenrod: '#daa520',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavender: '#e6e6fa',
    lavenderblush: '#fff0f5',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2'
};

const cssLevel3 = {
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    oldlace: '#fdf5e6',
    olivedrab: '#6b8e23',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    whitesmoke: '#f5f5f5',
    yellowgreen: '#9acd32'
};

const cssLevel4 = {
    rebeccapurple: '#663399'
};

const colorKeywords = __WEBPACK_IMPORTED_MODULE_0_lodash_assign___default()({}, cssLevel1, cssLevel2, cssLevel3, cssLevel4);

/* harmony default export */ __webpack_exports__["default"] = colorKeywords;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tinyEmitter = __webpack_require__(431);

var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var scopeEvent = function scopeEvent(controllerId, event) {
  return controllerId + '_' + event;
};

var Emitter = function () {
  function Emitter() {
    _classCallCheck(this, Emitter);

    this.emitter = new _tinyEmitter2.default();
  }

  _createClass(Emitter, [{
    key: 'createScopedEmitter',
    value: function createScopedEmitter(controllerId) {
      var _this = this;

      // adds a controller id to the name of the event.
      var boundFunc = function boundFunc(func) {
        return _defineProperty({}, func, _this[func].bind(_this, controllerId));
      };

      return ['on', 'off', 'once', 'fireEvent'].reduce(function (acc, funcName) {
        return (0, _assign2.default)(acc, boundFunc(funcName));
      }, {});
    }
  }, {
    key: 'on',
    value: function on(controllerId, event, callback, context) {
      var _this2 = this;

      var scopedEvent = scopeEvent(controllerId, event);
      this.emitter.on(scopedEvent, callback, context);
      return function () {
        return _this2.emitter.off(scopedEvent, callback);
      };
    }
  }, {
    key: 'once',
    value: function once(controllerId, event, callback, context) {
      var _this3 = this;

      var scopedEvent = scopeEvent(controllerId, event);
      this.emitter.once(scopedEvent, callback, context);
      return function () {
        return _this3.emitter.off(scopedEvent, callback);
      };
    }
  }, {
    key: 'off',
    value: function off(controllerId, event, callback) {
      this.emitter.off(scopeEvent(controllerId, event), callback);
    }
  }, {
    key: 'fireEvent',
    value: function fireEvent(controllerId, event) {
      var _emitter;

      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      (_emitter = this.emitter).emit.apply(_emitter, [scopeEvent(controllerId, event)].concat(args));
    }
  }]);

  return Emitter;
}();

exports.default = Emitter;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _set = __webpack_require__(37);

var _set2 = _interopRequireDefault(_set);

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _omit = __webpack_require__(64);

var _omit2 = _interopRequireDefault(_omit);

var _postMessage = __webpack_require__(18);

var postMessage = _interopRequireWildcard(_postMessage);

var _urlUtils = __webpack_require__(24);

var urlUtils = _interopRequireWildcard(_urlUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TYPES = {
    LOCAL: 'local',
    SESSION: 'session'
};

var getParsedStoredAppData = function getParsedStoredAppData(type, appId, storageObject) {
    return JSON.parse((0, _get2.default)(storageObject, [type + 'Storage', appId], '{}'));
};

var updateBrowserStorage = function updateBrowserStorage(type, appId, appDataToStore) {
    postMessage.sendMessage(postMessage.Intent.BROWSER_API, postMessage.MessageTypes.SET_TO_STORAGE, {
        type: type + 'Storage',
        key: appId,
        value: appDataToStore
    });
};

/**
 * @namespace wix-storage
 * @summary The wix-storage module contains functionality for the persistent
 *  storage of key/value data in the user's browser.
 * @description
 *  There are two types of storage:
 *
 *  + **Local** — Data in local storage never expires, even if the user closes
 *    your page. When the user reopens the page later, the data can still be
 *    retrieved.
 *
 *  + **Session** — Data in session storage is available while the user's web
 *    session is active. The session ends when the user closes the browser tab
 *    or window. When the session ends, all the data in session storage is lost.
 *    Reloading or restoring the page does not affect session storage data.
 *
 *
 *  To use the Storage API, import the needed storage type(s) from the
 *  `wix-storage` module:
 *
 *    ``` javascript
 *    import {local, session} from 'wix-storage';
 *
 *    // Or one of:
 *
 *    import {local} from 'wix-storage';
 *    import {session} from 'wix-storage';
 *    ```
 *
 *  The APIs in `wix-storage` can only be used in front-end code.
 *
 *  To work with the data in session and local storage use the functions described {@link wix-storage.Storage|here}.
 *
 *  Some older browsers may not fully support `wix-storage`. See
 *  <a href="https://developer.mozilla.org/en-US/docs/Web/API/Storage#Browser_compatibility" target=_blank>Browser
 *  compatibility</a> for more information.
 */

/**
 * @member local
 * @syntax import {local} from 'wix-storage';
 * @summary Used for local storage of data.
 * @description Use the methods in [`Storage`](wix-storage.Storage.html) to manage `local` data.
 * @type wix-storage.Storage
 * @memberof wix-storage
 */

/**
 * @member session
 * @syntax import {session} from 'wix-storage';
 * @summary Used for session storage of data.
 * @description Use the methods in [`Storage`](wix-storage.Storage.html) to manage `session` data.
 * @type wix-storage.Storage
 * @memberof wix-storage
 */

/**
 * @class Storage
 * @summary Used for storing local or session key/value data in the user's browser.
 * @description
 *  To learn more about local and session storage, see [`wix-storage`](wix-storage.html).
 *
 *  To use the Storage API, import the needed storage type(s) from the
 *  `wix-storage` module:
 *
 *    ``` javascript
 *    import {local, session} from 'wix-storage';
 *
 *    // Or one of:
 *
 *    import {local} from 'wix-storage';
 *    import {session} from 'wix-storage';
 *    ```
 *
 * @memberof wix-storage
 */
var methods = {

    /**
     * @function setItem
     * @syntax
     * function setItem(key: string, value: string): void
     * @summary Stores an item in local or session storage.
     * @param {external:String} key The key of item to set.
     * @param {external:String} value The value of the item to set.
     * @memberof wix-storage.Storage
     * @snippet [Storage-setItem_local.es6=Store an item in local storage]
     * @snippet [Storage-setItem_session.es6=Store an item in session storage]
     * @see [getItem( )](#getItem)
     */
    setItem: function setItem(type, appId, storageObject, key, value) {
        var newData = _defineProperty({}, String(key), String(value));
        var appDataToStore = JSON.stringify((0, _assign2.default)({}, getParsedStoredAppData(type, appId, storageObject), newData));

        if (appDataToStore.length > 50000) {
            throw new Error('QuotaExceededError - app storage limit is 50kb');
        }
        (0, _set2.default)(storageObject, [type + 'Storage', appId], appDataToStore);
        updateBrowserStorage(type, appId, appDataToStore);
    },

    /**
     * @function getItem
     * @syntax
     * function getItem(key: string): string
     * @summary Gets an item from local or session storage.
     * @param {external:String} key The key of the item to get.
     * @returns {external:String} The retrieved item value.
     * @memberof wix-storage.Storage
     * @snippet [Storage-getItem_local.es6=Retrieve an item from local storage]
     * @snippet [Storage-getItem_session.es6=Retrieve an item from session storage]
     * @see [setItem( )](#setItem)
     */
    getItem: function getItem(type, appId, storageObject, key) {
        var storedAppData = getParsedStoredAppData(type, appId, storageObject);
        return (0, _get2.default)(storedAppData, String(key), null);
    },

    /**
     * @function removeItem
     * @syntax
     * function removeItem(key: string): void
     * @summary Removes an item from local or session storage.
     * @param {external:String} key The key of the item to remove.
     * @memberof wix-storage.Storage
     * @snippet [Storage-removeItem_local.es6=Remove an item from local storage]
     * @snippet [Storage-removeItem_session.es6=Remove an item from session storage]
     * @see [clear( )](#clear)
     */
    removeItem: function removeItem(type, appId, storageObject, key) {
        var storedAppData = getParsedStoredAppData(type, appId, storageObject);
        var appDataToStore = JSON.stringify((0, _omit2.default)(storedAppData, key));

        (0, _set2.default)(storageObject, [type + 'Storage', appId], appDataToStore);
        updateBrowserStorage(type, appId, appDataToStore);
    },

    /**
     * @function clear
     * @syntax
     * function clear(): void
     * @summary Removes **all** items from local or session storage.
     * @memberof wix-storage.Storage
     * @snippet [Storage-clear_local.es6=Remove all items from local storage]
     * @snippet [Storage-clear_session.es6=Remove all items from session storage]
     * @see [remove( )](#remove)
     */
    clear: function clear(type, appId, storageObject) {
        var appDataToStore = '{}';
        (0, _set2.default)(storageObject, [type + 'Storage', appId], appDataToStore);
        updateBrowserStorage(type, appId, appDataToStore);
    }
};

var createBoundMethod = function createBoundMethod(storageType, appId, storageObject, methodName) {
    return _defineProperty({}, methodName, methods[methodName].bind(null, storageType, appId, storageObject));
};

var buildAPIObject = function buildAPIObject(storageType, appId, storageObject) {
    var methodNames = ['setItem', 'getItem', 'removeItem', 'clear'];
    return methodNames.reduce(function (acc, methodName) {
        return (0, _assign2.default)(acc, createBoundMethod(storageType, appId, storageObject, methodName));
    }, {});
};

var setStorageObject = function setStorageObject(storageObject, storageData) {
    var browserParsedStoredData = JSON.parse(storageData);
    (0, _set2.default)(storageObject, TYPES.LOCAL + 'Storage', (0, _get2.default)(browserParsedStoredData, TYPES.LOCAL));
    (0, _set2.default)(storageObject, TYPES.SESSION + 'Storage', (0, _get2.default)(browserParsedStoredData, TYPES.SESSION));
};

var Storage = function () {
    function Storage() {
        _classCallCheck(this, Storage);

        this._storageObject = {};
        setStorageObject(this._storageObject, urlUtils.getQueryParameter('storage'));
    }

    _createClass(Storage, [{
        key: 'createScopedStorage',
        value: function createScopedStorage(appId, storageValue) {
            var _this = this;

            setStorageObject(this._storageObject, storageValue);
            postMessage.registerEventListener(postMessage.MessageTypes.STORAGE_UPDATE, function (evtData) {
                setStorageObject(_this._storageObject, evtData.storageValue);
            });
            return {
                local: buildAPIObject(TYPES.LOCAL, appId, this._storageObject),
                session: buildAPIObject(TYPES.SESSION, appId, this._storageObject)
            };
        }
    }]);

    return Storage;
}();

exports.default = Storage;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(9);

var _formFactor = __webpack_require__(92);

var _formFactor2 = _interopRequireDefault(_formFactor);

var _ui = __webpack_require__(95);

var ui = _interopRequireWildcard(_ui);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _set2 = __webpack_require__(37);

var _set3 = _interopRequireDefault(_set2);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _validation = __webpack_require__(1);

var _mediaUtils = __webpack_require__(133);

var _mediaUtils2 = _interopRequireDefault(_mediaUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getBackgroundPropertyDataPath(property) {
    var deviceType = _formFactor2.default.getDeviceType();
    return 'pageBackgrounds.' + deviceType + '.ref.' + property;
}

function getCurrentMediaRefData() {
    var RMI = members._RMI.get(this);
    var contextId = members._contextId.get(this);
    var contextData = RMI.getData(contextId);
    var mediaRefPath = getBackgroundPropertyDataPath('mediaRef');
    return (0, _get2.default)(contextData, mediaRefPath) || {};
}
/**
 * @typedef $w.Document~BackgroundOptions
 * @summary An object used by the `background` property that contains the background options.
 * @description
 *  Setting the `src` property of the `BackgroundOptions` object changes the
 *  displayed image or video to the image or video found at the new `src` value.
 *
 *  Getting the `src` property of the `BackgroundOptions` object returns the
 *  location of the current image or video file.
 *
 *  Images can either be from the <a href="https://support.wix.com/en/article/about-the-media-manager" target="_blank">Media Manager</a>
 *  or an external image from any web location. Videos must come from the
 *  <a href="https://support.wix.com/en/article/about-the-media-manager" target="_blank">Media Manager</a>.
 *
 *  The URL formats supported are:
 *  + Images from the Media Manager:
 *    `wix:image://v1/<uri>/<filename>/#originWidth=<width>&originHeight=<height>[&watermark=<watermark_manifest_string>]`
 *  + Videos from the Media Manager:
 *    `wix:video://v1/<video_uri>/<filename>/#posterUri=<poster_uri>&posterWidth=<width>&posterHeight=<height>`
 *  + Vector images from the Media Manager:
 *    `wix:vector://v1/<vector_uri>/<filename>`
 *  + Images from the web:
 *    `http(s)://<image url>`
 * @property {external:String} src The file location of the background image.
 * @snippet [Background-background_get.es6=Get the background information]
 * @snippet [Background-background_set_wix.es6=Set the background image to be an image from the Media Manager]
 * @snippet [Background-background_set_web.es6=Set the background image to be an image from the web]
 * @see [background](#background)
 */

/**
 * @class Document
 * @summary A complete web page, which consists of a Header, Page, and Footer.
 * @classdesc
 *  Select the current document using: `$w("Document")`.
 * @memberof $w
 */

var Document = function () {
    function Document(RMI, compId, contextId, wixSelector, controllerId) {
        _classCallCheck(this, Document);

        members._RMI.set(this, RMI);
        members._compId.set(this, compId);
        members._contextId.set(this, contextId);
        members._wixSelector.set(this, wixSelector);
        members._controllerId.set(this, controllerId);
    }

    /**
     * @member background
     * @label property
     * @syntax
     * get background(): BackgroundOptions
     * @summary Gets an object containing information about the document's background, such as its image or video source.
     * @type {$w.Document~BackgroundOptions}
     * @snippet [Background-background_get.es6=Get the background information]
     * @snippet [Background-background_set_wix.es6=Set the background image to be an image from the Media Manager]
     * @snippet [Background-background_set_web.es6=Set the background image to be an image from the web]
     * @memberof $w.Document
     * @readonly
     */


    _createClass(Document, [{
        key: 'background',
        get: function get() {
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            return new BackgroundOptions(RMI, contextId);
        }

        /**
         * @member children
         * @label property
         * @syntax
         * get children(): Node[]
         * @summary Gets the document's Header, Page, and Footer.
         * @snippet [Document-children_get.es6=Get the document's children]
         * @type {$w.Node[]}
         * @memberof $w.Document
         * @see {@link $w.Header|Header}
         * @see {@link $w.Page|Page}
         * @see {@link $w.Footer|Footer}
         * @readonly
         */

    }, {
        key: 'children',
        get: function get() {
            var children = [];
            var childrenTypes = ['Page', 'Header', 'Footer'];
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var wixSelector = members._wixSelector.get(this);
            var controllerId = members._controllerId.get(this);

            function getInstance(compType, viewerType) {
                var Clazz = ui[compType] || Element;
                var compId = RMI.getCompIdsFromType(viewerType)[0];
                return new Clazz(RMI, compId, contextId, wixSelector, controllerId, undefined, { compType: compType, viewerType: viewerType });
            }

            childrenTypes.forEach(function (type) {
                var viewerType = _utils.types.getPotentialViewerTypes(type)[0];
                children.push(getInstance(type, viewerType));
            });

            return children;
        }

        /**
         * @member type
         * @label property
         * @syntax
         * get type(): string
         * @summary Gets the document's type.
         * @description
         *  Gets the string `"$w.Document"`.
         * @snippet [Document-type_get.es6=Get the document's type]
         * @type {external:String}
         * @memberof $w.Document
         * @readonly
         */

    }, {
        key: 'type',
        get: function get() {
            return '$w.Document';
        }
    }]);

    return Document;
}();

exports.default = Document;

var BackgroundOptions = function () {
    function BackgroundOptions(RMI, contextId) {
        _classCallCheck(this, BackgroundOptions);

        members._RMI.set(this, RMI);
        members._contextId.set(this, contextId);
    }

    _createClass(BackgroundOptions, [{
        key: 'src',
        get: function get() {
            var mediaRef = getCurrentMediaRefData.call(this);
            return _mediaUtils2.default.buildFullUrlFromMediaRef(mediaRef);
        },
        set: function set(value) {
            var _this = this;

            if (!(0, _validation.validate)('Document', 'backgroundImageUrl', { url: value })) {
                return;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var contextData = RMI.getData(contextId);
            var mediaRefPath = getBackgroundPropertyDataPath('mediaRef');
            var currentMediaRef = (0, _get2.default)(contextData, mediaRefPath) || {};

            if ((0, _isNil2.default)(value)) {
                (0, _set3.default)(contextData, mediaRefPath, null);
                RMI.setData(contextId, (0, _assign2.default)(contextData, {
                    pageBackgrounds: contextData.pageBackgrounds
                }));
                return;
            }

            var mediaData = _mediaUtils2.default.getMediaDataFromSrc(value);
            if (!mediaData) {
                return;
            }
            if (currentMediaRef && currentMediaRef.opacity) {
                (0, _assign2.default)(mediaData, { opacity: currentMediaRef.opacity });
            }
            _mediaUtils2.default.getFullMediaData(mediaData, function (fullMediaRefData) {
                if (!fullMediaRefData) {
                    return;
                }
                var updatedMediaRefData = getCurrentMediaRefData.call(_this);
                /*setDesignAsync with all media data*/
                (0, _set3.default)(contextData, mediaRefPath, mediaData);
                (0, _assign2.default)(updatedMediaRefData, fullMediaRefData);
                (0, _set3.default)(contextData, mediaRefPath, updatedMediaRefData);
                RMI.setData(contextId, (0, _assign2.default)(contextData, {
                    pageBackgrounds: contextData.pageBackgrounds
                }));
            });

            (0, _set3.default)(contextData, mediaRefPath, mediaData);
            RMI.setData(contextId, (0, _assign2.default)(contextData, {
                pageBackgrounds: contextData.pageBackgrounds
            }));
        }
    }]);

    return BackgroundOptions;
}();

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _postMessage = __webpack_require__(18);

var postMessage = _interopRequireWildcard(_postMessage);

var _Link = __webpack_require__(56);

var _Link2 = _interopRequireDefault(_Link);

var _platformUtils = __webpack_require__(13);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _urlUtils = __webpack_require__(24);

var urlUtils = _interopRequireWildcard(_urlUtils);

var _validation = __webpack_require__(1);

var _errors = __webpack_require__(12);

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @namespace wix-location
 * @summary The wix-location module contains functionality for getting information
 *  about the URL of the current page and for navigating to other pages.
 * @description
 *  To use the location module, import wixLocation from the wix-location module:
 *
 *    ``` javascript
 *    import wixLocation from 'wix-location';
 *    ```
 *
 *  The APIs in `wix-location` can only be used in front-end code and only after
 *  the page is ready.
 *
 * #### Premium Sites
 * Given the premium site URL: `https://domain.com/animals/mammals/elephant?species=african-elephant`,
 * the URL is broken down as shown in the table below:
 *
 * <table style="border-collapse: collapse;">
 *     <tr>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white" colspan=9>url</td>
 *     </tr>
 *     <tr>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white" colspan=3>baseUrl</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: #f7f9fa" colspan=6></td>
 *     </tr>
 *     <tr>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white" >protocol</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: #f7f9fa" ></td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white" >host</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white" >prefix</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white" >path</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: #f7f9fa" ></td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white" >query</td>
 *     </tr>
 *     <tr>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">https</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">://</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">domain.com</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">/animals</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">/mammals/elephant</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">?</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">species=african-elephant</td>
 *     </tr>
 * </table>
 *
 * #### Free Site
 * Given the free site URL: `https://user.wix-sites.com/zoo/animals/mammals/elephant?species=african-elephant`,
 * the URL is broken down as shown in the table below:
 *
 * <table style="border-collapse: collapse;">
 *     <tr>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white" colspan=11>url</td>
 *     </tr>
 *     <tr>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white" colspan=5>baseUrl</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: #f7f9fa" colspan=6></td>
 *     </tr>
 *     <tr>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">protocol</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: #f7f9fa"></td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">host</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: #f7f9fa"></td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">site</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">prefix</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">path</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: #f7f9fa"></td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">query</td>
 *     </tr>
 *     <tr>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">https</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">://</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">user.wix-sites.com</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">/</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">zoo</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">/animals</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">/mammals/elephant</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">?</td>
 *         <td style="border: 1px solid #dce0e2; padding: 5px; background-color: white">species=african-elephant</td>
 *     </tr>
 * </table>
 *
 *
 */
var Location = function () {
    function Location(appDefId) {
        _classCallCheck(this, Location);

        this.appDefId = appDefId;
    }

    /**
     * @member url
     * @label property
     * @syntax
     * get url(): string
     * @summary Gets the full URL of the current page.
     * @description
     *  Premium sites:
     *  ![Premium site URL](images/url_premium_url.png "Premium site URL")
     *
     *  Free sites:
     *  ![Free site URL](images/url_free_url.png "Free site URL")
     *
     *  If the site is not yet published, the function returns null.
     * @type {external:String}
     * @snippet [Location-url.es6=Get the full URL of the current page]
     * @see [baseUrl](#baseUrl)
     * @memberof wix-location
     * @readonly
     */


    _createClass(Location, [{
        key: 'to',


        /**
         * @function to
         * @syntax
         * function to(url: string): void
         * @summary Directs the browser to navigate to the specified URL.
         * @description
         *  The `to()` function navigates the browser to another web page.
         *
         * `to()` supports the following link patterns:
         *  + `/localPageURL` — another page on your site
         *  + `/localPageURL?queryParam=value` - another page on your site with query parameters
         *  + `/` — your site's home page
         *  + `http(s)://<url>` — an external web address
         *  + `wix:document://<location>` - a document stored in the Media Manager
         *  + `mailto:<address>@<someplace.com>?subject=<subject>` - an email
         *  + `tel:<phone number>` - a phone number
         *
         *
         *  To find the local URL of a page on your site in the Editor:
         *  + Regular page - See the **SEO** tab of the **Page Settings** panel.
         *  + Dynamic page - See the **Page Info** tab of the **Page Settings** panel
         *    for the URL structure. The actual URL used for navigation needs to contain
         *    values where the placeholders are.
         *
         *    For example, if the URL structure of your dynamic page looks like:
         *    ![Dynamic Page URL](images/dynamic_url.png "Dynamic Page URL")
         *    and you have an item with the title "Waffles", the local URL to that page
         *    is /Recipes/Waffles.
         *  + Router page - You cannot navigate directly to a specific router page. You
         *    can navigate to a URL with the router's prefix and the router code will
         *    decide which page to route to.
         *
         *
         *  The `to()` function will attempt to properly encode the URL parameter that
         *  is passed to it. For example, `.../some page` will be encoded to
         *  `.../some%20page`. However, some URLs do not have one unambiguous encoding.
         *  In those cases it is up to you to encode the URL to reflect your intentions.
         *  Because of these situations, it is a best practice to always encode URLs
         *  before you pass them to the `to()` function.
         *
         *  Note that Wix URLs do not contain spaces. A page which has spaces in its
         *  name has its spaces replaced with dashes (`-`). Similarly, a dynamic page
         *  whose URL contains the value of a field in your collection with spaces will
         *  have its spaces replaced with dashes (`-`).
         * @param {external:String} url The URL of the page or website to navigate to.
         * @snippet [Location-to_set_local.es6=Navigate to a local link]
         * @snippet [Location-to_set_weblink.es6=Navigate to an external web link]
         * @snippet [Location-to_set_mailto.es6=Open a new email window]
         * @snippet [Location-to_set_document.es6=Open a document]
         * @snippet [Location-to_set_telephone.es6=Make a phone call]
         * @memberof wix-location
         */
        value: function to(url) {
            var linkData = void 0;
            if (!(0, _validation.validate)('Location', 'to', { url: url })) {
                return this;
            }
            try {
                linkData = new _Link2.default(url).getData();
            } catch (e) {
                if (e.message === _errors.errors.ERROR_API_BEFORE_PAGE_READY) {
                    throw new Error(_errors.generateError.error_api_with_name_before_page_ready({ apiName: 'wix-location.to' }));
                }
                var message = e.message === 'Unsupported link type' ? url + ' is an unsupported url' : e.message;
                _reporter2.default.reportSdkError(message);
                return this;
            }

            if (linkData.hasOwnProperty('pageId')) {
                linkData.pageId = linkData.pageId === '#' ? linkData.pageId : linkData.pageId.replace('#', '');
            }

            if (linkData.hasOwnProperty('target')) {
                delete linkData.target;
            }

            postMessage.sendMessage(postMessage.Intent.WIX_CODE_SITE_API, postMessage.MessageTypes.NAVIGATE_TO, linkData);
        }
    }, {
        key: 'url',
        get: function get() {
            var RGI = _platformUtils2.default.getRGI();
            return urlUtils.getUrlFromRGI(RGI);
        }

        /*
         ******* COMMENTED OUT — SEE https://jira.wixpress.com/browse/WCD-3608  ******
         * @member hash
         * @label property
         * @syntax
         * get hash(): string
         * @summary Gets the part of the page's URL after the hash (`#`).
         * @description
         *  Premium sites:
         *  ![Premium site hash](images/url_premium_hash.png "Premium site hash")
         *
         *  Free sites:
         *  ![Free site hash](images/url_free_hash.png "Free site hash")
         * @snippet [Location-hash.es6=Get the hash of the current page's URL]
         * @type {external:String}
         * @memberof wix-location
         * @readonly
         */

    }, {
        key: 'hash',
        get: function get() {
            return urlUtils.parseUrl(this.url).hash;
        }

        /**
         * @member protocol
         * @label property
         * @syntax
         * get protocol(): string
         * @summary Gets the protocol of the page's URL.
         * @description
         *  Premium sites:
         *  ![Premium site protocol](images/url_premium_protocol.png "Premium site protocol")
         *
         *  Free sites:
         *  ![Free site protocol](images/url_free_protocol.png "Free site protocol")
         * @snippet [Location-protocol.es6=Get the protocol of the current page's URL]
         * @type {external:String}
         * @memberof wix-location
         * @readonly
         */

    }, {
        key: 'protocol',
        get: function get() {
            return urlUtils.parseUrl(this.url).protocol;
        }

        /**
         * @member prefix
         * @memberof wix-location
         * @label property
         * @syntax
         * get prefix(): string
         * @summary Gets the prefix of a dynamic page's or router page's URL.
         * @description
         *  Only dynamic pages and router pages have a prefix. The value of the
         *  `prefix` property for other page types is always `undefined`.
         *
         *  Premium sites:
         *  ![Premium site prefix](images/url_premium_prefix.png "Premium site prefix")
         *
         *  Free sites:
         *  ![Free site prefix](images/url_free_prefix.png "Free site prefix")
         *
         *  To learn more about dynamic page prefixes, see [About URL Prefixes and Page Grouping of Dynamic Pages](https://support.wix.com/en/article/about-url-prefixes-and-page-grouping-of-dynamic-pages).
         *
         *  To learn more about router page prefixes, see [About Routers](https://support.wix.com/en/article/about-routers#url-prefix).
         * @snippet [Location-prefix.es6=Get the prefix of the current page's URL]
         * @type {external:String}
         * @memberof wix-location
         * @readonly
         */

    }, {
        key: 'prefix',
        get: function get() {
            var RGI = _platformUtils2.default.getRGI();
            var nav = RGI.getNavigationInfo();
            return nav && nav.routerDefinition ? nav.routerDefinition.prefix : undefined;
        }

        /**
         * @member path
         * @label property
         * @syntax
         * get path(): string[]
         * @summary Gets the path of the page's URL.
         * @description
         *  Premium sites:
         *  ![Premium site path](images/url_premium_path.png "Premium site path")
         *
         *  Free sites:
         *  ![Free site path](images/url_free_path.png "Free site path")
         * @snippet [Location-path.es6=Get the path of the current page's URL]
         * @type {external:String[]}
         * @memberof wix-location
         * @readonly
         */

    }, {
        key: 'path',
        get: function get() {
            var prefix = this.prefix;
            var parsedUrl = urlUtils.parseUrl(this.url);
            var path = parsedUrl.path;
            var isFreeSite = this.baseUrl.indexOf('wixsite.com') > 0;
            var pathAsArray = path.substring(1).split('/');
            var fullPath = isFreeSite ? pathAsArray.slice(1) : pathAsArray;

            return prefix && fullPath[0] === prefix ? fullPath.slice(1) : fullPath;
        }

        /**
         * @member query
         * @label property
         * @syntax
         * get query(): Object
         * @summary Gets an object that represents the query segment of the page's URL.
         * @description
         *  Premium sites:
         *  ![Premium site query](images/url_premium_query.png "Premium site query")
         *
         *  Free sites:
         *  ![Free site query](images/url_free_query.png "Free site query")
         * @snippet [Location-query.es6=Get the query of the current page's URL]
         * @type {external:Object}
         * @memberof wix-location
         * @readonly
         */

    }, {
        key: 'query',
        get: function get() {
            return urlUtils.parseUrl(this.url).query;
        }

        /**
         * @member baseUrl
         * @label property
         * @syntax
         * get baseUrl(): string
         * @summary Gets the base URL of the page.
         * @description
         *  Premium sites:
         *  ![Premium site baseUrl](images/url_premium_baseUrl.png "Premium site baseUrl")
         *
         *  Free sites:
         *  ![Free site baseUrl](images/url_free_baseUrl.png "Free site baseUrl")
         *
         *  If the site is not yet published, the function returns null.
         * @snippet [Location-baseUrl.es6=Get the base URL of the current page]
         * @type {external:String}
         * @see [url](#url)
         * @memberof wix-location
         * @readonly
         */

    }, {
        key: 'baseUrl',
        get: function get() {
            var RGI = _platformUtils2.default.getRGI();
            return RGI.getNavigationInfo().baseUrl;
        }
    }]);

    return Location;
}();

exports.default = Location;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ga;

var _postMessage = __webpack_require__(18);

var postMessage = _interopRequireWildcard(_postMessage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function ga() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    postMessage.sendMessage(postMessage.Intent.WIX_CODE_SITE_API, postMessage.MessageTypes.GOOGLE_ANALYTICS, args);
}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.booleanInputClearance = exports.booleanInputInitialize = undefined;

var _validationsService = __webpack_require__(15);

var _valueValidatableInitialize = __webpack_require__(38);

var validationsEventHandler = function validationsEventHandler(RMI) {
    return function (e) {
        var value = e.target.checked;
        var compId = e.syntheticEvent.id;

        (0, _validationsService.runValidationsAfterChange)(RMI, compId, value);
    };
};

var updateValidationState = function updateValidationState(RMI, compId) {
    return (0, _validationsService.runValidations)(RMI, compId);
};

var booleanInputInitialize = function booleanInputInitialize(RMI, contextId, compId) {
    RMI.registerEvent(contextId, compId, RMI.getEventTypes().CHANGE, null, validationsEventHandler(RMI));
    updateValidationState(RMI, compId);
};

var booleanInputClearance = function booleanInputClearance(RMI, contextId, compId) {
    return (0, _valueValidatableInitialize.valueValidatableClearance)(RMI, contextId, compId);
};

exports.booleanInputInitialize = booleanInputInitialize;
exports.booleanInputClearance = booleanInputClearance;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.comboBoxInputClearance = exports.comboBoxInputInitialize = undefined;

var _valueValidatableInitialize = __webpack_require__(38);

var comboBoxInputInitialize = function comboBoxInputInitialize(RMI, contextId, compId) {
  return (0, _valueValidatableInitialize.valueValidatableInitialize)(RMI, contextId, compId);
};

var comboBoxInputClearance = function comboBoxInputClearance(RMI, contextId, compId) {
  return (0, _valueValidatableInitialize.valueValidatableClearance)(RMI, contextId, compId);
};

exports.comboBoxInputInitialize = comboBoxInputInitialize;
exports.comboBoxInputClearance = comboBoxInputClearance;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.datePickerClearance = exports.datePickerInitialize = undefined;

var _validatableWithSyncInitialize = __webpack_require__(129);

var _validatableWithSyncInitialize2 = _interopRequireDefault(_validatableWithSyncInitialize);

var _valueValidatableInitialize = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var datePickerInitialize = function datePickerInitialize(RMI, contextId, compId) {
  return (0, _validatableWithSyncInitialize2.default)(RMI, contextId, compId);
};
var datePickerClearance = function datePickerClearance(RMI, contextId, compId) {
  return (0, _valueValidatableInitialize.valueValidatableClearance)(RMI, contextId, compId);
};

exports.datePickerInitialize = datePickerInitialize;
exports.datePickerClearance = datePickerClearance;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.radioGroupClearance = exports.radioGroupInitialize = undefined;

var _validatableWithSyncInitialize = __webpack_require__(129);

var _validatableWithSyncInitialize2 = _interopRequireDefault(_validatableWithSyncInitialize);

var _valueValidatableInitialize = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var radioGroupInitialize = function radioGroupInitialize(RMI, contextId, compId) {
  return (0, _validatableWithSyncInitialize2.default)(RMI, contextId, compId);
};

var radioGroupClearance = function radioGroupClearance(RMI, contextId, compId) {
  return (0, _valueValidatableInitialize.valueValidatableClearance)(RMI, contextId, compId);
};

exports.radioGroupInitialize = radioGroupInitialize;
exports.radioGroupClearance = radioGroupClearance;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textAreaInputClearance = exports.textAreaInputInitialize = undefined;

var _valueValidatableInitialize = __webpack_require__(38);

var textAreaInputInitialize = function textAreaInputInitialize(RMI, contextId, compId) {
  return (0, _valueValidatableInitialize.valueValidatableInitialize)(RMI, contextId, compId);
};

var textAreaInputClearance = function textAreaInputClearance(RMI, contextId, compId) {
  return (0, _valueValidatableInitialize.valueValidatableClearance)(RMI, contextId, compId);
};

exports.textAreaInputInitialize = textAreaInputInitialize;
exports.textAreaInputClearance = textAreaInputClearance;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textInputClearance = exports.textInputInitialize = undefined;

var _valueValidatableInitialize = __webpack_require__(38);

var textInputInitialize = function textInputInitialize(RMI, contextId, compId) {
  return (0, _valueValidatableInitialize.valueValidatableInitialize)(RMI, contextId, compId);
};

var textInputClearance = function textInputClearance(RMI, contextId, compId) {
  return (0, _valueValidatableInitialize.valueValidatableClearance)(RMI, contextId, compId);
};

exports.textInputInitialize = textInputInitialize;
exports.textInputClearance = textInputClearance;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uploadButtonClearance = exports.uploadButtonInitialize = undefined;

var _validationsService = __webpack_require__(15);

var _valueValidatableInitialize = __webpack_require__(38);

var onChangeValidationsEventHandler = function onChangeValidationsEventHandler(RMI) {
    return function (e) {
        var value = e.target.value;
        var compId = e.syntheticEvent.id;

        (0, _validationsService.runValidationsAndSyncAfterChange)(RMI, compId, value);
    };
};

var validationsEventHandler = function validationsEventHandler(RMI) {
    return function (e) {
        return (0, _validationsService.runValidationsAndSync)(RMI, e.syntheticEvent.id);
    };
};

var updateValidationState = function updateValidationState(RMI, compId) {
    return (0, _validationsService.runValidationsAndSync)(RMI, compId);
};

var uploadButtonInitialize = function uploadButtonInitialize(RMI, contextId, compId) {
    RMI.registerEvent(contextId, compId, RMI.getEventTypes().CHANGE, null, onChangeValidationsEventHandler(RMI));
    RMI.registerEvent(contextId, compId, RMI.getEventTypes().VALIDATE, null, validationsEventHandler(RMI));
    updateValidationState(RMI, compId);
};

var uploadButtonClearance = function uploadButtonClearance(RMI, contextId, compId) {
    return (0, _valueValidatableInitialize.valueValidatableClearance)(RMI, contextId, compId);
};

exports.uploadButtonInitialize = uploadButtonInitialize;
exports.uploadButtonClearance = uploadButtonClearance;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createEventFrom;

var _isUndefined = __webpack_require__(30);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _platformUtils = __webpack_require__(13);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _WixEvent = __webpack_require__(40);

var _WixEvent2 = _interopRequireDefault(_WixEvent);

var _MouseEvent = __webpack_require__(277);

var _MouseEvent2 = _interopRequireDefault(_MouseEvent);

var _KeyboardEvent = __webpack_require__(276);

var _KeyboardEvent2 = _interopRequireDefault(_KeyboardEvent);

var _HtmlComponentMessageEvent = __webpack_require__(275);

var _HtmlComponentMessageEvent2 = _interopRequireDefault(_HtmlComponentMessageEvent);

var _GalleryItemClickedEvent = __webpack_require__(274);

var _GalleryItemClickedEvent2 = _interopRequireDefault(_GalleryItemClickedEvent);

var _GalleryItemChangedEvent = __webpack_require__(141);

var _GalleryItemChangedEvent2 = _interopRequireDefault(_GalleryItemChangedEvent);

var _TableCellEvent = __webpack_require__(278);

var _TableCellEvent2 = _interopRequireDefault(_TableCellEvent);

var _TableRowEvent = __webpack_require__(279);

var _TableRowEvent2 = _interopRequireDefault(_TableRowEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createEventFrom(data, controllerId) {
    var RMI = _platformUtils2.default.getRMI();
    var wixSelector = _platformUtils2.default.getWixSelector();
    var comp = wixSelector.getInstance(RMI, RMI.getType(data.compId), data.compId, controllerId);
    var EventTypes = RMI.getEventTypes();
    var type = (0, _get2.default)(data, 'event.action') || (0, _get2.default)(data, 'event.type');
    if ((0, _isUndefined2.default)(type)) {
        return new _WixEvent2.default(comp);
    }

    switch (type) {
        case EventTypes.MOUSE_IN:
        case EventTypes.MOUSE_OUT:
        case EventTypes.CLICK:
        case EventTypes.DBL_CLICK:
        case EventTypes.SCREEN_IN:
            return new _MouseEvent2.default(comp, data.event);
        case EventTypes.IMAGE_EXPANDED:
        case EventTypes.IMAGE_CHANGED:
            return new _GalleryItemChangedEvent2.default(comp, data.event);
        case EventTypes.KEY_PRESS:
            return new _KeyboardEvent2.default(comp, data.event);
        case EventTypes.MESSAGE:
            return new _HtmlComponentMessageEvent2.default(comp, data.event);
        case EventTypes.ITEM_CLICKED:
            return new _GalleryItemClickedEvent2.default(comp, data.event);
        case EventTypes.CELL_EDIT:
        case EventTypes.CELL_SELECT:
            return new _TableCellEvent2.default(comp, data.event);
        case EventTypes.ROW_SELECT:
            return new _TableRowEvent2.default(comp, data.event);
        default:
            return new _WixEvent2.default(comp, data.event);
    }
}

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* TURNED OFF JSDOC FOR THIS BLOCK; I DON'T THINK IT NEEDS TO BE EXPOSED TO THE USER:
 * @summary Types of links
 * @memberof $w
 * @enum {external:String}
 * @readonly
 */
var LinkType = {
  /**
   * Indicates linking to a Wix page
   */
  PAGE: 'PageLink',

  /**
   * Indicates linking to an external website
   */
  EXTERNAL: 'ExternalLink',
  /**
   * Indicates linking to an email address
   */
  EMAIL: 'EmailLink',
  /**
   * Indicates linking to a download
   */
  DOCUMENT: 'DocumentLink',

  /**
   * Indicates linking to the top of the page
   */
  PAGE_TOP: 'AnchorLink',
  /**
   * Indicates linking to the bottom of the page
   */
  PAGE_BOTTOM: 'AnchorLink',

  /**
   * Indicates linking to a Wix page w/ an Anchor
   */
  ANCHOR: 'AnchorLink',

  /**
   * Indicates linking to a phone number
   */
  PHONE: 'PhoneLink'
};

exports.default = LinkType;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _uniqueId = __webpack_require__(428);

var _uniqueId2 = _interopRequireDefault(_uniqueId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generateId(prefix) {
    return (0, _uniqueId2.default)(prefix);
}

exports.default = { generateId: generateId };

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (receiver, suppliers) {
    var receiverProps = Object.getOwnPropertyNames(receiver);
    receiverProps.forEach(function (prop) {
        return delete receiver[prop];
    });

    return suppliers.map(function (supplier) {
        return (0, _mixin2.default)(receiver, supplier);
    });
};

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function findCurrentPage(pagesData, currentPageId) {
    for (var i = 0; i < pagesData.length; i++) {
        var currPage = pagesData[i];
        if (currPage.id === currentPageId) {
            return currPage;
        }
        if (currPage.childPages) {
            currPage = findCurrentPage(currPage.childPages, currentPageId);
            if (currPage && currPage.id === currentPageId) {
                return currPage;
            }
        }
    }
}

function removeCompIdFromPagesData(pagesData) {
    pagesData.forEach(function (pageData) {
        delete pageData.id;
        if (pageData.childPages) {
            removeCompIdFromPagesData(pageData.childPages);
        }
    });
}
//
// function isDynamicPage(routers, pageId) {
//     return some(routers, (routerData) => {
//         return includes(values(routerData.pages), pageId);
//     });
// }

function isDynamicPage(pageSiteStructureData) {
    return pageSiteStructureData.prefix;
}

function getPageURI(currentPageSiteStructureData, currentNavigationInfo) {
    if (isDynamicPage(currentPageSiteStructureData)) {
        return "/" + currentNavigationInfo.routerDefinition.prefix + "/" + currentNavigationInfo.innerRoute;
    }
    if (currentPageSiteStructureData) {
        return currentPageSiteStructureData.url;
    }
}

exports.findCurrentPage = findCurrentPage;
exports.removeCompIdFromPagesData = removeCompIdFromPagesData;
exports.isDynamicPage = isDynamicPage;
exports.getPageURI = getPageURI;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _postMessage = __webpack_require__(18);

var postMessage = _interopRequireWildcard(_postMessage);

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function invokeApi(compId, compName, fn) {
    for (var _len = arguments.length, fnArgs = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        fnArgs[_key - 3] = arguments[_key];
    }

    return new Promise(function (resolve, reject) {
        postMessage.sendMessage(postMessage.Intent.WIX_CODE_APP_API, postMessage.MessageTypes.INVOKE_APP_FN, {
            compId: compId,
            fn: fn,
            fnArgs: fnArgs
        }, function (data, error) {
            if (error) {
                reject('Failed to invoke ' + fn + ' of component ' + compName);
            } else {
                resolve(data);
            }
        });
    });
}

function registerToApiEvent(compId, compName, fn, cb) {
    for (var _len2 = arguments.length, fnArgs = Array(_len2 > 4 ? _len2 - 4 : 0), _key2 = 4; _key2 < _len2; _key2++) {
        fnArgs[_key2 - 4] = arguments[_key2];
    }

    postMessage.sendMessage(postMessage.Intent.WIX_CODE_APP_API, postMessage.MessageTypes.INVOKE_APP_ON, {
        compId: compId,
        fn: fn,
        fnArgs: fnArgs
    }, function (data, error) {
        if (error) {
            _reporter2.default.reportSdkError('Failed to invoke ' + fn + ' of component ' + compName);
        } else {
            cb(data);
        }
    });
}

exports.default = {
    invokeApi: invokeApi,
    registerToApiEvent: registerToApiEvent
};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get2 = __webpack_require__(3);

var _get3 = _interopRequireDefault(_get2);

var _platformUtils = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TypesUtil = function () {
    function TypesUtil(typesData) {
        _classCallCheck(this, TypesUtil);

        this.typesData = typesData;
    }

    /**
     * @typedef {Object} TypesData
     * @propery {Object} supportedComponentAPIs
     * @property {Object} viewerTypeToSdkTypeDefinitions
     */

    _createClass(TypesUtil, [{
        key: 'getPotentialViewerTypes',
        value: function getPotentialViewerTypes(sdkType) {
            var typeUtils = (0, _platformUtils.getTypeUtils)();
            return typeUtils.getPotentialViewerTypes(sdkType);
        }
    }, {
        key: 'getSdkConstructorName',
        value: function getSdkConstructorName(comp) {
            if (!comp) {
                return null;
            }
            var typeUtils = (0, _platformUtils.getTypeUtils)();
            var viewerType = comp.type;
            var widgetId = (0, _get3.default)(comp, ['data', 'widgetId']);
            return typeUtils.getSdkType(viewerType, widgetId);
        }
    }, {
        key: 'getSdkPublicName',
        value: function getSdkPublicName(comp) {
            return this.getSdkConstructorName(comp);
        }
    }, {
        key: 'getDefaultSdkType',
        value: function getDefaultSdkType() {
            var typeUtils = (0, _platformUtils.getTypeUtils)();
            return (0, _get3.default)(typeUtils, 'defaultSdkType');
        }
    }, {
        key: 'possibleTypes',
        get: function get() {
            var typeUtils = (0, _platformUtils.getTypeUtils)();
            return (0, _get3.default)(typeUtils, 'Types');
        }
    }, {
        key: 'supportedComponentAPIs',
        get: function get() {
            return this.typesData.supportedComponentAPIs;
        }
    }]);

    return TypesUtil;
}();

exports.default = TypesUtil;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var supportedComponentAPIs = {
    'wysiwyg.viewer.components.BoxSlideShow': ['onPlay', 'onPause', 'play', 'pause', 'previous', 'next', 'isPlaying', 'clickAction', 'items', 'onItemClicked'],
    'wysiwyg.viewer.components.StripContainerSlideShow': ['onPlay', 'onPause', 'play', 'pause', 'previous', 'next', 'isPlaying', 'clickAction', 'items', 'onItemClicked'],
    'wysiwyg.viewer.components.SlideShowGallery': ['currentIndex', 'currentItem', 'showNavigationButtons', 'onCurrentItemChanged', 'onPlay', 'onPause', 'play', 'pause', 'previous', 'next', 'isPlaying', 'clickAction', 'items', 'onItemClicked'],
    'wysiwyg.viewer.components.SliderGallery': ['clickAction', 'items', 'onItemClicked'],
    'wysiwyg.viewer.components.MatrixGallery': ['clickAction', 'items', 'onItemClicked'],
    'wysiwyg.viewer.components.PaginatedGridGallery': ['showNavigationButtons', 'onPlay', 'onPause', 'play', 'pause', 'previous', 'next', 'isPlaying', 'clickAction', 'items', 'onItemClicked'],
    'tpa.viewer.components.Collage': ['clickAction', 'items', 'onItemClicked'],
    'tpa.viewer.components.Masonry': ['clickAction', 'items', 'onItemClicked'],
    'tpa.viewer.components.Honeycomb': ['clickAction', 'items', 'onItemClicked'],
    'tpa.viewer.components.Accordion': ['clickAction', 'items', 'onItemClicked'],
    'tpa.viewer.components.Freestyle': ['clickAction', 'items', 'onItemClicked'],
    'tpa.viewer.components.Thumbnails': ['currentIndex', 'currentItem', 'onCurrentItemChanged', 'showNavigationButtons', 'play', 'pause', 'previous', 'next', 'isPlaying', 'clickAction', 'items', 'onItemClicked'],
    'tpa.viewer.components.StripShowcase': ['currentIndex', 'currentItem', 'onCurrentItemChanged', 'showNavigationButtons', 'play', 'pause', 'previous', 'next', 'isPlaying', 'clickAction', 'items', 'onItemClicked'],
    'tpa.viewer.components.StripSlideshow': ['currentIndex', 'currentItem', 'onCurrentItemChanged', 'play', 'pause', 'previous', 'next', 'isPlaying', 'items', 'onItemClicked'],
    'wysiwyg.viewer.components.tpapps.TPA3DCarousel': ['currentIndex', 'currentItem', 'onCurrentItemChanged', 'play', 'pause', 'previous', 'next', 'isPlaying', 'clickAction', 'items', 'onItemClicked'],
    'wysiwyg.viewer.components.tpapps.TPA3DGallery': ['currentIndex', 'currentItem', 'onCurrentItemChanged', 'play', 'pause', 'previous', 'next', 'isPlaying', 'clickAction', 'items', 'onItemClicked'],
    'tpa.viewer.components.Impress': ['currentIndex', 'currentItem', 'onCurrentItemChanged', 'play', 'pause', 'previous', 'next', 'isPlaying', 'clickAction', 'items', 'onItemClicked']
};

/**
 * @typedef {Object} TypesData
 * @propery {Object} supportedComponentAPIs
 * @property {Object} viewerTypeToSdkTypeDefinitions
 */
exports.default = {
    supportedComponentAPIs: supportedComponentAPIs
};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addCustomValidityToValidateData = exports.validateValue = exports.getCustomValidity = undefined;

var _validity, _INVALID_MESSAGES, _ELEMENT_TYPES$TEXT_I, _ELEMENT_TYPE_TO_VALI;

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _defaults2 = __webpack_require__(60);

var _defaults3 = _interopRequireDefault(_defaults2);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isFinite = __webpack_require__(189);

var _isFinite2 = _interopRequireDefault(_isFinite);

var _toFinite = __webpack_require__(197);

var _toFinite2 = _interopRequireDefault(_toFinite);

var _flow = __webpack_require__(118);

var _flow2 = _interopRequireDefault(_flow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var VALIDITY_KEYS = {
    BAD_INPUT: 'badInput',
    CUSTOM_ERROR: 'customError',
    FILE_NOT_UPLOADED: 'fileNotUploaded',
    PATTERN_MISMATCH: 'patternMismatch',
    RANGE_OVERFLOW: 'rangeOverflow',
    RANGE_UNDERFLOW: 'rangeUnderflow',
    STEP_MISMATCH: 'stepMismatch',
    TOO_LONG: 'tooLong',
    TOO_SHORT: 'tooShort',
    TYPE_MISMATCH: 'typeMismatch',
    VALID: 'valid',
    VALUE_MISSING: 'valueMissing'
};
var INITIAL_VALIDATE_DATA = {
    validity: (_validity = {}, _defineProperty(_validity, VALIDITY_KEYS.BAD_INPUT, false), _defineProperty(_validity, VALIDITY_KEYS.CUSTOM_ERROR, false), _defineProperty(_validity, VALIDITY_KEYS.FILE_NOT_UPLOADED, false), _defineProperty(_validity, VALIDITY_KEYS.PATTERN_MISMATCH, false), _defineProperty(_validity, VALIDITY_KEYS.RANGE_OVERFLOW, false), _defineProperty(_validity, VALIDITY_KEYS.RANGE_UNDERFLOW, false), _defineProperty(_validity, VALIDITY_KEYS.STEP_MISMATCH, false), _defineProperty(_validity, VALIDITY_KEYS.TOO_LONG, false), _defineProperty(_validity, VALIDITY_KEYS.TOO_SHORT, false), _defineProperty(_validity, VALIDITY_KEYS.TYPE_MISMATCH, false), _defineProperty(_validity, VALIDITY_KEYS.VALID, true), _defineProperty(_validity, VALIDITY_KEYS.VALUE_MISSING, false), _validity),
    validationMessage: ''
};
var INVALID_MESSAGES = (_INVALID_MESSAGES = {}, _defineProperty(_INVALID_MESSAGES, VALIDITY_KEYS.VALUE_MISSING, 'value missing'), _defineProperty(_INVALID_MESSAGES, VALIDITY_KEYS.PATTERN_MISMATCH, 'pattern mismatch'), _defineProperty(_INVALID_MESSAGES, VALIDITY_KEYS.RANGE_OVERFLOW, 'range overflow'), _defineProperty(_INVALID_MESSAGES, VALIDITY_KEYS.RANGE_UNDERFLOW, 'range underflow'), _defineProperty(_INVALID_MESSAGES, VALIDITY_KEYS.STEP_MISMATCH, 'step mismatch'), _defineProperty(_INVALID_MESSAGES, VALIDITY_KEYS.TYPE_MISMATCH, 'type mismatch'), _defineProperty(_INVALID_MESSAGES, VALIDITY_KEYS.FILE_NOT_UPLOADED, 'file not uploaded'), _INVALID_MESSAGES);
var VALIDATORS_TYPES = {
    'TEXT_INPUT_TEXT': 'TEXT_INPUT_TEXT',
    'TEXT_INPUT_PASSWORD': 'TEXT_INPUT_PASSWORD',
    'TEXT_INPUT_NUMBER': 'TEXT_INPUT_NUMBER',
    'TEXT_INPUT_EMAIL': 'TEXT_INPUT_EMAIL',
    'TEXT_INPUT_URL': 'TEXT_INPUT_URL',
    'TEXT_INPUT_TEL': 'TEXT_INPUT_TEL',
    'TEXT_AREA': 'TEXT_AREA',
    'SELECT_INPUT': 'SELECT_INPUT',
    'RADIO_GROUP': 'RADIO_GROUP',
    'CHECKBOX': 'CHECKBOX',
    'DATE_PICKER': 'DATE_PICKER',
    'FILE_UPLOADER': 'FILE_UPLOADER'
};
var ELEMENT_TYPES = {
    TEXT_INPUT: 'TextInput',
    TEXT_AREA: 'TextAreaInput',
    SELECT_INPUT: 'SelectableList',
    RADIO_GROUP: 'RadioGroup',
    CHECKBOX: 'CheckboxInput',
    DATE_PICKER: 'DatePicker',
    FILE_UPLOADER: 'FileUploader'
};
var TEXT_INPUT_TYPES = {
    TEXT: 'text',
    PASSWORD: 'password',
    NUMBER: 'number',
    EMAIL: 'email',
    URL: 'url',
    TEL: 'tel'
};
var ELEMENT_TYPE_TO_VALIDATOR_TYPE = (_ELEMENT_TYPE_TO_VALI = {}, _defineProperty(_ELEMENT_TYPE_TO_VALI, ELEMENT_TYPES.TEXT_INPUT, (_ELEMENT_TYPES$TEXT_I = {}, _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.TEXT, VALIDATORS_TYPES.TEXT_INPUT_TEXT), _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.PASSWORD, VALIDATORS_TYPES.TEXT_INPUT_PASSWORD), _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.NUMBER, VALIDATORS_TYPES.TEXT_INPUT_NUMBER), _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.EMAIL, VALIDATORS_TYPES.TEXT_INPUT_EMAIL), _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.URL, VALIDATORS_TYPES.TEXT_INPUT_URL), _defineProperty(_ELEMENT_TYPES$TEXT_I, TEXT_INPUT_TYPES.TEL, VALIDATORS_TYPES.TEXT_INPUT_TEL), _ELEMENT_TYPES$TEXT_I)), _defineProperty(_ELEMENT_TYPE_TO_VALI, ELEMENT_TYPES.TEXT_AREA, VALIDATORS_TYPES.TEXT_AREA), _defineProperty(_ELEMENT_TYPE_TO_VALI, ELEMENT_TYPES.SELECT_INPUT, VALIDATORS_TYPES.SELECT_INPUT), _defineProperty(_ELEMENT_TYPE_TO_VALI, ELEMENT_TYPES.RADIO_GROUP, VALIDATORS_TYPES.RADIO_GROUP), _defineProperty(_ELEMENT_TYPE_TO_VALI, ELEMENT_TYPES.CHECKBOX, VALIDATORS_TYPES.CHECKBOX), _defineProperty(_ELEMENT_TYPE_TO_VALI, ELEMENT_TYPES.DATE_PICKER, VALIDATORS_TYPES.DATE_PICKER), _defineProperty(_ELEMENT_TYPE_TO_VALI, ELEMENT_TYPES.FILE_UPLOADER, VALIDATORS_TYPES.FILE_UPLOADER), _ELEMENT_TYPE_TO_VALI);
var UPLOAD_STATUSES = {
    NOT_STARTED: 'NOT_STARTED',
    STARTED: 'STARTED',
    FAILED: 'FAILED',
    DONE: 'DONE'
};

var getValidationMessage = function getValidationMessage(validityKey) {
    return INVALID_MESSAGES[validityKey];
};
var addErrorToValidateData = function addErrorToValidateData(validateData, validityKey, validationMessage) {
    var _defaults;

    return {
        validity: (0, _defaults3.default)((_defaults = {}, _defineProperty(_defaults, validityKey, true), _defineProperty(_defaults, VALIDITY_KEYS.VALID, false), _defaults), validateData.validity),
        validationMessage: validationMessage
    };
};

var addCustomValidityToValidateData = function addCustomValidityToValidateData(validateData, validationMessage) {
    return addErrorToValidateData(validateData, VALIDITY_KEYS.CUSTOM_ERROR, validationMessage || '');
};

var addErrorToValidateDataAndKeepMessage = function addErrorToValidateDataAndKeepMessage(validateData, validityKey, validationMessage) {
    var newValidationMessage = validateData.validationMessage || validationMessage || getValidationMessage(validityKey);

    return addErrorToValidateData(validateData, validityKey, newValidationMessage);
};

var emailRegExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
var validUrlRegExp = /(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/;

var isValidEmail = function isValidEmail(value) {
    return emailRegExp.test(value);
};
var isValidUrl = function isValidUrl(value) {
    return validUrlRegExp.test(value);
};
var getUploadStatus = function getUploadStatus(compState) {
    return (0, _get2.default)(compState, 'uploadStatus', UPLOAD_STATUSES.NOT_STARTED);
};
var isUploaded = function isUploaded(compState) {
    return getUploadStatus(compState) === UPLOAD_STATUSES.DONE;
};
var getFileMissingMessage = function getFileMissingMessage(compState) {
    if (getUploadStatus(compState) === UPLOAD_STATUSES.FAILED) {
        return (0, _get2.default)(compState, 'serverMessage', INVALID_MESSAGES[VALIDITY_KEYS.FILE_NOT_UPLOADED]);
    }

    return INVALID_MESSAGES[VALIDITY_KEYS.FILE_NOT_UPLOADED];
};

var validateRequired = function validateRequired(value, compData, compProps) {
    return function (validateData) {
        var isRequired = (0, _get2.default)(compProps, 'required', false);

        if (!isRequired || value) {
            return validateData;
        }

        return addErrorToValidateDataAndKeepMessage(validateData, VALIDITY_KEYS.VALUE_MISSING);
    };
};
var validateFileRequired = function validateFileRequired(value, compData, compProps) {
    return function (validateData) {
        var isRequired = (0, _get2.default)(compProps, 'required', false);

        if (!isRequired || !(0, _isEmpty2.default)(value)) {
            return validateData;
        }

        return addErrorToValidateDataAndKeepMessage(validateData, VALIDITY_KEYS.VALUE_MISSING);
    };
};
var validatePattern = function validatePattern(value, compData) {
    return function (validateData) {
        var pattern = (0, _get2.default)(compData, 'pattern');

        if (!pattern || (0, _isEmpty2.default)(value)) {
            return validateData;
        }

        // according to w3 spec: https://www.w3.org/TR/html5/forms.html#compiled-pattern-regular-expression
        var regExp = new RegExp('^(?:' + pattern + ')$');

        return regExp.test(value) ? validateData : addErrorToValidateDataAndKeepMessage(validateData, VALIDITY_KEYS.PATTERN_MISMATCH);
    };
};
var validateRangeOverflow = function validateRangeOverflow(value, compData) {
    return function (validateData) {
        var max = (0, _get2.default)(compData, 'max');

        if (!(0, _isFinite2.default)(max) || (0, _isEmpty2.default)(value)) {
            return validateData;
        }

        return (0, _toFinite2.default)(value) <= max ? validateData : addErrorToValidateDataAndKeepMessage(validateData, VALIDITY_KEYS.RANGE_OVERFLOW);
    };
};
var validateRangeUnderflow = function validateRangeUnderflow(value, compData) {
    return function (validateData) {
        var min = (0, _get2.default)(compData, 'min');

        if (!(0, _isFinite2.default)(min) || (0, _isEmpty2.default)(value)) {
            return validateData;
        }

        return (0, _toFinite2.default)(value) >= min ? validateData : addErrorToValidateDataAndKeepMessage(validateData, VALIDITY_KEYS.RANGE_UNDERFLOW);
    };
};
var DEFAULT_STEP = 1;
var validateStepMismatch = function validateStepMismatch(value) {
    return function (validateData) {
        if ((0, _isEmpty2.default)(value)) {
            return validateData;
        }

        return (0, _toFinite2.default)(value) % DEFAULT_STEP === 0 ? validateData : addErrorToValidateDataAndKeepMessage(validateData, VALIDITY_KEYS.STEP_MISMATCH);
    };
};
var validateEmail = function validateEmail(value) {
    return function (validateData) {
        if ((0, _isEmpty2.default)(value)) {
            return validateData;
        }

        return isValidEmail(value) ? validateData : addErrorToValidateDataAndKeepMessage(validateData, VALIDITY_KEYS.TYPE_MISMATCH);
    };
};
var validateUrl = function validateUrl(value) {
    return function (validateData) {
        if ((0, _isEmpty2.default)(value)) {
            return validateData;
        }

        return isValidUrl(value) ? validateData : addErrorToValidateDataAndKeepMessage(validateData, VALIDITY_KEYS.TYPE_MISMATCH);
    };
};

var validateUploadStatus = function validateUploadStatus(value, compProps, compState) {
    return function (validateData) {
        var isRequired = (0, _get2.default)(compProps, 'required', false);
        var isAlreadyInvalid = !validateData.validity[VALIDITY_KEYS.VALID];

        if (!isRequired || !compState || isAlreadyInvalid) {
            return validateData;
        }

        return isUploaded(compState) ? validateData : addErrorToValidateDataAndKeepMessage(validateData, VALIDITY_KEYS.FILE_NOT_UPLOADED, getFileMissingMessage(compState));
    };
};

var getValidatorByType = function getValidatorByType(validatorType, value, compData, compProps, compState) {
    switch (validatorType) {
        case VALIDATORS_TYPES.TEXT_INPUT_TEXT:
            return (0, _flow2.default)([validateRequired(value, compData, compProps), validatePattern(value, compData)]);
        case VALIDATORS_TYPES.TEXT_INPUT_PASSWORD:
            return (0, _flow2.default)([validateRequired(value, compData, compProps), validatePattern(value, compData)]);
        case VALIDATORS_TYPES.TEXT_INPUT_NUMBER:
            return (0, _flow2.default)([validateRequired(value, compData, compProps), validateRangeUnderflow(value, compData), validateRangeOverflow(value, compData), validateStepMismatch(value)]);
        case VALIDATORS_TYPES.TEXT_INPUT_EMAIL:
            return (0, _flow2.default)([validateRequired(value, compData, compProps), validateEmail(value), validatePattern(value, compData)]);
        case VALIDATORS_TYPES.TEXT_INPUT_URL:
            return (0, _flow2.default)([validateRequired(value, compData, compProps), validateUrl(value), validatePattern(value, compData)]);
        case VALIDATORS_TYPES.TEXT_INPUT_TEL:
            return (0, _flow2.default)([validateRequired(value, compData, compProps), validatePattern(value, compData)]);
        case VALIDATORS_TYPES.TEXT_AREA:
            return (0, _flow2.default)([validateRequired(value, compData, compProps)]);
        case VALIDATORS_TYPES.SELECT_INPUT:
            return (0, _flow2.default)([validateRequired(value, compData, compProps)]);
        case VALIDATORS_TYPES.RADIO_GROUP:
            return (0, _flow2.default)([validateRequired(value, compData, compProps)]);
        case VALIDATORS_TYPES.CHECKBOX:
            return (0, _flow2.default)([validateRequired(value, compData, compProps)]);
        case VALIDATORS_TYPES.DATE_PICKER:
            return (0, _flow2.default)([validateRequired(value, compData, compProps)]);
        case VALIDATORS_TYPES.FILE_UPLOADER:
            return (0, _flow2.default)([validateFileRequired(value, compData, compProps), validateUploadStatus(value, compProps, compState)]);
        default:
            return function (validateData) {
                return validateData;
            };
    }
};

var getValidator = function getValidator(value, compData, compProps, compState) {
    var elementType = compData.type;

    if (elementType === ELEMENT_TYPES.TEXT_INPUT) {
        elementType += '.' + compData.textType;
    }

    var validatorType = (0, _get2.default)(ELEMENT_TYPE_TO_VALIDATOR_TYPE, elementType);

    return getValidatorByType(validatorType, value, compData, compProps, compState);
};

var validateValue = function validateValue(value, compData, compProps, compState) {
    var validator = getValidator(value, compData, compProps, compState);

    return validator(INITIAL_VALIDATE_DATA);
};

var getCustomValidity = function getCustomValidity(validateData) {
    var hasCustomError = (0, _get2.default)(validateData, 'validity.customError', false);

    return hasCustomError ? validateData.validationMessage : '';
};

exports.getCustomValidity = getCustomValidity;
exports.validateValue = validateValue;
exports.addCustomValidityToValidateData = addCustomValidityToValidateData;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _platformUtils = __webpack_require__(13);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VIDEO_URL_REGEX = /^wix:video:\/\/v1\/([^\/]+)\/([^\/]+)\/#posterUri=([^\/]+)&posterWidth=([0-9]+)&posterHeight=([0-9]+)/;

function buildFullUrlFromMediaRef(mediaRef) {
    if (!mediaRef.videoId) {
        return null;
    }
    return 'wix:video://v1/' + getVideoId(mediaRef.videoId) + '/' + mediaRef.fileName + '/#posterUri=' + mediaRef.posterImageRef.uri + '&posterWidth=' + mediaRef.posterImageRef.width + '&posterHeight=' + mediaRef.posterImageRef.height;
}

function extractModelDataFromSrc(src) {
    if (VIDEO_URL_REGEX.test(src)) {
        var backgroundUtils = _platformUtils2.default.getBackgroundUtils();

        var _ref = src.match(VIDEO_URL_REGEX) || [0, src],
            _ref2 = _slicedToArray(_ref, 6),
            videoUri = _ref2[1],
            fileName = _ref2[2],
            posterUri = _ref2[3],
            posterWidth = _ref2[4],
            posterHeight = _ref2[5];

        return (0, _assign2.default)(backgroundUtils.getVideoPosterObject(videoUri, posterUri, parseInt(posterWidth, 10), parseInt(posterHeight, 10)), { fileName: fileName });
    }
    return null;
}

function getVideoId(videoId) {
    return videoId.replace('video/', '');
}

function isVideoUrl(src) {
    return VIDEO_URL_REGEX.test(src);
}

function getFullVideoData(videoId, callback) {
    videoId = getVideoId(videoId);
    var VIDEO_INFO_END_POINT = 'https://files.wix.com/files/' + videoId + '/info';
    fetch(VIDEO_INFO_END_POINT).then(function (response) {
        return response.json();
    }).then(function (response) {
        var backgroundUtils = _platformUtils2.default.getBackgroundUtils();
        var fullVideoMediaRef = backgroundUtils.getVideoBackgroundObject(response, {});
        callback(fullVideoMediaRef);
    });
}

exports.default = {
    buildFullUrlFromMediaRef: buildFullUrlFromMediaRef,
    isVideoUrl: isVideoUrl,
    extractModelDataFromSrc: extractModelDataFromSrc,
    getFullVideoData: getFullVideoData
};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPresetNameOfEffect = exports.getOptionsMappingsOfEffect = exports.getOptionsDefaultsOfEffect = exports.getValidationSchemaOfEffect = undefined;

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _includes = __webpack_require__(53);

var _includes2 = _interopRequireDefault(_includes);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var effectValidationSchemas = __webpack_require__(206);
var effectOptionsMapping = __webpack_require__(205);
var effectOptionsDefaults = __webpack_require__(204);
var effectNameMappings = __webpack_require__(203);

function getValidationSchemaOfEffect(effect) {
    return (0, _get2.default)(effectValidationSchemas, effect);
}

function getOptionsDefaultsOfEffect(effect) {
    return (0, _get2.default)(effectOptionsDefaults, effect);
}

function getOptionsMappingsOfEffect(effect) {
    return (0, _get2.default)(effectOptionsMapping, effect, effectOptionsMapping.ALL);
}

function getPresetNameOfEffect(effect, suffix, noSuffixPresets) {
    effect = (0, _get2.default)(effectNameMappings, effect + '.' + suffix, effect);
    var capitalizedEffect = (0, _utils.capitalize)(effect);
    //Preset name is the name of the effect that we send to the viewer
    return (0, _includes2.default)(noSuffixPresets, effect) ? capitalizedEffect : '' + capitalizedEffect + suffix;
}

exports.getValidationSchemaOfEffect = getValidationSchemaOfEffect;
exports.getOptionsDefaultsOfEffect = getOptionsDefaultsOfEffect;
exports.getOptionsMappingsOfEffect = getOptionsMappingsOfEffect;
exports.getPresetNameOfEffect = getPresetNameOfEffect;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effectSchemaAPI = __webpack_require__(230);

var _includes = __webpack_require__(53);

var _includes2 = _interopRequireDefault(_includes);

var _keys = __webpack_require__(31);

var _keys2 = _interopRequireDefault(_keys);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _difference = __webpack_require__(405);

var _difference2 = _interopRequireDefault(_difference);

var _set = __webpack_require__(37);

var _set2 = _interopRequireDefault(_set);

var _clone = __webpack_require__(83);

var _clone2 = _interopRequireDefault(_clone);

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _forEach = __webpack_require__(46);

var _forEach2 = _interopRequireDefault(_forEach);

var _validation = __webpack_require__(1);

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function validateAndReportDeprecatedEffect(effectName, options, functionName, compNickname) {
    if (!(0, _isEmpty2.default)(options)) {
        _reporter2.default.reportSdkWarning(_errors.generateError.warning_deprecated_effect_with_options({
            functionName: functionName,
            compNickname: compNickname,
            effectName: effectName
        }));
        return false;
    }
    // TODO Uncomment when new docs are released
    // reporter.reportSdkWarning(generateError.warning_deprecated_effect_name({
    //     functionName,
    //     compNickname,
    //     effectName
    // }));
    return true;
}

function reportInvalidOptionsValue(value, key, functionName, compNickname, effectName) {
    _reporter2.default.reportSdkWarning(_errors.generateError.warning_invalid_effect_options({
        functionName: functionName,
        compNickname: compNickname,
        effectName: effectName,
        wrongProperty: 'value',
        wrongValue: JSON.stringify(_defineProperty({}, key, value))
    }));
}

function validateOptionKeysAndReportIfNecessary(effectName, optionKeys, validKeys, functionName, compNickname) {
    var invalidKeys = (0, _difference2.default)(optionKeys, validKeys);

    if (!(0, _isEmpty2.default)(invalidKeys)) {
        _reporter2.default.reportSdkWarning(_errors.generateError.warning_invalid_effect_options({
            functionName: functionName,
            compNickname: compNickname,
            effectName: effectName,
            wrongProperty: 'keys',
            wrongValue: invalidKeys
        }));
        return false;
    }
    return true;
}

function validateOptionValuesAndReportIfNecessary(effectName, options, validations, functionName, compNickname) {
    var res = true;
    (0, _forEach2.default)(options, function (v, k) {
        var effectValidations = validations[k];
        if (!(0, _validation.validateByType)(v, effectValidations.type)) {
            reportInvalidOptionsValue(v, k, functionName, compNickname, effectName);
            res = false;
            return;
        }

        if (effectValidations.enum && !(0, _includes2.default)(effectValidations.enum, v)) {
            reportInvalidOptionsValue(v, k, functionName, compNickname, effectName);
            res = false;
            return;
        }

        if (effectValidations.range && !(0, _validation.isValueInRange)(v, effectValidations.range.minValue, effectValidations.range.maxValue)) {
            reportInvalidOptionsValue(v, k, functionName, compNickname, effectName);
            res = false;
        }
    });
    return res;
}

function validateEffect(effect, options, functionName, compNickname, deprecatedValues) {
    if (!effect) {
        if (!(0, _isEmpty2.default)(options)) {
            _reporter2.default.reportSdkWarning(_errors.generateError.warning_effect_options_not_set({
                functionName: functionName,
                compNickname: compNickname
            }));
            return false;
        }
        return true;
    }

    if ((0, _includes2.default)(deprecatedValues, effect)) {
        return validateAndReportDeprecatedEffect(effect, options, functionName, compNickname);
    }

    var validationSchema = (0, _effectSchemaAPI.getValidationSchemaOfEffect)(effect);
    if (!validationSchema) {
        _reporter2.default.reportSdkWarning(_errors.generateError.warning_invalid_effect_name({
            functionName: functionName,
            compNickname: compNickname,
            effectName: effect
        }));

        return false;
    }

    if (!(0, _isNil2.default)(options) && !(0, _validation.validateByType)(options, _validation.TYPES.OBJECT)) {
        _reporter2.default.reportSdkWarning(_errors.generateError.warning_invalid_type_effect_options({
            functionName: functionName,
            compNickname: compNickname,
            effectName: effect,
            wrongValue: options
        }));
        return false;
    }

    var validKeys = (0, _keys2.default)(validationSchema);
    var optionKeys = (0, _keys2.default)(options);
    var allOptionKeysValid = validateOptionKeysAndReportIfNecessary(effect, optionKeys, validKeys, functionName, compNickname);
    if (!allOptionKeysValid) {
        return false;
    }

    return validateOptionValuesAndReportIfNecessary(effect, options, validationSchema, functionName, compNickname);
}

function buildEffectParams(options, optionsDefaults, optionsMappings) {
    var params = (0, _clone2.default)(optionsDefaults);
    (0, _forEach2.default)(options, function (v, k) {
        var path = (0, _get2.default)(optionsMappings, 'keys.' + k) || k;

        var value = v;
        value = (0, _get2.default)(optionsMappings, 'values.' + k + '.convertMsToSecs') ? v / 1000 : value;
        value = (0, _get2.default)(optionsMappings, 'values.' + k + '.' + v, value);

        (0, _set2.default)(params, path, value);
    });
    return params;
}

function buildEffectObject(effect, options, functionData) {
    var deprecatedValues = functionData.deprecatedValues,
        suffix = functionData.suffix,
        noSuffixPresets = functionData.noSuffixPresets;

    if ((0, _includes2.default)(deprecatedValues, effect)) {
        return { presetName: effect, params: {} };
    }

    var presetName = (0, _effectSchemaAPI.getPresetNameOfEffect)(effect, suffix, noSuffixPresets);
    var optionsDefaults = (0, _effectSchemaAPI.getOptionsDefaultsOfEffect)(effect);
    var params = buildEffectParams(options, optionsDefaults, (0, _effectSchemaAPI.getOptionsMappingsOfEffect)(effect));

    return {
        presetName: presetName,
        params: params
    };
}

exports.default = {
    validateEffect: validateEffect,
    buildEffectObject: buildEffectObject
};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _clone = __webpack_require__(83);

var _clone2 = _interopRequireDefault(_clone);

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _map = __webpack_require__(20);

var _map2 = _interopRequireDefault(_map);

var _gridEnums = __webpack_require__(127);

var _gridEnums2 = _interopRequireDefault(_gridEnums);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GALLERY_SCHEMA = {
    galleryImageOnClickAction: {
        schemaType: ['string'],
        enum: ['none', 'expand', 'link'],
        warnIfNil: true,
        acceptNil: true,
        validations: {
            type: true
        }
    },
    showNavigation: {
        schemaType: ['boolean'],
        validations: {
            type: true
        }
    },
    arrowMode: {
        schemaType: ['boolean'],
        validations: {
            type: true
        }
    },
    onChange: {
        schemaType: ['function'],
        validations: {
            type: true
        }
    },
    onItemClicked: {
        schemaType: ['function'],
        validations: {
            type: true
        }
    },
    items: {
        schemaType: ['array'],
        acceptNil: true,
        warnIfNil: true,
        validations: {
            type: true
        }
    },
    compExtensions: ['viewportMixin', 'element', 'clickableMixin', 'playableMixin']
};
var compDataSchemas = {
    Image: {
        src: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            mandatory: true,
            validations: {
                type: true
            }
        },
        description: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        title: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        alt: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        tooltip: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        id: {
            schemaType: ['string'],
            validations: {
                type: true
            }
        },
        width: {
            schemaType: ['number'],
            validations: {
                type: true
            }
        },
        height: {
            schemaType: ['number'],
            validations: {
                type: true
            }
        },
        compExtensions: ['viewportMixin', 'element', 'clickableMixin', 'linkableMixin']
    },
    Gallery: GALLERY_SCHEMA,
    ProGallery: GALLERY_SCHEMA,
    GoogleMap: {
        latitude: {
            schemaType: ['number'],
            maxVal: 90,
            minVal: -90,
            mandatory: true,
            warnIfNil: true,
            validations: {
                type: true,
                range: true
            }
        },
        longitude: {
            schemaType: ['number'],
            maxVal: 180,
            minVal: -180,
            mandatory: true,
            warnIfNil: true,
            validations: {
                type: true,
                range: true
            }
        },
        description: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        compExtensions: ['viewportMixin', 'element']
    },
    Box: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element']
    },
    Button: {
        label: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        compExtensions: ['linkableMixin', 'clickableMixin', 'viewportMixin', 'element']
    },
    Lightbox: {
        name: {
            schemaType: ['string'],
            validations: {
                type: true
            }
        }
    },
    modal: {
        url: {
            schemaType: ['url'],
            validations: {
                type: true
            }
        },
        options: {
            schemaType: ['object'],
            mandatory: true,
            validations: {
                type: true
            },
            width: {
                schemaType: ['number'],
                mandatory: true,
                validations: {
                    type: true
                }
            },
            height: {
                schemaType: ['number'],
                mandatory: true,
                validations: {
                    type: true
                }
            },
            theme: {
                schemaType: ['string'],
                enum: ['DEFAULT', 'BARE'],
                acceptNil: true,
                validations: {
                    type: true
                }
            }
        }
    },
    trackEvent: {
        eventName: {
            schemaType: ['string'],
            mandatory: true,
            validations: {
                type: true
            }
        },
        data: {
            schemaType: ['object'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        options: {
            schemaType: ['object'],
            acceptNil: true,
            validations: {
                type: true
            }
        }
    },
    Slideshow: {
        onChange: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        showNavigationButtons: {
            schemaType: ['boolean'],
            validations: {
                type: true
            }
        },
        showSlideButtons: {
            schemaType: ['boolean'],
            validations: {
                type: true
            }
        },
        compExtensions: ['playableMixin', 'clickableMixin', 'viewportMixin', 'element'],
        slideInfo: {
            schemaType: ['object', 'integer'],
            mandatory: true,
            validations: {
                type: true
            }
        }
    },
    Checkbox: {
        checked: {
            schemaType: ['boolean'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        compExtensions: ['requiredMixin', 'focusMixin', 'formElement', 'element', 'clickableMixin', 'viewportMixin']
    },
    Switch: {
        checked: {
            schemaType: ['boolean'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        compExtensions: ['requiredMixin', 'focusMixin', 'formElement', 'element', 'clickableMixin', 'viewportMixin']
    },
    Pagination: {
        currentPage: {
            schemaType: ['integer'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        totalPages: {
            schemaType: ['integer'],
            minVal: 1,
            validations: {
                type: true,
                minimum: true
            }
        },
        onChange: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        compExtensions: ['focusMixin', 'element', 'clickableMixin', 'viewportMixin']
    },
    Column: {
        compExtensions: ['clickableMixin', 'element', 'viewportMixin', 'backgroundMixin']
    },
    ColumnStrip: {
        compExtensions: ['clickableMixin', 'element', 'viewportMixin', 'backgroundMixin']
    },
    DatePicker: {
        value: {
            schemaType: ['date'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        maxDate: {
            schemaType: ['date'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        minDate: {
            schemaType: ['date'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        disabledDates: {
            schemaType: ['array'],
            acceptNil: true,
            validations: {
                type: true
            },
            itemsTypes: 'disableDate'
        },
        disableDate: {
            schemaType: ['date'],
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        disabledDaysOfWeek: {
            schemaType: ['array'],
            acceptNil: true,
            validations: {
                type: true
            },
            itemsTypes: 'disableDayOfWeek'

        },
        disableDayOfWeek: {
            schemaType: ['number'],
            enum: [0, 1, 2, 3, 4, 5, 6],
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        compExtensions: ['requiredMixin', 'focusMixin', 'formElement', 'element', 'clickableMixin', 'viewportMixin', 'readOnlyMixin']
    },
    Video: {
        videoUrl: {
            schemaType: ['url'],
            validationExpressions: 'validateVideoUrlFormats',
            validations: {
                type: true,
                regex: true
            }
        },
        compExtensions: ['element', 'viewportMixin']
    },
    Dropdown: {
        compExtensions: ['requiredMixin', 'focusMixin', 'formElement', 'element', 'clickableMixin', 'viewportMixin'],
        options: {
            schemaType: ['array'],
            warnIfNil: true,
            acceptNil: true,
            validations: {
                type: true
            },
            itemsTypes: 'selectOption'
        },
        selectOption: {
            schemaType: ['object'],
            validations: {
                type: true
            },
            value: {
                acceptNil: true,
                schemaType: ['string'],
                maxLength: 400,
                minLength: 0,
                validations: {
                    type: true,
                    length: true
                }
            },
            label: {
                acceptNil: true,
                schemaType: ['string'],
                maxLength: 400,
                minLength: 0,
                validations: {
                    type: true,
                    length: true
                }
            }
        },
        placeholder: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        selectedIndex: {
            acceptNil: true,
            schemaType: ['integer'],
            validations: {
                type: true
            }
        }
    },
    RadioButtonGroup: {
        compExtensions: ['requiredMixin', 'focusMixin', 'formElement', 'element', 'clickableMixin', 'viewportMixin'],
        options: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            },
            itemsTypes: 'RadioButton'
        },
        RadioButton: {
            schemaType: ['object'],
            validations: {
                type: true
            },
            value: {
                schemaType: ['string'],
                acceptNil: true,
                maxLength: 400,
                minLength: 0,
                validations: {
                    type: true,
                    length: true
                }
            },
            label: {
                schemaType: ['string'],
                acceptNil: true,
                maxLength: 400,
                minLength: 0,
                validations: {
                    type: true,
                    length: true
                }
            }
        },
        selectedIndex: {
            schemaType: ['integer'],
            acceptNil: true,
            validations: {
                type: true
            }
        }
    },
    UploadButton: {
        compExtensions: ['requiredMixin', 'focusMixin', 'formElement', 'element', 'clickableMixin', 'viewportMixin'],
        filesSizeLimit: {
            schemaType: ['number'],
            maxVal: 15,
            minVal: 1,
            warnIfNil: true,
            validations: {
                type: true,
                range: true
            }
        },
        buttonLabel: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }

        },
        filesType: {
            schemaType: ['string'],
            enum: ['Image', 'Document'],
            validations: {
                type: true
            }
        }
    },
    Footer: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element']
    },
    Header: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element']
    },
    Page: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element']
    },
    HoverBox: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element', 'backgroundMixin']
    },
    Shape: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element', 'linkableMixin']
    },
    Slide: {
        compExtensions: ['viewportMixin', 'element', 'backgroundMixin']
    },
    Text: {
        compExtensions: ['viewportMixin', 'element'],
        text: {
            schemaType: ['string'],
            warnIfNil: true,
            acceptNil: true,
            validations: {
                type: true
            }
        },
        html: {
            schemaType: ['string'],
            warnIfNil: true,
            acceptNil: true,
            validations: {
                type: true
            }
        }
    },
    TextBox: {
        compExtensions: ['requiredMixin', 'focusMixin', 'formElement', 'element', 'viewportMixin', 'textInputMixin', 'readOnlyMixin'],
        wrap: {
            schemaType: ['string'],
            enum: ['hard', 'soft'],
            validations: {
                type: true
            }
        }
    },
    TextInput: {
        compExtensions: ['requiredMixin', 'focusMixin', 'formElement', 'element', 'viewportMixin', 'textInputMixin', 'readOnlyMixin'],
        min: {
            schemaType: ['number'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        max: {
            schemaType: ['number'],
            acceptNil: true,
            validations: {
                type: true
            }
        },
        inputType: {
            schemaType: ['string'],
            enum: ['text', 'email', 'number', 'password', 'tel', 'url'],
            validations: {
                type: true
            }
        }
    },
    HtmlComponent: {
        compExtensions: ['RequiredMixin', 'viewportMixin', 'element'],
        url: {
            schemaType: ['url'],
            validations: {
                type: true
            }
        },
        message: {
            schemaType: ['object', 'string', 'number', 'boolean', 'array'],
            validations: {
                type: true
            }
        },
        onMessage: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        scrolling: {
            schemaType: ['string'],
            enum: ['no', 'yes', 'auto'],
            validations: {
                type: true
            }
        }
    },
    Repeater: {
        data: {
            schemaType: ['array'],
            validations: {
                type: true
            }
        },
        callback: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        _id: {
            schemaType: ['string'],
            validations: {
                type: true
            }
        },
        ids: {
            schemaType: ['array'],
            validations: {
                type: true
            }
        }
    },
    Container: {
        compExtensions: ['clickableMixin', 'backgroundMixin']
    },
    Table: {
        compExtensions: ['clickableMixin', 'viewportMixin', 'element'],
        onRowSelect: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        dataFetcherCallback: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        onCellSelect: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        rowIndex: {
            schemaType: ['number'],
            validations: {
                type: true
            }
        },
        rows: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        row: {
            schemaType: ['object'],
            validations: {
                type: true
            }
        },
        columns: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        column: {
            schemaType: ['object'],
            validations: {
                type: true
            },
            id: {
                schemaType: ['string'],
                mandatory: true,
                validations: {
                    type: true
                }
            }
        },
        sorting: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        filter: {
            schemaType: ['object'],
            validations: {
                type: true
            }
        },
        pagination: {
            schemaType: ['object'],
            validations: {
                type: true
            },
            type: {
                schemaType: ['string'],
                mandatory: true,
                enum: (0, _map2.default)(_gridEnums2.default.PaginationType),
                validations: {
                    type: true
                }
            },
            rowsPerPage: {
                schemaType: ['number'],
                validations: {
                    type: true
                }
            }
        }
    },
    Window: {
        x: {
            schemaType: ['number'],
            validations: {
                type: true
            }
        },
        y: {
            schemaType: ['number'],
            validations: {
                type: true
            }
        },
        payload: {
            schemaType: ['object'],
            validations: {
                type: true
            }
        },
        target: {
            schemaType: ['string'],
            enum: ['parent'],
            acceptNil: true,
            validations: {
                type: true
            }
        }
    },
    Document: {
        url: {
            schemaType: ['string'],
            acceptNil: true,
            validations: {
                type: true
            }
        }
    },
    Location: {
        url: {
            schemaType: ['string'],
            validations: {
                type: true
            }
        }
    },
    Users: {
        mode: {
            schemaType: ['string'],
            enum: ['login', 'signup'],
            validations: {
                type: true
            }
        },
        lang: {
            schemaType: ['string'],
            maxLength: 2,
            minLength: 2,
            validations: {
                type: true,
                length: true
            }
        },
        onLogin: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        language: {
            schemaType: ['string'],
            maxLength: 2,
            minLength: 2,
            validations: {
                type: true,
                length: true
            }
        }
    },
    VectorImage: {
        src: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            mandatory: true,
            validations: {
                type: true
            }
        },
        compExtensions: ['clickableMixin', 'viewportMixin', 'element', 'linkableMixin']
    },
    CRM: {
        userId: {
            schemaType: ['uuid'],
            validations: {
                type: true
            }
        },
        emailId: {
            schemaType: ['string'],
            validations: {
                type: true
            }
        },
        emailOptions: {
            schemaType: ['object'],
            acceptNil: true,
            validations: {
                type: true
            },
            variables: {
                schemaType: ['object'],
                acceptNil: true,
                validations: {
                    type: true
                }
            }
        }
    },
    VerticalMenu: {
        menuItems: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        }
    },
    AccountNavBar: {
        menuItems: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        navBarItems: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        }
    },
    MobileMenu: {
        menuItems: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        navBarItems: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        }
    },
    BasicMenuItem: {
        schemaType: ['object'],
        validations: {
            type: true
        },
        visibleOnDesktop: {
            schemaType: ['boolean'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        visibleOnMobile: {
            schemaType: ['boolean'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        icon: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        label: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        displayCount: {
            schemaType: ['number'],
            acceptNil: true,
            warnIfNil: false,
            validations: {
                type: true
            }
        },
        items: {
            schemaType: ['array'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            },
            itemsTypes: 'BasicMenuItem'
        }
    }

};

var compExtensions = {
    viewportMixin: {
        onViewportLeave: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        onViewportEnter: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    },
    linkableMixin: {
        link: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        target: {
            schemaType: ['string'],
            enum: ['_blank', '_self'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        }
    },
    clickableMixin: {
        onClick: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        onDblClick: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    },
    playableMixin: {
        onPause: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        onPlay: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    },
    readOnlyMixin: {
        readonly: {
            schemaType: ['boolean'],
            validations: {
                type: true
            }
        }
    },
    requiredMixin: {
        required: {
            schemaType: ['boolean'],
            validations: {
                type: true
            }
        }
    },
    textInputMixin: {
        placeholder: {
            schemaType: ['string'],
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        maxlength: {
            schemaType: ['integer'],
            minVal: 0,
            acceptNil: true,
            validations: {
                type: true,
                minimum: true
            }
        },
        onKeyPress: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    },
    backgroundMixin: {
        src: {
            schemaType: ['string'],
            acceptNil: true,
            validations: {
                type: true
            }
        }
    },
    focusMixin: {
        onFocus: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        onBlur: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    },
    element: {
        onMouseIn: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        },
        onMouseOut: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    },
    formElement: {
        required: {
            schemaType: ['boolean'],
            validations: {
                type: true
            }
        },
        value: {
            schemaType: ['string'],
            acceptNil: true,
            warnIfNil: true,
            validations: {
                type: true
            }
        },
        onChange: {
            schemaType: ['function'],
            validations: {
                type: true
            }
        }
    }
};

function getSchemaOfComp(compType) {
    var compDataSchema = (0, _clone2.default)((0, _get2.default)(compDataSchemas, compType));
    if (!compDataSchema) {
        return;
    }
    var res = {};
    if (compDataSchema.compExtensions) {
        compDataSchema.compExtensions.forEach(function (mixinName) {
            var mixinSchema = compExtensions[mixinName];
            (0, _assign2.default)(res, mixinSchema);
        });
    }
    (0, _assign2.default)(res, compDataSchema);
    return res;
}

exports.default = getSchemaOfComp;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var validationExpressions = {
    validYouTubeLongUrlReg: /(?:youtube\.com\/watch[^\s]*[\?&]v=)([\w-]+)/,
    validYouTubeShortUrlReg: /(?:youtu\.be\/)([\w-]+)/,
    validVimeoUrlReg: /vimeo\.com\/(\d+)$/,
    validDailymotionUrlReg: /dailymotion\.com\/(?:video|playlist)\/([^_/]+)/,
    validFacebookUrlReg: /facebook\.com\/.+\/videos\/[A-Za-z0-9._%-]*/,
    validRepeaterItemId: /^[a-zA-Z\d-]+$/,
    validUUID: /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
};

exports.default = validationExpressions;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.unsetCompValidationState = exports.setCompValidationState = exports.getCompValidationState = exports.initValidationsServiceState = undefined;

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _set = __webpack_require__(37);

var _set2 = _interopRequireDefault(_set);

var _unset = __webpack_require__(429);

var _unset2 = _interopRequireDefault(_unset);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _clone = __webpack_require__(83);

var _clone2 = _interopRequireDefault(_clone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validationsServiceState = void 0;

var initValidationsServiceState = function initValidationsServiceState() {
    validationsServiceState = {};
};

var getCompValidationState = function getCompValidationState(compId) {
    return (0, _clone2.default)((0, _get2.default)(validationsServiceState, compId));
};

var setCompValidationState = function setCompValidationState(compId, validationState) {
    var currentValidationState = getCompValidationState(compId);

    var newValidationState = (0, _assign2.default)({}, currentValidationState, validationState);

    (0, _set2.default)(validationsServiceState, [compId], newValidationState);
};

var unsetCompValidationState = function unsetCompValidationState(compId) {
    (0, _unset2.default)(validationsServiceState, compId);
};

exports.initValidationsServiceState = initValidationsServiceState;
exports.getCompValidationState = getCompValidationState;
exports.setCompValidationState = setCompValidationState;
exports.unsetCompValidationState = unsetCompValidationState;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _urlUtils = __webpack_require__(24);

var urlUtils = _interopRequireWildcard(_urlUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function getViewMode() {
    return urlUtils.getQueryParameter('viewMode');
}

exports.default = {
    getViewMode: getViewMode
};

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _transform = __webpack_require__(198);

var _transform2 = _interopRequireDefault(_transform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCompsForType(types, scopedRMI, type, onlyNestedScope) {
    return (0, _transform2.default)(types.getPotentialViewerTypes(type), function (result, value) {
        var compIds = scopedRMI.getCompIdsFromType(value, onlyNestedScope) || [];
        compIds.forEach(function (compId) {
            if (getSdkPublicName(types, scopedRMI, compId) === type) {
                result.push({
                    id: compId,
                    type: value
                });
            }
        });
    }, []);
}

function getSdkConstructorName(types, RMI, compId) {
    var comp = RMI.getComp(compId);
    if (!comp) {
        return null;
    }
    return types.getSdkConstructorName(comp);
}

function getSdkPublicName(types, RMI, compId) {
    var comp = RMI.getComp(compId);
    if (!comp) {
        return null;
    }
    return types.getSdkPublicName(comp);
}

exports.default = {
    getCompsForType: getCompsForType,
    getSdkConstructorName: getSdkConstructorName,
    getSdkPublicName: getSdkPublicName
};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _postMessage = __webpack_require__(18);

var postMessage = _interopRequireWildcard(_postMessage);

var _platformUtils = __webpack_require__(13);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _omit = __webpack_require__(64);

var _omit2 = _interopRequireDefault(_omit);

var _map = __webpack_require__(20);

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @namespace wix-site
 * @summary The wix-site module contains functionality for obtaining information about your site and its pages.
 * @description
 *  To use the site module, import `wixSite` from the `wix-site` module:
 *
 *    ``` javascript
 *    import wixSite from 'wix-site';
 *    ```
 *
 *  The APIs in `wix-site` can only be used in front-end code.
 */

/**
 * @typedef {external:Object} wix-site~SiteStructure
 * @summary An object that contains information about the site's pages, prefixes, and lightboxes.
 * @description
 *  The `SiteStructure` object is a flattened representation of the site. Use
 *  the [`getSiteStructure()`](#getSiteStructure) function to get the site's
 *  `SiteStructure` object. The structure does not include the headers and links
 *  from the site's **Pages** menu.
 * @snippet [Site-getSiteStructure.es6=Get information about the site's pages, prefixes, and lightboxes]
 *  This example gets the structure of the site with the following in its pages menu:
 *  ![Site Structure](images/site_structure.png "Site Structure")
 * @property {wix-site~StructurePage[]} pages The pages of the site.
 * @property {wix-site~Prefix[]} prefixes The prefixes of the site's routers and dynamic pages.
 * @property {wix-site~StructureLightbox[]} lightboxes The site's lightboxes.
 * @see [getSiteStructure( )](#getSiteStructure)
 * @memberof wix-site
 */

/**
 * @typedef {external:Object} wix-site~StructurePage
 * @summary An object that contains information about a page on the site.
 * @description
 *  The `StructurePage` object represents a page in the site. The page can be a
 *  regular page, dynamic page, router page, or page from an app.
 * @snippet [Site-pages.es6=Get information about the site's pages]
 *  This example gets the pages of the site with the following in its pages menu:
 *  ![Site Structure](images/site_structure.png "Site Structure")
 * @property {external:String} name The of the page.
 * @property {external:String} type The type of the page: `"static"` or `"template"`.
 * @property {external:String} [url] The URL of the page. If the page is a `static` page the `url` property is the page's SEO URL.
 * @property {external:String} [applicationId] If the page is an app page, the `applicationId` property is the app's ID.
 * @property {external:String} [prefix] If the page is a router or dynamic page, the `prefix` property is the page's prefix.
 * @see [SiteStructure](#SiteStructure)
 * @see [getSiteStructure( )](#getSiteStructure)
 * @memberof wix-site
 */

/**
 * @typedef {external:Object} wix-site~Prefix
 * @summary An object that contains information about the site's prefixes.
 * @description
 *  A site's routers, dynamic pages, and app pages all have prefixes.
 * @snippet [Site-prefixes.es6=Get information about the site's prefixes]
 *  This example gets the prefixes of the site with the following in its pages menu:
 *  ![Site Structure](images/site_structure.png "Site Structure")
 * @property {external:String} name The name of the prefix.
 * @property {external:String} type The type of the prefix: `"dynamicPages"`, `"router"`, or `"app"`.
 * @property {external:String} prefix The prefix.
 * @property {external:String} [applicationId] If the prefix is an app's prefix, the `applicationId` property is the app's ID.
 * @see [SiteStructure](#SiteStructure)
 * @see [getSiteStructure( )](#getSiteStructure)
 * @memberof wix-site
 */

/**
 * @typedef {external:Object} wix-site~StructureLightbox
 * @summary An object that contains information about a lightbox on the site.
 * @snippet [Site-lightboxes.es6=Get information about the site's lightboxes]
 *  This example gets the lightboxes of the site with the following in its pages menu:
 *  ![Site Structure](images/site_structure.png "Site Structure")
 * @property {external:String} name The name of the lightbox.
 * @see [SiteStructure](#SiteStructure)
 * @see [getSiteStructure( )](#getSiteStructure)
 * @memberof wix-site
 */

var Site = function () {
    function Site(appDefId) {
        _classCallCheck(this, Site);

        this.appDefId = appDefId;
    }

    /**
     * @function routerSitemap
     * @syntax
     * function routerSitemap(routerPrefix: string): Promise&lt;WixRouterSitemapEntry[]&gt;
     * @summary Returns the sitemap for a router or dynamic page prefix.
     * @description
     *  The `routerSitemap()` function returns a Promise that resolves to a list of
     *  [`WixSitemapEntry`](wix-router.WixRouterSitemapEntry.html) objects. Each
     *  [`WixSitemapEntry`](wix-router.WixRouterSitemapEntry.html) includes
     *  information about a page, such as its URL, title, and name.
     *
     *  A sitemap is used by search engines to find the links to the site's pages.
     * @snippet [Site-routerSiteMap.es6=Get the sitemap for a prefix]
     * @param {external:String} routerPrefix The prefix of the router to get the sitemap for.
     * @returns {external:Promise}
     * @fulfill {wix-router.WixRouterSitemapEntry[]} A list of sitemap entries.
     * @reject {external:Error} The error that caused the rejection.
     * @memberof wix-site
     */


    _createClass(Site, [{
        key: 'routerSitemap',
        value: function routerSitemap(prefix) {
            return new Promise(function (resolve, reject) {
                postMessage.sendMessage(postMessage.Intent.WIX_CODE_SITE_API, postMessage.MessageTypes.GET_ROUTERS_SITEMAP, { prefix: prefix }, function (data, err) {
                    if (err) {
                        reject(err);
                    } else {
                        resolve(data);
                    }
                });
            });
        }

        /**
         * @function getSiteStructure
         * @syntax
         * function wixSite.getSiteStructure(): SiteStructure
         * @summary Returns information about the site's pages, prefixes, and lightboxes.
         * @snippet [Site-getSiteStructure.es6=Get information about the site's pages, prefixes, and lightboxes]
         *  This example gets the structure of the site with the following in its pages menu:
         *  ![Site Structure](images/site_structure.png "Site Structure")
         * @returns {wix-site~SiteStructure} An object that contains information about the site's pages, prefixes, and lightboxes.
         * @memberof wix-site
         */

    }, {
        key: 'getSiteStructure',
        value: function getSiteStructure() {
            var RMI = _platformUtils2.default.getRMI('wix-site.getSiteStructure');
            var siteStructure = RMI.getSiteStructure();
            (0, _map2.default)(siteStructure, function (val, key) {
                siteStructure[key] = (0, _map2.default)(val, function (obj) {
                    return (0, _omit2.default)(obj, ['id', 'isMainPage']);
                });
            });
            return siteStructure;
        }
    }]);

    return Site;
}();

exports.default = Site;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _map = __webpack_require__(20);

var _map2 = _interopRequireDefault(_map);

var _get2 = __webpack_require__(3);

var _get3 = _interopRequireDefault(_get2);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _menuUtils = __webpack_require__(94);

var _menuUtils2 = _interopRequireDefault(_menuUtils);

var _validation = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * @class AccountNavBar
 * @summary Provides all functionality related to UserProfileMenu
 * @classdesc The `UserProfileMenu` class provides functionality related to Wix UserProfileMenu.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof wix.ui
 * @tagname AccountNavBar
 * @viewername wysiwyg.viewer.components.LoginSocialBar
 */
var AccountNavBar = function (_Element) {
    _inherits(AccountNavBar, _Element);

    function AccountNavBar(RMI, compName, widgetInstanceId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, AccountNavBar);

        var _this = _possibleConstructorReturn(this, (AccountNavBar.__proto__ || Object.getPrototypeOf(AccountNavBar)).call(this, RMI, compName, widgetInstanceId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(AccountNavBar.prototype, _HiddenCollapsedMixin2.default.prototype);
        return _this;
    }

    _createClass(AccountNavBar, [{
        key: 'menuItems',
        set: function set(menuItems) {
            var RMI = members._RMI.get(this);
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'menuItems', { menuItems: menuItems })) {
                return this;
            }
            if ((0, _isNil2.default)(menuItems)) {
                menuItems = [];
            }
            var validMenuItems = _menuUtils2.default.checkUserProfileMenuItemsValidation(menuItems, 'menuItems');
            var convertedMenuItems = (0, _map2.default)(validMenuItems, function (menuItem, menuItemIndex) {
                return _menuUtils2.default.convertMenuItemToModelFormat(RMI, menuItem, menuItemIndex, 'menuItems');
            });

            RMI.setData(members._compId.get(this), { menuItemsRef: { type: 'CustomMenuDataRef', menuRef: { type: 'CustomMenu', items: convertedMenuItems } } });
        },
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var data = RMI.getData(compId);
            var menuItems = (0, _get3.default)(data, 'menuItemsRef.menuRef.items');
            return (0, _map2.default)(menuItems, function (menuItem) {
                return _menuUtils2.default.convertNavItemToUserFormat(menuItem);
            });
        }
    }, {
        key: 'navBarItems',
        set: function set(navBarItems) {
            var RMI = members._RMI.get(this);
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'navBarItems', { navBarItems: navBarItems })) {
                return this;
            }
            if ((0, _isNil2.default)(navBarItems)) {
                navBarItems = [];
            }
            var validNavBarItems = _menuUtils2.default.checkUserProfileNavBarItemsValidation(navBarItems, 'navBarItems');
            var convertedNavItems = (0, _map2.default)(validNavBarItems, function (navItem, navItemIndex) {
                return _menuUtils2.default.convertMenuItemToModelFormat(RMI, navItem, navItemIndex, 'navBarItems', true);
            });
            RMI.setData(members._compId.get(this), { iconItemsRef: { type: 'CustomMenuDataRef', menuRef: { type: 'CustomMenu', items: convertedNavItems } } });
        },
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var data = RMI.getData(compId);
            var navBarItems = (0, _get3.default)(data, 'iconItemsRef.menuRef.items');
            return (0, _map2.default)(navBarItems, function (navBarItem) {
                return _menuUtils2.default.convertNavItemToUserFormat(navBarItem);
            });
        }
    }]);

    return AccountNavBar;
}(_Element3.default);

exports.default = AccountNavBar;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Node2 = __webpack_require__(66);

var _Node3 = _interopRequireDefault(_Node2);

var _ViewportMixin = __webpack_require__(144);

var _ViewportMixin2 = _interopRequireDefault(_ViewportMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Anchor
 * @summary <a href="https://www.wix.com/support/html5/article/about-anchors" target="_blank">Anchors</a>
 *  are invisible position markers which you can place anywhere on your site.
 *  They are a useful way to direct users to important sections.
 * @mixes $w.Node
 * @mixes $w.ViewportMixin
 * @memberof $w
 * @viewername wysiwyg.common.components.anchor.viewer.Anchor
 * @tagname Anchor
 */
var Anchor = function (_Node) {
    _inherits(Anchor, _Node);

    function Anchor(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, Anchor);

        var _this = _possibleConstructorReturn(this, (Anchor.__proto__ || Object.getPrototypeOf(Anchor)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(Anchor.prototype, _ViewportMixin2.default.prototype);

        return _this;
    }
    /**
     * @member name
     * @label property
     * @syntax
     * get name(): string
     * @summary Gets the name of an anchor.
     * @description
     *  An anchor's `name` is used as a label for the anchor. The value of the `name`
     *  property appears in [anchor menus](https://support.wix.com/en/article/anchor-menu).
     *
     *  An anchor's `name` is set in the Editor using the Anchor Settings panel.
     *  ![Anchor Settings](images/anchor_settings.png "Anchor Settings")
     * @snippet [Anchor-name.es6=Get an anchor's name]
     * @type {external:String}
     * @see [id](#id)
     * @memberof $w.Anchor
     * @instance
     * @readonly
     */


    _createClass(Anchor, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                name = this.name;

            return { id: id, type: type, global: global, rendered: rendered, name: name };
        }
    }, {
        key: 'name',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getData(compId).name;
        }
    }]);

    return Anchor;
}(_Node3.default);

exports.default = Anchor;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Node2 = __webpack_require__(66);

var _Node3 = _interopRequireDefault(_Node2);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _isFunction = __webpack_require__(29);

var _isFunction2 = _interopRequireDefault(_isFunction);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* DISABLING JSDOC FOR THIS CLASS UNTIL FURTHER NOTICE:
 * @class AppController
 * @summary Provides functionality for the Wix Application Controller.
 * @mixes $w.Node
 * @memberof $w
 * @tagname AppController
 * @viewername platform.components.AppController
 */
var AppController = function (_Node) {
  _inherits(AppController, _Node);

  function AppController(RMI, compId, contextId, wixSelector, controllerId, role, type, emitter) {
    _classCallCheck(this, AppController);

    var _this = _possibleConstructorReturn(this, (AppController.__proto__ || Object.getPrototypeOf(AppController)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type, emitter.createScopedEmitter(compId)));

    var publicAPI = RMI.getPublicAPI(compId);
    if ((0, _isFunction2.default)(publicAPI)) {
      var controllerData = RMI.getData(compId);
      (0, _assign2.default)(_this, publicAPI(RMI.getCurrentScope(), wixSelector.scoped$W(controllerData.id)));
    } else if (publicAPI) {
      (0, _assign2.default)(_this, publicAPI);
    }
    return _this;
  }

  /* DISABLING JSDOC FOR THIS PROPERTY UNTIL FURTHER NOTICE:
   * @member type
   * @label property
   * @syntax
     * let controllerType = $w("#myController").type;
   * @summary Gets the controller's type.
   * @type {external:String}
   * @see [Types](wix.html#Types)
   * @memberof $w.AppController
   * @attr {external:String}
   * @readonly
   */


  _createClass(AppController, [{
    key: 'on',
    value: function on(event, callback, context) {
      var emitter = members._emitter.get(this);
      emitter.on(event, callback, context);
    }
  }, {
    key: 'off',
    value: function off(event, callback) {
      var emitter = members._emitter.get(this);
      emitter.off(event, callback);
    }
  }, {
    key: 'once',
    value: function once(event, callback, context) {
      var emitter = members._emitter.get(this);
      emitter.once(event, callback, context);
    }
  }, {
    key: 'type',
    get: function get() {
      var RMI = members._RMI.get(this);
      var compId = members._compId.get(this);

      return RMI.getData(compId).controllerType;
    }
  }]);

  return AppController;
}(_Node3.default);

exports.default = AppController;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _ContainableMixin = __webpack_require__(26);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _StyleMixin = __webpack_require__(28);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Box
 * @summary Container <a href="https://support.wix.com/en/article/container-boxes" target="_blank">boxes</a>
 *  are used to structure your site. You can <a href="https://support.wix.com/en/article/attaching-elements-to-a-box" target="_blank">attach</a>
 *  any element to a container box and move the box around, which is a useful
 *  way to to keep elements together. Some actions performed on a box affect the
 *  elements it contains. For example, [hiding](#hide) a box also effectively
 *  hides all the elements in the box, although the values of the
 *  [hidden](#hidden) properties of the elements contained in the box do not change.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @mixes $w.StyleMixin
 * @memberof $w
 * @tagname Box
 * @viewername mobile.core.components.Container
 */
var Box = function (_Element) {
  _inherits(Box, _Element);

  function Box(RMI, compId, contextId, wixSelector, controllerId, role, type) {
    _classCallCheck(this, Box);

    var _this = _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

    (0, _mixin2.default)(Box.prototype, _HiddenCollapsedMixin2.default.prototype);
    (0, _mixin2.default)(Box.prototype, _ClickableMixin2.default.prototype);
    (0, _mixin2.default)(Box.prototype, _ContainableMixin2.default.prototype);
    (0, _mixin2.default)(Box.prototype, _StyleMixin2.default.prototype);
    return _this;
  }

  /**
   * @member style
   * @label property
   * @syntax
   * get style(): Style
   * @summary Gets an object containing information about the box's styles.
   * @description
   *  The following styles can be used with boxes:
   *  + [`backgroundColor`]($w.Style.html#backgroundColor)
   *  + [`borderColor`]($w.Style.html#borderColor)
   *  + [`borderWidth`]($w.Style.html#borderWidth)
   * @note
   *  Not all styles can be used on all box designs. To determine which styles
   *  work with a specific box design, go to the **Box Design** panel in
   *  the Editor, choose a design, and click **Customize Design**.
   * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
   * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
   * @type {$w.Style}
   * @memberof $w.Box
   * @readonly
   * @override
   */


  return Box;
}(_Element3.default);

exports.default = Box;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LinkableMixin = __webpack_require__(67);

var _LinkableMixin2 = _interopRequireDefault(_LinkableMixin);

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _utils = __webpack_require__(9);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _DisabledMixin = __webpack_require__(27);

var _DisabledMixin2 = _interopRequireDefault(_DisabledMixin);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(1);

var _StyleMixin = __webpack_require__(28);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Button
 * @summary A text button or an icon button.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.DisabledMixin
 * @mixes $w.LinkableMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.StyleMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.SiteButton
 * @viewername wysiwyg.common.components.imagebutton.viewer.ImageButton
 * @tagname button
 */
var Button = function (_Element) {
    _inherits(Button, _Element);

    function Button(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, Button);

        var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(Button.prototype, _LinkableMixin2.default.prototype);
        (0, _mixin2.default)(Button.prototype, _HiddenCollapsedMixin2.default.prototype);
        (0, _mixin2.default)(Button.prototype, _DisabledMixin2.default.prototype);
        (0, _mixin2.default)(Button.prototype, _ClickableMixin2.default.prototype);
        (0, _mixin2.default)(Button.prototype, _StyleMixin2.default.prototype);
        return _this;
    }

    /**
     * @member style
     * @label property
     * @syntax
     * get style(): Style
     * @summary Gets an object containing information about the button's styles.
     * @description
     *  The following styles can be used with buttons:
     *  + [`backgroundColor`]($w.Style.html#backgroundColor)
     *  + [`borderColor`]($w.Style.html#borderColor)
     *  + [`borderRadius`]($w.Style.html#borderRadius)
     *  + [`borderWidth`]($w.Style.html#borderWidth)
     *  + [`color`]($w.Style.html#color)
     *
     *
     *  Getting or setting a button's styles, gets or sets the styles of the
     *  button's regular state. It does not set the styles of the button's hover
     *  or disabled states.
     * @note
     *  Not all styles can be used on all button designs. To determine which styles
     *  work with a specific button design, go to the **Button Design** panel in
     *  the Editor, choose a design, and click **Customize Design**.
     * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
     * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
     * @type {$w.Style}
     * @memberof $w.Button
     * @readonly
     * @override
     */

    /**
     * @member label
     * @label property
     * @syntax
     * get label(): string
     * set label(value: string): void
     * @summary Sets or gets the label of a text button.
     * @type {external:String}
     * @snippet [Button-label_get.es6=Get a button's label]
     * @snippet [Button-label_set.es6=Set a button's label]
     * @default Empty string
     * @memberof $w.Button
     * @instance
     */


    _createClass(Button, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                label = this.label;

            return { id: id, type: type, global: global, rendered: rendered, label: label };
        }
    }, {
        key: 'label',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getData(compId).label;
        }

        /**
         * @param {external:String} value The new label to display.
         * @ignore
         */
        ,
        set: function set(value) {
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)(compType, 'label', { label: value });
            if (!isValid) {
                return;
            }
            var label = (0, _utils.emptyStringIfNil)(value);
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            RMI.setData(compId, { label: label });
        }
    }]);

    return Button;
}(_Element3.default);

exports.default = Button;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _FormElement2 = __webpack_require__(33);

var _FormElement3 = _interopRequireDefault(_FormElement2);

var _StyleMixin = __webpack_require__(28);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

var _DisabledMixin = __webpack_require__(27);

var _DisabledMixin2 = _interopRequireDefault(_DisabledMixin);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _FocusMixin = __webpack_require__(32);

var _FocusMixin2 = _interopRequireDefault(_FocusMixin);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _Utils = __webpack_require__(25);

var Utils = _interopRequireWildcard(_Utils);

var _validation = __webpack_require__(1);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _valueSanitzationAlgorithm = __webpack_require__(54);

var _valueSanitzationAlgorithm2 = _interopRequireDefault(_valueSanitzationAlgorithm);

var _validationsService = __webpack_require__(15);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _RequiredMixin = __webpack_require__(41);

var _RequiredMixin2 = _interopRequireDefault(_RequiredMixin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Checkbox
 * @summary Checkboxes are used for a single binary choice.
 * @mixes $w.FormElement
 * @mixes $w.DisabledMixin
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.FocusMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.StyleMixin
 * @mixes $w.RequiredMixin
 * @memberof $w
 * @tagname checkbox
 * @viewername wysiwyg.viewer.components.inputs.Checkbox
 */
var Checkbox = function (_FormElement) {
    _inherits(Checkbox, _FormElement);

    function Checkbox(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, Checkbox);

        var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(Checkbox.prototype, _DisabledMixin2.default.prototype);
        (0, _mixin2.default)(Checkbox.prototype, _HiddenCollapsedMixin2.default.prototype);
        (0, _mixin2.default)(Checkbox.prototype, _FocusMixin2.default.prototype);
        (0, _mixin2.default)(Checkbox.prototype, _ClickableMixin2.default.prototype);
        (0, _mixin2.default)(Checkbox.prototype, _StyleMixin2.default.prototype);
        (0, _mixin2.default)(Checkbox.prototype, _RequiredMixin2.default.prototype);
        return _this;
    }

    /**
     * @member checked
     * @label property
     * @syntax
       * get checked(): boolean
       * set checked(value: boolean): void
     * @summary Sets or gets whether a checkbox is checked.
     * @description
     *  Setting the `checked` property to `true` places a check in
     *  the checkbox. Setting it to `false` removes the check from the checkbox.
     *
     *  Getting the `checked` property returns
     *  whether the checkbox is checked or unchecked.
     * @snippet [Checkbox-checked_get.es6=Get whether checkbox is checked]
     * @snippet [Checkbox-checked_set.es6=Set a checkbox to be checked]
     * @snippet [Checkbox-checked_toggle.es6=Toggle whether a checkbox is checked]
     * @type {external:Boolean}
     * @memberof $w.Checkbox
     * @instance
     */


    _createClass(Checkbox, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                required = this.required,
                value = this.value,
                checked = this.checked;

            return { id: id, type: type, global: global, rendered: rendered, required: required, value: value, checked: checked };
        }
    }, {
        key: 'checked',
        get: function get() {
            return Utils.getData(this, 'checked') || false;
        }

        /**
         * @param {external:Boolean} checked
         * @ignore
         */
        ,
        set: function set(checked) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;

            if (!(0, _validation.validate)(compType, 'checked', { checked: checked })) {
                return;
            }

            (0, _validationsService.runValidationsAfterChange)(RMI, compId, checked);
            if ((0, _isNil2.default)(checked)) {
                checked = false;
            }
            Utils.setData(this, { checked: checked });
        }

        /**
         * @member value
         * @label property
         * @syntax
         * get value(): string
         * set value(value: string): void
         * @summary Sets or gets a checkbox's value.
         * @description
         *  The `value` property is not related to whether the checkbox is checked or
         *  not. To determine the checked status of a checkbox, use the [`checked`](#checked)
         *  property.
         *
         *  The `value` property is used for storing a value that is associated with
         *  the checkbox.
         *
         *  It is not considered when evaluating the checkbox's validity
         *  and it does not trigger an `onChange` event when the value is modified.
         *
         *  Even if a checkbox is connected to a dataset, its `value` property
         *  is not related to the value of the collection field it is connected to.
         *  The field's value is determined by the checkbox's [`checked`](#checked) property.
         * @snippet [FormElement-value_get.es6=Get an element's value]
         * @snippet [FormElement-value_set.es6=Set an element's value]
         * @type {external:String}
         * @memberof $w.Checkbox
         * @override
         */

    }, {
        key: 'value',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getData(compId).value;
        }

        /**
         * @param {external:String} val The input element's new value.
         * @ignore
         */
        ,
        set: function set(val) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getFullDataWithOverrides(compId);
            var compType = members._type.get(this).compType;
            var value = (0, _valueSanitzationAlgorithm2.default)(compData, val);
            var isValid = (0, _validation.validate)(compType, 'value', { value: value });

            if (!isValid) {
                return;
            }

            RMI.setData(compId, { value: value });
        }
    }]);

    return Checkbox;
}(_FormElement3.default);

// THE FOLLOWING JSDOC SNIPPETS ARE NOT ATTACHED TO ACTUAL CODE BUT WILL HELP TO MAKE
//  THESE CHECKBOX METHODS MORE UNDERSTANDABLE, AS THEY FUNCTION DIFFERENTLY FOR CHECKBOXES:


/**
 * @member required
 * @label property
 * @syntax
   * get required(): boolean
   * set required(value: boolean): void
 * @summary Determines if a checkbox is required to be checked.
 * @description
 *  If `required` is `true`, the checkbox is only valid if it is
 *  [checked](#checked).
 *
 *  If `required` is `false`, the checkbox will always be valid.
 *
 *  You can also set a checkbox to be required
 *  by using the element's Settings pane in the Editor.
 * @type {external:Boolean}
 * @memberof $w.Checkbox
 * @override
 */

/**
 * @member style
 * @label property
 * @syntax
 * get style(): Style
 * @summary Gets an object containing information about the checkbox's styles.
 * @description
 *  The following styles can be used with checkboxes:
 *  + [`backgroundColor`]($w.Style.html#backgroundColor)
 *  + [`borderColor`]($w.Style.html#borderColor)
 *  + [`borderRadius`]($w.Style.html#borderRadius)
 *  + [`borderWidth`]($w.Style.html#borderWidth)
 *
 *
 *  Getting or setting a checkbox's styles, gets or sets the styles of the
 *  checkbox's regular state. It does not set the styles of the checkbox's hover,
 *  focus, error, or disabled states.
 * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
 * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
 * @type {$w.Style}
 * @memberof $w.Checkbox
 * @readonly
 * @override
 */

exports.default = Checkbox;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Background2 = __webpack_require__(49);

var _Background3 = _interopRequireDefault(_Background2);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _ContainableMixin = __webpack_require__(26);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Column
 * @summary A `Column` is a component part of a `ColumnStrip`.
 * @mixes $w.Element
 * @mixes $w.Background
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @tagname column
 * @viewername wysiwyg.viewer.components.Column
 */
var Column = function (_Background) {
    _inherits(Column, _Background);

    function Column(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, Column);

        var _this = _possibleConstructorReturn(this, (Column.__proto__ || Object.getPrototypeOf(Column)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(Column.prototype, _ClickableMixin2.default.prototype);
        (0, _mixin2.default)(Column.prototype, _ContainableMixin2.default.prototype);
        return _this;
    }

    return Column;
}(_Background3.default);

exports.default = Column;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Background2 = __webpack_require__(49);

var _Background3 = _interopRequireDefault(_Background2);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _componentsBatchFunctions = __webpack_require__(93);

var _componentsBatchFunctions2 = _interopRequireDefault(_componentsBatchFunctions);

var _ContainableMixin = __webpack_require__(26);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _utils = __webpack_require__(9);

var _includes = __webpack_require__(53);

var _includes2 = _interopRequireDefault(_includes);

var _head = __webpack_require__(188);

var _head2 = _interopRequireDefault(_head);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class ColumnStrip
 * @summary A `ColumnStrip` is a strip of `Column` elements.
 * @mixes $w.Element
 * @mixes $w.Background
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @tagname columnstrip
 * @viewername wysiwyg.viewer.components.StripColumnsContainer
 */

var ColumnStrip = function (_Background) {
    _inherits(ColumnStrip, _Background);

    function ColumnStrip(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, ColumnStrip);

        var _this = _possibleConstructorReturn(this, (ColumnStrip.__proto__ || Object.getPrototypeOf(ColumnStrip)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(ColumnStrip.prototype, _HiddenCollapsedMixin2.default.prototype);
        (0, _mixin2.default)(ColumnStrip.prototype, _ClickableMixin2.default.prototype);
        (0, _mixin2.default)(ColumnStrip.prototype, _ContainableMixin2.default.prototype);
        return _this;
    }
    /**
     * @member columns
     * @label property
     * @syntax
       * get columns(): Column[]
     * @summary Gets a list of all the columns contained in the column strip.
     * @description
     *  Note that the column indices in a column strip are zero-based, even though
     *  they are numbered starting from 1 in the Editor.
     * @snippet [ColumnStrip-columns.es6=Get a column strip's columns]
     * @snippet [ColumnStrip-columns_plus.es6=Get the columns, number of columns, and ID of the first column from a column strip]
     * @type {$w.Column[]}
     * @memberof $w.ColumnStrip
     * @instance
     * @readonly
     */


    _createClass(ColumnStrip, [{
        key: 'columns',
        get: function get() {
            var RMI = members._RMI.get(this);
            var wixSelector = members._wixSelector.get(this);
            var compId = members._compId.get(this);
            var controllerId = members._controllerId.get(this);

            var columns = RMI.getChildren(compId).filter(function (id) {
                return (0, _includes2.default)(_utils.types.getPotentialViewerTypes('Column'), RMI.getComp(id).type);
            }).map(function (id) {
                return wixSelector.getInstance(RMI, RMI.getComp(id).type, id, controllerId);
            });

            return _componentsBatchFunctions2.default.expose(columns);
        }

        /**
         * @member background
         * @label property
         * @syntax
         * get background(): BackgroundOptions
         * @summary Gets an object containing information about the column strip's background, such as its image or video source.
         * @type {$w.Document~BackgroundOptions}
         * @snippet [Background-background_get.es6=Get the background information]
         * @snippet [Background-background_set_wix.es6=Set the background image to be an image from the Media Manager]
         * @snippet [Background-background_set_web.es6=Set the background image to be an image from the web]
         * @memberof $w.Document
         * @readonly
         */

    }, {
        key: 'background',
        get: function get() {
            if (this.columns.length === 1) {
                return (0, _head2.default)(this.columns).background;
            }

            return _get(ColumnStrip.prototype.__proto__ || Object.getPrototypeOf(ColumnStrip.prototype), 'background', this);
        }
    }]);

    return ColumnStrip;
}(_Background3.default);

exports.default = ColumnStrip;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Background2 = __webpack_require__(49);

var _Background3 = _interopRequireDefault(_Background2);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _ContainableMixin = __webpack_require__(26);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Container
 * @summary A container for Repeater items.
 * @mixes $w.Element
 * @mixes $w.Background
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @tagname cell
 * @viewername wysiwyg.viewer.components.MediaContainer
 */

var Container = function (_Background) {
    _inherits(Container, _Background);

    function Container(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, Container);

        var _this = _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(Container.prototype, _ClickableMixin2.default.prototype);
        (0, _mixin2.default)(Container.prototype, _ContainableMixin2.default.prototype);
        return _this;
    }

    _createClass(Container, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                title = this.title;

            return { id: id, type: type, global: global, rendered: rendered, title: title };
        }
    }]);

    return Container;
}(_Background3.default);

exports.default = Container;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _defaults = __webpack_require__(60);

var _defaults2 = _interopRequireDefault(_defaults);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _map = __webpack_require__(20);

var _map2 = _interopRequireDefault(_map);

var _every = __webpack_require__(35);

var _every2 = _interopRequireDefault(_every);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _FormElement2 = __webpack_require__(33);

var _FormElement3 = _interopRequireDefault(_FormElement2);

var _ReadOnlyMixin = __webpack_require__(96);

var _ReadOnlyMixin2 = _interopRequireDefault(_ReadOnlyMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _DisabledMixin = __webpack_require__(27);

var _DisabledMixin2 = _interopRequireDefault(_DisabledMixin);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _FocusMixin = __webpack_require__(32);

var _FocusMixin2 = _interopRequireDefault(_FocusMixin);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(1);

var _utils = __webpack_require__(9);

var _validationsService = __webpack_require__(15);

var _RequiredMixin = __webpack_require__(41);

var _RequiredMixin2 = _interopRequireDefault(_RequiredMixin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class DatePicker
 * @summary A `DatePicker` is used for entering dates. It lets users populate a
 *  date field by picking a date using a calendar popup.
 * @mixes $w.FormElement
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.DisabledMixin
 * @mixes $w.FocusMixin
 * @mixes $w.ReadOnlyMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.RequiredMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.inputs.DatePicker
 * @tagname datepicker
 */
var DatePicker = function (_FormElement) {
    _inherits(DatePicker, _FormElement);

    function DatePicker(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, DatePicker);

        var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(DatePicker.prototype, _HiddenCollapsedMixin2.default.prototype);
        (0, _mixin2.default)(DatePicker.prototype, _DisabledMixin2.default.prototype);
        (0, _mixin2.default)(DatePicker.prototype, _FocusMixin2.default.prototype);
        (0, _mixin2.default)(DatePicker.prototype, _ReadOnlyMixin2.default.prototype);
        (0, _mixin2.default)(DatePicker.prototype, _ClickableMixin2.default.prototype);
        (0, _mixin2.default)(DatePicker.prototype, _RequiredMixin2.default.prototype);
        return _this;
    }

    /**
     * @member value
     * @label property
     * @syntax
     * get value(): Date
     * set value(value: Date): void
     * @summary Sets or gets the value of the date picker.
     * @note
     *  If a date picker is connected to a dataset, setting the date picker's `value`
     *  in code does not set the value of the connected field in the dataset.
     *  That means if you use the dataset to perform a submit, the value changed
     *  in code is not reflected in the submitted item.
     *
     *  To submit the new value using a dataset, set the field's value using the
     *  [`setFieldValue()`](wix-dataset.html#setFieldValue) function before
     *  performing the submit.
     * @snippet [DatePicker-value_get.es6=Get a datepicker's date value]
     * @snippet [DatePicker-value_set.es6=Set a datepicker's date value to be today]
     * @type {external:Date}
     * @memberof $w.DatePicker
     * @instance
     * @override
     */


    _createClass(DatePicker, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                readOnly = this.readOnly,
                required = this.required,
                value = this.value,
                maxDate = this.maxDate,
                minDate = this.minDate,
                disabledDates = this.disabledDates,
                disabledDaysOfWeek = this.disabledDaysOfWeek;

            return {
                id: id,
                type: type,
                global: global,
                rendered: rendered,
                readOnly: readOnly,
                required: required,
                value: value,
                maxDate: maxDate,
                minDate: minDate,
                disabledDates: disabledDates,
                disabledDaysOfWeek: disabledDaysOfWeek
            };
        }
    }, {
        key: 'value',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);

            return RMI.getState(compId).selectedDate;
        }

        /**
         * @param {external:Date} value The date picker's new date value.
         * @ignore
         */
        ,
        set: function set(value) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);

            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)(compType, 'value', { value: value });
            if (!(0, _isNil2.default)(value) && !isValid) {
                return;
            }

            var dateValue = (0, _utils.nullIfNil)(value);

            var newState = (0, _defaults2.default)({ selectedDate: dateValue }, RMI.getState(compId));

            (0, _validationsService.runValidationsAndSyncAfterChange)(RMI, compId, dateValue);
            RMI.updateModel(_defineProperty({}, compId, { state: newState }));
            RMI.executeCompBehavior(compId, 'setValue', { value: dateValue });
        }

        /**
         * @member maxDate
         * @label property
         * @syntax
         * get maxDate(): Date
         * set maxDate(value: Date): void
         * @summary Sets or gets the latest date that a user can select.
         * @description
         * Setting the `maxDate` property prevents users from selecting
         * dates past the maximum date. However, it does not limit your ability to
         * change the date picker's value to one that exceeds `maxDate`
         * programmatically.
         *
         * Set `maxDate` to `undefined` to remove the
         * current maximum date limitation.
         *
         * Getting the `maxDate` property returns the current maximum
         * date that a user can select.
         * @snippet [DatePicker-maxDate_get.es6=Get a date picker's maximum date]
         * @snippet [DatePicker-maxDate_set.es6=Set a date picker's maximum date to today]
         * @type {external:Date}
         * @default `undefined`
         * @see [minDate](#minDate)
         * @memberof $w.DatePicker
         * @instance
         */

    }, {
        key: 'maxDate',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var maxDateISO = RMI.getData(compId).maxDate;

            return maxDateISO && new Date(maxDateISO);
        }

        /**
         * @param {external:Date} maxDate The maximim date value a user can select.
         * @ignore
         */
        ,
        set: function set(maxDate) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)(compType, 'maxDate', { maxDate: maxDate });
            if (!(0, _isNil2.default)(maxDate) && !isValid) {
                return;
            }
            var maxDateToSet = (0, _utils.nullIfNil)(maxDate) ? maxDate.toISOString() : null;
            RMI.setData(compId, { maxDate: maxDateToSet });
        }

        /**
         * @member minDate
         * @label property
         * @syntax
         * get minDate(): Date
         * set minDate(value: Date): void
         * @summary Sets or gets the earliest date that a user can select.
         * @description
         * Setting the `minDate` property prevents users from selecting
         * dates before the minimum date. However, it does not limit your ability to
         * change the date picker's value to one that preceeds `minDate`
         * programmatically.
         *
         * Set `minDate` to `undefined` to remove the current minimum date limitation.
         *
         * Getting the `minDate` property returns the current minimum
         * date that a user can select.
         * @snippet [DatePicker-minDate_get.es6=Get a date picker's minimum date]
         * @snippet [DatePicker-minDate_set.es6=Set a date picker's minimum date to today]
         * @type {external:Date}
         * @default `undefined`
         * @see [maxDate](#maxDate)
         * @memberof $w.DatePicker
         * @instance
         */

    }, {
        key: 'minDate',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var minDateISO = RMI.getData(compId).minDate;

            return minDateISO && new Date(minDateISO);
        }

        /**
         * @param {external:Date} minDate The minimum date value a user can select.
         * @ignore
         */
        ,
        set: function set(minDate) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)(compType, 'minDate', { minDate: minDate });
            if (!(0, _isNil2.default)(minDate) && !isValid) {
                return;
            }
            var minDateToSet = (0, _utils.nullIfNil)(minDate) ? minDate.toISOString() : null;
            RMI.setData(compId, { minDate: minDateToSet });
        }

        /**
         * @member disabledDates
         * @label property
         * @syntax
         * get disabledDates(): Date[]
         * set disabledDates(value: Date[]): void
         * @summary Sets or gets the dates that a user cannot select.
         * @description
         *  Setting the `disabledDates` property prevents users from
         *  selecting the specified dates. However, it does not limit your ability
         *  to set those dates programmatically.
         *
         *  Set `disabledDates` to an empty array (`[]`) to remove the current disabled dates.
         *
         *  Getting the `disabledDates` property returns the current
         *  list of disabled dates.
         * @snippet [DatePicker-disabledDates_get.es6=Get dates which are disabled]
         * @snippet [DatePicker-disabledDates_set.es6=Set dates which are disabled]
         * @type {external:Date[]}
         * @see [disabledDaysOfWeek](#disabledDaysOfWeek)
         * @memberof $w.DatePicker
         * @instance
         */

    }, {
        key: 'disabledDates',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var disabledDates = RMI.getData(compId).disabledDates;

            return disabledDates && (0, _map2.default)(disabledDates, function (date) {
                return new Date(date);
            });
        }

        /**
         * @param {external:Array} disabledDates The disabled dates.
         * @ignore
         */
        ,
        set: function set(disabledDates) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            var isArrayValid = (0, _validation.validate)(compType, 'disabledDates', { disabledDates: disabledDates });
            if (!(0, _isNil2.default)(disabledDates) && !isArrayValid) {
                return;
            }
            var arrItemsArrValid = (0, _every2.default)(disabledDates, function (v, i) {
                return (0, _validation.validate)(compType, 'disabledDates', { 'disableDate': v }, null, i);
            });
            if (!arrItemsArrValid) {
                return;
            }
            var disabledDateToSet = (0, _isEmpty2.default)(disabledDates) ? [] : (0, _map2.default)(disabledDates, function (date) {
                return date.toISOString();
            });
            RMI.setData(compId, { disabledDates: disabledDateToSet });
        }

        /**
         * @member disabledDaysOfWeek
         * @label property
         * @syntax
         * get disabledDaysOfWeek(): Number[]
         * set disabledDaysOfWeek(value: Number[]): void
         * @summary Sets or gets the days of the week that a user cannot select.
         * @description
         *  Setting the `disabledDaysOfWeek` property prevents users
         *  from selecting the specified days of the weeks. However, it does not
         *  limit your ability to set those dates programmatically. Set
         *  `disabledDaysOfWeek` to an empty array (`[]`) to remove the current
         *  disabled days of the week.
         *
         *  Getting the `disabledDaysOfWeek` property returns the
         *  current list of disabled days of the week.
         *
         *  The `disabledDaysOfWeek` property accepts an array of integers from 0 to
         *  6, where 0 represent Sunday, 1 is Monday, 2 is Tuesday, and so on.
         * @snippet [DatePicker-disabledDaysOfWeek_get.es6=Get which days of the week are disabled]
         * @snippet [DatePicker-disabledDaysOfWeek_set.es6=Set Sundays and Saturdays to be disabled]
         * @type {external:Number[]}
         * @see [disabledDates](#disabledDates)
         * @memberof $w.DatePicker
         * @instance
         */

    }, {
        key: 'disabledDaysOfWeek',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);

            return RMI.getData(compId).disabledDaysOfWeek;
        }

        /**
         * @param {external:Array} disabledDaysOfWeek The disabled days of the week.
         * @ignore
         */
        ,
        set: function set(disabledDaysOfWeek) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            var isArrayValid = (0, _validation.validate)(compType, 'disabledDaysOfWeek', { disabledDaysOfWeek: disabledDaysOfWeek });
            if (!(0, _isNil2.default)(disabledDaysOfWeek) && !isArrayValid) {
                return this;
            }
            var arrItemsValid = (0, _every2.default)(disabledDaysOfWeek, function (v, i) {
                return (0, _validation.validate)(compType, 'disabledDaysOfWeek', { 'disableDayOfWeek': v }, null, i);
            });
            if (!arrItemsValid) {
                return;
            }
            var disabledDateToSet = (0, _isEmpty2.default)(disabledDaysOfWeek) ? [] : disabledDaysOfWeek;
            RMI.setData(compId, { disabledDaysOfWeek: disabledDateToSet });
        }
    }]);

    return DatePicker;
}(_FormElement3.default);

exports.default = DatePicker;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _every = __webpack_require__(35);

var _every2 = _interopRequireDefault(_every);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _FormElement2 = __webpack_require__(33);

var _FormElement3 = _interopRequireDefault(_FormElement2);

var _StyleMixin = __webpack_require__(28);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _DisabledMixin = __webpack_require__(27);

var _DisabledMixin2 = _interopRequireDefault(_DisabledMixin);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _FocusMixin = __webpack_require__(32);

var _FocusMixin2 = _interopRequireDefault(_FocusMixin);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _Utils = __webpack_require__(25);

var Utils = _interopRequireWildcard(_Utils);

var _utils = __webpack_require__(9);

var _validation = __webpack_require__(1);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _validationsService = __webpack_require__(15);

var _valueSanitzationAlgorithm = __webpack_require__(54);

var _valueSanitzationAlgorithm2 = _interopRequireDefault(_valueSanitzationAlgorithm);

var _optionsUtils = __webpack_require__(134);

var _RequiredMixin = __webpack_require__(41);

var _RequiredMixin2 = _interopRequireDefault(_RequiredMixin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Dropdown
 * @summary Dropdowns are used for selecting one of a number of options.
 *  They are especially useful when there are too many options to display using
 *  [radio buttons]($w.RadioButtonGroup.html). Dropdowns consist of a list
 *  of [options](#Option). Each [option](#Option) contains a label, which is
 *  what the user sees, and a value, which is what is used in code and stored in
 *  you collections.
 * @mixes $w.FormElement
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.DisabledMixin
 * @mixes $w.FocusMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.StyleMixin
 * @mixes $w.RequiredMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.inputs.ComboBoxInput
 * @tagname dropdown
 */
var DropDown = function (_FormElement) {
    _inherits(DropDown, _FormElement);

    function DropDown(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, DropDown);

        var _this = _possibleConstructorReturn(this, (DropDown.__proto__ || Object.getPrototypeOf(DropDown)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(DropDown.prototype, _HiddenCollapsedMixin2.default.prototype);
        (0, _mixin2.default)(DropDown.prototype, _DisabledMixin2.default.prototype);
        (0, _mixin2.default)(DropDown.prototype, _FocusMixin2.default.prototype);
        (0, _mixin2.default)(DropDown.prototype, _ClickableMixin2.default.prototype);
        (0, _mixin2.default)(DropDown.prototype, _StyleMixin2.default.prototype);
        (0, _mixin2.default)(DropDown.prototype, _RequiredMixin2.default.prototype);
        return _this;
    }

    /**
     * @typedef {external:Object} $w.Dropdown~Option
     * @summary An object used by the `options` property that contains the attributes of a dropdown list item.
     * @property {external:String} value The value of the dropdown option. This is what you use in code and is what is stored in your collections.
     * @property {external:String} [label] The label of the dropdown option. This is what a user sees.
     * @snippet [Option.es6=Get option info]
     * @see [options](#Options)
     * @see [value](#value)
     */

    /**
     * @member options
     * @label property
     * @syntax
       * get options(): Option[]
       * set options(value: Options[]): void
     * @summary Sets or gets the options in a dropdown.
     * @description
     *  Setting the `options` property sets all the [options](#Option)
     *  available to a user.
     *
     *  Set `options` to an empty array (`[]`) to remove the current dropdown options.
     *
     *  Getting the `options` property returns the current
     *  list of [options](#Option) available to a user.
     *
     *  You cannot modify the options array in-place. To add, change, or remove
     *  individual dropdown options:
     *    1. Store the value of the `options` property in a variable.
     *    1. Make changes to the options array.
     *    1. Reset the `options` property with the modified array.
     * @snippet [DropDown-options_get.es6=Get the list of options and the first option's label and value from dropdown]
     * @snippet [DropDown-options_set.es6=Set the list of options for a dropdown]
     * @snippet [DropDown-add.es6=Add an option to a dropdown]
     *  This example retrieves the options of a dropdown, adds a new
     *  option, and then overwrites the old options.
     * @type {$w.Dropdown~Option[]}
     * @default An empty array
     * @memberof $w.Dropdown
     * @see [Option](#Option)
     * @instance
     */


    _createClass(DropDown, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                required = this.required,
                value = this.value,
                options = this.options,
                placeholder = this.placeholder,
                selectedIndex = this.selectedIndex;

            return { id: id, type: type, global: global, rendered: rendered, required: required, value: value, options: options, placeholder: placeholder, selectedIndex: selectedIndex };
        }

        /**
         * @member style
         * @label property
         * @syntax
         * get style(): Style
         * @summary Gets an object containing information about the dropdown's styles.
         * @description
         *  The following styles can be used with dropdowns:
         *  + [`backgroundColor`]($w.Style.html#backgroundColor)
         *  + [`borderColor`]($w.Style.html#borderColor)
         *  + [`borderRadius`]($w.Style.html#borderRadius)
         *  + [`borderWidth`]($w.Style.html#borderWidth)
         *  + [`color`]($w.Style.html#color)
         *
         *
         *  Getting or setting a dropdown's styles, gets or sets the styles of the
         *  dropdown's regular state. It does not set the styles of the dropdown's hover,
         *  focus, error, or disabled states.
         * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
         * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
         * @type {$w.Style}
         * @memberof $w.Dropdown
         * @readonly
         * @override
         */

    }, {
        key: 'options',
        get: function get() {
            var options = Utils.getData(this, 'options');

            return options ? options.map(function (option) {
                return { label: option.text, value: option.value };
            }) : options;
        }

        /**
         * @ignore
         */
        ,
        set: function set(newOptions) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            var isArrayValid = (0, _validation.validate)(compType, 'options', { options: newOptions });
            if (!isArrayValid) {
                return;
            }
            var arrItemsArrValid = (0, _every2.default)(newOptions, function (v, i) {
                return (0, _validation.validate)(compType, 'options', { selectOption: v }, true, i) && (0, _optionsUtils.validateOption)(v, i, 'selectOption');
            });
            if (!arrItemsArrValid) {
                return;
            }

            var options = (0, _utils.nullIfNil)(newOptions) ? (0, _optionsUtils.optionsToDisplay)(newOptions) : [];
            var modifiedOptions = options.map(function (option) {
                return {
                    value: option.value,
                    text: option.label,
                    type: 'SelectOption',
                    description: option.label,
                    disabled: false
                };
            });

            var valToValidate = (0, _optionsUtils.emptyStringIfNotInOptions)(modifiedOptions, RMI.getData(compId).value);

            (0, _validationsService.runValidations)(RMI, compId, valToValidate);
            Utils.setData(this, { options: modifiedOptions });
        }

        /**
         * @member placeholder
         * @label property
         * @syntax
           * get placeholder: string
           * set placeholder(value: string): void
         * @summary Sets or gets the dropdown's placeholder text.
         * @description
         *  Placeholder text is typically used to
         *  provide a hint to the user describing what the dropdown is for.
         *  When the user chooses an option, the placeholder text disappears.
         * @type {external:String}
         * @snippet [DropDown-placeholder_get.es6=Get a dropdown's placeholder text]
         * @snippet [DropDown-placeholder_set.es6=Set a dropdown's placeholder text]
         * @memberof $w.Dropdown
         * @instance
         * @attr {external:String}
         */

    }, {
        key: 'placeholder',
        get: function get() {
            var placeholder = Utils.getProp(this, 'placeholder') || {};
            return placeholder.value || '';
        }

        /**
         * @param {external:String} placeholder The text to set as the placeholder.
         * @ignore
         */
        ,
        set: function set(placeholderToSet) {
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)(compType, 'placeholder', { placeholder: placeholderToSet });
            if (!isValid) {
                return;
            }
            placeholderToSet = (0, _utils.emptyStringIfNil)(placeholderToSet);
            Utils.setProp(this, {
                placeholder: {
                    text: placeholderToSet,
                    value: placeholderToSet
                }
            });
        }

        /**
         * @member selectedIndex
         * @label property
         * @syntax
           * get selectedIndex: Number
           * set selectedIndex(value: Number): void
         * @summary Sets or gets the index of the selected option.
         * @description
         *  Setting the `selectedIndex` property sets the option at
         *  that index to be the selected option. To set one of the options to be
         *  selected, set the `selectedIndex` property to an index between `0` and
         *  `options.length - 1`.
         *
         *  To reset the dropdown to have no option
         *  selected, set the `selectedIndex` property to `undefined`.
         *
         *  Getting the `selectedIndex` property returns the index of
         *  the currently selected option. If no value is selected, the
         *  `selectedIndex` property returns `undefined`.
         * @type {external:Number}
         * @default `-1`
         * @snippet [DropDown-selectedIndex_get.es6=Get the index of the selected option]
         * @snippet [DropDown-selectedIndex_set.es6=Select the first option by index]
         * @memberof $w.Dropdown
         * @instance
         * @attr {external:String}
         */

    }, {
        key: 'selectedIndex',
        get: function get() {
            return (0, _utils.getIndexOrUndefined)(this.options, 'value', Utils.getData(this, 'value'));
        }

        /**
         * @param {external:Number} selectedIndex The index of the selected option.
         * @ignore
         */
        ,
        set: function set(index) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;

            var options = _optionsUtils.getOptionsFromFull.call(this);
            var acceptNil = true;
            if (!(0, _validation.validate)(compType, 'selectedIndex', { selectedIndex: index }) || !(0, _validation.validateRange)('selectedIndex', 'selectedIndex', index, 0, options.length - 1, undefined, acceptNil)) {
                return;
            }

            var value = (0, _isNil2.default)(index) ? '' : options[index].value;

            (0, _validationsService.runValidationsAfterChange)(RMI, compId, value);
            Utils.setData(this, { value: value });
        }

        /**
         * @member value
         * @label property
         * @syntax
         * get value(): string
         * set value(value: string): void
         * @summary Sets or gets an element's value.
         * @note
         *  If an element is connected to a dataset, setting the element's `value`
         *  in code does not set the value of the connected field in the dataset.
         *  That means if you use the dataset to perform a submit, the value changed
         *  in code is not reflected in the submitted item.
         *
         *  To submit the new value using a dataset, set the field's value using the
         *  [`setFieldValue()`](wix-dataset.html#setFieldValue) function before
         *  performing the submit.
         * @snippet [FormElement-value_get.es6=Get an element's value]
         * @snippet [FormElement-value_set.es6=Set an element's value]
         * @type {external:String}
         * @memberof $w.FormElement
         * @override
         */

    }, {
        key: 'value',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var value = RMI.getData(compId).value;

            return (0, _optionsUtils.emptyStringIfNotInOptions)(this.options, value);
        }

        /**
         * @param {external:String} val The input element's new value.
         * @ignore
         */
        ,
        set: function set(val) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getFullDataWithOverrides(compId);
            var compType = members._type.get(this).compType;
            var value = (0, _valueSanitzationAlgorithm2.default)(compData, val);
            var isValid = (0, _validation.validate)(compType, 'value', { value: value });

            if (!isValid) {
                return;
            }
            var valToValidate = (0, _optionsUtils.emptyStringIfNotInOptions)(this.options, value);
            (0, _validationsService.runValidationsAfterChange)(RMI, compId, valToValidate);
            RMI.setData(compId, { value: valToValidate });
        }
    }]);

    return DropDown;
}(_FormElement3.default);

exports.default = DropDown;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _ContainableMixin = __webpack_require__(26);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _StyleMixin = __webpack_require__(28);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Footer
 * @summary The footer is the area of your site that appears at the bottom and
 *  throughout all of your pages.
 * @classdesc The footer is located at the bottom of the page:
 *  ![Wix Page Footer](images/footer.png "Wix Page Footer")
 *  The footer is a container that can contain other elements.
 *
 *  The contained elements are the footer's [children](#children) and the
 *  footer is the contained elements' [parent](#parent).
 *
 *  The same footer appears on all pages of your site. Therefore, the children
 *  elements of a footer appear on all pages of your site.
 * @see {@link $w.Header}
 * @mixes $w.Element
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @mixes $w.StyleMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.FooterContainer
 * @tagname footer
 */
var Footer = function (_Element) {
  _inherits(Footer, _Element);

  function Footer(RMI, compId, contextId, wixSelector, controllerId, role, type) {
    _classCallCheck(this, Footer);

    var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

    (0, _mixin2.default)(Footer.prototype, _ClickableMixin2.default.prototype);
    (0, _mixin2.default)(Footer.prototype, _ContainableMixin2.default.prototype);
    (0, _mixin2.default)(Footer.prototype, _StyleMixin2.default.prototype);
    return _this;
  }

  /**
   * @member style
   * @label property
   * @syntax
   * get style(): Style
   * @summary Gets an object containing information about the footer's styles.
   * @description
   *  The following styles can be used with footers:
   *  + [`backgroundColor`]($w.Style.html#backgroundColor)
   *  + [`borderColor`]($w.Style.html#borderColor)
   * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
   * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
   * @type {$w.Style}
   * @memberof $w.Footer
   * @readonly
   * @override
   */


  return Footer;
}(_Element3.default);

exports.default = Footer;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BaseGallery = __webpack_require__(137);

var _BaseGallery2 = _interopRequireDefault(_BaseGallery);

var _ProGallery = __webpack_require__(259);

var _ProGallery2 = _interopRequireDefault(_ProGallery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GalleryFactory(RMI, compId, contextId, wixSelector, controllerId, role, type) {
    switch (type.viewerType) {
        case 'wysiwyg.viewer.components.tpapps.TPAWidget':
            return new _ProGallery2.default(RMI, compId, contextId, wixSelector, controllerId, role, type);
        default:
            return new _BaseGallery2.default(RMI, compId, contextId, wixSelector, controllerId, role, type);
    }
}

exports.default = GalleryFactory;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(1);

var _utils = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class GoogleMap
 * @summary A [Google Map element](https://www.wix.com/support/html5/article/adding-google-maps)
 *  that allows you to display a given location.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.GoogleMap
 * @tagname GoogleMap
 */
var GoogleMap = function (_Element) {
    _inherits(GoogleMap, _Element);

    /**
     * @typedef {external:Object} $w.GoogleMap~MapLocation
     * @syntax {latitude: 37.8, longitude: -122.4, description: "My Humble Home"}
     * @summary An object used by the `location` property that
     *  contains the attributes of a marked map location.
     * @property {external:Number} latitude The latitude of the location. Must be between -90 and 90.
     * @property {external:Number} longitude The longitude of the location. Must be between -180 and 180.
     * @property {external:String} [description] The description of the location.
     * @snippet [GoogleMap-location_get.es6=Get map location info]
     * @see [location](#location)
     */

    function GoogleMap(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, GoogleMap);

        var _this = _possibleConstructorReturn(this, (GoogleMap.__proto__ || Object.getPrototypeOf(GoogleMap)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(GoogleMap.prototype, _HiddenCollapsedMixin2.default.prototype);
        return _this;
    }

    /**
     * @member location
     * @label property
     * @syntax
     * get location(): MapLocation
     * set location(value: MapLocation): void
     * @summary Sets or gets the location information of a map's marked location.
     * @description
     *  Setting the `location` property to a [`MapLocation`](#MapLocation)
     *  object moves the map's marked location.
     *
     *  Getting the `location` property returns the [location
     *  information](#MapLocation) of the map's marked location.
     * @snippet [GoogleMap-location_get.es6=Get map location info]
     * @snippet [GoogleMap-location_set.es6=Set map location info]
     * @type {$w.GoogleMap~MapLocation}
     * @memberof $w.GoogleMap
     */


    _createClass(GoogleMap, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                location = this.location;

            return { id: id, type: type, global: global, rendered: rendered, location: location };
        }
    }, {
        key: 'location',
        set: function set(location) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'location', location, true)) {
                return;
            }
            var description = (0, _utils.emptyStringIfNil)(location.description);
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            RMI.setData(compId, {
                latitude: location.latitude,
                longitude: location.longitude,
                addressInfo: description
            });
        },
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getData(compId);
            return {
                latitude: compData.latitude,
                longitude: compData.longitude,
                description: compData.addressInfo
            };
        }
    }]);

    return GoogleMap;
}(_Element3.default);

exports.default = GoogleMap;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _ContainableMixin = __webpack_require__(26);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _StyleMixin = __webpack_require__(28);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Header
 * @summary The header is the area of your site that appears at the top and
 *  throughout all of your pages.
 * @classdesc The header is located at the top of the page:
 *  ![Wix Page Header](images/header.png "Wix Page Header")
 *  The header is a container that can contain other elements.
 *
 *  The contained elements are the header's [children](#children) and the
 *  header is the contained elements' [parent](#parent).
 *
 *  The same header appears on all pages of your site. Therefore, The children
 *  elements of a header appear on all pages of your site.
 * @see {@link $w.Footer}
 * @mixes $w.Element
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @mixes $w.StyleMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.HeaderContainer
 * @tagname header
 */
var Header = function (_Element) {
  _inherits(Header, _Element);

  function Header(RMI, compId, contextId, wixSelector, controllerId, role, type) {
    _classCallCheck(this, Header);

    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

    (0, _mixin2.default)(Header.prototype, _ClickableMixin2.default.prototype);
    (0, _mixin2.default)(Header.prototype, _ContainableMixin2.default.prototype);
    (0, _mixin2.default)(Header.prototype, _StyleMixin2.default.prototype);
    return _this;
  }

  /**
   * @member style
   * @label property
   * @syntax
   * get style(): Style
   * @summary Gets an object containing information about the header's styles.
   * @description
   *  The following styles can be used with headers:
   *  + [`backgroundColor`]($w.Style.html#backgroundColor)
   *  + [`borderColor`]($w.Style.html#borderColor)
   * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
   * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
   * @type {$w.Style}
   * @memberof $w.Header
   * @readonly
   * @override
   */


  return Header;
}(_Element3.default);

exports.default = Header;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Background2 = __webpack_require__(49);

var _Background3 = _interopRequireDefault(_Background2);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _ContainableMixin = __webpack_require__(26);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* COMMENTED OUT FOR THE TIME BEING UNTIL HOVERBOXES ARE RELEASED TO USERS
 * @class HoverBox
 * @summary A hover box is a container that changes when the mouse hovers over
 *  it. A hover box has two views: regular and hover. You can
 *  <a href="https://support.wix.com/en/article/attaching-elements-to-a-box" target="_blank">attach</a>
 *  elements to a hover box. Some actions performed on a hover box affect the
 *  elements it contains. For example, [hiding](#hide) a hover box also
 *  effectively hides all the elements in the hover box, although the
 *  values of the [hidden](#hidden) properties of the elements contained in the 
 *  hover box do not change.
 * @mixes $w.Element
 * @mixes $w.Background
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.HoverBox
 */
var HoverBox = function (_Background) {
    _inherits(HoverBox, _Background);

    function HoverBox(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, HoverBox);

        var _this = _possibleConstructorReturn(this, (HoverBox.__proto__ || Object.getPrototypeOf(HoverBox)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(HoverBox.prototype, _HiddenCollapsedMixin2.default.prototype);
        (0, _mixin2.default)(HoverBox.prototype, _ClickableMixin2.default.prototype);
        (0, _mixin2.default)(HoverBox.prototype, _ContainableMixin2.default.prototype);
        return _this;
    }

    return HoverBox;
}(_Background3.default);

exports.default = HoverBox;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _IFrame2 = __webpack_require__(139);

var _IFrame3 = _interopRequireDefault(_IFrame2);

var _Utils = __webpack_require__(25);

var Utils = _interopRequireWildcard(_Utils);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _postMessage2 = __webpack_require__(18);

var _postMessage = _interopRequireWildcard(_postMessage2);

var _validation = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @callback $w.HtmlElementEventHandler
 * @description Handles events fired when a message is received from an HTML
 *  Component.
 * @param {$w.HtmlComponentMessageEvent} event The message event that occurred.
 * @param {$w.$w} $w A selector function. The $w function enables event handlers
 *  to work with elements in [repeaters]($w.Repeater.html#repeating-callback-selector)
 *  and in the [global scope]($w.Repeater.html#regular-callback-selector).
 */

/**
 * @class HtmlComponent
 * @summary A container for internal or external HTML code. Messages can be sent
 *  from your page code to the code in an HTML component and from the HTML
 *  component to your page code using the [`postMessage()`](#postMessage) and
 *  [`onMessage()`](#onMessage) functions. To learn more about what code an HTML
 *  component can hold, see <a href="https://support.wix.com/en/article/guidelines-and-limitations-of-the-html-code-and-embed-a-site-elements" target="_blank">here</a>.
 *
 *  For an overview of working with an HTML Component using code, see <a href="https://support.wix.com/en/article/working-with-the-html-component-in-wix-code" target="_blank">Working with the HTML Component in Wix Code</a>.
 * @mixes $w.IFrame
 * @memberof $w
 * @tagname IFrame
 * @viewername wysiwyg.viewer.components.HtmlComponent
 */

var HtmlComponent = function (_IFrame) {
    _inherits(HtmlComponent, _IFrame);

    function HtmlComponent() {
        _classCallCheck(this, HtmlComponent);

        return _possibleConstructorReturn(this, (HtmlComponent.__proto__ || Object.getPrototypeOf(HtmlComponent)).apply(this, arguments));
    }

    _createClass(HtmlComponent, [{
        key: 'postMessage',


        // METHODS:
        /**
         * @function postMessage
         * @syntax
         * function postMessage(msg: string | number | boolean | object | array)
         * @summary Sends a message to the HTML Component.
         * @description
         *  The `postMessage()` function sends a message from your page code to the
         *  HTML Component.
         *
         *  To receive the message sent from the `postMessage()` function in your
         *  HTML Component, create an event handler for the `window.onmessage` event
         *  in the component's code. You create the event handler within an HTML
         *  `<script>` tag. You get the received data by getting the data property
         *  of the event handler's event parameter.
         *
         *  Often, you will define the `window.onMessage` event handler in a function
         *  that gets called when the HTML component loads using the `body onload`
         *  or `window.onload`:
         *
         *      &lt;script type="text/javascript"&gt;
         *        window.onmessage = (event) => {
         *          if (event.data) {
         *            console.log(`HTML Component received a message: ${event.data}`);
         *            // additional code here
         *          }
         *        }
         *      &lt;/script&gt;
         *
         *
         *  For more information on sending and receiving messages between your page
         *  and your HTML Component, see <a href="https://support.wix.com/en/article/working-with-the-html-component-in-wix-code#messaging-1" target="_blank">Working with the HTML Component in Wix Code</a>.
         * @note
         *  An HTML Component needs to load before you can send it messages using the
         *  `postMessage()` function. Usually an HTML Component finishes loading a
         *  short time after the page it is on finishes loading. So if you call
         *  `postMessage()` inside the page’s [`onReady()`]($w.html#onReady)
         *  event handler, the HTML Component might not be ready yet.
         *
         *  To call `postMessage()` as soon as possible after a page loads, send a
         *  message from the HTML Component to the page code as when the HTML
         *  Component is loaded and then call `postMessage()` upon receipt of that
         *  message.
         * @snippet [HtmlComponent-postMessage.es6=Send a message to an HTML Component]
         * @snippet [HtmlComponent-full.es6=Send a message to an HTML Component and receive a confirmation]
         *  This example assumes you have created a page with an HTML Component
         *  whose ID is `myHtmlComponent` and a button whose onClick event handler
         *  is set to `messageSendButton_onClick`.
         *
         *  When the user clicks the button, a message is sent to the HTML Code
         *  element. Code inside the element receives and displays the message. Then
         *  it sends a message back to the page code. The page code receives and
         *  logs the message.
         * @param {external:String | external:Number | external:Boolean | external:Object | external:Array} msg The message to send to the HTML Component.
         * @see [onMessage( )](#onMessage)
         * @memberof $w.HtmlComponent
         */
        value: function postMessage(msg) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'postMessage', { message: msg })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var id = RMI.getCompIdsFromRole(this.id)[0];
            _postMessage.sendMessage(_postMessage.Intent.WIX_CODE_SITE_API, _postMessage.MessageTypes.POST_HTML_MESSAGE, {
                id: id,
                msg: msg
            });
            return this;
        }

        /**
         * @function onMessage
         * @syntax
         * function onMessage(handler: HtmlElementEventHandler): HtmlComponent
         * callback HtmlElementEventHandler(event: HtmlComponentMessageEvent, $w: Function): void
         * @summary Adds an event handler that will run when the HTML Component
         *  sends a message.
         * @description
         *  The `onMessage()` function allows your page code to receive messages
         *  from an HTML Component on your page. When a message is received,
         *  the specified event handler is executed and the message can be retrieved
         *  using `event.data`.
         *
         *  To send a message from your HTML Component, use the postMessage() function
         *  in the HTML component's code. Generally, you will be calling postMessage()
         *  from within a function:
         *
         *      &lt;script type="text/javascript"&gt;
         *        function sendReturnMessage(msg) {
         *          window.parent.postMessage(msg, "*");
         *        }
         *      &lt;/script&gt;
         *
         *
         *  For more information on sending and receiving messages between your page
         *  and your HTML Component, see <a href="https://support.wix.com/en/article/working-with-the-html-component-in-wix-code#messaging-1" target="_blank">Working with the HTML Component in Wix Code</a>.
         * @snippet [HtmlComponent-onMessage.es6=Receive a message from an HTML Component]
         * @snippet [HtmlComponent-full.es6=Send a message to an HTML Component and receive a confirmation]
         *  This example assumes you have created a page with an HTML Component
         *  whose ID is `myHtmlComponent` and a button whose onClick event handler
         *  is set to `messageSendButton_onClick`.
         *
         *  When the user clicks the button, a message is sent to the HTML Code
         *  element. Code inside the element receives and displays the message. Then
         *  it sends a message back to the page code. The page code receives and
         *  logs the message.
         * @param {$w.HtmlComponentMessageEventHandler} handler The name of the function or
         *  the function expression to run when the HTML Component sends a message.
         * @returns {$w.HtmlComponent} The HTML Code element that triggered the event.
         * @see [postMessage( )](#postMessage)
         * @memberof $w.HtmlComponent
         * @eventtype message
         * @eventhandler
         */

    }, {
        key: 'onMessage',
        value: function onMessage(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'onMessage', { onMessage: cb })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().MESSAGE, controllerId, cb);
            return this;
        }

        /**
         * @function allowFullScreen
         * @label property
         * @syntax
         * function allowFullScreen(): HtmlComponent
         * @summary Allows the HTML Component to be put into full screen mode.
         * @description
         *  By default, users cannot place the HTML Component in full screen mode. Calling
         *  this function allows a user to place the HTML Component in full screen mode.
         * @snippet [HtmlComponent-allowFullScreen.es6=Allow an HTML Component to be placed in full screen mode]
         * @returns {$w.HtmlComponent}
         * @memberof $w.HtmlComponent
         */

    }, {
        key: 'allowFullScreen',
        value: function allowFullScreen() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            RMI.setData(compId, {
                allowFullScreen: true
            });
            return this;
        }
    }, {
        key: 'src',


        // PROPERTIES:
        /**
         * @member src
         * @label property
         * @syntax
         * get src(): string
         * set src(value: string): void
         * @summary Sets or gets the URL of the HTML Component's code.
         * @description
         *  Setting the `src` property sets the website that is
         *  displayed in the HTML Component. The `src` value must be set to an HTTPS
         *  URL.
         *
         *  Getting the `src` property returns the URL of the website
         *  that is displayed in the HTML Component.
         * @snippet [HtmlComponent-src_get.es6=Get the displayed website's URL]
         * @snippet [HtmlComponent-src_set.es6=Set the displayed website]
         * @type {external:String}
         * @memberof $w.HtmlComponent
         * @instance
         */
        set: function set(url) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'src', { url: url }, true)) {
                return;
            }
            Utils.setData(this, { url: url });
        },
        get: function get() {
            return Utils.getData(this, 'url') || null;
        }

        /**
         * @member scrolling
         * @label property
         * @syntax
         * get scrolling(): ScrollType
         * set scrolling(value: ScrollType): void
         * type ScrollType = "auto" | "yes" | "no"
         * @summary Sets or gets whether the HTML Component displays scrollbars.
         * @description
         *  Setting the `scrolling` property sets what happens when the content in
         *  the HTML Component is larger than the size of the component.
         *
         *  The value can be set to:
         *  + `"auto"`: Scrollbars are displayed only if needed. (This is the default.)
         *  + `"yes"`: Scrollbars are always shown, even if they are not needed.
         *  + `"no"`: Scrollbars are never shown, even if they are needed).
         *
         *  Getting the `scrolling` property returns which `ScrollType` the component
         *  is set to use.
         * @snippet [HtmlComponent-scrolling_set.es6=Set whether the Html Component displays scrollbars]
         * @snippet [HtmlComponent-scrolling_get.es6=Get whether the Html Component displays scrollbars]
         * @memberof $w.HtmlComponent
         */

    }, {
        key: 'scrolling',
        set: function set(value) {
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)(compType, 'scrolling', {
                scrolling: value
            });
            if (!isValid) {
                return;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            RMI.setData(compId, {
                scrolling: value
            });
        },
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getData(compId).scrolling || 'auto';
        }
    }]);

    return HtmlComponent;
}(_IFrame3.default);

exports.default = HtmlComponent;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _utils = __webpack_require__(9);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _LinkableMixin = __webpack_require__(67);

var _LinkableMixin2 = _interopRequireDefault(_LinkableMixin);

var _imageUtils = __webpack_require__(39);

var _imageUtils2 = _interopRequireDefault(_imageUtils);

var _validation = __webpack_require__(1);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Image
 * @summary Images are images stored in the <a href="https://support.wix.com/en/article/about-the-media-manager" target="_blank">Media Manager</a>
 *  or retreived from an external web location.
 *
 *  The URL formats for images are:
 *  + Images from the Media Manager: <code class="inline-code">wix:image:&sol;&sol;...</code>
 *  + Images from the web: <code class="inline-code">http(s):&sol;&sol;_&lt;image url&gt;_</code>
 *
 * @memberof $w
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.LinkableMixin
 * @mixes $w.ClickableMixin
 * @viewername wysiwyg.viewer.components.WPhoto
 * @tagname image
 */
var Image = function (_Element) {
    _inherits(Image, _Element);

    function Image(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, Image);

        var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(Image.prototype, _HiddenCollapsedMixin2.default.prototype);
        (0, _mixin2.default)(Image.prototype, _LinkableMixin2.default.prototype);
        (0, _mixin2.default)(Image.prototype, _ClickableMixin2.default.prototype);
        return _this;
    }

    /**
     * @member alt
     * @label property
     * @syntax
     * get alt(): string
     * set alt(value: string): void
     * @summary Sets or gets an image's alt text.
     * @description
     *  An image's alternative text is typically a relatively short phrase that
     *  describes what the image depicts.
     *
     *  The alternative text is used:
     *  + If the browser cannot display the image.
     *  + If the user is utilizing a screen reader.
     *  + By search engines to understand what images are on your site.
     * @snippet [Image-alt_get.es6=Get the image's alt text]
     * @snippet [Image-alt_set.es6=Set the image's alt text]
     * @type {external:String}
     * @default An empty string
     * @memberof $w.Image
     * @instance
     * @attr {external:String}
     */


    _createClass(Image, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                alt = this.alt,
                tooltip = this.tooltip,
                src = this.src;

            return { id: id, type: type, global: global, rendered: rendered, alt: alt, tooltip: tooltip, src: src };
        }
    }, {
        key: 'alt',
        get: function get() {
            var RMI = members._RMI.get(this);
            return RMI.getData(members._compId.get(this)).alt;
        }

        /**
         * @param {external:String} value.
         * @ignore
         */
        ,
        set: function set(value) {
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)(compType, 'alt', { alt: value });
            if (!isValid) {
                return;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            RMI.setData(compId, {
                alt: (0, _utils.emptyStringIfNil)(value)
            });
        }

        /**
         * @member tooltip
         * @label property
         * @syntax
         * get tooltip(): string
         * set tooltip(value: string): void
         * @summary Sets or gets an image's tooltip.
         *  An image's tooltip text is displayed when a user hovers over the image
         *  or when the image opens in a popup.
         * @snippet [Image-alt_get.es6=Get the image's alt text]
         * @snippet [Image-alt_set.es6=Set the image's alt text]
         * @type {external:String}
         * @default An empty string
         * @memberof $w.Image
         * @instance
         * @attr {external:String}
         */

    }, {
        key: 'tooltip',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getData(compId).title;
        }

        /*
         * @ignore
         */
        ,
        set: function set(value) {
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)(compType, 'tooltip', { tooltip: value });
            if (!isValid) {
                return;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var title = (0, _utils.emptyStringIfNil)(value);
            RMI.setData(compId, { title: title });
        }

        /**
         * @member src
         * @label property
         * @syntax
         * get src(): string
         * set src(value: string): void
         * @summary Sets or gets the file location of the image.
         * @description
         *  Setting the `src` property changes the displayed image to
         *  the image found at the new `src` value.
         *
         *  Getting the `src` property returns the location of the
         *  current image file.
         *
         *  The image file can either be an image file from the <a href="https://support.wix.com/en/article/about-the-media-manager" target="_blank">Media Manager</a>
         *  or an external file from any web location.
         *
         *  The URL formats supported are:
         *  + Images from the Media Manager: `wix:image://v1/<uri>/<filename>#originWidth=<width>&originHeight=<height>[&watermark=<watermark_manifest_string>]`
         *  + Images from the web: `http(s)://<image url>`
         * @snippet [Image-src_get.es6=Get the image's location]
         * @snippet [Image-src_set_wix.es6=Set the image to be an image from the Media Manager]
         * @snippet [Image-src_set_web.es6=Set the image to be an image from the web]
         * @type {external:String}
         * @default An empty string
         * @memberof $w.Image
         * @instance
         * @attr {external:String}
         */

    }, {
        key: 'src',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getData(compId) || {};

            return _imageUtils2.default.buildFullUrlFromUri(compData.uri, compData.width, compData.height, compData.title);
        }

        /**
         * @param {external:String} value
         * @ignore
         */
        ,
        set: function set(value) {
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)(compType, 'src', { src: value });
            if (!isValid) {
                return;
            }

            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var imageData = void 0;

            if ((0, _isNil2.default)(value)) {
                imageData = { uri: value };
            } else {
                imageData = _imageUtils2.default.convertImageToModelFormatAndReportIfError(value, 'src', 'src');
                if (!imageData) {
                    imageData = { uri: '' };
                }
            }

            imageData.crop = null;

            RMI.setData(compId, imageData);
        }
    }]);

    return Image;
}(_Element3.default);

exports.default = Image;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _map = __webpack_require__(20);

var _map2 = _interopRequireDefault(_map);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _get2 = __webpack_require__(3);

var _get3 = _interopRequireDefault(_get2);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _menuUtils = __webpack_require__(94);

var _menuUtils2 = _interopRequireDefault(_menuUtils);

var _validation = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * @class MobileMenu
 * @summary Provides all functionality related to MobileMenu
 * @classdesc The `MobileMenu` class provides functionality related to Wix MobileMenu.
 * The component is avaliable only on mobile
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof wix.ui
 * @tagname MobileMenu
 * @viewername wysiwyg.viewer.components.mobile.TinyMenu
 */
var MobileMenu = function (_Element) {
    _inherits(MobileMenu, _Element);

    function MobileMenu(RMI, compId, widgetInstanceId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, MobileMenu);

        var _this = _possibleConstructorReturn(this, (MobileMenu.__proto__ || Object.getPrototypeOf(MobileMenu)).call(this, RMI, compId, widgetInstanceId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(MobileMenu.prototype, _HiddenCollapsedMixin2.default.prototype);
        return _this;
    }

    /*
     * @member accountNavBar
     * @label property
     * @syntax
     * @summary Gets an object containing function to preform on accountNavBar when its available on mobile menu.
     * @memberof $w.MobileMenu
     * @readonly
     */


    _createClass(MobileMenu, [{
        key: 'accountNavBar',
        get: function get() {
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var type = members._type.get(this);
            var compId = members._compId.get(this);
            return new AccountNavBarOptions(RMI, compId, contextId, type);
        }
    }]);

    return MobileMenu;
}(_Element3.default);

exports.default = MobileMenu;

var AccountNavBarOptions = function () {
    function AccountNavBarOptions(RMI, compId, contextId, type) {
        _classCallCheck(this, AccountNavBarOptions);

        members._RMI.set(this, RMI);
        members._contextId.set(this, contextId);
        members._type.set(this, type);
        members._compId.set(this, compId);
    }

    _createClass(AccountNavBarOptions, [{
        key: 'menuItems',
        set: function set(menuItems) {
            var RMI = members._RMI.get(this);
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'menuItems', { menuItems: menuItems })) {
                return this;
            }
            if ((0, _isNil2.default)(menuItems)) {
                menuItems = [];
            }
            var validMenuItems = _menuUtils2.default.checkUserProfileTinyMenuItemsValidation(menuItems, 'menuItems');
            var convertedMenuItems = (0, _map2.default)(validMenuItems, function (menuItem, menuItemIndex) {
                return _menuUtils2.default.convertMenuItemToModelFormat(RMI, menuItem, menuItemIndex, 'menuItems');
            });
            var compId = members._compId.get(this);
            var currentData = RMI.getData(compId);
            var loginSocialBarRef = (0, _get3.default)(currentData, 'loginSocialBarRef');
            var newData = (0, _assign2.default)(loginSocialBarRef, { menuItemsRef: { type: 'CustomMenuDataRef', menuRef: { type: 'CustomMenu', items: convertedMenuItems } } });
            RMI.setData(members._compId.get(this), { loginSocialBarRef: newData });
        },
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var data = RMI.getData(compId);
            var menuItems = (0, _get3.default)(data, 'loginSocialBarRef.menuItemsRef.menuRef.items');
            return (0, _map2.default)(menuItems, function (item) {
                return _menuUtils2.default.convertNavItemToUserFormat(item, ['visibleOnDesktop']);
            });
        }
    }, {
        key: 'navBarItems',
        set: function set(navBarItems) {
            var RMI = members._RMI.get(this);
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'navBarItems', { navBarItems: navBarItems })) {
                return this;
            }
            if ((0, _isNil2.default)(navBarItems)) {
                navBarItems = [];
            }
            var validNavBarItems = _menuUtils2.default.checkUserProfileTinuMenuNavBarItemsValidation(navBarItems, 'navBarItems');
            var convertedNavItems = (0, _map2.default)(validNavBarItems, function (navItem, navItemIndex) {
                return _menuUtils2.default.convertMenuItemToModelFormat(RMI, navItem, navItemIndex, 'navBarItems', true);
            });
            var compId = members._compId.get(this);
            var currentData = RMI.getData(compId);
            var loginSocialBarRef = (0, _get3.default)(currentData, 'loginSocialBarRef');
            var newData = (0, _assign2.default)(loginSocialBarRef, { iconItemsRef: { type: 'CustomMenuDataRef', menuRef: { type: 'CustomMenu', items: convertedNavItems } } });
            RMI.setData(members._compId.get(this), { loginSocialBarRef: newData });
        },
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var data = RMI.getData(compId);
            var navBarItems = (0, _get3.default)(data, 'loginSocialBarRef.iconItemsRef.menuRef.items');
            return (0, _map2.default)(navBarItems, function (item) {
                return _menuUtils2.default.convertNavItemToUserFormat(item, ['visibleOnDesktop']);
            });
        }
    }]);

    return AccountNavBarOptions;
}();

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _ContainableMixin = __webpack_require__(26);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Page
 * @summary A page is a web page that can contain other elements.
 * @classdesc
 *  Some `Page` properties refer only to the central part of the web page as show here:
 *
 * ![Wix Page](images/page.png "Wix Page")
 *
 *  For example, elements placed within this central area are the page's
 *  [children](#children), but elements placed in the page
 *  [header]($w.Header.html) are not.
 *
 *  Other `Page` properties refer to the page in general.
 * @see {@link $w.Header}
 * @see {@link $w.Footer}
 * @mixes $w.Element
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @viewername mobile.core.components.Page
 * @tagname page
 */

var Page = function (_Element) {
    _inherits(Page, _Element);

    function Page(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, Page);

        var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(Page.prototype, _ClickableMixin2.default.prototype);
        (0, _mixin2.default)(Page.prototype, _ContainableMixin2.default.prototype);
        return _this;
    }

    /**
     * @member description
     * @label property
     * @syntax
     * get description(): string
     * @summary Gets the page's <a href="https://support.wix.com/en/article/page-description-meta-tag" target="_blank">SEO description</a>.
     * @description
     *  The page description is a meta tag. It provides potential site visitors
     *  with a summary of what the page is about. It is not visible to users,
     *  but appears below your site's title in search results.
     *
     *  A page's `description` is <a href="https://support.wix.com/en/article/changing-your-page-description" target="_blank">set in the Editor</a>
     *  using the <a href="https://support.wix.com/en/article/page-settings" target="_blank">Page Settings panel</a>.
     * @snippet [Page-description_get.es6=Get the page's description]
     * @type {external:String}
     * @memberof $w.Page
     * @instance
     * @readonly
     */


    _createClass(Page, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                title = this.title,
                description = this.description,
                url = this.url,
                fullUrl = this.fullUrl,
                keywords = this.keywords,
                visibleInMenu = this.visibleInMenu;

            return { id: id, type: type, global: global, rendered: rendered, title: title, description: description, url: url, fullUrl: fullUrl, keywords: keywords, visibleInMenu: visibleInMenu };
        }
    }, {
        key: 'description',
        get: function get() {
            var RMI = members._RMI.get(this);
            var pageData = RMI.getPageData();

            return pageData && pageData.currentPageSEODescription;
        }

        /**
         * @member keywords
         * @label property
         * @syntax
         * get keywords(): string[]
         * @summary Gets the page's keywords.
         * @description
         *  The <a href="https://support.wix.com/en/article/page-keywords" target="_blank">page's keywords</a>
         *  are not used by Google, but may be used by other search engines.
         *
         *  Page `keywords` are set in the Editor using the
         *  <a href="https://support.wix.com/en/article/page-settings" target="_blank">Page Settings panel</a>.
         * @snippet [Page-keywords_get.es6=Get the page's description]
         * @type {external:String[]}
         * @memberof $w.Page
         * @instance
         * @readonly
         */

    }, {
        key: 'keywords',
        get: function get() {
            var RMI = members._RMI.get(this);
            var pageData = RMI.getPageData();

            return pageData && pageData.currentPageSEOKeywords;
        }

        /**
         * @member {external:String} title
         * @label property
         * @syntax
         * get title(): string
         * @summary Gets the page's title.
         * @description
         *  The <a href="https://www.wix.com/support/html5/article/page-title-meta-tag" target="_blank">page title</a> is used in:
         *
         *  + Search results.
         *  + When saving to favorites.
         *  + In the browser's tab.
         *
         *
         *  A page's `title` is <a href="https://support.wix.com/en/article/changing-your-page-title" target="_blank">set in the Editor</a>
         *  using the <a href="https://support.wix.com/en/article/page-settings" target="_blank">Page Settings panel</a>.
         * @snippet [Page-title_get.es6=Get the page's title]
         * @memberof $w.Page
         * @instance
         * @readonly
         */

    }, {
        key: 'title',
        get: function get() {
            var RMI = members._RMI.get(this);
            var pageData = RMI.getPageData();

            return pageData && pageData.currentUrlPageTitle;
        }

        /**
         * @member visibleInMenu
         * @label property
         * @syntax
         * get visibleInMenu(): boolean
         * @summary Indicates if the page is included in the site's menu.
         * @description
         *  Whether a page is visible in the site menu is <a href="https://www.wix.com/support/html5/article/hiding-a-page-from-the-menu" target="_blank">set in the Editor</a>
         *  using the <a href="https://support.wix.com/en/article/page-settings" target="_blank">Page Settings panel</a>.
         * @snippet [Page-visibleInMenu_get.es6=Get whether the page appears in the site menu]
         * @type {external:Boolean}
         * @memberof $w.Page
         * @instance
         * @readonly
         */

    }, {
        key: 'visibleInMenu',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var pageData = RMI.getData(compId);
            if (pageData) {
                return !pageData.hidePage;
            }
        }
    }]);

    return Page;
}(_Element3.default);

exports.default = Page;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _DisabledMixin = __webpack_require__(27);

var _DisabledMixin2 = _interopRequireDefault(_DisabledMixin);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _FocusMixin = __webpack_require__(32);

var _FocusMixin2 = _interopRequireDefault(_FocusMixin);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _Utils = __webpack_require__(25);

var Utils = _interopRequireWildcard(_Utils);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(1);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _errors = __webpack_require__(12);

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Pagination
 * @summary An element for working with paging.
 * @mixes $w.Element
 * @mixes $w.DisabledMixin
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.FocusMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.ViewportMixin
 * @memberof $w
 * @classdesc
 *  Pagination bars provide a way for your users to control the [paging of
 *  a dataset](wix-dataset.html#data-paging). Elements that are connected to the
 *  same dataset as the pagination bar will be affected when the user
 *  interacts with the pagination bar.
 *
 *  For example, suppose you have a repeater connected to a dataset and that dataset
 *  is set to have a page size of 5. When the page loads, the repeater will show
 *  the first 5 items from the dataset. When a user clicks on the next page button
 *  of a pagination bar that is connected to the same dataset as the repeater,
 *  the repeater will then show items 6-10 from the dataset.
 *
 *  You can also use a pagination bar without connecting it to a dataset.
 *  When doing so, you will have to provide the pagination logic that runs when
 *  a user interacts with the pagination bar.
 * @tagname pagination
 * @viewername wixui.Pagination
 */
var Pagination = function (_Element) {
    _inherits(Pagination, _Element);

    function Pagination(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, Pagination);

        var _this = _possibleConstructorReturn(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(Pagination.prototype, _DisabledMixin2.default.prototype);
        (0, _mixin2.default)(Pagination.prototype, _HiddenCollapsedMixin2.default.prototype);
        (0, _mixin2.default)(Pagination.prototype, _FocusMixin2.default.prototype);
        (0, _mixin2.default)(Pagination.prototype, _ClickableMixin2.default.prototype);
        return _this;
    }

    /**
     * @function onChange
     * @syntax
     * function onChange(handler: ChangeEventHandler): Pagination
     * callback EventHandler(event, selector: Function): void
     * @summary Adds an event handler that runs when the pagination bar
     *  is changed.
     * @description
     *  A pagination bar receives a `change` event when a user changes the
     *  current page by interacting with the pagination bar.
     *
     *  A `change` event is not triggered when you change a pagination bar's
     *  current page using the [`currentPage`](#currentPage) property.
     *
     *  When a pagination bar is connected to a dataset, changing the [dataset's
     *  current page](wix-dataset.html#data-paging) using dataset functions, such
     *  as [`nextPage()`](wix-dataset.html#nextPage), do not trigger `change`
     *  events on the pagination bar.
     * @snippet [Pagination-onChange.es6=Get the new current page of the pagination bar that was changed]
     * @param {$w.EventHandler} handler The name of the function or
     *  the function expression to run when the item is ready.
     * @returns {$w.Pagination} The pagination bar on which the event is now registered.
     * @eventtype Change
     * @eventhandler
     * @memberof $w.Pagination
     */

    _createClass(Pagination, [{
        key: 'onChange',
        value: function onChange(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'onChange', { onChange: cb })) {
                return this;
            }

            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().CHANGE, controllerId, cb);
            return this;
        }

        /**
         * @member currentPage
         * @label property
         * @syntax
         * get currentPage(): number
         * set currentPage(value: number): void
         * @summary Sets or gets the current page.
         * @description
         *  Setting the `currentPage` property updates the visual indicator of the
         *  pagination bar to display the current page. If the pagination bar
         *  is connected to a dataset, setting `currentPage` will also update the
         *  current page of the dataset and update any relevant elements connected
         *  to that dataset.
         *
         *  Setting `currentPage` does not trigger a `change` event on the pagination
         *  bar.
         *
         *  Getting the `currentPage` property returns the index of the current page.
         *  Note that page numbers begin with 1.
         * @snippet [Pagination-currentPage_get.es6=Get a pagination bar's current page]
         * @snippet [Pagination-currentPage_set.es6=Set a pagination bar's current page]
         * @type {external:Number}
         * @memberof $w.Pagination
         * @see [totalPages](#totalPages)
         * @instance
         */

    }, {
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                currentPage = this.currentPage,
                totalPages = this.totalPages;

            return { id: id, type: type, global: global, rendered: rendered, currentPage: currentPage, totalPages: totalPages };
        }
    }, {
        key: 'currentPage',
        get: function get() {
            return Utils.getData(this, 'currentPage');
        }

        /**
         * @param {external:Number} currentPage
         * @ignore
         */
        ,
        set: function set(currentPage) {
            var compType = members._type.get(this).compType;
            var acceptNil = true;
            var index = null;

            if (!(0, _validation.validate)(compType, 'currentPage', { currentPage: currentPage }) || !(0, _validation.validateRange)('currentPage', 'currentPage', currentPage, 1, this.totalPages, index, acceptNil)) {
                return;
            }

            if ((0, _isNil2.default)(currentPage)) {
                currentPage = 1;
            }

            Utils.setData(this, { currentPage: currentPage });
        }

        /**
         * @member totalPages
         * @label property
         * @syntax
         * get totalPages(): number
         * set totalPages(value: number): void
         * @summary Sets or gets the total number of pages shown in a pagination bar.
         * @description
         *  Setting the `totalPages` property updates the number of pages shown in
         *  the pagination bar.
         *
         *  Setting `totalPages` to a value less than [`currentPage`](#currentPage)
         *  will cause `currentPage` to be reset to the new `totalPages` value. For
         *  example, if `currentPage` is `8` and `totalPages` is set to `5`, `currentPage`
         *  will be reset automatically to `5`.
         *
         *  Getting the `totalPages` property returns the total number of pages available
         *  for selection in the pagination bar. If the pagination bar is
         *  connected to a dataset, the initial `totalPages` value is calculated based
         *  on the total number of items in the dataset and the dataset's page size.
         * @snippet [Pagination-totalPages_get.es6=Get the number of pages available in a pagination element]
         * @snippet [Pagination-totalPages_set.es6=Set the number of pages available in a pagination element]
         * @type {external:Number}
         * @memberof $w.Pagination
         * @see [currentPage](#currentPage)
         * @instance
         */

    }, {
        key: 'totalPages',
        get: function get() {
            return Utils.getData(this, 'totalPages');
        }

        /**
         * @param {external:Number} total Pages
         * @ignore
         */
        ,
        set: function set(totalPages) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'totalPages', { totalPages: totalPages })) {
                return;
            }

            var newData = { totalPages: totalPages };

            if (Utils.getData(this, 'currentPage') > totalPages) {
                newData.currentPage = totalPages;
                _reporter2.default.reportSdkWarning(_errors.generateError.warning_value_changed({
                    propertyName: 'totalPages',
                    compNickname: this.id,
                    newValue: totalPages,
                    changedProperty: 'currentPage'
                }));
            }

            Utils.setData(this, newData);
        }
    }]);

    return Pagination;
}(_Element3.default);

exports.default = Pagination;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseGallery2 = __webpack_require__(137);

var _BaseGallery3 = _interopRequireDefault(_BaseGallery2);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _tpaUtils = __webpack_require__(225);

var _tpaUtils2 = _interopRequireDefault(_tpaUtils);

var _validation = __webpack_require__(1);

var _constants = __webpack_require__(91);

var _constants2 = _interopRequireDefault(_constants);

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _imageUtils = __webpack_require__(39);

var _imageUtils2 = _interopRequireDefault(_imageUtils);

var _every = __webpack_require__(35);

var _every2 = _interopRequireDefault(_every);

var _map = __webpack_require__(20);

var _map2 = _interopRequireDefault(_map);

var _get2 = __webpack_require__(3);

var _get3 = _interopRequireDefault(_get2);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* REMOVING ALL JSDOC FOR THIS CLASS AND ITS APIs (see https://jira.wixpress.com/browse/WCD-3056) */
var Gallery = function (_BaseGallery) {
    _inherits(Gallery, _BaseGallery);

    // This is named Gallery on purpose so that the user sees it as Gallery
    function Gallery(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, Gallery);

        var _this = _possibleConstructorReturn(this, (Gallery.__proto__ || Object.getPrototypeOf(Gallery)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(Gallery.prototype, _HiddenCollapsedMixin2.default.prototype);
        return _this;
    }

    /* REMOVING JSDOC FROM THIS API (see https://jira.wixpress.com/browse/WCD-3056) */


    _createClass(Gallery, [{
        key: 'onItemClicked',


        // The following block of JSDoc must be included due to jsdoc-events lint rule:
        /**
         * @function onItemClicked
         * @param {$w.GalleryItemClickedEventHandler} handler
         * @returns {$w.Gallery}
         * @see [clickAction](#clickAction)
         * @memberof $w.Gallery
         * @eventtype itemClicked
         * @eventhandler
         */
        value: function onItemClicked(cb) {
            var compType = members._type.get(this).compType;
            if ((0, _validation.validate)(compType, 'onItemClicked', { onItemClicked: cb })) {
                var RMI = members._RMI.get(this);
                var compId = members._compId.get(this);
                var compName = RMI.getId(compId);
                _tpaUtils2.default.registerToApiEvent(compId, compName, 'onItemClicked', cb);
            }
            return this;
        }

        /* REMOVING JSDOC FROM THIS API (see https://jira.wixpress.com/browse/WCD-3056) */

    }, {
        key: 'type',
        get: function get() {
            return '$w.Gallery';
        }

        /* REMOVING JSDOC FROM THIS API (see https://jira.wixpress.com/browse/WCD-3056) */

    }, {
        key: 'items',
        set: function set(items) {
            var areAllImagesValid = (0, _every2.default)(items, _imageUtils2.default.checkImageValidation);
            if (areAllImagesValid) {
                var newItems = (0, _map2.default)(items, _imageUtils2.default.dataFormat.toModel);
                var RMI = members._RMI.get(this);
                var compId = members._compId.get(this);
                var compName = RMI.getId(compId);
                RMI.setData(compId, { items: newItems });
                _tpaUtils2.default.invokeApi(compId, compName, 'setItems', newItems);
            }
        },
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var data = RMI.getData(compId);
            if (!data.items) {
                _reporter2.default.reportSdkWarning('retrieving items from a Pro Gallery is only supported after the items have been set via code');
                return null;
            }
            var items = data.items || [];
            return (0, _map2.default)(items, _imageUtils2.default.dataFormat.toUser);
        }
    }, {
        key: 'galleryCapabilities',
        get: function get() {
            return Object.freeze({
                isPlayable: false,
                hasCurrentItem: false,
                hasNavigationButtons: false
            });
        }
    }, {
        key: 'clickAction',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var galleryImageClickAction = (0, _get3.default)(RMI.getProps(compId), 'galleryImageOnClickAction');
            if (!galleryImageClickAction) {
                _reporter2.default.reportSdkWarning('retrieving clickAction from a Pro Gallery is only supported after the items have been set via code');
                return null;
            }
            for (var action in _constants2.default.IMAGE_CLICK_ACTIONS) {
                if (_constants2.default.IMAGE_CLICK_ACTIONS[action] === galleryImageClickAction) {
                    return action;
                }
            }
        },
        set: function set(action) {
            var compType = members._type.get(this).compType;
            if ((0, _validation.validate)(compType, 'clickAction', { galleryImageOnClickAction: action })) {
                var galleryImageClickAction = (0, _isNil2.default)(action) ? _constants2.default.IMAGE_CLICK_ACTIONS.none : _constants2.default.IMAGE_CLICK_ACTIONS[action];
                if (galleryImageClickAction) {
                    var RMI = members._RMI.get(this);
                    var compId = members._compId.get(this);
                    var compName = this.id;
                    RMI.setProps(compId, { galleryImageOnClickAction: galleryImageClickAction });
                    _tpaUtils2.default.invokeApi(compId, compName, 'setClickAction', galleryImageClickAction);
                }
            }
        }
    }]);

    return Gallery;
}(_BaseGallery3.default);

exports.default = Gallery;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _every = __webpack_require__(35);

var _every2 = _interopRequireDefault(_every);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _FormElement2 = __webpack_require__(33);

var _FormElement3 = _interopRequireDefault(_FormElement2);

var _StyleMixin = __webpack_require__(28);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _DisabledMixin = __webpack_require__(27);

var _DisabledMixin2 = _interopRequireDefault(_DisabledMixin);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _FocusMixin = __webpack_require__(32);

var _FocusMixin2 = _interopRequireDefault(_FocusMixin);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _Utils = __webpack_require__(25);

var Utils = _interopRequireWildcard(_Utils);

var _utils = __webpack_require__(9);

var _validation = __webpack_require__(1);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _valueSanitzationAlgorithm = __webpack_require__(54);

var _valueSanitzationAlgorithm2 = _interopRequireDefault(_valueSanitzationAlgorithm);

var _validationsService = __webpack_require__(15);

var _optionsUtils = __webpack_require__(134);

var _RequiredMixin = __webpack_require__(41);

var _RequiredMixin2 = _interopRequireDefault(_RequiredMixin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class RadioButtonGroup
 * @summary Radio button groups are used for selecting one of a number of
 *  options. Radio button groups consist of a list of [options](#Option). Each
 *  [option](#Option) contains a label, which is what the user sees, and a
 *  value, which is what is used in code and stored in you collections.
 * @mixes $w.FormElement
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.DisabledMixin
 * @mixes $w.FocusMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.StyleMixin
 * @mixes $w.RequiredMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.inputs.RadioGroup
 * @tagname RadioButtonGroup
 */
var RadioButtonGroup = function (_FormElement) {
    _inherits(RadioButtonGroup, _FormElement);

    function RadioButtonGroup(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, RadioButtonGroup);

        var _this = _possibleConstructorReturn(this, (RadioButtonGroup.__proto__ || Object.getPrototypeOf(RadioButtonGroup)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(RadioButtonGroup.prototype, _HiddenCollapsedMixin2.default.prototype);
        (0, _mixin2.default)(RadioButtonGroup.prototype, _DisabledMixin2.default.prototype);
        (0, _mixin2.default)(RadioButtonGroup.prototype, _FocusMixin2.default.prototype);
        (0, _mixin2.default)(RadioButtonGroup.prototype, _ClickableMixin2.default.prototype);
        (0, _mixin2.default)(RadioButtonGroup.prototype, _StyleMixin2.default.prototype);
        (0, _mixin2.default)(RadioButtonGroup.prototype, _RequiredMixin2.default.prototype);
        return _this;
    }

    /**
     * @typedef {external:Object} $w.RadioButtonGroup~Option
     * @summary An object used by the `options` property that contains the attributes of a radio button item.
     * @property {external:String} value The value of the radio button option. This is what you use in code and is what is stored in your collections.
     * @property {external:String} [label] The label of the radio button option. This is what a user sees.
     * @see [options](#options)
     * @see [value](#value)
     */

    /**
     * @member options
     * @label property
     * @syntax
     * get options(): Option[]
     * set options(value: options[]): void
     * @summary Sets or gets the options in a radio button group.
     * @description
     *  Setting the `options` property sets all the [options](#Option)
     *  available to a user.
     *
     *  Set `options` to an empty array (`[]`) to remove the current radio button group options.
     *
     *  Getting the `options` property returns the current
     *  list of [options](#Option) available to a user.
     *
     *  You cannot modify the data array in-place. To add, change, or remove
     *  individual radio button options:
     *    1. Store the value of the `options` property in a variable.
     *    1. Make changes to the options array.
     *    1. Reset the `options` property with the modified array.
     * @snippet [RadioButtonGroup-options_get.es6=Get the list of options and the first option's label and value from a radio button group]
     * @snippet [RadioButtonGroup-options_set.es6=Set the list of options for a radio button group]
     * @snippet [RadioButtonGroup-add.es6=Add an option to a radio button group]
     *  This example retrieves the options of a radio button group, adds a new
     *  option, and then overwrites the old options.
     * @type {$w.RadioButtonGroup~Option[]}
     * @default An empty array
     * @memberof $w.RadioButtonGroup
     * @instance
     */


    _createClass(RadioButtonGroup, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                required = this.required,
                value = this.value,
                options = this.options,
                selectedIndex = this.selectedIndex;

            return { id: id, type: type, global: global, rendered: rendered, required: required, value: value, options: options, selectedIndex: selectedIndex };
        }

        /**
         * @member style
         * @label property
         * @syntax
         * get style(): Style
         * @summary Gets an object containing information about the radio button group's styles.
         * @description
         *  The following styles can be used with radio button groups:
         *  + [`backgroundColor`]($w.Style.html#backgroundColor)
         *  + [`borderColor`]($w.Style.html#borderColor)
         *  + [`borderWidth`]($w.Style.html#borderWidth)
         *  + [`color`]($w.Style.html#color)
         *
         *
         *  Getting or setting a radio button group's styles, gets or sets the styles of the
         *  radio button group's regular state. It does not set the styles of the radio button group's hover,
         *  focus, error, or disabled states.
         * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
         * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
         * @type {$w.Style}
         * @memberof $w.RadioButtonGroup
         * @readonly
         * @override
         */

    }, {
        key: 'options',
        get: function get() {
            var options = Utils.getData(this, 'options');

            return options ? options.map(function (option) {
                return { label: option.label, value: option.value };
            }) : options;
        }

        /**
         * @ignore
         */
        ,
        set: function set(newOptions) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            var isArrayValid = (0, _validation.validate)(compType, 'options', { options: newOptions });
            if (!isArrayValid) {
                return;
            }
            var arrItemsArrValid = (0, _every2.default)(newOptions, function (v, i) {
                return (0, _validation.validate)(compType, 'options', { RadioButton: v }, true, i) && (0, _optionsUtils.validateOption)(v, i, 'RadioButton');
            });
            if (!arrItemsArrValid) {
                return;
            }

            var options = (0, _utils.nullIfNil)(newOptions) ? (0, _optionsUtils.optionsToDisplay)(newOptions) : [];
            var modifiedOptions = options.map(function (option) {
                return {
                    value: option.value,
                    label: option.label,
                    type: 'RadioButton'
                };
            });

            var valToValidate = (0, _optionsUtils.emptyStringIfNotInOptions)(modifiedOptions, RMI.getData(compId).value);

            (0, _validationsService.runValidationsAndSync)(RMI, compId, valToValidate);
            Utils.setData(this, { options: modifiedOptions });
        }

        /**
         * @member value
         * @label property
         * @syntax
         * get value(): string
         * set value(value: string): void
         * @summary Sets or gets the value of the selected option.
         * @description
         *  Setting the `value` property sets the [`Option`](#Option)
         *  with that value to be the selected option. You must set the `value`
         *  property to a value that exists in the [`options`](#options) list.
         *
         *  To reset the radio button group to have no option
         *  selected, set the `value` property to `null` or `undefined`.
         *
         *  Getting the `value` property returns the value of
         *  the currently selected option. If no value is selected, the
         *  `value` property returns an empty string.
         * @note
         *  If a radio button group is connected to a dataset, setting the radio button group's `value`
         *  in code does not set the value of the connected field in the dataset.
         *  That means if you use the dataset to perform a submit, the value changed
         *  in code is not reflected in the submitted item.
         *
         *  To submit the new value using a dataset, set the field's value using the
         *  [`setFieldValue()`](wix-dataset.html#setFieldValue) function before
         *  performing the submit.
         * @snippet [RadioButtonGroup-value_get.es6=Get the value of the selected option]
         * @snippet [RadioButtonGroup-value_set.es6=Select an option by value]
         * @type {external:String}
         * @memberof $w.RadioButtonGroup
         * @override
         */

    }, {
        key: 'value',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var value = RMI.getData(compId).value;

            return (0, _optionsUtils.emptyStringIfNotInOptions)(this.options, value);
        }

        /**
         * @param {external:String} val The input element's new value.
         * @ignore
         */
        ,
        set: function set(val) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getFullDataWithOverrides(compId);
            var compType = members._type.get(this).compType;
            var value = (0, _valueSanitzationAlgorithm2.default)(compData, val);
            var isValid = (0, _validation.validate)(compType, 'value', { value: value });

            if (!isValid) {
                return;
            }

            var valToValidate = (0, _optionsUtils.emptyStringIfNotInOptions)(this.options, value);

            (0, _validationsService.runValidationsAndSyncAfterChange)(RMI, compId, valToValidate);

            RMI.setData(compId, { value: valToValidate });
        }

        /**
         * @member selectedIndex
         * @label property
         * @syntax
         * get selectedIndex(): Number
         * set selectedIndex(value: Number): void
         * @summary Sets or gets the index of the selected option.
         * @description
         *  Setting the `selectedIndex` property sets the option at
         *  that index to be the selected option. To set one of the options to be
         *  selected, set the `selectedIndex` property to an index between `0` and
         *  `options.length - 1`.
         *
         *  To reset the radio button group to have no option
         *  selected, set the `selectedIndex` property to `undefined`.
         *
         *  Getting the `selectedIndex` property returns the index of
         *  the currently selected option. If no value is selected, the
         *  `selectedIndex` property returns `undefined`.
         * @type {external:Number}
         * @snippet [RadioButtonGroup-selectedIndex_get.es6=Get the index of the selected option]
         * @snippet [RadioButtonGroup-selectedIndex_set.es6=Select the first option by index]
         * @default `-1`
         * @memberof $w.RadioButtonGroup
         * @instance
         * @attr {external:String}
         */

    }, {
        key: 'selectedIndex',
        get: function get() {
            return (0, _utils.getIndexOrUndefined)(this.options, 'value', Utils.getData(this, 'value'));
        }

        /**
         * @param {external:Number} selectedIndex The index of the selected radio button.
         * @ignore
         */
        ,
        set: function set(index) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;

            var options = _optionsUtils.getOptionsFromFull.call(this);
            var acceptNil = true;
            if (!(0, _validation.validate)(compType, 'selectedIndex', { selectedIndex: index }) || !(0, _validation.validateRange)('selectedIndex', 'selectedIndex', index, 0, options.length - 1, undefined, acceptNil)) {
                return;
            }

            var value = (0, _isNil2.default)(index) ? '' : options[index].value;

            (0, _validationsService.runValidationsAndSyncAfterChange)(RMI, compId, value);
            Utils.setData(this, { value: value });
        }
    }]);

    return RadioButtonGroup;
}(_FormElement3.default);

exports.default = RadioButtonGroup;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _platformUtils = __webpack_require__(13);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _map = __webpack_require__(20);

var _map2 = _interopRequireDefault(_map);

var _set = __webpack_require__(37);

var _set2 = _interopRequireDefault(_set);

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _forEach = __webpack_require__(46);

var _forEach2 = _interopRequireDefault(_forEach);

var _uniq = __webpack_require__(427);

var _uniq2 = _interopRequireDefault(_uniq);

var _uniqBy = __webpack_require__(199);

var _uniqBy2 = _interopRequireDefault(_uniqBy);

var _filter = __webpack_require__(117);

var _filter2 = _interopRequireDefault(_filter);

var _reduce = __webpack_require__(125);

var _reduce2 = _interopRequireDefault(_reduce);

var _transform = __webpack_require__(198);

var _transform2 = _interopRequireDefault(_transform);

var _findIndex = __webpack_require__(84);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _every = __webpack_require__(35);

var _every2 = _interopRequireDefault(_every);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _validation = __webpack_require__(1);

var _regexValidations = __webpack_require__(136);

var _regexValidations2 = _interopRequireDefault(_regexValidations);

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(12);

var _compInitializeService = __webpack_require__(128);

var _compInitializeService2 = _interopRequireDefault(_compInitializeService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getRepeaterOrDataItems(RMI, compId) {
    var compData = RMI.getData(compId);
    return compData.fullItems || (0, _map2.default)(compData.items, function (itemId) {
        return { _id: itemId };
    });
}

function executeBehaviorByTypeForItems(RMI, wixSelector, repeaterId, behaviorType, items, callWith$w, compNickname, functionName) {
    var componentEvents = RMI.getEvents(repeaterId);
    var filteredBehaviors = (0, _filter2.default)(componentEvents, { eventType: behaviorType });
    var compBehaviors = (0, _transform2.default)(filteredBehaviors, function (result, behavior) {
        var funcRef = behavior.callbackId;
        var dynamicCallback = RMI.getCallbackById(funcRef, true);
        var staticCallback = _platformUtils2.default.getStaticEventHandler(funcRef);
        var eventHandler = dynamicCallback || staticCallback;
        if (eventHandler) {
            result.push({ cb: (0, _get2.default)(eventHandler, 'callback'), contextId: (0, _get2.default)(eventHandler, 'contextId'), controllerId: (0, _get2.default)(eventHandler, 'controllerId') || (0, _get2.default)(eventHandler, 'contextId') });
        }
    }, []);

    executeBehaviorForItems(wixSelector, repeaterId, compBehaviors, items, callWith$w, compNickname, functionName);
}

function logErrorFromFunction(compNickname, functionName, errorMessage) {
    _reporter2.default.reportSdkError(_errors.generateError.error_function_throws_error({
        compNickname: compNickname,
        functionName: functionName,
        errorMessage: errorMessage
    }));
}

function executeBehaviorForItems(wixSelector, repeaterId, compBehaviors, items, callWith$w, compNickname, functionName) {
    var _this = this;

    if ((0, _isEmpty2.default)(items) || (0, _isEmpty2.default)(compBehaviors)) {
        return;
    }
    (0, _forEach2.default)(items, function (item) {
        var $wToContextAndController = {};
        (0, _forEach2.default)(compBehaviors, function (behavior) {
            var controllerId = behavior.controllerId;
            var contextId = behavior.contextId;
            if (!callWith$w) {
                try {
                    behavior.cb.call(_this, item.item);
                } catch (e) {
                    logErrorFromFunction(compNickname, functionName, e.message);
                }
                return;
            }
            var $w = (0, _get2.default)($wToContextAndController, [contextId, controllerId]);
            if (!$w) {
                $w = wixSelector.getScopedSelectorForDisplayedOnlyComp(repeaterId, item.item._id, contextId, controllerId);
                (0, _set2.default)($wToContextAndController, [contextId, controllerId], $w);
            }
            try {
                behavior.cb.call(_this, $w, item.item, item.index);
            } catch (e) {
                logErrorFromFunction(compNickname, functionName, e.message);
            }
        });
    });
}

function getCompsWithData(RMI, repeaterId, reduceItems) {
    var repeaterUtils = _platformUtils2.default.getRepeaterUtils();
    return (0, _reduce2.default)(repeaterUtils.items.getTemplateCompsId(RMI, repeaterId, reduceItems), function (result, compId) {
        result[compId] = RMI.getComp(compId);
        return result;
    }, {});
}

function validateItemIdFormatAndReportIfNecessary(id, index, repeaterId) {
    if (!_regexValidations2.default.validateRepeaterItemIdFormat(id)) {
        _reporter2.default.reportSdkError(_errors.generateError.error_bad_item_id_format({
            repeaterId: repeaterId,
            wrongValue: id,
            index: index
        }));

        return false;
    }
    return true;
}

/**
 * @class Repeater
 * @summary A repeating layout.
 * @classdesc
 *  Repeaters provide a way for you to add repeating content to a page in your
 *  site. Repeaters consist of repeating items, each with the same layout
 *  but different data.
 *
 *  <h3 id="item-template">Repeated Item Template</h3>
 *
 *  A repeater has an item template that contains the elements and initial data
 *  that is used when new items are created. The template's initial state is the
 *  state of the first repeated item that appears in the Editor. Using code, you
 *  can set the properties of, get the properties of, or call functions on the
 *  elements of the item template by selecting the elements using the
 *  [`$w()`]($w.html#w) function from the [global scope](#global-scope).
 *
 *  <h3 id="selector-scope">Selector Scope</h3>
 *
 *  Selector functions are used to select specific page elements so you can work
 *  with them in code. Depending on which selector you use, you will be able to
 *  select elements from the different scopes described below.
 *
 *  To determine which scope a given selector selects from, consider the context
 *  you received the selector from.
 *
 *  <h4 id="page-selector">Selector from Page or Site Code</h4>
 *
 *  The [`$w()`]($w.html#w) function that is available to your Page
 *  and Site code selects elements in the [global scope](#global-scope).
 *
 *  For example, the selections below are global scope selections.
 *  ```
 *  $w.onReady( function () {
 *    let element = $w("#myElement");
 *    let repeatedElement = $w("#myRepeatedElement");
 *  } );
 *  ```
 *
 *
 *  <h4 id="regular-callback-selector">Selector from a Callback Parameter - Non-Repeating Element Event Handler</h4>
 *
 *  The selector function that is passed to the event handler of an element
 *  that is not inside a repeater selects elements in the [global scope](#global-scope).
 *
 *  For example, the selector passed to the `onClick` event handler below is a global scope selector.
 *  ```
 *  $w("#myElement").onClick( (event, $w) => {
 *    // ...
 *  } );
 *  ```
 *
 *
 *  <h4 id="repeating-callback-selector">Selector from a Callback Parameter - Repeating Element Event Handler</h4>
 *
 *  The selector function that is passed to the event handler of an element
 *  that is inside a repeater selects elements in the [repeated item scope](#repeated-item-scope).
 *
 *  For example, the selector passed to the `onClick` event handler below is a repeated item scope selector.
 *  ```
 *  $w("#myRepeatedElement").onClick( (event, $w) => {
 *    // ...
 *  } );
 *  ```
 *
 *
 *  <h4 id="repeater-callback-selector">Selector from a Callback Parameter - Repeater Functions</h4>
 *
 *  The selector function that is passed to an event handler of a repeater or a
 *  callback from one of a repeater's loop functions selects elements in the [repeated item scope](#repeated-item-scope).
 *
 *  For example, the selector passed to the callback functions below are repeated item scope selectors.
 *  ```
 *  $w("#myRepeater").onItemReady( ($w, itemData, index) => {
 *    // ...
 *  } );
 *
 *  // and
 *
 *  $w("#myRepeater").forEachItem( ($w, itemData, index) => {
 *    // ...
 *  } );
 *  ```
 *
 *
 *  <h4 id="global-scope">Global Scope</h3>
 *
 *  A selector with global scope can be used to select any element that is not
 *  contained in a repeater. You can also use it to select an element that is
 *  contained in a repeater, but you need to understand what that selection means.
 *
 *  When you select an element contained in a repeater from the global scope and
 *  you get the value of one of the element's properties, you receive the value
 *  of that element's property from the repeater's [item template](#item-template).
 *
 *  For example, here `templateText` will be the `text` value of the `myRepeatedText` element from the repeater's item template.
 *
 *  ```
 *  $w.onReady( function () {
 *    let templateText = $w("#myRepeatedText").text;
 *  } );
 *  ```
 *
 *
 *  When you select an element contained in a repeater from the global scope and
 *  you set the value of one of the element's properties or call one of the
 *  element's functions, the value is set or the function is called on the
 *  repeater's [item template](#item-template) **and** all repeated instances of
 *  that element.
 *
 *
 *  For example, here the item template will change so that `"New Text"` will be the `text` value of the `myRepeatedText` element. Also, all existing repeated items will have the `text` value of their `myRepeatedText` element set to `"New Text"`.
 *
 *  ```
 *  $w.onReady( function () {
 *    $w("#myRepeatedText").text = "New Text";
 *  } );
 *  ```
 *
 *  And here the item template will change so that the `myRepeatedImage` element is hidden. Also, all existing repeated items will have their `myRepeatedImage` element hidden.
 *
 *  ```
 *  $w.onReady( function () {
 *    $w("#myRepeatedImage").hide();
 *  } );
 *  ```
 *
 *
 *  <h4 id="repeated-item-scope">Repeated Item Scope</h3>
 *
 *  A selector with repeated item scope selects the instance of a repeating
 *  element in the current repeating item and its descendants. You can also
 *  use it to select non-repeating elements from the global scope. You cannot
 *  change the item template using a selector with repeated item scope.
 *
 *
 *  For example, here when the `myRepeatedImage` element is clicked, the `text` value of the `myRepeatedText` element from the repeated item where the image was clicked will be changed to "Selected". All the other `myRepeatedText` elements in the other items of the repeater will not be affected.
 *
 *  ```
 *  $w.onReady( function () {
 *    $w("#myRepeatedImage").onClick( (event, $w) => {
 *      $w("#myRepeatedText").text = "Selected";
 *    } );
 *  } );
 *  ```
 *
 *  You can restrict a selector with repeated item scope to only select
 *  elements from the current repeated items and their descendants, but not elements
 *  from the global scope by adding `.scoped()` to the selector so the function
 *  call looks like `$w.scoped("#idToSelect")`.
 *
 *  <h3 id="select-item">Retrieve Repeater Item Data When Clicked</h3>
 *
 *  Each repeated item in a repeater has a [`Container`]($w.Container.html) element
 *  that holds all of its other repeated elements. To retrieve the data associated
 *  with a specific repeated item when it is clicked, create an `onClick` event
 *  handler for the item's `Container`. Depending on how you populated the repeater
 *  with data, you either user the connected dataset or the repeater's `data`
 *  array to retrieve the clicked item's data in the event handler.
 *
 *  For a repeater populated by connecting it to a dataset:
 *
 *  ```
 *  $w.onReady( function () {
 *    $w("#repeatedContainer").onClick( (event, $w) => {
 *      let clickedItemData = $w("#myDataset").getCurrentItem();
 *    } );
 *  } );
 *  ```
 *
 *  For a repeater populated by setting its [`data`](#data) property:
 *
 *  ```
 *  $w.onReady( function () {
 *    $w("#repeatedContainer").onClick( (event, $w) => {
 *      const data = $w("#myRepeater").data;
 *      let clickedItemData = data.filter(item => item._id === event.context.itemId));
 *    } );
 *  } );
 *  ```
 *
 *
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.Repeater
 * @tagname PLACEHOLDER
 */

var Repeater = function (_Element) {
    _inherits(Repeater, _Element);

    function Repeater(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, Repeater);

        var _this2 = _possibleConstructorReturn(this, (Repeater.__proto__ || Object.getPrototypeOf(Repeater)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(Repeater.prototype, _HiddenCollapsedMixin2.default.prototype);
        return _this2;
    }

    /**
     * @member data
     * @label property
     * @syntax
     * get data(): Object[]
     * set data(value: Object[]): void
     * @summary Sets or gets the repeater data.
     * @description
     *  A repeater's data is stored as an array of objects. Each object in the array
     *  must contain a unique `_id` property which is used to match the object's
     *  data to the individual repeated items of the repeater as described below.
     *  The value of the `_id` property can only contain alphanumeric
     *  characters and hyphens (`-`). Other than `_id`, the objects in the
     *  repeater's data array can contain anything you want.
     *
     *  For example, a simple array of repeater data may look like this:
     *  ```
     *  [
     *    {
     *      "_id": "1",
     *      "firstName": "John",
     *      "lastName": "Doe",
     *      "image": "http://someImageUrl/john.jpg"
     *    },
     *    {
     *      "_id": "2",
     *      "firstName": "Jane",
     *      "lastName": "Doe",
     *      "image": "http://someImageUrl/jane.jpg"
     *    }
     *  ]
     *  ```
     *
     *  Repeater data is not automatically applied to the elements in the reapeated
     *  items. You choose how to use the repeater's data in the [`onItemReady()`](#onItemReady),
     *  [`onItemRemoved()`](#onItemRemoved), [`forItems()`](#forItems), and
     *  [`forEachItem()`](#forEachItem) callback functions. Most often, you will
     *  be applying the data of a repeated item to the properties and functions
     *  of the repeated elements contained in that repeated item.
     *
     *  You cannot modify the data array in-place. To add, change, or remove
     *  objects from the repeater's data array:
     *    1. Store the value of the `data` property in a variable.
     *    1. Make changes to the objects of the shouldTriggerOnItemRemoved array.
     *    1. Reset the `data` property with the modified array.
     *
     *
     *  When the repeater's `data` property is set:
     *    1. New repeated items are created for each object that has an `_id` value
     *       that is not already present in the current array of data objects. The elements
     *       in the new items are first populated with the data of the repeater's
     *       [item template](item-template). Then the [`onItemReady()`](#onItemReady)
     *       event handler is triggered for each of the new items. Usually, you
     *       will overwrite some or all of the data populated from the item template
     *       in the [`onItemReady()`](#onItemReady) event handler with the data for
     *       that specific item. When all of the [`onItemReady()`](#onItemReady)
     *       event handlers have finished running, the new items are displayed.
     *    1. Repeated items are removed if their IDs are no longer in the array of
     *       data objects. The [`onItemRemoved()`](#onItemRemoved) event handler is
     *       triggered for each of the removed items.
     *    1. Nothing occurs to repeated items whose IDs were already in the array
     *       of data objects, even if other data in the object has changed. To update
     *       repeated items with the new data, use the [`forEachItem()`](#forEachItem)
     *       or [`forItems()`](#forItems) functions.
     *
     *
     *  Getting the `data` property returns the repeater's current data. If you
     *  have not yet explicitly set the repeater's `data`, getting the `data`
     *  property returns only the IDs of the current repeated items that were
     *  set in the Editor.
     * @snippet [Repeater-data_get.es6=Get a repeater's data]
     * @snippet [Repeater-data_set.es6=Set a repeater's data]
     * @snippet [Repeater-data_set-query.es6=Set a repeater's data from a database query]
     * @snippet [Repeater-data_change.es6=Modify a repeater's data]
     * @snippet [Repeater-data_set-scenario.es6=Set a repeater's data]
     *  This example defines an event handler to handle the creation of new items
     *  and sets a repeater's data.
     * @snippet [Repeater-data_set-scenario-add.es6=Set a repeater's data and add new data on a button click]
     *  This example defines an event handler to handle the creation of new items
     *  and sets a repeater's data. It also adds an event handler to an
     *  "addButton" that is not part of the repeater. Clicking the button resets
     *  the repeater's data, adding another item.
     * @snippet [Repeater-data_set-scenario-remove.es6=Set the a repeater's data and remove some data on a button click]
     *  This example defines event handlers to handle the creation of new items
     *  and the removal of existing items. Then it sets a repeater's data.
     *  Lastly, it adds an event handler to a "removeButton" that is not part of
     *  the repeater. Clicking the button resets the repeater's data, removing
     *  one of the items.
     * @type {external:Object[]}
     * @memberof $w.Repeater
     */


    _createClass(Repeater, [{
        key: 'onItemReady',


        /**
         * @callback $w.ItemReadyEventHandler
         * @description Handles repeater item ready events.
         * @param {$w.$w} $w A selector function with [repeated item scope](#repeated-item-scope).
         * @param {external:Object} itemData The object from the repeater's `data` array that corresponds to the repeated item being created.
         * @param {external:Number} index The index of the `itemData` object in the `data` array.
         */

        /**
         * @function onItemReady
         * @syntax
         * function onItemReady(handler: ItemReadyEventHandler): Repeater
         * callback ItemReadyEventHandler($w: Function, itemData: Object, index: Number): void
         * @summary Sets the function that runs when a new repeated item is created.
         * @description
         *  Use the `onItemReady()` function for code you want to run before new
         *  repeated items are rendered.
         *
         *  The callback is triggered when you add new items by setting the
         *  [`data`](#data) property. It is not triggered for existing items that
         *  are updated when you set the [`data`](#data) property. To run code after
         *  updating existing items, use the [`forEachItem`](#forEachItem) or
         *  [`forItems`](#forItems) functions.
         *
         *
         *  Usually, you will use `onItemReady()` to:
         *  + Apply the repeated item's `itemData` to the properties and functions
         *    of the repeated elements contained in the repeated item being created.
         *  + Add event handlers to the repeated elements contained in
         *    the repeated item being created.
         * @snippet [Repeater-onItemReady.es6=Set up new repeated items]
         * @snippet [Repeater-onItemReady_scenario.es6=Set up new repeated items]
         *  This example creates an event handler that sets up new repeated items by
         *  setting the source of a repeated image element and the text value of a
         *  repeated text element to values from the repeated item's data.
         *
         *  It also sets an event handler that runs when the image in a repeated
         *  item is clicked. The event handler changes the value of a repeated text
         *  element to indicate whether the repeated item is "selected". It also
         *  changes the value of a non-repeated text element which serves as a
         *  counter for how many repeated items are "selected".
         * @param {$w.ItemReadyEventHandler} handler The name of the function or
         *  the function expression to run when the item is ready.
         * @returns {$w.Repeater} The element on which the event is now registered.
         * @eventtype itemReady
         * @eventhandler
         * @memberof $w.Repeater
         */

        value: function onItemReady(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'onItemReady', { callback: cb })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var controllerId = members._controllerId.get(this);
            var contextId = members._contextId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().ITEM_READY, controllerId, cb);

            /*Trigger onItemReady on existing items, only after the first set items()*/
            var compData = RMI.getData(compId);
            if (compData.fullItems) {
                var currentItems = getRepeaterOrDataItems(RMI, compId);
                var wixSelector = members._wixSelector.get(this);
                var newBehavior = [{ cb: cb, contextId: contextId, controllerId: controllerId }];
                var itemsWithIndex = (0, _map2.default)(currentItems, function (item, index) {
                    return { item: item, index: index };
                });

                executeBehaviorForItems(wixSelector, compId, newBehavior, itemsWithIndex, true, this.id, 'onItemReady');
            }

            return this;
        }

        /**
         * @callback $w.ItemRemovedEventHandler
         * @description Handles repeater item removed events.
         * @param {external:Object} itemData The object from the repeater's `data` array that corresponds to the repeated item being removed.
         */

        /**
         * @function onItemRemoved
         * @syntax
         * function onItemRemoved(handler: ItemRemovedEventHandler): Repeater
         * callback ItemRemovedEventHandler(itemData: Object): void
         * @summary Sets the function that runs when a repeated item is removed.
         * @description
         *  Use the `onItemRemoved()` function for code you want to run when
         *  repeated items are removed. The callback is triggered when you remove
         *  items by setting the value of the [`data`](#data) property to an array
         *  in which some of the existing item IDs are no longer present.
         * @note
         *  The `onItemRemoved()` callback function is not called when the static
         *  repeated items that were set in the Editor are removed.
         * @snippet [Repeater-onItemRemoved.es6=Get data from items being removed]
         * @param {$w.ItemRemovedEventHandler} handler The name of the function or
         *  the function expression to run when the item is removed.
         * @returns {$w.Repeater} The element on which the event is now registered.
         * @eventtype itemRemoved
         * @eventhandler
         * @memberof $w.Repeater
         */

    }, {
        key: 'onItemRemoved',
        value: function onItemRemoved(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'onItemRemoved', { callback: cb })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var controllerId = members._controllerId.get(this);
            var contextId = members._contextId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().ITEM_REMOVED, controllerId, cb);

            return this;
        }

        /**
         * @callback $w.ForItemCallback
         * @description Runs for items in a repeater.
         * @param {$w.$w} $w A selector function with [repeated item scope](#repeated-item-scope).
         * @param {external:Object} itemData The object from the repeater's `data` array that corresponds to the current repeated item.
         * @param {external:Number} index The index of the `itemData` object in the `data` array.
         */

        /**
         * @function forEachItem
         * @syntax
         * function forEachItem(callback: ForItemCallback): void
         * callback ForItemCallback($w: Function, itemData: Object, index: Number): void
         * @summary Runs a function for each repeated item.
         * @description
         *  Use the `forEachItem()` function to run a function on all of a repeater's
         *  repeated items. You can use the callback function to update or pull
         *  information from all of the repeater's repeated items.
         *
         *  When you set a repeater's [`data`](#data) property with data that changes
         *  items with existing IDs, those changes are not automatically reflected
         *  in the elements contained in the repeater. That is because you are
         *  responsible for applying a repeater's data to its repeated items.
         *
         *  To apply the data to items with new IDs, you can use the [`onItemReady()`](#onItemReady)
         *  event handler.
         *
         *  To update items with existing IDs, you can use the `forEachItem()` or
         *  [`forItems()`](#forItems) functions.
         *
         *  Usually, when updating repeated items you will:
         *  + Apply the repeated item's `itemData` to the elements contained in each
         *    of the repeater's repeated items.
         *  + Add event handlers to the elements contained in each of the
         *    repeater's repeated items.
         * @snippet [Repeater-forEachItem.es6=Loop through all of a repeater's repeated items]
         * @snippet [Repeater-forEachItem_scenario.es6=Update data in all of a repeater's repeated items]
         * @param {$w.ForItemCallback} callback The name of the function or the function expression to run for each repeated item.
         * @memberof $w.Repeater
         */

    }, {
        key: 'forEachItem',
        value: function forEachItem(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'forEachItem', { callback: cb })) {
                return;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var repeaterItems = getRepeaterOrDataItems(RMI, compId);
            var wixSelector = members._wixSelector.get(this);

            (0, _forEach2.default)(repeaterItems, function (itemData, index) {
                return cb(wixSelector.getScopedSelectorForDisplayedOnlyComp(compId, itemData._id), itemData, index);
            });
        }

        /**
         * @function forItems
         * @syntax
         * function forItems(itemIds: String[], callback: ForItemCallback): void
         * callback ForItemCallback(selector: Function, itemData: Object, index: Number): void
         * @summary Runs a function for each repeated item with the given IDs.
         * @description
         *  Use the `forItems()` function to run a function on a specified list of
         *  repeated items. You can use the callback function to update or pull
         *  information from the specified repeated items.
         *
         *  When you set a repeater's [`data`](#data) property with data that changes
         *  items with existing IDs, those changes are not automatically reflected
         *  in the elements contained in the repeater. That is because you are
         *  responsible for applying a repeater's data to its repeated items.
         *
         *  To apply the data to items with new IDs, you can use the [`onItemReady()`](#onItemReady)
         *  event handler.
         *
         *  To update items with existing IDs, you can use the `forEachItem()` or
         *  [`forItems()`](#forItems) functions.
         *
         *  Usually, when updating repeated items you will:
         *  + Apply the repeated item's `itemData` to the elements contained in each
         *    of the repeater's repeated items.
         *  + Add event handlers to the elements contained in each of the
         *    repeater's repeated items.
         *
         *
         * @snippet [Repeater-forItems.es6=Loop through some of a repeater's repeated items]
         * @snippet [Repeater-forItems_scenario.es6=Update data in some of a repeater's repeated items]
         * @param {external:String[]} itemIds The IDs of the items on which to run the callback function.
         * @param {$w.ForItemCallback} callback The name of the function or the function expression to run for each repeated item.
         * @memberof $w.Repeater
         */

    }, {
        key: 'forItems',
        value: function forItems(ids, cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'forItems', { callback: cb, ids: ids })) {
                return;
            }

            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var repeaterItems = getRepeaterOrDataItems(RMI, compId);
            var wixSelector = members._wixSelector.get(this);

            var existItems = (0, _transform2.default)(ids, function (result, id) {
                var itemIndex = (0, _findIndex2.default)(repeaterItems, { _id: id });
                if (itemIndex === -1) {
                    _reporter2.default.reportSdkWarning(_errors.generateError.warning_non_existing_item({
                        functionName: 'forItems',
                        _id: id
                    }));

                    return;
                }

                result.push({ itemData: repeaterItems[itemIndex], index: itemIndex });
            }, []);

            (0, _forEach2.default)(existItems, function (item) {
                return cb(wixSelector.getScopedSelectorForDisplayedOnlyComp(compId, item.itemData._id), item.itemData, item.index);
            });
        }
    }, {
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                title = this.title,
                items = this.items;

            return { id: id, type: type, global: global, rendered: rendered, title: title, items: items };
        }
    }, {
        key: 'data',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return getRepeaterOrDataItems(RMI, compId);
        },
        set: function set(items) {
            var _this3 = this;

            var RMI = members._RMI.get(this);
            var compType = members._type.get(this).compType;
            var compId = members._compId.get(this);

            if (!(0, _validation.validate)(compType, 'data', { data: items }) || !(0, _validation.validateArrayContainsItemsWithIds)(items) || !(0, _every2.default)(items, function (item, index) {
                return validateItemIdFormatAndReportIfNecessary(item._id, index, _this3.id) && (0, _validation.validate)(compType, 'data', { _id: item._id });
            })) {
                return;
            }

            var contextId = members._contextId.get(this);
            var wixSelector = members._wixSelector.get(this);
            var compData = RMI.getData(compId);
            var shouldTriggerOnItemRemoved = !!compData.fullItems;
            var currentItems = getRepeaterOrDataItems(RMI, compId);
            var uniqueItems = (0, _uniqBy2.default)(items, '_id');
            var repeaterUtils = _platformUtils2.default.getRepeaterUtils();
            var addedItems = repeaterUtils.items.getAddedItems(currentItems, uniqueItems);
            var removedItems = repeaterUtils.items.getRemovedItems(currentItems, uniqueItems);
            var removedComps = getCompsWithData(RMI, compId, removedItems);
            var itemIds = (0, _uniq2.default)((0, _map2.default)(items, '_id'));

            RMI.startTransaction();
            RMI.setDataWithoutUpdate(compId, { fullItems: uniqueItems });
            RMI.setData(compId, { items: itemIds });

            var addedComps = getCompsWithData(RMI, compId, addedItems);
            _compInitializeService2.default.componentsInitialize(RMI, contextId, addedComps);
            _compInitializeService2.default.componentsRemoval(RMI, contextId, removedComps);

            executeBehaviorByTypeForItems(RMI, wixSelector, compId, RMI.getEventTypes().ITEM_READY, addedItems, true, this.id, 'onItemReady');
            if (shouldTriggerOnItemRemoved) {
                executeBehaviorByTypeForItems(RMI, wixSelector, compId, RMI.getEventTypes().ITEM_REMOVED, removedItems, false, this.id, 'onItemRemoved');
            }
            RMI.endTransaction();
        }
    }]);

    return Repeater;
}(_Element3.default);

exports.default = Repeater;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _LinkableMixin = __webpack_require__(67);

var _LinkableMixin2 = _interopRequireDefault(_LinkableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Shape
 * @summary A simple shape.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.LinkableMixin
 * @mixes $w.ClickableMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.svgshape.SvgShape
 * @viewername wysiwyg.viewer.components.VectorImage
 * @tagname shape
 */
var Shape = function (_Element) {
    _inherits(Shape, _Element);

    function Shape(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, Shape);

        var _this = _possibleConstructorReturn(this, (Shape.__proto__ || Object.getPrototypeOf(Shape)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(Shape.prototype, _HiddenCollapsedMixin2.default.prototype);
        (0, _mixin2.default)(Shape.prototype, _LinkableMixin2.default.prototype);
        (0, _mixin2.default)(Shape.prototype, _ClickableMixin2.default.prototype);
        return _this;
    }

    return Shape;
}(_Element3.default);

exports.default = Shape;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _Slide = __webpack_require__(140);

var _Slide2 = _interopRequireDefault(_Slide);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(1);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _PlayableMixin = __webpack_require__(142);

var _PlayableMixin2 = _interopRequireDefault(_PlayableMixin);

var _ContainableMixin = __webpack_require__(26);

var _ContainableMixin2 = _interopRequireDefault(_ContainableMixin);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _isObject = __webpack_require__(14);

var _isObject2 = _interopRequireDefault(_isObject);

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(12);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validateSlideInfo = function validateSlideInfo(compType, slideInfo, slidesCount, slideIndex, slideshowID) {
    if (!(0, _validation.validate)(compType, 'changeSlide', (0, _isNil2.default)(slideInfo) ? {} : { slideInfo: slideInfo }, true)) {
        return false;
    }
    if ((0, _isObject2.default)(slideInfo) && !(slideInfo instanceof _Slide2.default)) {
        _reporter2.default.reportSdkError(_errors.generateError.error_type({
            functionName: 'changeSlide',
            propertyName: 'slideInfo',
            wrongValue: slideInfo,
            expectedType: 'slide,integer'
        }));
        return false;
    }

    if (slideIndex < 0 || slideIndex >= slidesCount) {
        if (slideInfo instanceof _Slide2.default) {
            _reporter2.default.reportSdkError(_errors.generateError.error_slide_input({
                propertyName: 'slideInfo',
                functionName: 'changeSlide',
                minValue: 0,
                maxValue: slidesCount - 1,
                slideshowID: slideshowID,
                wrongValue: slideInfo.id }));
        } else {
            _reporter2.default.reportSdkError(_errors.generateError.error_slide_input({
                propertyName: 'slideInfo',
                functionName: 'changeSlide',
                minValue: 0,
                maxValue: slidesCount - 1,
                slideshowID: slideshowID,
                wrongValue: slideIndex
            }));
        }
        return false;
    }

    return true;
};

var computeSlideIndex = function computeSlideIndex(RMI, compId, slideInfo) {
    var slideIndex = -1;
    if (slideInfo instanceof _Slide2.default) {
        var slideCompId = members._compId.get(slideInfo);

        slideIndex = Array.indexOf(RMI.getChildren(compId), slideCompId);
    } else {
        slideIndex = slideInfo;
    }

    return slideIndex;
};

var getSlidesCount = function getSlidesCount(RMI, compId) {
    return RMI.getChildren(compId).length;
};

/**
 * @class Slideshow
 * @summary Slideshows are playable containers for slides.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.PlayableMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.BoxSlideShow
 * @viewername wysiwyg.viewer.components.StripContainerSlideShow
 * @tagname box-slideshow
 */

var Slideshow = function (_Element) {
    _inherits(Slideshow, _Element);

    function Slideshow(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, Slideshow);

        var _this = _possibleConstructorReturn(this, (Slideshow.__proto__ || Object.getPrototypeOf(Slideshow)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(Slideshow.prototype, _HiddenCollapsedMixin2.default.prototype);
        (0, _mixin2.default)(Slideshow.prototype, _PlayableMixin2.default.prototype);
        (0, _mixin2.default)(Slideshow.prototype, _ClickableMixin2.default.prototype);
        (0, _mixin2.default)(Slideshow.prototype, _ContainableMixin2.default.prototype);
        return _this;
    }

    /**
     * @function onChange
     * @syntax
     * function onChange(handler: EventHandler): Slideshow
     * callback EventHandler(event: Event, $w: Function): void
     * @summary Adds an event handler that runs when the slideshow moves to a new slide.
     * @description
     *  A slideshow moves to a new slide through user actions, such as clicking
     *  on navigation or slide buttons, or programmatically, using functions
     *  such as [play()](#play), [previous( )](#previous), and [next( )](#next).
     *
     *  The event handler set by the `onChange` function is run immediately before
     *  the slideshow moves to the new slide. Therefore, reading the slideshow's
     *  [`currentIndex`](#currentIndex) or [`currentSlide`](#currentSlide) within
     *  the event handler function will return the index or slide that the slideshow
     *  is moving away from.
     * @param {$w.EventHandler} eventHandler The name of the function or
     *  the function expression to run when the slideshow moves to a new slide.
     * @returns {$w.Slideshow} The slideshow on which the event is now registered.
     * @snippet [Slideshow-onChange.es6=Get the index of the slide that the slideshow is moving away from]
     * @see [changeSlide( )](#changeSlide)
     * @see [previous( )](#previous)
     * @see [next( )](#next)
     * @see [autoplay](#autoplay)
     * @memberof $w.Slideshow
     * @eventtype change
     * @eventhandler
     */


    _createClass(Slideshow, [{
        key: 'onChange',
        value: function onChange(callback) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'onChange', { onChange: callback })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            var contextId = members._contextId.get(this);
            var controllerId = members._controllerId.get(this);
            var compId = members._compId.get(this);
            RMI.registerEvent(contextId, compId, RMI.getEventTypes().CHANGE, controllerId, callback);
            return this;
        }

        /**
         * @member currentSlide
         * @label property
         * @syntax
         * get currentSlide(): Slide
         * @summary Gets the slideshow's current slide.
         * @snippet [Slideshow-currentSlide.es6=Get the current slide and its name]
         * @type {$w.Slide}
         * @see [currentIndex](#currentindex)
         * @memberof $w.Slideshow
         * @instance
         * @readonly
         */

    }, {
        key: 'changeSlide',


        /**
         * @function changeSlide
         * @syntax
         * function changeSlide(slideReference: Number | Slide): Promise&lt;Slide&gt;
         * @summary Change the slideshow's current slide to a specific slide or index.
         * @description
         *  The `changeSlide()` function returns a Promise that is resolved when
         *  the slideshow finishes moving from the current slide to the slide
         *  referred to by `slideReference`.
         *
         *  You can retrieve [`Slide`]($w.Slide.html) objects to pass to the
         *  `slideReference` parameter from your slideshow using the
         *  [`currentSlide`](#currentSlide) or [`slides`](#slides) properties.
         *
         *  If passing a number, note that slide indices in a slideshow are zero-based,
         *  even though they are numbered starting from 1 in the Editor.
         * @snippet [Slideshow-changeSlide-index.es6=Move to a new slide using an index]
         *  This example moves to the third slide in the slideshow.
         * @snippet [Slideshow-changeSlide-object.es6=Move to a new slide using a [`Slide`]($w.Slide.html) object]
         *  This example moves to the slide that is stored in the `slide` variable.
         * @snippet [Slideshow-changeSlide-done.es6=Moves to a new slide and logs a message when the move is finished]
         * @param {external:Number|$w.Slide} slideReference The slide to move to. Either the index of the slide or a [`Slide`](#w.Slide.html) from the slideshow.
         * @returns {external:Promise}
         * @fulfill {$w.Slide} The slide that the slideshow changed to.
         * @throws {external:Error} If no argument was provided or the argument is not a number or an existing slide.
         * @memberof $w.Slideshow
         */

        value: function changeSlide(slideInfo) {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                var compType = members._type.get(_this2).compType;
                var RMI = members._RMI.get(_this2);
                var compId = members._compId.get(_this2);
                var wixSelector = members._wixSelector.get(_this2);
                var controllerId = members._controllerId.get(_this2);

                var slideIndex = computeSlideIndex(RMI, compId, slideInfo);
                if (!validateSlideInfo(compType, slideInfo, getSlidesCount(RMI, compId), slideIndex, _this2.id)) {
                    return reject(_errors.generateError.error_slide_input({
                        propertyName: 'slideInfo',
                        functionName: 'changeSlide',
                        minValue: 0,
                        maxValue: getSlidesCount(RMI, compId) - 1,
                        slideshowID: _this2.id,
                        wrongValue: slideInfo
                    }));
                }

                RMI.executeCompBehavior(compId, 'moveToSlide', { slide: slideIndex }, function () {
                    var childrenIds = RMI.getChildren(compId);
                    var slideCompId = childrenIds[slideIndex];
                    var slide = RMI.getComp(slideCompId);
                    resolve(RMI, wixSelector.getInstance(RMI, slide.type, slideCompId, controllerId));
                });
            });
        }

        /**
         * @member slides
         * @label property
         * @syntax
           * get slides(): Slide[]
         * @summary Gets a list of all the slides contained in the slideshow.
         * @description
         *  Note that the slide indices in a slideshow are zero-based, even though
         *  they are numbered starting from 1 in the Editor.
         * @snippet [Slideshow-slides.es6=Get a slidshow's slides]
         * @snippet [Slideshow-slides_plus.es6=Get the slides, number of slides, and name of the first slide from a slideshow]
         * @type {$w.Slide[]}
         * @memberof $w.Slideshow
         * @instance
         * @readonly
         */

    }, {
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                currentIndex = this.currentIndex,
                showNavigationButtons = this.showNavigationButtons,
                showSlideButtons = this.showSlideButtons;

            return { id: id, type: type, global: global, rendered: rendered, currentIndex: currentIndex, showNavigationButtons: showNavigationButtons, showSlideButtons: showSlideButtons };
        }
    }, {
        key: 'currentSlide',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var wixSelector = members._wixSelector.get(this);
            var controllerId = members._controllerId.get(this);

            var currentSlideIndex = RMI.getState(compId).currentIndex;
            var currentSlideCompId = RMI.getChildren(compId)[currentSlideIndex];
            var currentSlideType = RMI.getType(currentSlideCompId);

            return wixSelector.getInstance(RMI, currentSlideType, currentSlideCompId, controllerId);
        }
    }, {
        key: 'slides',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var wixSelector = members._wixSelector.get(this);
            var controllerId = members._controllerId.get(this);

            return RMI.getChildren(compId).map(function (id) {
                return wixSelector.getInstance(RMI, RMI.getComp(id).type, id, controllerId);
            });
        }

        /**
         * @member currentIndex
         * @label property
         * @syntax
           * get currentIndex(): Number
         * @summary Gets the index of the slideshow's current slide.
         * @description
         *  Note that the slide indices in a slideshow are zero-based, even though
         *  they are numbered starting from 1 in the Editor.
         * @snippet [Slideshow-currentIndex.es6=Get the name of the current slide's index]
         * @type {external:Number}
         * @see [currentSlide](#currentSlide)
         * @memberof $w.Slideshow
         * @instance
         * @readonly
         */

    }, {
        key: 'currentIndex',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getState(compId).currentIndex;
        }

        /**
         * @member showNavigationButtons
         * @label property
         * @syntax
         * get showNavigationButtons(): boolean
         * set showNavigationButtons(value: boolean): void
         * @summary Sets or gets whether a slideshow's navigation buttons are shown.
         * @description
         *  Setting the `showNavigationButtons` property to `true` shows
         *  the slideshow's [navigation buttons](https://support.wix.com/en/article/slideshow-layouts).
         *  Setting it to `false` hides the slideshow's [navigation buttons](https://support.wix.com/en/article/slideshow-layouts).
         *
         *  Getting the `showNavigationButtons` property returns
         *  whether a slideshow's [navigation buttons](https://support.wix.com/en/article/slideshow-layouts)
         *  are shown or hidden.
         * @snippet [Slideshow-showNavigationButtons_get.es6=Get whether navigation buttons are shown]
         * @snippet [Slideshow-showNavigationButtons_set.es6=Set navigation buttons to be hidden]
         * @snippet [Slideshow-showNavigationButtons_toggle.es6=Toggle whether navigation buttons are shown]
         * @type {external:Boolean}
         * @memberof $w.Slideshow
         * @instance
         */

    }, {
        key: 'showNavigationButtons',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getProps(compId).showNavigationButton;
        }

        /**
         * @param {external:Boolean} show.
         * @ignore
         */
        ,
        set: function set(show) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'showNavigationButtons', { showNavigationButtons: show })) {
                return;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            RMI.setProps(compId, {
                showNavigationButton: show
            });
        }

        /**
         * @member showSlideButtons
         * @label property
         * @syntax
         * get showSlideButtons(): boolean
         * set showSlideButtons(value: boolean): void
         * @summary Set or returns whether a slideshow's slide buttons are shown.
         * @description
         *  Setting the `showSlideButtons` property to `true` shows
         *  the slideshow's [slide buttons](https://support.wix.com/en/article/slideshow-layouts).
         *  Setting it to `false` hides the slideshow's [slide buttons](https://support.wix.com/en/article/slideshow-layouts).
         *
         *  Getting the `showSlideButtons` property returns
         *  whether a slideshow's [slide buttons](https://support.wix.com/en/article/slideshow-layouts)
         *  are shown or hidden.
         * @snippet [Slideshow-showSlideButtons_get.es6=Get whether slide buttons are shown]
         * @snippet [Slideshow-showSlideButtons_set.es6=Set slide buttons to be hidden]
         * @snippet [Slideshow-showSlideButtons_toggle.es6=Toggle whether slide buttons are shown]
         * @type {external:Boolean}
         * @memberof $w.Slideshow
         * @instance
         */

    }, {
        key: 'showSlideButtons',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getProps(compId).showNavigationDots;
        }

        /**
         * @param {external:Boolean} show.
         * @ignore
         */
        ,
        set: function set(show) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'showSlideButtons', { showSlideButtons: show })) {
                return;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            RMI.setProps(compId, {
                showNavigationDots: show
            });
        }
    }]);

    return Slideshow;
}(_Element3.default);

exports.default = Slideshow;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _FormElement2 = __webpack_require__(33);

var _FormElement3 = _interopRequireDefault(_FormElement2);

var _DisabledMixin = __webpack_require__(27);

var _DisabledMixin2 = _interopRequireDefault(_DisabledMixin);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _FocusMixin = __webpack_require__(32);

var _FocusMixin2 = _interopRequireDefault(_FocusMixin);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _Utils = __webpack_require__(25);

var Utils = _interopRequireWildcard(_Utils);

var _validation = __webpack_require__(1);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _valueSanitzationAlgorithm = __webpack_require__(54);

var _valueSanitzationAlgorithm2 = _interopRequireDefault(_valueSanitzationAlgorithm);

var _validationsService = __webpack_require__(15);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Switch
 * @summary Switches are used for a single binary choice.
 * @mixes $w.FormElement
 * @mixes $w.DisabledMixin
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.FocusMixin
 * @mixes $w.ClickableMixin
 * @memberof $w
 * @tagname switch
 * @viewername wixui.ToggleSwitch
 */
var Switch = function (_FormElement) {
    _inherits(Switch, _FormElement);

    function Switch(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, Switch);

        var _this = _possibleConstructorReturn(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(Switch.prototype, _DisabledMixin2.default.prototype);
        (0, _mixin2.default)(Switch.prototype, _HiddenCollapsedMixin2.default.prototype);
        (0, _mixin2.default)(Switch.prototype, _FocusMixin2.default.prototype);
        (0, _mixin2.default)(Switch.prototype, _ClickableMixin2.default.prototype);
        return _this;
    }
    /**
     * @member checked
     * @label property
     * @syntax
     * get checked(): boolean
     * set checked(value: boolean): void
     * @summary Sets or gets whether a switch is on or off.
     * @description
     *  Setting the `checked` property to `true` toggles the switch to the on
     *  position. Setting it to `false` toggles the switch to the off position.
     *
     *  Getting the `checked` property returns whether the switch is on or off.
     * @type {external:Boolean}
     * @memberof $w.Switch
     * @instance
     */


    _createClass(Switch, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                required = this.required,
                value = this.value,
                checked = this.checked;

            return { id: id, type: type, global: global, rendered: rendered, required: required, value: value, checked: checked };
        }
    }, {
        key: 'checked',
        get: function get() {
            return Utils.getData(this, 'checked') || false;
        }

        /**
         * @param {external:Boolean} checked
         * @ignore
         */
        ,
        set: function set(checked) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;

            if (!(0, _validation.validate)(compType, 'checked', { checked: checked })) {
                return;
            }

            (0, _validationsService.runValidationsAfterChange)(RMI, compId, checked);
            if ((0, _isNil2.default)(checked)) {
                checked = false;
            }
            Utils.setData(this, { checked: checked });
        }

        /**
         * @member value
         * @label property
         * @syntax
         * get value(): string
         * set value(value: string): void
         * @summary Sets or gets a switch's value.
         * @description
         *  The `value` property is not related to whether the switch is on or
         *  off. To determine whether the switch is on or off, use the [`checked`](#checked)
         *  property.
         *
         *  The `value` property is used for storing a value that is associated with
         *  the switch.
         *
         *  It does not trigger an `onChange` event when the value is modified.
         *
         *  Even if a switch is connected to a dataset, its `value` property
         *  is not related to the value of the collection field it is connected to.
         *  The field's value is determined by the switch's [`checked`](#checked) property.
         * @snippet [FormElement-value_get.es6=Get an element's value]
         * @snippet [FormElement-value_set.es6=Set an element's value]
         * @type {external:String}
         * @memberof $w.Switch
         * @override
         */

    }, {
        key: 'value',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getData(compId).value;
        }

        /**
         * @param {external:String} val The input element's new value.
         * @ignore
         */
        ,
        set: function set(val) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getFullDataWithOverrides(compId);
            var compType = members._type.get(this).compType;
            var value = (0, _valueSanitzationAlgorithm2.default)(compData, val);
            var isValid = (0, _validation.validate)(compType, 'value', { value: value });

            if (!isValid) {
                return;
            }

            RMI.setData(compId, { value: value });
        }
    }]);

    return Switch;
}(_FormElement3.default);

exports.default = Switch;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _fieldTypeOperatorTyp;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reduce = __webpack_require__(125);

var _reduce2 = _interopRequireDefault(_reduce);

var _forEach = __webpack_require__(46);

var _forEach2 = _interopRequireDefault(_forEach);

var _filter = __webpack_require__(117);

var _filter2 = _interopRequireDefault(_filter);

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _set = __webpack_require__(37);

var _set2 = _interopRequireDefault(_set);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _omit = __webpack_require__(64);

var _omit2 = _interopRequireDefault(_omit);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

var _isUndefined = __webpack_require__(30);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _isFunction = __webpack_require__(29);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _map = __webpack_require__(20);

var _map2 = _interopRequireDefault(_map);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

var _Utils = __webpack_require__(25);

var Utils = _interopRequireWildcard(_Utils);

var _Link = __webpack_require__(56);

var _Link2 = _interopRequireDefault(_Link);

var _gridEnums = __webpack_require__(127);

var _gridEnums2 = _interopRequireDefault(_gridEnums);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(1);

var _utils = __webpack_require__(9);

var _every = __webpack_require__(35);

var _every2 = _interopRequireDefault(_every);

var _isObject = __webpack_require__(14);

var _isObject2 = _interopRequireDefault(_isObject);

var _imageUtils = __webpack_require__(39);

var _imageUtils2 = _interopRequireDefault(_imageUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function processRowLinks(rows, columnDefs, linksTarget) {
    var linkPaths = (0, _reduce2.default)(columnDefs, function (links, columnDef) {
        if (columnDef.linkPath) {
            links.push(columnDef.linkPath);
        }
        return links;
    }, []);
    if (linkPaths.length > 0) {
        (0, _map2.default)(rows, function (row) {
            (0, _forEach2.default)(linkPaths, function (linkPath) {
                var url = (0, _get2.default)(row, linkPath);
                var linkData = void 0;
                try {
                    var link = new _Link2.default(url, linksTarget);
                    linkData = link.getData();
                } catch (ex) {
                    if (!(0, _isEmpty2.default)(url)) {
                        _reporter2.default.reportSdkError('Error: couldn\'t process link with url "' + url + '": ' + ex.message);
                    }
                    linkData = {};
                } finally {
                    var linkObjPath = linkPath + '_linkObj';
                    (0, _set2.default)(row, linkObjPath, linkData);
                }
            });
        });
    }
    return rows;
}

function processRowImageURIs(rows, columnDefs) {
    var imageColumns = (0, _filter2.default)(columnDefs, function (_ref) {
        var type = _ref.type;
        return type === _gridEnums2.default.FieldType.IMAGE;
    });
    (0, _forEach2.default)(imageColumns, function (columnDef) {
        (0, _forEach2.default)(rows, function (row) {
            var src = (0, _get2.default)(row, columnDef.dataPath);
            if (!(0, _isNil2.default)(src)) {
                var imageData = _imageUtils2.default.extractModelDataFromSrc(src);
                if (!(0, _isNil2.default)(imageData)) {
                    (0, _set2.default)(row, columnDef.dataPath, imageData);
                }
            }
        });
    });
    return rows;
}

function validateDates(rows, columnDefs) {
    var dateColumns = (0, _filter2.default)(columnDefs, { type: _gridEnums2.default.FieldType.DATE });
    (0, _forEach2.default)(dateColumns, function (columnDef) {
        (0, _forEach2.default)(rows, function (row) {
            var dateValue = (0, _get2.default)(row, columnDef.dataPath);
            if (!(0, _isNil2.default)(dateValue)) {
                var date = new Date(dateValue);
                if (isNaN(date)) {
                    _reporter2.default.reportSdkError('Error: Invalid date: "' + dateValue + '" in column \'"' + columnDef.dataPath + '"\'');
                }
            }
        });
    });
}

function executeModificationRowBehaviour(delta) {
    var RMI = members._RMI.get(this);
    var compId = members._compId.get(this);
    RMI.executeCompBehavior(compId, 'modifyRow', delta);
}

function _processData(rows, columnDefs, linksTarget) {
    validateDates(rows, columnDefs);
    var processedRows = processRowLinks(rows, columnDefs, linksTarget);
    processedRows = processRowImageURIs(rows, columnDefs);
    return processedRows;
}

function dataFetchHandler(RMI) {
    return function (e) {
        var compId = e.syntheticEvent.id;
        var compData = RMI.getData(compId);
        var rowRetrievalFunc = (0, _get2.default)(compData, 'dataFetchHandlers');
        if (!(0, _isFunction2.default)(rowRetrievalFunc)) {
            return;
        }
        rowRetrievalFunc(e.syntheticEvent.startRow, e.syntheticEvent.endRow, e.syntheticEvent.sorting, e.syntheticEvent.filter).then(function (data) {
            var props = RMI.getProps(compId);
            var pageRows = _processData(data.pageRows, props.columns, props.linkTarget);
            var prevNumberOfRows = RMI.getData(compId).numberOfDisplayedRows;
            var currNumberOfRows = props.pagination.type === _gridEnums2.default.PaginationType.PAGES ? pageRows.length : prevNumberOfRows;
            RMI.setData(compId, {
                rows: pageRows,
                rowsCount: data.totalRowsCount,
                numberOfDisplayedRows: currNumberOfRows,
                revision: Date.now()
            });
        });
    };
}

/**
 * @class Table
 * @summary A table for displaying data.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.ClickableMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.Grid
 */

var Table = function (_Element) {
    _inherits(Table, _Element);

    function Table(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, Table);

        var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(Table.prototype, _HiddenCollapsedMixin2.default.prototype);
        (0, _mixin2.default)(Table.prototype, _ClickableMixin2.default.prototype);
        return _this;
    }

    _createClass(Table, [{
        key: 'getDataSourceType',


        // METHODS

        value: function getDataSourceType() {
            return (0, _get2.default)(Utils.getData(this, 'dataSource'), 'type');
        }

        // PROPERTIES:

        /*  REMOVED FROM SDK FOR PLATFORM 1.0
         Leeron Shalev indicated that `sorting` is not going to be included in "the first release"
         * @typedef {external:Object} $w.Table~SortParam
         * @summary An object used by the `sorting` property that contains one set of sorting parameters.
         * @property {external:String} colId The [column]($w.Table~Column) ID to sort
         * @property {ASC|DSC|NONE} direction The sorting direction
         * @see [sorting](#sorting)
         */

        /*  REMOVED FROM SDK FOR PLATFORM 1.0
         Leeron Shalev indicated that `sorting` is not going to be included in "the first release"
         * @member {$w.Table~SortParam[]} sorting
         * @label property
         * @syntax
         * let tableSortParams = $w("#myTable").sorting;
         * $w("#myTable").sorting = tableSortParams;
         * @summary Sets the parameters being used to sort the specified table, or returns the existing sort parameters.
         * @description The `sorting` property is composed of an array of {@link $w.Table~SortParam|`SortParam[]`} objects.
         *  The order of the objects in the array determines the order in which the columns are sorted. ___Not clear if
         *  the first object in the array is sorted last or first i.e. is the primary sort key or the least significant sort key___
         * @note When setting the filter, if the `fieldType` or `operator` provided in [tableFilterParams]($w.Table~FilterParam)
         *  is not valid, an error is printed to the console.
         * @memberof $w.Table
         * @instance
         */

    }, {
        key: 'refresh',


        // METHODS:

        /**
         * @function refresh
         * @syntax
         * function refresh(): void
         * @summary Fetches the most current data and updates the table.
         * @snippet [Table-refresh.es6=Refresh a table]
         * @memberof $w.Table
         */
        value: function refresh() {
            var type = this.getDataSourceType();
            if ((0, _isUndefined2.default)(type)) {
                _reporter2.default.reportSdkError('Error: (Table.refresh) no data source is set');
                return;
            }
            Utils.setData(this, { dataSource: {
                    type: type,
                    revision: Date.now()
                } });
        }

        /**
         * @function onDataChange
         * @syntax
         * function onDataChange(handler: DataChangeEventHandler): void
         * callback DataChangeEventHandler(event: DataChangeEvent, $w: Function): void
         * @summary Adds an event handler that runs when the table's data is changed.
         * @description
         *  A table receives a `dataChange` event when the table's data is changed
         *  using the [`rows`](#rows) property or a data request triggers the
         *  [`onDataRequest` handler](#onDataRequest).
         * @param {$w.EventHandler} eventHandler The name of the function or
         *  the function expression to run when the table's data is changed.
         * @memberof $w.Table
         * @eventtype dataChange
         * @eventhandler
         */

    }, {
        key: 'onDataChange',
        value: function onDataChange(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'onDataChange', { onDataChange: cb })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            return Utils.onEvent(this, RMI.getEventTypes().DATA_CHANGE, cb);
        }

        /**
         * @function onCellSelect
         * @syntax
         * function onCellSelect(handler: TableCellEventHandler): Table
         * callback TableCellEventHandler(event: TableCellEvent, $w: Function): void
         * @summary Adds an event handler that runs when a table cell is selected.
         * @description
         *  A table receives a [`TableCellEvent`]($w.TableCellEvent.html) when the
         *  table is set [set](https://support.wix.com/en/article/table-settings) in
         *  the Editor to select cells when clicked.
         * ![Clicking Selects Cells](images/table_settings_click_cells.png "Clicking Selects Cells")
         * @snippet [TableCellEvent-all.es6=Get the selected table cell information]
         * @param {$w.TableCellEventHandler} eventHandler The name of the function or
         *  the function expression to run when the cell is selected.
         * @returns {$w.Table} The table that triggered the event.
         * @memberof $w.Table
         * @eventtype cellSelect
         * @eventhandler
         */

    }, {
        key: 'onCellSelect',
        value: function onCellSelect(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'onCellSelect', { onCellSelect: cb })) {
                return this;
            }
            var RMI = members._RMI.get(this);
            return Utils.onEvent(this, RMI.getEventTypes().CELL_SELECT, cb);
        }

        /**
         * @function onRowSelect
         * @syntax
         * function onRowSelect(handler: TableRowEventHandler): Table
         * callback TableRowEventHandler(event: TableRowEvent, $w: Function): void
         * @summary Adds an event handler that runs when a table row is selected.
         * @description
         *  A table receives a [`TableRowEvent`]($w.TableRowEvent.html) when the
         *  table is set [set](https://support.wix.com/en/article/table-settings) in
         *  the Editor to select rows when clicked.
         * ![Clicking Selects Rows](images/table_settings_click_rows.png "Clicking Selects Rows")
         * @snippet [TableRowEvent-all.es6=Get the selected table cell information]
         * @snippet [TableRowEvent-rowData_dataset.es6=Get the full item information from the dataset]
         * @param {$w.TableRowEventHandler} eventHandler The name of the function or
         *  the function expression to run when the row is selected.
         * @returns {$w.Table} The table that triggered the event.
         * @memberof $w.Table
         * @eventtype rowSelect
         * @eventhandler
         */

    }, {
        key: 'onRowSelect',
        value: function onRowSelect(cb) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'onRowSelect', { onRowSelect: cb })) {
                return;
            }
            var RMI = members._RMI.get(this);
            return Utils.onEvent(this, RMI.getEventTypes().ROW_SELECT, cb);
        }

        /**
         * @function selectRow
         * @syntax
         * function selectRow(index: Number): void
         * @summary Selects a table row by index.
         * @param {external:Number} index The number of the row to select.
         * @description
         *  The rows in a table are zero-based and do not include the table header.
         *  ![Table Row Numbering](images/table_row.png "Table Row Numbering")
         * @snippet [Table-selectRow.es6=Select the table's first row]
         * @memberof $w.Table
         */

    }, {
        key: 'selectRow',
        value: function selectRow(index) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'selectRow', { rowIndex: index })) {
                return this;
            }
            if (!(0, _validation.validateRange)('selectRow', 'rowIndex', index, 0, this.rows.length - 1)) {
                return this;
            }
            RMI.executeCompBehavior(compId, 'modifySelection', { userSelection: { rowIndex: index } });
        }

        /**
         * @function updateRow
         * @syntax
         * function updateRow(index: Number, rowData: Object) : void
         * @summary Updates a the row data of a single row at the specified index.
         * @param {external:Number} index The number of the row to update.
         * @param {external:Object} rowData A row data object of field_name:value pairs where the keys are the table columns.
         * @description
         *  The rows in a table are zero-based and do not include the table header.
         *  ![Table Row Numbering](images/table_row.png "Table Row Numbering")
         * @snippet [Table-updateRow.es6=Update the table's first row]
         * @snippet [Table-updateRow-scenario.es6=Update the table's first row]
         * @memberof $w.Table
         */

    }, {
        key: 'updateRow',
        value: function updateRow(index, rowData) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'updateRow', { rowIndex: index, row: rowData })) {
                return this;
            }

            var type = this.getDataSourceType();
            if (type === _gridEnums2.default.DataSourceType.DYNAMIC) {
                executeModificationRowBehaviour.call(this, {
                    rowDataDelta: {
                        revision: Date.now(),
                        index: index,
                        op: _gridEnums2.default.RowModification.UPDATE,
                        data: rowData
                    }
                });
            } else {
                var rowsData = Utils.getData(this, 'rows');
                rowsData.splice(index, 1, rowData);
                Utils.setData(this, {
                    dataSource: { type: _gridEnums2.default.DataSourceType.STATIC, revision: Date.now() },
                    rows: rowsData,
                    revision: Date.now()
                });
            }
        }
    }, {
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                sorting = this.sorting,
                filter = this.filter,
                pagination = this.pagination,
                columns = this.columns,
                rows = this.rows;

            return { id: id, type: type, global: global, rendered: rendered, sorting: sorting, filter: filter, pagination: pagination, columns: columns, rows: rows };
        }
    }, {
        key: 'sorting',
        get: function get() {
            return Utils.getProp(this, 'sorting');
        }

        // param [{colId: String, sort: SortDirection}] sortDef
        /**
         * @ignore
         */
        ,
        set: function set(sortDef) {
            var directions = (0, _map2.default)(_gridEnums2.default.SortDirection);
            var compType = members._type.get(this).compType;
            var isArrayValid = (0, _validation.validate)(compType, 'sorting', { sorting: sortDef });
            if (!isArrayValid) {
                return;
            }
            var allItemsFromEnum = true;

            (0, _forEach2.default)(sortDef, function (colSort, index) {
                if (!(0, _isObject2.default)(colSort) || !(0, _validation.validateValueFromEnum)('sorting', 'sortDef', colSort.sort, directions, index)) {
                    allItemsFromEnum = false;
                }
            });

            if (!allItemsFromEnum) {
                return;
            }
            Utils.setProp(this, { sorting: sortDef });
        }

        /*  REMOVED FROM SDK FOR PLATFORM 1.0
         Leeron Shalev indicated that `filter` is not going to be included in "the first release"
         * @typedef {external:Object} $w.Table~FilterParam
         * @summary An object used by the `filter` property that contains one set of filter parameters.
         * @property {STRING|NUMBER|DATE|IMAGE|BOOLEAN|RICH_TEXT} fieldType The data type of the field to be filtered. ___Not sure about this...___
         * @property {$w.Table~StringOperator|$w.Table~NumericOperator|$w.Table~DateOperator} operator
         *  The comparison operator to use, such as ENDS_WITH or GREATER_THAN.
         * @property {external:String|external:Number|external:Date} value The value used for the comparison.
         * @see [filter](#filter)
         */

        /*  REMOVED FROM SDK FOR PLATFORM 1.0
         Leeron Shalev indicated that `filter` is not going to be included in "the first release"
         * @member {$w.Table~FilterParam} filter
         * @label property
         * @syntax
         * let tableFilterParams = $w("#myTable").filter;
         * $w("#myTable").filter = tableFilterParams;
         * @summary Sets the parameters being used to filter the specified table, or returns the existing filter parameters.
         * @description ___I'm not sure if by setting this you actually execute the filtering of a table, but it would seem so___
         * @note When setting the filter, if the `fieldType` or `operator` provided in [tableFilterParams]($w.Table~FilterParam) is
         *  not valid, an error is printed to the console.
         * @memberof $w.Table
         * @instance
         */

    }, {
        key: 'filter',
        get: function get() {
            return Utils.getProp(this, 'filter');
        }

        // param {columnId: {type: Enums.FieldType, operator: Table.StringOperator|Table.NumberOperator|Table.DateOperator}} filter
        /**
         * @ignore
         */
        ,
        set: function set(filter) {
            var fieldTypes = (0, _map2.default)(_gridEnums2.default.FieldType);
            var compType = members._type.get(this).compType;
            var isObj = (0, _validation.validate)(compType, 'filter', { filter: filter });
            if (!isObj) {
                return;
            }
            var isValid = true;
            (0, _forEach2.default)((0, _map2.default)(filter), function (currentFilter) {
                if (!(0, _validation.validateValueFromEnum)('filter', 'filter', currentFilter.type, fieldTypes)) {
                    isValid = false;
                    return;
                }
                var operatorType = fieldTypeOperatorTypeMapping[currentFilter.type];
                if (!(0, _validation.validateValueFromEnum)('filter', 'filter', currentFilter.operator, (0, _map2.default)(_gridEnums2.default.filtering[operatorType]))) {
                    isValid = false;
                }
            });
            if (!isValid) {
                return;
            }

            Utils.setProp(this, { filter: filter });
        }

        /**
         * @typedef {external:Object} $w.Table~PaginationParam
         * @summary An object used by the `pagination` property that
         * contains the pagination parameters which determine if and how the table
         * is paginated.
         * @description
         * The table can paginate in three ways:
         *  + `"normal"`: No pagination. The table is scrollable if there are more
         *    rows than can be displayed at once. All data is fetched at once.
         *  + `"pagination"`: The data is separated into pages which are navigatable
         *    using paging buttons. New data is fetched when a user clicks on a
         *    paging button.
         *  + `"virtual"`: The data is separated into pages which are navigated by
         *    scrolling. New data is fetched when user a user scrolls below the
         *    displayed rows.
         * @property {external:String} type The type of pagination to use: `"normal"`, `"pagination"`, or `"virtual"`.
         * @property {external:Number} rowsPerPage The number of rows per page.
         * @snippet [Table-pagination_get.es6=Get the table's pagination parameters]
         * @snippet [Table-pagination_set.es6=Set the table's pagination parameters]
         * @see [pagination](#pagination)
         */

        /**
         * @member {$w.Table~PaginationParam} pagination
         * @label property
         * @syntax
         * set pagination(): PaginationParam
         * get pagination(value: PaginationParam): void
         * @summary Sets or gets the table's pagination parameters.
         * @description
         *  Setting the `pagination` property sets the table's
         *  [pagination parameters](#PaginationParam) and changes the way the table
         *  is paginated.
         *
         *  Getting the `pagination` property returns the table's
         *  current [pagination parameters](#PaginationParam).
         * @snippet [Table-pagination_get.es6=Get the table's pagination parameters]
         * @snippet [Table-pagination_set.es6=Set the table's pagination parameters]
         * @memberof $w.Table
         * @instance
         */

    }, {
        key: 'pagination',
        get: function get() {
            return (0, _omit2.default)(Utils.getProp(this, 'pagination'), ['manualHeightProps']);
        }

        /**
         * @ignore
         */
        ,
        set: function set(pagination) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'pagination', { pagination: pagination }, true)) {
                return;
            }
            Utils.setProp(this, { pagination: pagination });
        }

        /**
         * @typedef {external:Object} $w.Table~Column
         * @summary An object used by the `columns` property that
         *  contains the properties that define a table column. Table columns do not
         *  store any data.
         * @property {external:String} id The column ID.
         * @property {external:String} dataPath The location of the data displayed
         *  in the column.
         *
         *  When the table is populated by a connection to a dataset, the `dataPath`
         *  value is a field key from the collection that the dataset is connected to.
         *
         *  When the table is populated by using the [`rows`](#rows) or
         *  [`dataFetcher`](#dataFetcher) properties, the `dataPath` value is one of the
         *  property keys from the table's row objects.
         * @property {external:String} label The column header label.
         * @property {external:String} type The type of data in this column: `"number"`, `"string"`, `"date"`, `"image"`, `"bool"`, or `"richText"`.
         * @property {external:Number} [width] The pixel width of the column.
         * @property {external:Boolean} [visible] Whether the column is visible.
         * @property {external:String} [linkPath] The location of the links used when
         *  the items in the column are clicked.
         *
         *  When the table is populated by a connection to a dataset, the `linkPath`
         *  value is a field key from the collection that the dataset is connected to.
         *  The collection field can be a [regular field](https://support.wix.com/en/article/about-database-collections#regular-fields)
         *  that contains URLs or a [calculated field](https://support.wix.com/en/article/about-database-collections#calculated-fields)
         *  that contains relative links to dynamic pages.
         *
         *  When the table is populated by using the [`rows`](#rows) or
         *  [`dataFetcher`](#dataFetcher) properties, the `linkPath` value is one of the
         *  property keys from the table's rows objects.
         *  The property values associated with that key contain URLs or relative links.
         * @snippet [Table-columns_get.es6=Get the list of columns and the first columns's information]
         * @snippet [Table-columns_set.es6=Set the list of columns for a table]
         * @snippet [Table-columns_set_data.es6=Set the columns, data, and links for a table]
         *  This example sets the columns of the table using the table's `columns`
         *  property. The items in the first column are linked using the URLs found
         *  in the `wikiLink` property of the table data. It then populates a table
         *  with static data using the table's `rows` property.
         * @see [columns](#columns)
         */

        /**
         * @member columns
         * @label property
         * @syntax
         * set columns(): Column[]
         * get columns(value: Column[]): void
         * @summary Sets or gets the defining properties of the columns in a table.
         * @description
         *  Table [columns](#Column) do not store any data. They contain the
         *  properties, such as the `label` and `type`, that define a table column.
         *
         *  Setting the `columns` property sets the [columns](#Column)
         *  in the table.
         *
         *  Getting the `columns` property returns the current
         *  list of [columns](#Column) in the table.
         *
         *  You cannot modify the data array in-place. To add, change, or remove
         *  individual columns:
         *    1. Store the value of the `columns` property in a variable.
         *    1. Make changes to the columns array.
         *    1. Reset the `columns` property with the modified array.
         * @snippet [Table-columns_get.es6=Get the list of columns and the first columns's information]
         * @snippet [Table-columns_set.es6=Set the list of columns for a table]
         * @snippet [Table-add.es6=Add a column to a table]
         *  This example retrieves the columns of a table, adds a new column, and
         *  then overwrites the old options.
         * @type {$w.Table~Column[]}
         * @memberof $w.Table
         * @instance
         */

    }, {
        key: 'columns',
        get: function get() {
            return Utils.getProp(this, 'columns');
        }

        /**
         * @param {external:Object} columns
         * @ignore
         */
        ,
        set: function set(columns) {
            var compType = members._type.get(this).compType;
            var isArrayValid = (0, _validation.validate)(compType, 'columns', { columns: columns });
            if (!isArrayValid) {
                return;
            }
            var arrItemsArrValid = (0, _every2.default)(columns, function (v, i) {
                return (0, _validation.validate)(compType, 'columns', { column: v }, true, i);
            });
            if (!arrItemsArrValid) {
                return;
            }
            columns = (0, _utils.nullIfNil)(columns) ? columns : [];
            Utils.setProp(this, {
                columns: (0, _map2.default)(columns, function (column) {
                    // Set column.visible to true by default
                    return (0, _assign2.default)({ visible: true }, column);
                })
            });
        }

        /* Taken out of docs in change back to dataFetcher property
         * @typedef {external:Object} $w.Table~RequestedData
         * @summary An object return by the handler set by the `onDataRequest` function.
         * @property {external:Object[]} pageRows An array of row data objects with field_name:value pairs.
         * @property {external:Number} totalRowsCount The number of total rows in all pages.
         * @snippet [Table-onDataRequest_set.es6=Set the function that fetches more data]
         * @snippet [Table-onDataRequest-scenario.es6=Fetch data from a static array]
         * @see [onDataRequest](#onDataRequest)
         */

        /* Taken out of docs in change back to dataFetcher property
         * @callback $w.DataRequestHandler
         * @summary Function that runs when a new page of table data is to be displayed.
         * @param {external:Number} startRow The index of the first row to get.
         * @param {external:Number} endRow The index after the last row to get.
         * @returns {Promise}
         * @fulfill {$w.Table~RequestedData} A row data object with field_name:value pairs.
         */

        /**
         * @member dataFetcher
         * @label property
         * @syntax
         * get dataFetcher: function
         * set dataFetcher(rowRetrievalFunction: function): void
         * @summary Sets the function that will be called when a new page of table data is to be displayed.
         * @description
         *  The `dataFetcher` property is typically used when you are populating
         *  your table with data from an external (non-Wix) data source. You set it
         *  to a function that fetches the data to display.
         *
         *  The function that runs to fetch a new page of data must conform to the
         *  following structure:
         *
         *    ```javascript
         *    function rowRetrievalFunction(startRow, endRow) {
         *      return new Promise( (resolve, reject) => {
         *        // Data retrieval code here
         *        if( retrievalSuccess ) {
         *          resolve( {
         *            pageRows: fetchedRows,
         *            totalRowsCount: numRows
         *          } );
         *        }
         *        else {
         *          reject();
         *        }
         *      } );
         *    }
         *    ```
         *
         *  Meaning, your function must:
         *    + Take in two parameters:
         *        + `startRow` the index of the first row to get
         *        + `endRow` the index after the last row to get
         *    + Return a Promise which:
         *        + Either resolves to an object with the following properties:
         *            + `pageRows` is an array of column:value row data
         *            + `totalRowsCount` is the number of total rows in all pages
         *        + Or rejects
         *
         *
         *
         *  Another way of populating your table with data programmatically is to
         *  use the [`rows`](#rows) property.
         * @snippet [Table-dataFetcher_set.es6=Set the function that fetches more data]
         * @snippet [Table-dataFetcher-scenario.es6=Fetch data from a static array]
         *  This example stores row data in a static array and uses `dataFetcher`
         *  to set the `getRows` function as the function to run when the table
         *  needs new data. The example assumes you have a table with ID `myTable`
         *  that contains two fields, `name` (type Text) and `num` (type Number).
         * @memberof $w.Table
         * @instance
         * @see [rows](#rows)
         */

    }, {
        key: 'dataFetcher',
        set: function set(rowRetrievalFunc) {
            var compType = members._type.get(this).compType;
            if (!(0, _isNil2.default)(rowRetrievalFunc) && !(0, _validation.validate)(compType, 'dataFetcher', { dataFetcherCallback: rowRetrievalFunc })) {
                return this;
            }

            var RMI = members._RMI.get(this);
            var fetchDataEvent = RMI.getEventTypes().FETCH_DATA;

            Utils.setDataWithoutUpdate(this, { dataFetchHandlers: rowRetrievalFunc });
            var componentEvents = Utils.getEvents(this);
            var filteredBehaviors = (0, _filter2.default)(componentEvents, { eventType: fetchDataEvent });
            if ((0, _isEmpty2.default)(filteredBehaviors)) {
                Utils.onEvent(this, fetchDataEvent, dataFetchHandler(RMI));
            }

            Utils.setData(this, {
                numberOfDisplayedRows: 0,
                dataSource: { type: _gridEnums2.default.DataSourceType.DYNAMIC, revision: Date.now() }
            });
            if (this.pagination.type === _gridEnums2.default.PaginationType.NONE) {
                this.pagination = (0, _assign2.default)(this.pagination, { type: _gridEnums2.default.PaginationType.SCROLL });
            }
        },
        get: function get() {
            return Utils.getData(this, 'dataFetchHandlers');
        }

        /**
         * @member {external:Object[]} rows
         * @label property
         * @syntax
         * get rows(): Object[]
         * set rows(value: Object[]): void
         * @summary Sets or gets the table's row data.
         * @description
         *  Setting the `rows` property sets the data of the table's rows. A table's
         *  data is stored as an array of objects where each object represents a row
         *  in the table.
         *
         *  The objects are composed of `"key":"value"` pairs where:
         *  + `key` is:
         *    + A table column **Field Name** if the columns were set in the Editor
         *      using the **Manage Table** panel.
         *    + A [table column](#Column) `dataPath` if the columns were set in code
         *      using the [`columns`](#columns) property.
         *  + `value` is the value to be placed in that table column for the current row.
         *
         *
         *  For example, a simple array of table data may look like this:
         *  ```
         *  [
         *    {
         *      "firstName": "John",
         *      "lastName": "Doe",
         *      "email": "john.doe@somedomain.com",
         *      "image": "http://someImageUrl/john.jpg"
         *    },
         *    {
         *      "firstName": "Jane",
         *      "lastName": "Doe",
         *      "email": "jane.doe@somedomain.com",
         *      "image": "http://someImageUrl/jane.jpg"
         *    }
         *  ]
         *  ```
         *
         *  If the `rows` array contains objects with values whose keys are not
         *  table columns, those values will not appear in the table. For example,
         *  assuming the `rows` array shown above, if the table does not have an
         *  **email** column, the email values will not appear in the table.
         *
         *  Set `rows` to an empty array (`[]`) to remove the current rows.
         *
         *  Getting the `rows` property returns the current list of
         *  the table's row data. If the table is connected to a dataset, `rows`
         *  does not include the fields from the dataset items that are not
         *  connected to table columns.
         *
         *  To update an individual table row, use the [`updateRow()`](#updateRow)
         *  function.
         *
         *  To add or remove individual table rows:
         *    1. Store the value of the `rows` property in a variable.
         *    1. Apply standard JavaScript array operators to the rows array.
         *    1. Reset the `rows` property with the new array.
         *
         *
         *  To set a table's row data based on a [`query`](wix-data.html#query)
         *  you perform using the [`wix-data`](wix-data.html) API:
         *  1. Set the columns of the table in the Editor using the **Manage Table**
         *     panel or in code using the [`columns`](#columns) property to include
         *     the collection fields you want to display.
         *  1. Execute a [`query()`](wix-data.html#query) using the [`find()`]
         *     function.
         *  1. Set the tables `rows` to the [`items`](wix-data.WixDataQueryResult.html#items)
         *     of the query's [results](wix-data.WixDataQueryResult.html).
         *
         *
         *  Note that you can optionally add to, remove from, or modify the data
         *  returned from the query before using it to set the table's row data.
         * @snippet [Table-rows_get.es6=Get a table's row data]
         * @snippet [Table-rows_set.es6=Set a table's row data]
         * @snippet [Table-rows-add.es6=Add a row to a table]
         *  This example retrieves the rows of a table, adds a new row, and then
         *  overwrites the old rows.
         * @snippet [Table-rows_scenario-array.es6=Set a table's row data from an array]
         * @snippet [Table-rows_scenario-query.es6=Set a table's row data from a query]
         * @snippet [Table-rows_scenario-query-plus.es6=Set a table's row data from a query]
         *  This example populates a table that displays information about documents
         *  that are stored in a collection and allows users to download each document
         *  by clicking a link in the table.
         *
         *  When the page is loaded, we first set the columns of the table to match
         *  the fields of the collection that contains the documents, excluding the
         *  field that contains the actual document. We also create one additional
         *  column whose value is not taken from the collection. The values users
         *  will see in that column are set later, but the links are set to take
         *  their URLs from a collection field.
         *
         *  Then a query is executed to retrieve information from the collection.
         *  Before setting the query results to be the table's row data, we add a
         *  property and value to each retrieved item. These are the values that will
         *  be populated in the additional column that was created earlier.
         * @memberof $w.Table
         * @instance
         */

    }, {
        key: 'rows',
        set: function set(data) {
            var compType = members._type.get(this).compType;
            var isArrayValid = (0, _validation.validate)(compType, 'rows', { rows: data });
            if (!isArrayValid) {
                return;
            }
            var arrItemsArrValid = (0, _every2.default)(data, function (v, i) {
                return (0, _validation.validate)(compType, 'rows', { row: v }, true, i);
            });
            if (!arrItemsArrValid) {
                return;
            }
            data = (0, _utils.nullIfNil)(data) ? data : [];
            var linksTarget = Utils.getProp(this, 'linkTarget');
            var rowsData = _processData(data, this.columns, linksTarget);
            Utils.setData(this, {
                dataSource: { type: _gridEnums2.default.DataSourceType.STATIC, revision: Date.now() },
                rows: rowsData,
                revision: Date.now(),
                numberOfDisplayedRows: rowsData.length
            });
        },
        get: function get() {
            return Utils.getData(this, 'rows');
        }
    }], [{
        key: 'processData',
        value: function processData(rows, columnDefs, linksTarget) {
            return _processData(rows, columnDefs, linksTarget);
        }
    }]);

    return Table;
}(_Element3.default);

var fieldTypeOperatorTypeMapping = (_fieldTypeOperatorTyp = {}, _defineProperty(_fieldTypeOperatorTyp, _gridEnums2.default.FieldType.STRING, 'StringOperator'), _defineProperty(_fieldTypeOperatorTyp, _gridEnums2.default.FieldType.NUMBER, 'NumericOperator'), _defineProperty(_fieldTypeOperatorTyp, _gridEnums2.default.FieldType.DATE, 'DateOperator'), _fieldTypeOperatorTyp);

exports.default = Table;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _utils = __webpack_require__(9);

var _find = __webpack_require__(62);

var _find2 = _interopRequireDefault(_find);

var _flow = __webpack_require__(118);

var _flow2 = _interopRequireDefault(_flow);

var _escape = __webpack_require__(186);

var _escape2 = _interopRequireDefault(_escape);

var _unescape = __webpack_require__(426);

var _unescape2 = _interopRequireDefault(_unescape);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _idGenerator = __webpack_require__(222);

var _idGenerator2 = _interopRequireDefault(_idGenerator);

var _platformUtils = __webpack_require__(13);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _linkGenerator = __webpack_require__(65);

var _linkGenerator2 = _interopRequireDefault(_linkGenerator);

var _validation = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//regex taken from santa/htmlParser
var startTagRegex = '<([-A-Za-z0-9_?:]+)((?:\\s+(?:x:)?[-A-Za-z0-9_]+(?:\\s*=\\s*(?:(?:"[^"]*")|(?:\'[^\']*\')|[^>\\s]+))?)*)\\s*(/?)>';
var endTagRegex = '</([-A-Za-z0-9_?:]+)[^>]*>';
var endBlockTagRegex = '</(h[1-6]|p)[^>]*>';

function indexOfEndOfFirstTextNode(htmlStr) {
    var regexOpenOrCloseTag = '((' + startTagRegex + ')|(' + endTagRegex + '))';
    var regex = new RegExp('.*?' + regexOpenOrCloseTag + '[^<]+');
    var matched = htmlStr.match(regex);
    return matched ? matched[0].length : -1;
}

function removeTextNodesAfter(htmlStr, startIndex) {
    var strStart = htmlStr.substring(0, startIndex);
    var strEnd = htmlStr.substring(startIndex, htmlStr.length);
    var regexDefinition = '((' + startTagRegex + ')|(' + endTagRegex + '))[^<]+';
    var regex = new RegExp(regexDefinition, 'g');
    return strStart + strEnd.replace(regex, '$1');
}
function removeEmptyTags(htmlStr) {
    var regex = new RegExp(startTagRegex + endTagRegex);
    while (regex.test(htmlStr)) {
        htmlStr = htmlStr.replace(regex, '');
    }
    return htmlStr;
}
function removeSelfClosingTags(htmlStr) {
    return htmlStr.replace(/<\/?(|area|base|br|col|command|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)\s*\/?>/mg, '');
}

function convertOneTextNodeHtml(htmlStr) {
    htmlStr = removeSelfClosingTags(htmlStr).replace(/\n/g, '').replace(/<span class="wixGuard">([^<]*)<\/span>/g, '$1');
    var idx = indexOfEndOfFirstTextNode(htmlStr);
    if (idx === -1) {
        return '<p class="font_8">replaceMe</p>';
    }
    htmlStr = removeTextNodesAfter(htmlStr, idx);
    return removeEmptyTags(htmlStr);
}

function replaceTextNodeContents(htmlStr, newText) {
    var regex = new RegExp('(' + startTagRegex + ')[^<]+');
    return htmlStr.replace(regex, function (matched, g1) {
        return g1 + newText;
    });
}

function getTarget(str) {
    if (!str) {
        return;
    }
    var res = str.match(/target=(?:['"])(.*)(?:['"])/);
    return res && res[1];
}
function convertToTextComponentData(compId, htmlStr) {
    var links = [];
    var linkRegexp = /<a(.*?)href=['"](.*?)["'](.*?)>(.*?)<\/a>/g;
    var textData = htmlStr.replace(linkRegexp, function (matched, g1, urlGroup, g3, linkTextGroup) {
        var target = getTarget(g1) || getTarget(g3) || undefined;
        var linkData = _linkGenerator2.default.convertLinkToModelFormatAndReportIfError(urlGroup, target, 'html', undefined, htmlStr);

        if ((0, _isNil2.default)(linkData)) {
            return linkTextGroup;
        }

        linkData.id = _idGenerator2.default.generateId(compId + '_runtime_');
        links.push(linkData);
        return '<a' + g1 + 'dataquery="#' + linkData.id + '"' + g3 + '>' + linkTextGroup + '</a>';
    });
    return {
        text: textData,
        linkList: links
    };
}

function convertLinkForGetHtml() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var linkRegexp = /<a(.*?)dataquery="#(.*?)"(.*?)>(.*?)<\/a>/g;

    var text = data.text && data.text.replace(linkRegexp, function (matched, g1, dataQueryId, g3, linkTextGroup) {
        var link = (0, _find2.default)(data.linkList, { id: dataQueryId });
        var linkUrl = _linkGenerator2.default.convertLinkToUrlAndReportIfError(link, undefined, 'html');
        if (!(0, _isNil2.default)(linkUrl)) {
            return '<a' + g1 + 'href="' + linkUrl + '"' + g3 + '>' + linkTextGroup + '</a>';
        }
        return linkTextGroup;
    });
    return text;
}
function removeWixGuard(htmlStr) {
    return htmlStr.replace(/<span class="wixGuard">([^<]*)<\/span>/g, function (matched) {
        var g1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        if (g1.trim() === '&#8203;') {
            return '';
        }
        return g1;
    });
}
/**
 * @class Text
 * @summary Provides functionality for text elements.
 * @classdesc
 *  `Text` type elements contain text which can be formatted using a subset of
 *  standard HTML tags and CSS styles, as detailed below.
 *
 *  <h3 id="formatting-text">Formatting Text</h3>
 *  <h4 id="the-html-subset-supported">Supported HTML Subset</h4>
 *
 *  The supported HTML tags are:
 *  + `<p>`
 *  + `<h1>`, `<h2>`, `<h3>`, `<h4>`, `<h5>`, and `<h6>`
 *  + `<a>`
 *  + `<span>`
 *  + `<ul>`, `<ol>`, and `<li>`
 *  + `<br>`
 *
 *
 *  <h4 id="built-in-text-themes">Text Theme Translation</h4>
 *
 *  Each text theme in the Editor corresponds to a specific set of HTML and CSS attributes:
 *  + **Site Title** — `<h1>`
 *  + **Page Title** — `<h2>`
 *  + **Huge Heading** — `<h3>`
 *  + **Large Heading** — `<h4>`
 *  + **Basic Heading** — `<h5>`
 *  + **Small Heading** — `<h6>`
 *  + **Paragraph 1** — `<p class="p1">`
 *  + **Paragraph 2** — `<p>` or `<p class="p2">`
 *  + **Paragraph 3** — `<p class="p3">`
 *
 *
 *  <h4 id="inline-styling">Inline Styling</h4>
 *
 *  Text elements support inline styling via the `<span>` HTML element. The element can contain the following attributes:
 *  + `style` <br>&nbsp;&nbsp; e.g. `<span style="font-size: 1.5em"></span>`
 *  + `dir` (text direction) <br>&nbsp;&nbsp; e.g. `<span dir="rtl"></span>`
 *
 *
 *  The `style` attribute supports the following properties:
 *
 *  + `font-face`
 *  + `font-size`
 *  + `font-weight`
 *  + `font-style`
 *  + `text-decoration`
 *  + `color`
 *  + `background-color`
 *  + `text-align`
 *  + `margin-left`
 *  + `text-shadow`
 *  + `line-height`
 *  + `letter-spacing`
 *
 *
 *  <h4 id="bullets-and-numbering">Bulleted and Numbered Lists</h4>
 *
 *  Text elements can contain bulleted and numbered lists using standard HTML tags:
 *
 *  + Numbered lists — using `<ol>` and `<li>`
 *  + Bulleted lists — using `<ul>` and `<li>`
 *
 *
 *  <h4 id="links">Links</h4>
 *
 *  You can create links using the standard HTML `<a>` anchor element. Anchor elements support the `href` and `target`
 *  attributes. For example:
 *  <p>`<a href="http://wix.com" target="_blank">Stunning</a>`</p>
 *
 *  The `href` attribute can contain all link types in the [Wix link]($w.LinkableMixin.html#link) format.
 *
 * @see <a href="https://www.wix.com/support/html5/article/customizing-and-saving-text-themes"
 *  target="_blank">Customizing and Saving Text Themes</a>
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.ClickableMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.WRichText
 * @tagname text
 * @defaultcontent {html}
 */

var Text = function (_Element) {
    _inherits(Text, _Element);

    function Text(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, Text);

        var _this = _possibleConstructorReturn(this, (Text.__proto__ || Object.getPrototypeOf(Text)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(Text.prototype, _HiddenCollapsedMixin2.default.prototype);
        (0, _mixin2.default)(Text.prototype, _ClickableMixin2.default.prototype);
        return _this;
    }

    /**
     * @member html
     * @label property
     * @syntax
     * get html(): string
     * set html(value: string): void
     * @summary Sets or gets the contents of a text element using standard HTML.
     * @description
     *  Setting the `html` property sets the text and styling of
     *  the text element. You can use a subset of HTML tags and CSS attributes
     *  as described [above](#formatting-text). Any text that the element
     *  already contained is replaced.
     *
     *  Getting the `html` property returns the element's text, including
     *  HTML tags.
     *
     *  The `html` property maps the Editor's built-in text themes and custom
     *  formatting to HTML and CSS [as described here](#built-in-text-themes).
     *
     *  To set or get the plain, unstyled contents of a text element, use the
     *  [`text`](#text) property instead.
     * @snippet [Text-html_get.es6=Get a text element's HTML content]
     * @snippet [Text-html_set.es6=Set a text element's HTML content]
     * @type {external:String}
     * @see [Formatting Text](#formatting-text)
     * @see [text](#text)
     * @memberof $w.Text
     * @instance
     * @attr {external:String}
     */


    _createClass(Text, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                html = this.html,
                text = this.text;

            return { id: id, type: type, global: global, rendered: rendered, html: html, text: text };
        }
    }, {
        key: 'html',
        get: function get() {
            var richTextUtils = _platformUtils2.default.getRichTextUtils();
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var data = RMI.getData(compId);
            return (0, _flow2.default)([convertLinkForGetHtml, richTextUtils.applyTransformationForGetHtml, removeWixGuard])(data);
        }

        /**
         * @param {external:String} value
         * @ignore
         */
        ,
        set: function set(value) {
            var richTextUtils = _platformUtils2.default.getRichTextUtils();
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)(compType, 'html', { html: value });
            if (!isValid) {
                return;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            value = richTextUtils.applyTransformationForSetHtml((0, _utils.emptyStringIfNil)(value));
            RMI.setData(compId, convertToTextComponentData(compId, value));
            return value;
        }

        /**
         * @member text
         * @label property
         * @syntax
         * get text(): string
         * set text(value: string): void
         * @summary Sets or gets the plain-text contents of a text element.
         * @description
         *  Setting the `text` property sets the plain-text contents of
         *  the text element. Any text that the element already contained is
         *  replaced. The new text is formatted using the formatting that was used
         *  on of the first character of the previous `text` value.
         *
         *  Getting the `text` property returns the plain-text content
         *  of the element, without any HTML tags.
         *
         *  To set or get the HTML contents of a text element, use the
         *  [`html`](#html) property instead.
         * @type {external:String}
         * @default An empty string
         * @snippet [Text-text_get.es6=Get a text element's plain-text content]
         * @snippet [Text-text_set.es6=Set a text element's plain-text content]
         * @see [html](#html)
         * @memberof $w.Text
         * @instance
         * @attr {external:String}
         */

    }, {
        key: 'text',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var data = RMI.getData(compId);
            return data.text && (0, _unescape2.default)(removeWixGuard(data.text).replace(/\n/g, '').replace(/<br><\/br>/g, '\n').replace(/<br\s*\/?>/g, '\n').replace(new RegExp(endBlockTagRegex, 'mg'), '\n').replace(new RegExp(endTagRegex, 'mg'), '').replace(new RegExp(startTagRegex, 'mg'), '').trim());
        }

        /**
         * @param {external:String} value
         * @ignore
         */
        ,
        set: function set(value) {
            var compType = members._type.get(this).compType;
            var isValid = (0, _validation.validate)(compType, 'text', { text: value });
            if (!isValid) {
                return;
            }

            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getFullDataWithOverrides(compId);
            value = (0, _utils.emptyStringIfNil)((0, _escape2.default)(value));
            if (value === '') {
                value = '<span class="wixGuard">&#8203;</span>';
            }
            compData.text = replaceTextNodeContents(convertOneTextNodeHtml(compData.text), value).replace(/\n/g, '<br>');
            RMI.setData(compId, compData);
            return compData.text;
        }
    }]);

    return Text;
}(_Element3.default);

exports.default = Text;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FormElement2 = __webpack_require__(33);

var _FormElement3 = _interopRequireDefault(_FormElement2);

var _StyleMixin = __webpack_require__(28);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

var _DisabledMixin = __webpack_require__(27);

var _DisabledMixin2 = _interopRequireDefault(_DisabledMixin);

var _TextInputMixin = __webpack_require__(143);

var _TextInputMixin2 = _interopRequireDefault(_TextInputMixin);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _FocusMixin = __webpack_require__(32);

var _FocusMixin2 = _interopRequireDefault(_FocusMixin);

var _ReadOnlyMixin = __webpack_require__(96);

var _ReadOnlyMixin2 = _interopRequireDefault(_ReadOnlyMixin);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(1);

var _RequiredMixin = __webpack_require__(41);

var _RequiredMixin2 = _interopRequireDefault(_RequiredMixin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class TextBox
 * @summary An input element for capturing large amounts of text.
 * @mixes $w.FormElement
 * @mixes $w.DisabledMixin
 * @mixes $w.TextInputMixin
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.FocusMixin
 * @mixes $w.ReadOnlyMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.StyleMixin
 * @mixes $w.RequiredMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.inputs.TextAreaInput
 * @tagname textarea
 */
var TextBox = function (_FormElement) {
    _inherits(TextBox, _FormElement);

    function TextBox(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, TextBox);

        var _this = _possibleConstructorReturn(this, (TextBox.__proto__ || Object.getPrototypeOf(TextBox)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(TextBox.prototype, _DisabledMixin2.default.prototype);
        (0, _mixin2.default)(TextBox.prototype, _HiddenCollapsedMixin2.default.prototype);
        (0, _mixin2.default)(TextBox.prototype, _TextInputMixin2.default.prototype);
        (0, _mixin2.default)(TextBox.prototype, _FocusMixin2.default.prototype);
        (0, _mixin2.default)(TextBox.prototype, _ReadOnlyMixin2.default.prototype);
        (0, _mixin2.default)(TextBox.prototype, _ClickableMixin2.default.prototype);
        (0, _mixin2.default)(TextBox.prototype, _StyleMixin2.default.prototype);
        (0, _mixin2.default)(TextBox.prototype, _RequiredMixin2.default.prototype);
        return _this;
    }

    /**
     * @member value
     * @label property
     * @syntax
     * get value(): string
     * set value(value: string): void
     * @summary Sets or gets a text input's value.
     * @description
     *  To reset the text box, restoring any placeholder text, set the value
     *  property to null or undefined.
     *
     * @note
     *  When getting the `value` of a text box in an [`onKeyPress`]($w.TextInputMixin.html#onKeyPress)
     *  event handler, you may receive the value of the element before the key
     *  was pressed. To get the text box's updated value, use the [`updatedTargetValue`]($w.KeyboardEvent.html#updatedTargetValue)
     *  property of the event handler's `event` parameter.
     *
     *  If an element is connected to a dataset, setting the element's `value`
     *  in code does not set the value of the connected field in the dataset.
     *  That means if you use the dataset to perform a submit, the value changed
     *  in code is not reflected in the submitted item.
     *
     *  To submit the new value using a dataset, set the field's value using the
     *  [`setFieldValue()`](wix-dataset.html#setFieldValue) function before
     *  performing the submit.
     * @snippet [FormElement-value_get.es6=Get an element's value]
     * @snippet [FormElement-value_set.es6=Set an element's value]
     * @type {external:String}
     * @memberof $w.TextBox
     * @override
     */

    /**
     * @member wrap
     * @label property
     * @syntax
     * get wrap(): string
     * set wrap(value: string): void
     * @summary Determines if the text will contain line breaks when its value is read.
     * @description
     *  Setting the `wrap` property sets how the text box's contents
     *  will be returned when its value is read. Setting `wrap` to `"hard"`
     *  means line breaks are automatically inserted into the text. The width of
     *  the text box determines where the line breaks are placed. Setting `wrap`
     *  to `"soft"` means line breaks are not inserted when the value of the
     *  text box is read.
     *
     *  Getting the `wrap` property gets how the text box's contents
     *  will be returned when its value is read.
     * @snippet [TextBox-wrap_get.es6=Get a text box's wrapping]
     * @snippet [TextBox-wrap_set.es6=Set a text box's wrapping]
     * @default `"soft"`
     * @type {external:String}
     * @memberof $w.TextBox
     * @instance
     */


    _createClass(TextBox, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                readOnly = this.readOnly,
                required = this.required,
                value = this.value,
                wrap = this.wrap;

            return { id: id, type: type, global: global, rendered: rendered, readOnly: readOnly, required: required, value: value, wrap: wrap };
        }

        /**
         * @member style
         * @label property
         * @syntax
         * get style(): Style
         * @summary Gets an object containing information about the text box's styles.
         * @description
         *  The following styles can be used with text boxes:
         *  + [`backgroundColor`]($w.Style.html#backgroundColor)
         *  + [`borderColor`]($w.Style.html#borderColor)
         *  + [`borderRadius`]($w.Style.html#borderRadius)
         *  + [`borderWidth`]($w.Style.html#borderWidth)
         *  + [`color`]($w.Style.html#color)
         *
         *
         *  Getting or setting a text box's styles, gets or sets the styles of the
         *  text box's regular state. It does not set the styles of the text box's hover,
         *  focus, error, or disabled states.
         * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
         * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
         * @type {$w.Style}
         * @memberof $w.TextBox
         * @readonly
         * @override
         */

    }, {
        key: 'wrap',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            return RMI.getProps(compId).wrap;
        }

        /**
         * @ignore
         */
        ,
        set: function set(wrap) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'wrap', { wrap: wrap })) {
                return;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            RMI.setProps(compId, { wrap: wrap });
        }

        /**
         * @member inputType
         * @label property
         * @syntax
         * get inputType(): string
         * @summary Return the input type.
         * @description
         *  Getting the `inputType` property gets the type of the input.
         * @snippet [TextBox-inputType_get.es6=Get a text box's input type]
         * @default `"text"`
         * @type {external:String}
         * @memberof $w.TextBox
         * @instance
         */

    }, {
        key: 'inputType',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);

            return RMI.getData(compId).textType;
        }
    }]);

    return TextBox;
}(_FormElement3.default);

exports.default = TextBox;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FormElement2 = __webpack_require__(33);

var _FormElement3 = _interopRequireDefault(_FormElement2);

var _TextInputMixin = __webpack_require__(143);

var _TextInputMixin2 = _interopRequireDefault(_TextInputMixin);

var _ReadOnlyMixin = __webpack_require__(96);

var _ReadOnlyMixin2 = _interopRequireDefault(_ReadOnlyMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _DisabledMixin = __webpack_require__(27);

var _DisabledMixin2 = _interopRequireDefault(_DisabledMixin);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _FocusMixin = __webpack_require__(32);

var _FocusMixin2 = _interopRequireDefault(_FocusMixin);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(1);

var _validationsService = __webpack_require__(15);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _utils = __webpack_require__(9);

var _isNumber = __webpack_require__(122);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _StyleMixin = __webpack_require__(28);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

var _RequiredMixin = __webpack_require__(41);

var _RequiredMixin2 = _interopRequireDefault(_RequiredMixin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class TextInput
 * @summary An input element for capturing small amounts of text.
 * @classdesc
 *  A text input is configured to receive
 *  <a href="https://www.wix.com/support/html5/article/text-input-settings" target="_blank">different types
 *  of information</a>, such as strings, numbers, or passwords.
 * @mixes $w.FormElement
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.DisabledMixin
 * @mixes $w.TextInputMixin
 * @mixes $w.FocusMixin
 * @mixes $w.ReadOnlyMixin
 * @mixes $w.ClickableMixin
 * @mixes $w.StyleMixin
 * @mixes $w.RequiredMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.inputs.TextInput
 * @tagname textinput
 */
var TextInput = function (_FormElement) {
    _inherits(TextInput, _FormElement);

    function TextInput(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, TextInput);

        var _this = _possibleConstructorReturn(this, (TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(TextInput.prototype, _HiddenCollapsedMixin2.default.prototype);
        (0, _mixin2.default)(TextInput.prototype, _DisabledMixin2.default.prototype);
        (0, _mixin2.default)(TextInput.prototype, _TextInputMixin2.default.prototype);
        (0, _mixin2.default)(TextInput.prototype, _FocusMixin2.default.prototype);
        (0, _mixin2.default)(TextInput.prototype, _ReadOnlyMixin2.default.prototype);
        (0, _mixin2.default)(TextInput.prototype, _ClickableMixin2.default.prototype);
        (0, _mixin2.default)(TextInput.prototype, _StyleMixin2.default.prototype);
        (0, _mixin2.default)(TextInput.prototype, _RequiredMixin2.default.prototype);
        return _this;
    }

    /**
     * @member value
     * @label property
     * @syntax
     * get value(): string
     * set value(value: string): void
     * @summary Sets or gets a text input's value.
     * @description
     *  To reset the text input, restoring any placeholder text, set the value
     *  property to null or undefined.
     *
     * @note
     *  Using the **Input Settings** panel in the Editor you can set the type of
     *  a text input. That type is used only for validation purposes. The value
     *  returned by the `value` property of a text input is always a string,
     *  regardless of the type set in the Editor.
     *
     *  When getting the `value` of a text input in an [`onKeyPress`]($w.TextInputMixin.html#onKeyPress)
     *  event handler, you may receive the value of the element before the key
     *  was pressed. To get the text input's updated value, use the [`updatedTargetValue`]($w.KeyboardEvent.html#updatedTargetValue)
     *  property of the event handler's `event` parameter.
     *
     *  If an element is connected to a dataset, setting the element's `value`
     *  in code does not set the value of the connected field in the dataset.
     *  That means if you use the dataset to perform a submit, the value changed
     *  in code is not reflected in the submitted item.
     *
     *  To submit the new value using a dataset, set the field's value using the
     *  [`setFieldValue()`](wix-dataset.html#setFieldValue) function before
     *  performing the submit.
     * @snippet [FormElement-value_get.es6=Get an element's value]
     * @snippet [FormElement-value_set.es6=Set an element's value]
     * @type {external:String}
     * @memberof $w.TextInput
     * @override
     */

    /**
     * @member max
     * @label property
     * @syntax
     * get max(): Number
     * set max(value: Number): void
     * @summary Sets or gets the maximum value for a text input element whose
     *  type is set to **Number**.
     * @description
     *  Setting the `max` property restricts users from changing
     *  the text input's value to a number greater than `max` if the
     *  text input is set to be a **Number** type. However, it does not limit
     *  your ability to change the value to a number greater than `max`
     *  programmatically.
     *
     *  Set `max` to `undefined` to remove the current maximum value limitation.
     *
     *  Getting the `max` property returns the maximum value a user
     *  can enter into the text input.
     *
     *  You can also set an element's `max` property in the Editor using the Settings pane:
     *  ![Input Settings pane](images/input_settings-max_value.png)
     * @snippet [TextInput-max_get.es6=Gets a text input's max value]
     * @snippet [TextInput-max_set.es6=Sets a text input's max value]
     * @type {external:Number}
     * @memberof $w.TextInput
     * @see [min](#min)
     * @instance
     */


    _createClass(TextInput, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                readOnly = this.readOnly,
                required = this.required,
                value = this.value,
                max = this.max,
                min = this.min,
                inputType = this.inputType;

            return { id: id, type: type, global: global, rendered: rendered, readOnly: readOnly, required: required, value: value, max: max, min: min, inputType: inputType };
        }

        /**
         * @member style
         * @label property
         * @syntax
         * get style(): Style
         * @summary Gets an object containing information about the text input's styles.
         * @description
         *  The following styles can be used with text input elements:
         *  + [`backgroundColor`]($w.Style.html#backgroundColor)
         *  + [`borderColor`]($w.Style.html#borderColor)
         *  + [`borderRadius`]($w.Style.html#borderRadius)
         *  + [`borderWidth`]($w.Style.html#borderWidth)
         *  + [`color`]($w.Style.html#color)
         *
         *
         *  Getting or setting a text input's styles, gets or sets the styles of the
         *  text input's regular state. It does not set the styles of the text input's hover,
         *  focus, error, or disabled states.
         * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
         * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
         * @type {$w.Style}
         * @memberof $w.TextInput
         * @readonly
         * @override
         */

    }, {
        key: 'max',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getData(compId);

            return compData && compData.max;
        }

        /**
         * @param {external:Number} max The max value of this input.
         * @ignore
         */
        ,
        set: function set(max) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            var minValue = this.min;

            if (!(0, _validation.validate)(compType, 'max', { max: max }) || !(0, _isNil2.default)(max) && (0, _isNumber2.default)(minValue) && !(0, _validation.validateMinimum)('max', 'max', max, minValue)) {
                return;
            }

            RMI.setData(compId, { max: (0, _utils.nullIfNil)(max) });
            (0, _validationsService.runValidationsAndSyncAfterChange)(RMI, compId, this.value);
        }

        /**
         * @member min
         * @label property
         * @syntax
         * get min(): Number
         * set min(value: Number): void
         * @summary Sets or gets the minimum value for a text input element whose
         *  type is set to **Number**.
         * @description
         *  Setting the `min` property restricts users from changing
         *  the text input's value to a number lower than `min` if the
         *  text input is set to be a **Number** type. However, it does not limit
         *  your ability to change the value to a number lower than `min`
         *  programmatically.
         *
         *  Set `min` to `undefined` to remove the current maximum value limitation.
         *
         *  Getting the `min` property returns the minimum value a user
         *  can enter into the text input.
         *
         *  You can also set an element's `min` property in the Editor using the Settings pane:
         *  ![Input Settings pane](images/input_settings-min_value.png)
         * @snippet [TextInput-min_get.es6=Gets a text input's min value]
         * @snippet [TextInput-min_set.es6=Sets a text input's min value]
         * @type {external:Number}
         * @memberof $w.TextInput
         * @see [max](#max)
         * @instance
         */

    }, {
        key: 'min',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getData(compId);
            return compData && compData.min;
        }

        /**
         * @param {external:Number} min The min value of this input.
         * @ignore
         */
        ,
        set: function set(min) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            var maxValue = this.max;

            if (!(0, _validation.validate)(compType, 'min', { min: min }) || !(0, _isNil2.default)(min) && (0, _isNumber2.default)(maxValue) && !(0, _validation.validateMaximum)('min', 'min', min, maxValue)) {
                return;
            }

            RMI.setData(compId, { min: (0, _utils.nullIfNil)(min) });
            (0, _validationsService.runValidationsAndSyncAfterChange)(RMI, compId, this.value);
        }

        /**
         * @member inputType
         * @label property
         * @syntax
         * get inputType(): InputType
         * set inputType(value: InputType): void
         * type InputType = "text" | "password" | "number" | "url" | "tel"
         * @summary Sets or gets the input type of an Input element.
         * @description
         *  Setting the `inputType` property sets what type of data a
         *  user can enter into the text input element. However, it does not limit
         *  your ability to change the value programmatically.
         *
         *  Getting the `inputType` property gets what type of data a
         *  user can enter into the text input element.
         *
         *  The text input types are:
         *  + `"text"` - Can contain any type of character.
         *  + `"password"` - A password field. Text is hidden with bullets (•••).
         *  + `"number"` - A valid number.
         *  + `"email"`- A valid email address.
         *  + `"url"` - A valid web address.
         *  + `"tel"` - Can contain only digits and certain symbols.
         *
         *
         *  You can also set an element's `inputType` property in the Editor using the Settings pane:
         *  ![Input Settings pane](images/input_settings-type.png)
         * @snippet [TextInput-inputType_get.es6=Gets a text input's input type]
         * @snippet [TextInput-inputType_set.es6=Sets a text input's input type]
         * @type {external:String}
         * @memberof $w.TextInput
         * @attr {external:String}
         */

    }, {
        key: 'inputType',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getData(compId);

            return compData && compData.textType;
        }

        /**
         * @param {external:String} newType The inputType value.
         * @ignore
         */
        ,
        set: function set(newType) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'inputType', { inputType: newType })) {
                return;
            }
            RMI.setData(compId, {
                textType: newType
            });
            (0, _validationsService.runValidationsAndSyncAfterChange)(RMI, compId, this.value);
        }
    }]);

    return TextInput;
}(_FormElement3.default);

exports.default = TextInput;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(9);

/*
 * @enum {external:String}
 * @summary Types of elements that you can access using Wix Code.
 * @readonly
 */
var getTypes = function getTypes() {
  return _utils.types.possibleTypes;
};

exports.default = getTypes;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FormElement2 = __webpack_require__(33);

var _FormElement3 = _interopRequireDefault(_FormElement2);

var _StyleMixin = __webpack_require__(28);

var _StyleMixin2 = _interopRequireDefault(_StyleMixin);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _DisabledMixin = __webpack_require__(27);

var _DisabledMixin2 = _interopRequireDefault(_DisabledMixin);

var _FocusMixin = __webpack_require__(32);

var _FocusMixin2 = _interopRequireDefault(_FocusMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _get2 = __webpack_require__(3);

var _get3 = _interopRequireDefault(_get2);

var _defaults = __webpack_require__(60);

var _defaults2 = _interopRequireDefault(_defaults);

var _postMessage = __webpack_require__(18);

var postMessage = _interopRequireWildcard(_postMessage);

var _platformUtils = __webpack_require__(13);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _validation = __webpack_require__(1);

var _utils = __webpack_require__(9);

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

var _errors = __webpack_require__(12);

var _validationsService = __webpack_require__(15);

var _RequiredMixin = __webpack_require__(41);

var _RequiredMixin2 = _interopRequireDefault(_RequiredMixin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @typedef {external:Object} $w.UploadButton~File
 * @summary The object used by the `value` property that represents
 *  files ready for upload.
 * @property {external:String} name The file's name.
 * @property {external:String} size The file's size in bytes.
 * @snippet [UploadButton-value.es6=Get the files pending upload]
 * @see [value](#value)
 */

/**
 * @typedef {external:Object} $w.UploadButton~UploadedFile
 * @summary The object returned by the `startUpload()` function's
 *  Promise that contains the URL of the successfully uploaded file.
 * @property {external:String} url The Wix URL of the uploaded file.
 * @snippet [UploadButton-startUpload.es6=Get uploaded file information]
 * @see [startUpload](#startUpload)
 */

/**
 * @typedef {external:Object} $w.UploadButton~UploadError
 * @summary The object returned by the `startUpload()` function's
 *  Promise when an upload fails.
 * @property {external:String} errorCode Numeric The error's code.
 * @property {external:String} errorDescription The error's description.
 * @snippet [UploadButton-startUpload.es6=Get upload error information]
 * @see [startUpload](#startUpload)
 */

/**
 * @class UploadButton
 * @summary An upload button enables users to upload files to your site.
 * @description
 *  <h3 id="typical-scenario">Typical File Upload Scenario</h3>
 *  <p>In a typical scenario, the page from which files are uploaded contains
 *  an upload button and another element, such as a regular button. The user chooses
 *  which file to upload by clicking the upload button and selecting the
 *  file in a native file chooser dialog. At that point the file is stored in
 *  the upload button's [`value`](#value) property as a [`File`](#File) object. Then
 *  the user triggers an event, such as a button click, on the other element.
 *  That element's event handler calls the [`startUpload()`](#startUpload)
 *  function to perform the actual upload. The upload will either succeed and
 *  and give you an [`UploadedFile`](#UploadedFile) object, or fail and give you
 *  an [`UploadError`](#UploadError) object.</p>
 * @snippet [UploadButton-startUpload_scenario.es6=Typical file upload scenario]
 *  This example uploads a file when the user clicks on a button. First it
 *  checks to see if the user has chosen a file. If a file was chosen, it
 *  triggers the upload and logs the status of the upload when it completes
 *  successfully or with an error.
 * @mixes $w.FormElement
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.DisabledMixin
 * @mixes $w.FocusMixin
 * @mixes $w.StyleMixin
 * @mixes $w.RequiredMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.inputs.FileUploader
 * @tagname fileuploader
 */
var UploadButton = function (_FormElement) {
    _inherits(UploadButton, _FormElement);

    function UploadButton(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, UploadButton);

        var _this = _possibleConstructorReturn(this, (UploadButton.__proto__ || Object.getPrototypeOf(UploadButton)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(UploadButton.prototype, _HiddenCollapsedMixin2.default.prototype);
        (0, _mixin2.default)(UploadButton.prototype, _DisabledMixin2.default.prototype);
        (0, _mixin2.default)(UploadButton.prototype, _FocusMixin2.default.prototype);
        (0, _mixin2.default)(UploadButton.prototype, _StyleMixin2.default.prototype);
        (0, _mixin2.default)(UploadButton.prototype, _RequiredMixin2.default.prototype);
        return _this;
    }

    // PROPERTIES:

    /**
     * @member buttonLabel
     * @label property
     * @syntax
     * get buttonLabel(): string
     * set buttonLabel(value: string): void
     * @summary Sets or gets the label on the upload button.
     * @type {external:String}
     * @snippet [UploadButton-buttonLabel_get.es6=Get an upload button's label]
     * @snippet [UploadButton-buttonLabel_set.es6=Set an upload button's label]
     * @memberof $w.UploadButton
     * @instance
     */


    _createClass(UploadButton, [{
        key: 'startUpload',


        /**
         * @function startUpload
         * @syntax
         * function startUpload(): Promise&lt;UploadedFile&gt;
         * @summary Uploads the files that the user has chosen.
         * @description
         *  The `startUpload()` function triggers the upload of the files in the
         *  upload button's [value](#value) property.
         *
         *  See how `startUpload()` is used in a
         *  [typical file upload scenario](#typical-scenario).
         *
         *  The upload button will not accept files that are larger than 25MB.
         * @returns {Promise}
         * @fulfill {$w.UploadButton~UploadedFile} Resolves when the file upload is completed.
         * @reject {$w.UploadButton~UploadError} Rejects if the file upload fails.
         * @snippet [UploadButton-startUpload.es6=Start a file upload]
         * @snippet [UploadButton-startUpload_scenario.es6=Full file upload scenario]
         *  This example uploads a file when the user clicks on a button. First it
         *  checks to see if the user has chosen a file. If a file was chosen, it
         *  triggers the upload and logs the status of the upload when it completes
         *  successfully or with an error.
         * @memberof $w.UploadButton
         */
        value: function startUpload() {
            var uriUtils = _platformUtils2.default.getUriUtils();
            var compId = members._compId.get(this);
            return new Promise(function (resolve, reject) {
                postMessage.sendMessage(postMessage.Intent.WIX_CODE_SITE_API, postMessage.MessageTypes.START_UPLOAD, { compId: compId }, function (data, err) {
                    if (err) {
                        reject(err);
                    } else {
                        if (data.media_type === 'picture') {
                            resolve({ url: uriUtils.generateWixCodeImageUri(data) });
                            return;
                        } else if (data.media_type === 'document') {
                            resolve({ url: uriUtils.generateWixCodeDocumentUri(data) });
                        }
                        resolve(data);
                    }
                });
            });
        }

        /**
         * @function reset
         * @syntax
         * function reset(): void
         * @summary Clears the files that are pending upload.
         * @description
         *  The `value` of the upload button contains a list of files that have been
         *  selected to upload. The `reset()` function clears these files.
         * @snippet [UploadButton-reset.es6=Clears the files pending upload]
         * @memberof $w.UploadButton
         */

    }, {
        key: 'reset',
        value: function reset() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var value = [];
            var newState = (0, _defaults2.default)({ value: value, uploadStatus: 'NOT_STARTED', serverMessage: '' }, RMI.getState(compId));

            RMI.updateModel(_defineProperty({}, compId, { state: newState }));
            RMI.executeCompBehavior(compId, 'reset');
            (0, _validationsService.runValidationsAndSync)(RMI, compId, value); // must run validations after executing rest behavior so that viewer validations will be correct
            (0, _validationsService.hideValidityIndication)(RMI, compId);
        }
    }, {
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                required = this.required,
                value = this.value,
                buttonLabel = this.buttonLabel,
                fileType = this.fileType,
                startUpload = this.startUpload,
                reset = this.reset;

            return { id: id, type: type, global: global, rendered: rendered, required: required, value: value, buttonLabel: buttonLabel, fileType: fileType, startUpload: startUpload, reset: reset };
        }

        /**
         * @member style
         * @label property
         * @syntax
         * get style(): Style
         * @summary Gets an object containing information about the upload button's styles.
         * @description
         *  The following styles can be used with upload buttons:
         *  + [`backgroundColor`]($w.Style.html#backgroundColor)
         *  + [`borderColor`]($w.Style.html#borderColor)
         *  + [`borderRadius`]($w.Style.html#borderRadius)
         *  + [`borderWidth`]($w.Style.html#borderWidth)
         *  + [`color`]($w.Style.html#color)
         *
         *
         *  Getting or setting an upload button's styles, gets or sets the styles of the
         *  upload button's regular state. It does not set the styles of the upload button's hover,
         *  focus, error, or disabled states.
         * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
         * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
         * @type {$w.Style}
         * @memberof $w.UploadButton
         * @readonly
         * @override
         */

    }, {
        key: 'buttonLabel',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getData(compId);

            return compData && compData.buttonLabel;
        },
        set: function set(label) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'buttonLabel', { buttonLabel: label })) {
                return;
            }
            RMI.setData(compId, {
                buttonLabel: (0, _utils.emptyStringIfNil)(label)
            });
        }

        /**
         * @member fileType
         * @label property
         * @syntax
         * get fileType(): FileType
         * set fileType(value: FileType): void
         * type FileType = "Image" | "Document"
         * @summary Sets or gets the type of file that a user can upload.
         * @description
         *  Setting the `fileType` property sets the type of file that
         *  a user can upload. The value of `fileType` can be set to either
         *  `"Image"` or `"Document"`.
         *
         *  Getting the `fileType` property returns the current type of
         *  file that a user can upload.
         *
         *  The file types of the images and documents that can be uploaded are
         *  listed [here](https://support.wix.com/en/article/supported-media-file-types-and-file-sizes).
         * @snippet [UploadButton-fileType_get.es6=Get an upload button's type]
         * @snippet [UploadButton-fileType_set.es6=Set an upload button's type]
         * @type {external:String}
         * @memberof $w.UploadButton
         */

    }, {
        key: 'fileType',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compProps = RMI.getProps(compId);

            return compProps && compProps.filesType;
        },
        set: function set(type) {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'fileType', { filesType: type }, true)) {
                return;
            }
            RMI.setProps(compId, {
                filesType: type
            });
        }

        /**
         * @member value
         * @label property
         * @syntax
         * get value(): File[]
         * @summary Returns a list of files that are pending upload.
         * @description
         *  Returns a list of [File](#File) objects that a user has selected to
         *  upload after pressing the upload button.
         *
         *  See how `value` is used in a
         *  [typical file upload scenario](#typical-scenario).
         * @snippet [UploadButton-value.es6=Get the files pending upload]
         * @snippet [UploadButton-startUpload_scenario.es6=Full file upload scenario]
         *  This example uploads a file when the user clicks on a button. First it
         *  checks to see if the user has chosen a file. If a file was chosen, it
         *  triggers the upload and logs the status of the upload when it completes
         *  successfully or with an error.
         * @type {$w.UploadButton~File[]}
         * @memberof $w.UploadButton
         * @readonly
         * @override
         */

    }, {
        key: 'value',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compState = RMI.getState(compId);

            return (0, _get3.default)(compState, 'value');
        },
        set: function set(val) {
            var compType = members._type.get(this).compType;
            _reporter2.default.reportSdkError(_errors.generateError.error_only_getter({
                propertyName: 'value',
                compType: compType
            }));
        }
    }]);

    return UploadButton;
}(_FormElement3.default);

exports.default = UploadButton;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _ClickableMixin = __webpack_require__(8);

var _ClickableMixin2 = _interopRequireDefault(_ClickableMixin);

var _LinkableMixin = __webpack_require__(67);

var _LinkableMixin2 = _interopRequireDefault(_LinkableMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _vectorImageUtils = __webpack_require__(135);

var _vectorImageUtils2 = _interopRequireDefault(_vectorImageUtils);

var _validation = __webpack_require__(1);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class VectorImage
 * @summary A simple vectorImage.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.LinkableMixin
 * @mixes $w.ClickableMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.svgshape.SvgShape
 * @viewername wysiwyg.viewer.components.VectorImage
 * @tagname vectorImage
 */
var VectorImage = function (_Element) {
    _inherits(VectorImage, _Element);

    function VectorImage(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, VectorImage);

        var _this = _possibleConstructorReturn(this, (VectorImage.__proto__ || Object.getPrototypeOf(VectorImage)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(VectorImage.prototype, _HiddenCollapsedMixin2.default.prototype);
        (0, _mixin2.default)(VectorImage.prototype, _LinkableMixin2.default.prototype);
        (0, _mixin2.default)(VectorImage.prototype, _ClickableMixin2.default.prototype);
        return _this;
    }

    /**
     * @member src
     * @label property
     * @syntax
     * get src(): string
     * set src(value: string): void
     * @summary Sets or gets the file location of the vector image.
     * @description
     *  Setting the `src` property changes the displayed vector image to
     *  the vector image found at the new `src` value.
     *
     *  Getting the `src` property returns the location of the
     *  current vector image file.
     *
     *  The vector image file is an image file from the <a href="https://support.wix.com/en/article/about-the-media-manager" target="_blank">Media Manager</a>.
     *
     *  The URL format is: `wix:vector://v1/<vector_uri>/<filename>`.
     * @snippet [VectorImage-src_get.es6=Get the vector image's location]
     * @snippet [VectorImage-src_set.es6=Set the vector image to be a vector image from the Media Manager]
     * @type {external:String}
     * @default An empty string
     * @memberof $w.VectorImage
     * @instance
     * @attr {external:String}
     */


    _createClass(VectorImage, [{
        key: 'toJSON',
        value: function toJSON() {
            var id = this.id,
                type = this.type,
                global = this.global,
                rendered = this.rendered,
                src = this.src;

            return { id: id, type: type, global: global, rendered: rendered, src: src };
        }
    }, {
        key: 'src',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getData(compId) || {};

            return _vectorImageUtils2.default.buildFullUrlFromSvgId(compData.svgId, compData.title);
        }

        /**
         * @param {external:String} value
         * @ignore
         */
        ,
        set: function set(value) {
            var compType = members._type.get(this).compType;

            if (!(0, _validation.validate)(compType, 'src', { src: value })) {
                return;
            }

            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var placeholderSvgData = { svgId: '0da768_b05a1a324a9f4a2e9be9a9c5dc3f50c9.svg', title: '' };
            var svgData = void 0;

            if ((0, _isNil2.default)(value)) {
                svgData = placeholderSvgData;
            } else {
                svgData = _vectorImageUtils2.default.convertToModelFormatAndReportIfError(value, 'src', 'src');
                if (!svgData) {
                    svgData = placeholderSvgData;
                }
            }

            RMI.setData(compId, svgData);
        }
    }]);

    return VectorImage;
}(_Element3.default);

exports.default = VectorImage;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _map = __webpack_require__(20);

var _map2 = _interopRequireDefault(_map);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _menuUtils = __webpack_require__(94);

var _menuUtils2 = _interopRequireDefault(_menuUtils);

var _validation = __webpack_require__(1);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * @class VerticalMenu
 * @summary Provides all functionality related to Vertical Menu.22
 * @classdesc The `VerticalMenu` class provides functionality related to Wix VerticalMenu.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof wix.ui
 * @tagname VerticalMenu
 * @viewername wysiwyg.common.components.verticalmenu.viewer.VerticalMenu
 */
var VerticalMenu = function (_Element) {
    _inherits(VerticalMenu, _Element);

    function VerticalMenu(RMI, compName, widgetInstanceId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, VerticalMenu);

        var _this = _possibleConstructorReturn(this, (VerticalMenu.__proto__ || Object.getPrototypeOf(VerticalMenu)).call(this, RMI, compName, widgetInstanceId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(VerticalMenu.prototype, _HiddenCollapsedMixin2.default.prototype);
        return _this;
    }

    _createClass(VerticalMenu, [{
        key: 'items',
        set: function set(menuItems) {
            var RMI = members._RMI.get(this);
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'items', { menuItems: menuItems })) {
                return this;
            }
            if ((0, _isNil2.default)(menuItems)) {
                menuItems = [];
            }
            _menuUtils2.default.checkMenuItemsValidation(menuItems, 'items');
            var convertedMenuItems = (0, _map2.default)(menuItems, function (menuItem, menuItemIndex) {
                return _menuUtils2.default.convertMenuItemToModelFormat(RMI, menuItem, menuItemIndex, 'items');
            });
            RMI.setData(members._compId.get(this), { menuRef: { items: convertedMenuItems } });
        },
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var data = RMI.getData(compId);
            var menuItems = data.menuRef.items;
            return (0, _map2.default)(menuItems, _menuUtils2.default.convertMenuItemToUserFormat);
        }
    }]);

    return VerticalMenu;
}(_Element3.default);

exports.default = VerticalMenu;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Element2 = __webpack_require__(7);

var _Element3 = _interopRequireDefault(_Element2);

var _HiddenCollapsedMixin = __webpack_require__(5);

var _HiddenCollapsedMixin2 = _interopRequireDefault(_HiddenCollapsedMixin);

var _mixin = __webpack_require__(2);

var _mixin2 = _interopRequireDefault(_mixin);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _validation = __webpack_require__(1);

var _platformUtils = __webpack_require__(13);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class Video
 * @summary An element that displays a video from Vimeo or Youtube.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.Video
 * @tagname Video
 */
var Video = function (_Element) {
    _inherits(Video, _Element);

    function Video(RMI, compId, contextId, wixSelector, controllerId, role, type) {
        _classCallCheck(this, Video);

        var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, RMI, compId, contextId, wixSelector, controllerId, role, type));

        (0, _mixin2.default)(Video.prototype, _HiddenCollapsedMixin2.default.prototype);
        return _this;
    }

    /**
     * @ignore
     */


    _createClass(Video, [{
        key: 'videoUrl',
        set: function set(newUrl) {
            var compType = members._type.get(this).compType;
            if (!(0, _validation.validate)(compType, 'videoUrl', { videoUrl: newUrl })) {
                return;
            }
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var videoUrlUtils = _platformUtils2.default.getVideoUrlUtils();
            var newVideoData = videoUrlUtils.getVideoDataFromUrl(newUrl);
            if (!(0, _isEmpty2.default)(newVideoData)) {
                RMI.setData(compId, newVideoData);
            }
        }

        /**
         * @member videoUrl
         * @label property
         * @syntax
         * get videoUrl(): string
         * set videoUrl(value: string): void
         * @summary Sets or gets the URL of the video.
         * @description
         *  Setting the value of the `videoUrl` property sets the video that the
         *  element plays.
         *
         *  Getting the value of the `videoUrl` property gets the URL of the video
         *  that the element plays.
         * @snippet [Video-videoUrl_set.es6=Set the video to play]
         * @snippet [Video-videoUrl_get.es6=Get the video to play]
         * @type {external:String}
         * @memberof $w.Video
         * @instance
         */
        ,
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var compData = RMI.getData(compId);
            var videoUrlUtils = _platformUtils2.default.getVideoUrlUtils();
            return videoUrlUtils.getVideoUrl(compData);
        }
    }]);

    return Video;
}(_Element3.default);

exports.default = Video;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GalleryItemChangedEvent = __webpack_require__(141);

var _GalleryItemChangedEvent2 = _interopRequireDefault(_GalleryItemChangedEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @callback $w.GalleryItemClickedEventHandler
 * @summary Handles events fired when an image in a gallery is clicked.
 * @param {$w.GalleryItemClickedEvent} event The event that has occurred.
 * @param {$w.$w} $w A selector function. The $w function enables event handlers
 *  to work with elements in [repeaters]($w.Repeater.html#repeating-callback-selector)
 *  and in the [global scope]($w.Repeater.html#regular-callback-selector).
 */

/**
 * @class GalleryItemClickedEvent
 * @summary Event that is fired when an image in a gallery is clicked.
 * @memberof $w
 * @mixes $w.GalleryItemChangedEvent
 * @mixes $w.Event
 */
var GalleryItemClickedEvent = function (_GalleryItemChangedEv) {
  _inherits(GalleryItemClickedEvent, _GalleryItemChangedEv);

  function GalleryItemClickedEvent() {
    _classCallCheck(this, GalleryItemClickedEvent);

    return _possibleConstructorReturn(this, (GalleryItemClickedEvent.__proto__ || Object.getPrototypeOf(GalleryItemClickedEvent)).apply(this, arguments));
  }

  return GalleryItemClickedEvent;
}(_GalleryItemChangedEvent2.default);

exports.default = GalleryItemClickedEvent;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _WixEvent2 = __webpack_require__(40);

var _WixEvent3 = _interopRequireDefault(_WixEvent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @callback $w.HtmlComponentMessageEventHandler
 * @summary Handles events fired when the code in an HtmlComponent sends a message.
 * @param {$w.HtmlComponentMessageEvent} event The HtmlComponent event that occurred.
 * @param {$w.$w} $w A selector function. The $w function enables event handlers
 *  to work with elements in [repeaters]($w.Repeater.html#repeating-callback-selector)
 *  and in the [global scope]($w.Repeater.html#regular-callback-selector).
 */

/**
 * @class HtmlComponentMessageEvent
 * @summary Event that is fired when the code in an HtmlComponent sends a message.
 * @memberof $w
 * @mixes $w.Event
 */
var HtmlComponentMessageEvent = function (_WixEvent) {
  _inherits(HtmlComponentMessageEvent, _WixEvent);

  function HtmlComponentMessageEvent(target, event) {
    _classCallCheck(this, HtmlComponentMessageEvent);

    var _this = _possibleConstructorReturn(this, (HtmlComponentMessageEvent.__proto__ || Object.getPrototypeOf(HtmlComponentMessageEvent)).call(this, target, event));

    _this.data = (0, _get2.default)(event, 'data');
    return _this;
  }

  /**
   * @member {$w.Element} data
   * @label property
   * @syntax
   * get data(): string
   * @summary Gets the event data.
   * @snippet [HtmlComponent-onMessage.es6=Receive a message from an HTML Component]
   * @memberof $w.HtmlComponentMessageEvent
   * @readonly
   */


  return HtmlComponentMessageEvent;
}(_WixEvent3.default);

exports.default = HtmlComponentMessageEvent;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _WixEvent2 = __webpack_require__(40);

var _WixEvent3 = _interopRequireDefault(_WixEvent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @callback $w.KeyboardEventHandler
 * @summary Handles events fired when the keyboard is pressed.
 * @param {$w.KeyboardEvent} event The keyboard event that occurred.
 * @param {$w.$w} $w A selector function. The $w function enables event handlers
 *  to work with elements in [repeaters]($w.Repeater.html#repeating-callback-selector)
 *  and in the [global scope]($w.Repeater.html#regular-callback-selector).
 */

/**
 * @class KeyboardEvent
 * @summary Event that is fired when the keyboard is pressed.
 * @description
 *  A `KeyboardEvent` event occurs when the user presses a key while the cursor
 *  is located inside a {@link $w.TextInput|`TextInput`} or
 *  {@link $w.TextBox|`TextBox`}.
 * @memberof $w
 * @mixes $w.Event
 */
var KeyboardEvent = function (_WixEvent) {
  _inherits(KeyboardEvent, _WixEvent);

  function KeyboardEvent(target, event) {
    _classCallCheck(this, KeyboardEvent);

    var _this = _possibleConstructorReturn(this, (KeyboardEvent.__proto__ || Object.getPrototypeOf(KeyboardEvent)).call(this, target, event));

    _this.metaKey = (0, _get2.default)(event, 'metaKey');
    _this.altKey = (0, _get2.default)(event, 'altKey');
    _this.shiftKey = (0, _get2.default)(event, 'shiftKey');
    _this.ctrlKey = (0, _get2.default)(event, 'ctrlKey');
    _this.key = (0, _get2.default)(event, 'key');
    _this.code = (0, _get2.default)(event, 'keyCode');
    return _this;
  }

  /**
   * @member {external:Boolean} metaKey
   * @label property
   * @syntax
   * get metaKey(): boolean
   * @summary Indicates if the ⌘ Command key on a Mac or ⊞ Windows key on a PC
   *  was pressed.
   * @snippet [KeyboardEvent-metaKey.es6=Get the keyboard event's `metaKey` property]
   * @snippet [KeyboardEvent-all.es6=Get all of the keyboard event's properties]
   *  This example gets the properties of a keyboard event fired when the
   *  `Shift` and `a` keys were pressed.
   * @memberof $w.KeyboardEvent
   * @readonly
   */

  /**
   * @member {external:Boolean} altKey
   * @label property
   * @syntax
   * get altKey(): boolean
   * @summary Indicates if the Option key on a Mac or Alt key on a PC was pressed.
   * @snippet [KeyboardEvent-altKey.es6=Get the keyboard event's `altKey` property]
   * @snippet [KeyboardEvent-all.es6=Get all of the keyboard event's properties]
   *  This example gets the properties of a keyboard event fired when the
   *  `Shift` and `a` keys were pressed.
   * @memberof $w.KeyboardEvent
   * @readonly
   */

  /**
   * @member {external:Boolean} shiftKey
   * @label property
   * @syntax
   * get shiftKey(): boolean
   * @summary Indicates if the Shift key was pressed.
   * @snippet [KeyboardEvent-shiftKey.es6=Get the keyboard event's `shiftKey` property]
   * @snippet [KeyboardEvent-all.es6=Get all of the keyboard event's properties]
   *  This example gets the properties of a keyboard event fired when the
   *  `Shift` and `a` keys were pressed.
   * @memberof $w.KeyboardEvent
   * @readonly
   */

  /**
   * @member {external:Boolean} ctrlKey
   * @label property
   * @syntax
   * get ctrlKey(): boolean
   * @summary Indicates if the Control (Ctrl) key was pressed.
   * @snippet [KeyboardEvent-ctrlKey.es6=Get the keyboard event's `ctrlKey` property]
   * @snippet [KeyboardEvent-all.es6=Get all of the keyboard event's properties]
   *  This example gets the properties of a keyboard event fired when the
   *  `Shift` and `a` keys were pressed.
   * @memberof $w.KeyboardEvent
   * @readonly
   */

  /**
   * @member {external:String} key
   * @label property
   * @syntax
   * get key(): string
   * @summary Gets the character that was pressed.
   * @description
   *  The `key` property gets a Unicode character string containing the
   *  printable representation of the key that was pressed. This does not
   *  necessarily correspond to what is printed on the physical key since the
   *  user could have changed the keyboard layout.
   *
   *  For keys that have no printable representation, a string indicating the
   *  key's purpose is returned. Some examples are "Enter", "Escape", and "Tab".
   *
   *  If more than one key is pressed and the combination includes a modifier
   *  that results in printing keystroke, the `key` property gets the
   *  modified printable character. For example, if the combination Shift+A is
   *  pressed, `key` gets "A".
   *
   *  However, if more than one key is pressed and the combination includes a
   *  modifier that results in a non-printing keystroke, the `key` property
   *  gets the unmodified printable character. For example, if the
   *  non-printing combination Ctrl+A is pressed, `key` gets the letter "a".
   *
   * @snippet [KeyboardEvent-key.es6=Get the keyboard event's `key` property]
   * @snippet [KeyboardEvent-all.es6=Get all of the keyboard event's properties]
   *  This example get the properties of a keyboard event fired when the
   *  `Shift` and `a` keys were pressed.
   * @memberof $w.KeyboardEvent
   * @readonly
   */

  /* REMOVING THIS FOR NOW; IT'S BASICALLY USELESS AS IT'S COMPLETELY BROWSER-DEPENDENT
   * @member {external:String} code
   * @label property
   * @syntax let charCode = event.code;
   * @summary Gets the numeric Unicode value of the character that was pressed.
   * @description
   *  The `code` property gets the ASCII code of the
   *  pressed key's physical representation, regardless of the current keyboard layout. For example, if
   *  the keyboard layout is set to Spanish on a US keyboard, pressing "ñ" results in a
   *  `code` value of 186. This is the ASCII code for a semicolon, since that is what is printed on the key.
   *
   *  For the exceptions where a [non-printable keypress](#non-printable) generates a `KeyboardEvent` event:
   *  * If the Enter key is pressed, `code` returns 13.
   *  * If the Escape key is pressed, `code` returns 27.
   *  * If more than one key is pressed and the combination includes a modifier that makes the resulting keystroke
   *    non-printing, the returned value is the printable character. For example, if the non-printing combination
   *    Ctrl-A is pressed, `code` returns the letter "a".
   *
   * @see [#key](#key)
   * @memberof $w.KeyboardEvent
   * @readonly
   */

  return KeyboardEvent;
}(_WixEvent3.default);

exports.default = KeyboardEvent;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _WixEvent2 = __webpack_require__(40);

var _WixEvent3 = _interopRequireDefault(_WixEvent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @callback $w.MouseEventHandler
 * @summary Handles events fired when the mouse is clicked.
 * @param {$w.MouseEvent} event The mouse event that occurred.
 * @param {$w.$w} $w A selector function. The $w function enables event handlers
 *  to work with elements in [repeaters]($w.Repeater.html#repeating-callback-selector)
 *  and in the [global scope]($w.Repeater.html#regular-callback-selector).
 */

/**
 * @class MouseEvent
 * @summary Event that is fired when the mouse is clicked.
 * @description
 *  The properties of a `MouseEvent` refer to the client, page, and screen.
 *  These terms refer to different containers as shown in the diagrams below.
 *  ![Coodinate Reference](images/coordinates_client.png "Coordinate Reference")
 *  ![Coodinate Reference](images/coordinates_page.png "Coordinate Reference")
 *  ![Coodinate Reference](images/coordinates_screen.png "Coordinate Reference")
 * @memberof $w
 * @mixes $w.Event
 */
var MouseEvent = function (_WixEvent) {
  _inherits(MouseEvent, _WixEvent);

  function MouseEvent(target, event) {
    _classCallCheck(this, MouseEvent);

    var _this = _possibleConstructorReturn(this, (MouseEvent.__proto__ || Object.getPrototypeOf(MouseEvent)).call(this, target, event));

    _this.pageX = (0, _get2.default)(event, 'pageX');
    _this.pageY = (0, _get2.default)(event, 'pageY');
    _this.screenX = (0, _get2.default)(event, 'screenX');
    _this.screenY = (0, _get2.default)(event, 'screenY');
    _this.clientX = (0, _get2.default)(event, 'clientX');
    _this.clientY = (0, _get2.default)(event, 'clientY');
    _this.offsetX = (0, _get2.default)(event, 'nativeEvent.offsetX');
    _this.offsetY = (0, _get2.default)(event, 'nativeEvent.offsetY');
    return _this;
  }

  /**
   * @member {external:Number} pageX
   * @label property
   * @syntax
   * get pageX(): Number
   * @summary Gets the distance in pixels between the mouse pointer and the
   *  left edge of the page.
   * @description The page refers to the entire web page, even parts that are
   *  not currently viewable in the browser. Therefore, two clicks on the same
   *  physical point of the screen will return different `pageX` values if the
   *  page is scrolled horizontally in the meantime. But two clicks on the
   *  same point on the page will return the same `pageX` values even if the
   *  page is scrolled horizontally in the meantime.
   *  ![Coodinate Reference](images/coordinates_page.png "Coordinate Reference")
   * @snippet [onClick-get_coordinates.es6=Get a mouse click's coordinates]
   * @memberof $w.MouseEvent
   * @readonly
   */

  /**
   * @member {external:Number} pageY
   * @label property
   * @syntax
   * get pageY(): Number
   * @summary Gets the distance in pixels between the mouse pointer and the
   *  top edge of the page.
   * @description The page refers to the entire web page, even parts that are
   *  not currently viewable in the browser. Therefore, two clicks on the same
   *  physical point of the screen will return different `pageY` values if the
   *  page is scrolled vertically in the meantime. But two clicks on the
   *  same point on the page will return the same `pageY` values even if the
   *  page is scrolled vertically in the meantime.
   *  ![Coodinate Reference](images/coordinates_page.png "Coordinate Reference")
   * @snippet [onClick-get_coordinates.es6=Get a mouse click's coordinates]
   * @memberof $w.MouseEvent
   * @readonly
   */

  /**
   * @member {external:Number} screenX
   * @label property
   * @syntax
   * get screenX(): Number
   * @summary Gets the distance in pixels between the mouse pointer and the
   *  left edge of the screen or screens.
   * @description The screen refers to the physical screen or screens.
   *  Therefore, two clicks on the same physical point of the screen will
   *  return the same `screenX` values even if the page is scrolled horizontally in
   *  the meantime. But two clicks on the
   *  same point on the page will return different `screenX` values if the
   *  page is scrolled horizontally in the meantime.
   *  ![Coodinate Reference](images/coordinates_screen.png "Coordinate Reference")
   * @snippet [onClick-get_coordinates.es6=Get a mouse click's coordinates]
   * @memberof $w.MouseEvent
   * @readonly
   */

  /**
   * @member {external:Number} screenY
   * @label property
   * @syntax
   * get screenY(): Number
   * @summary Gets the distance in pixels between the mouse pointer and the
   *  top edge of the screen or screens.
   * @description The screen refers to the physical screen or screens.
   *  Therefore, two clicks on the same physical point of the screen will
   *  return the same `screenY` values if the page is scrolled vertically in
   *  the meantime. But two clicks on the
   *  same point on the page will return different `screenY` values if the
   *  page is scrolled vertically in the meantime.
   *  ![Coodinate Reference](images/coordinates_screen.png "Coordinate Reference")
   * @snippet [onClick-get_coordinates.es6=Get a mouse click's coordinates]
   * @memberof $w.MouseEvent
   * @readonly
   */

  /**
   * @member {external:Number} clientX
   * @label property
   * @syntax
   * get clientX(): Number
   * @summary Gets the distance in pixels between the mouse pointer and the
   *  left edge of the browser's viewable area.
   * @description The browser's viewable area refers to the viewable contents
   *  of the page and excludes elements such as a sidebar and scrollbar.
   *  Therefore, two clicks on the same physical point of the screen will
   *  return the same `clientX` values even if the page is scrolled horizontally in
   *  the meantime. But two clicks on the
   *  same point on the page will return different `clientX` values if the
   *  page is scrolled horizontally in the meantime.
   *  ![Coodinate Reference](images/coordinates_client.png "Coordinate Reference")
   * @snippet [onClick-get_coordinates.es6=Get a mouse click's coordinates]
   * @memberof $w.MouseEvent
   * @readonly
   */

  /**
   * @member {external:Number} clientY
   * @label property
   * @syntax
   * get clientY(): Number
   * @summary Gets the distance in pixels between the mouse pointer and the
   *  top edge of the browser's viewable area.
   * @description The browser's viewable area refers to the viewable contents
   *  of the page and excludes elements such as a toolbar and scrollbar.
   *  Therefore, two clicks on the same physical point of the screen will
   *  return the same `clientY` values if the page is scrolled vertically in
   *  the meantime. But two clicks on the
   *  same point on the page will return different `clientY` values if the
   *  page is scrolled vertically in the meantime.
   *  ![Coodinate Reference](images/coordinates_client.png "Coordinate Reference")
   * @snippet [onClick-get_coordinates.es6=Get a mouse click's coordinates]
   * @memberof $w.MouseEvent
   * @readonly
   */

  /**
   * @member {external:Number} offsetX
   * @label property
   * @syntax
   * get offsetX(): Number
   * @summary Gets the distance in pixels between the mouse pointer and the
   *  left edge of the element that triggered this event.
   * @description
   *  Scrolling the web page causes its elements to shift relative to the
   *  browser window. Therefore, two clicks on the same physical point of the
   *  screen will return different `offsetX` values if the page is scrolled
   *  horizontally in the meantime. But two clicks on the
   *  same point on the element will return the same `offsetX` values even if the
   *  page is scrolled horizontally in the meantime.
   * @snippet [onClick-get_coordinates.es6=Get a mouse click's coordinates]
   * @memberof $w.MouseEvent
   * @readonly
   */

  /**
   * @member {external:Number} offsetY
   * @label property
   * @syntax
   * get offsetY(): Number
   * @summary Gets the distance in pixels between the mouse pointer and the
   *  top edge of the element that triggered this event.
   * @description
   *  Scrolling the web page causes its elements to shift relative to the
   *  browser window. Therefore, two clicks on the same physical point of the
   *  screen will return different `offsetY` values if the page is scrolled
   *  vertically in the meantime. But two clicks on the
   *  same point on the element will return the same `offsetY` values even if the
   *  page is scrolled horizontally in the meantime.
   * @snippet [onClick-get_coordinates.es6=Get a mouse click's coordinates]
   * @memberof $w.MouseEvent
   * @readonly
   */

  return MouseEvent;
}(_WixEvent3.default);

exports.default = MouseEvent;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _WixEvent2 = __webpack_require__(40);

var _WixEvent3 = _interopRequireDefault(_WixEvent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getCellData(event) {
  var cellData = void 0;

  if ((0, _get2.default)(event, 'cellData')) {
    cellData = JSON.parse(event.cellData);
  }

  return cellData;
}

/**
 * @callback $w.TableCellEventHandler
 * @summary Handles events fired when a table cell is selected.
 * @param {$w.TableCellEvent} event The table cell event that occurred.
 * @param {$w.$w} $w A selector function. The $w function enables event handlers
 *  to work with elements in [repeaters]($w.Repeater.html#repeating-callback-selector)
 *  and in the [global scope]($w.Repeater.html#regular-callback-selector).
 */

/**
 * @class TableCellEvent
 * @summary Event that is fired when a table cell is selected.
 * @description This event is only fired if the table is
 *  [set](https://support.wix.com/en/article/table-settings) in the Editor to
 *  select cells when clicked.
 * ![Clicking Selects Cells](images/table_settings_click_cells.png "Clicking Selects Cells")
 * @memberof $w
 * @mixes $w.Event
 */

var TableCellEvent = function (_WixEvent) {
  _inherits(TableCellEvent, _WixEvent);

  function TableCellEvent(target, event) {
    _classCallCheck(this, TableCellEvent);

    var _this = _possibleConstructorReturn(this, (TableCellEvent.__proto__ || Object.getPrototypeOf(TableCellEvent)).call(this, target, event));

    _this.cellRowIndex = (0, _get2.default)(event, 'rowIndex');
    _this.cellColumnId = (0, _get2.default)(event, 'columnId');
    _this.cellData = getCellData(event);
    return _this;
  }

  /**
   * @member {external:Number} cellRowIndex
   * @label property
   * @syntax
   * get cellRowIndex(): Number
   * @summary Gets the row index of the selected cell.
   * @description
   *  The rows in a table are zero-based and do not include the table header.
   *  ![Table Row Numbering](images/table_row.png "Table Row Numbering")
   * @snippet [TableCellEvent-all.es6=Get the selected table cell information]
   * @memberof $w.TableCellEvent
   * @readonly
   */

  /**
   * @member {external:String} cellColumnId
   * @label property
   * @syntax
   * get cellColumnId(): string
   * @summary Gets the column ID of the selected cell.
   * @description
   *  The `cellColumnId` is the `id` property of the
   *  [`Column`]($w.Table.html#Column) object that corresponds to the column
   *  of the selected cell.
   * @snippet [TableCellEvent-all.es6=Get the selected table cell information]
   * @memberof $w.TableCellEvent
   * @readonly
   */

  /**
   * @member {external:String} cellData
   * @label property
   * @syntax
   * get cellData(): string
   * @summary Gets the data from the selected cell.
   * @snippet [TableCellEvent-all.es6=Get the selected table cell information]
   * @memberof $w.TableCellEvent
   * @readonly
   */


  return TableCellEvent;
}(_WixEvent3.default);

exports.default = TableCellEvent;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _WixEvent2 = __webpack_require__(40);

var _WixEvent3 = _interopRequireDefault(_WixEvent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getRowData(event) {
  var rowData = void 0;

  if ((0, _get2.default)(event, 'rowData')) {
    rowData = JSON.parse(event.rowData);
  }

  return rowData;
}

/**
 * @callback $w.TableRowEventHandler
 * @summary Handles events fired when a table row is selected.
 * @param {$w.TableRowEvent} event The event that has occurred.
 * @param {$w.$w} $w A selector function. The $w function enables event handlers
 *  to work with elements in [repeaters]($w.Repeater.html#repeating-callback-selector)
 *  and in the [global scope]($w.Repeater.html#regular-callback-selector).
 */

/**
 * @class TableRowEvent
 * @summary Event that is fired when a table row is selected.
 * @description This event is only fired if the table is
 *  [set](https://support.wix.com/en/article/table-settings) in the Editor to
 *  select rows when clicked.
 * ![Clicking Selects Rows](images/table_settings_click_rows.png "Clicking Selects Rows")
 * @memberof $w
 * @mixes $w.Event
 */

var TableRowEvent = function (_WixEvent) {
  _inherits(TableRowEvent, _WixEvent);

  function TableRowEvent(target, event) {
    _classCallCheck(this, TableRowEvent);

    var _this = _possibleConstructorReturn(this, (TableRowEvent.__proto__ || Object.getPrototypeOf(TableRowEvent)).call(this, target, event));

    _this.rowIndex = (0, _get2.default)(event, 'rowIndex');
    _this.rowData = getRowData(event);
    return _this;
  }

  /**
   * @member {external:Number} rowIndex
   * @label property
   * @syntax
   * get rowIndex(): Number
   * @summary Gets the index of the selected row.
   * @description
   *  The rows in a table are zero-based and do not include the table header.
   *  ![Table Row Numbering](images/table_row.png "Table Row Numbering")
   * @snippet [TableRowEvent-all.es6=Get the selected table row information]
   * @memberof $w.TableRowEvent
   * @readonly
   */

  /**
   * @member {external:String} rowData
   * @label property
   * @syntax
   * get rowData(): string
   * @summary Gets the data for the selected row.
   * @description
   *  The row data is a JSON object of `columnName:cellData` key:value pairs.
   *  The object only contains the data that is displayed in the table.
   *
   *  If the table is connected to a dataset, the `rowData` does not include the
   *  fields from the dataset item that are not connected to table columns.
   *
   *  To retrieve the dataset item data that corresponds to the table row data,
   *  use the dataset [`getCurrentItem()`](wix-dataset.html#getCurrentItem)
   *  function in the dataset [`onCurrentIndexChanged()`](wix-dataset.html#onCurrentIndexChanged)
   *  event handler.
   *
   *  Getting the `rowData` gets the same object that is returned in the array
   *  of rows when readingthe table's [`rows`]($w.Table.html#rows) property.
   * @snippet [TableRowEvent-all.es6=Get the selected table row information]
   * @snippet [TableRowEvent-rowData_dataset.es6=Get the full item information from the dataset]
   * @memberof $w.TableRowEvent
   * @readonly
   */

  return TableRowEvent;
}(_WixEvent3.default);

exports.default = TableRowEvent;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function changeElementCollapsiblity(RMI, compId, isCollapsed, cb) {
    RMI.setProps(compId, { isCollapsed: isCollapsed }, cb);
}
/**
 * @mixin CollapsedMixin
 * @summary Provides functionality for elements that can be collapsed.
 *
 *  To learn about the behavior of a collapsed element,
 *  see the [`collapsed`](#collapsed) property.
 * @memberof $w
 */

var CollapsedMixin = function () {
    function CollapsedMixin() {
        _classCallCheck(this, CollapsedMixin);
    }

    _createClass(CollapsedMixin, [{
        key: 'collapse',


        /**
         * @function collapse
         * @syntax
         * function collapse(): Promise&lt;void&gt;
         * @summary Collapses the element and sets its `collapsed` property to `true`.
         * @description
         *  The `collapse()` function returns a Promise that is resolved when the
         *  element's [`collapsed`](#collapsed) property has been set to `true`.
         *
         *  To learn about the behavior of a collapsed element,
         *  see the [`collapsed`](#collapsed) property.
         *
         *  You can also collapse an element
         *  when the page loads by using the Properties panel in the Editor.
         * @returns {Promise}
         * @fulfill {void} When the element's `collapsed` property has been set to `true`.
         * @snippet [CollapsedMixin-collapse.es6=Collapse an element]
         * @snippet [CollapsedMixin-collapse_then.es6=Collapse an element and log a message when done]
         * @snippet [CollapsedMixin_toggle_collapsed.es6=Toggle an element's collapsed state]
         * @see [expand( )](#expand)
         * @see [collapsed](#collapsed)
         * @see {@link $w.HiddenMixin.hide|hide( )}
         * @memberof $w.CollapsedMixin
         */
        value: function collapse() {
            var _this = this;

            return new Promise(function (resolve) {
                var RMI = members._RMI.get(_this);
                var compId = members._compId.get(_this);

                if (!_this.collapsed) {
                    changeElementCollapsiblity(RMI, compId, true, resolve);
                } else {
                    resolve();
                }
            });
        }

        /**
         * @member collapsed
         * @label property
         * @syntax
         * get collapsed(): boolean
         * @summary Indicates if the element is collapsed or expanded.
         * @description
         *  If `collapsed` is `true`, the element is not displayed on the page under
         *  any circumstances. A collapsed element, unlike a
         *  [`hidden`]($w.HiddenMixin.html#hide) element, does not take up any
         *  space on the page. When collapsed, elements positioned within 70 pixels
         *  below the collapsed element and each other will move up to take the
         *  collapsed element's place where possible. The elements that move up
         *  maintain their positions relative to one another.
         *
         *  If `collapsed` is `false`, the element _may_ be displayed on the page.
         *  Elements that moved up to take the collapsed element's place on the
         *  page are moved back down.
         *
         *  However, an expanded element (an element whose `collapsed` property is
         *  `false`) will still not be displayed if:
         *
         *  + It is [hidden]($w.HiddenMixin.html#hidden).
         *  + Its [parent element]($w.Node.html#parent) is hidden or collapsed.
         *  + It is a slide in a [Slideshow]($w.Slideshow.html) which is
         *    currently not being displayed.
         *
         *
         *  Even if the element will not be displayed due to the conditions
         *  mentioned above, if its `collapsed` property is `false`, it will
         *  be displayed when the conditions no longer apply.
         *
         *  To set the `collapsed` property on an element, use the element's
         *  [`collapse()`](#collapse) and [`expand()`](#expand) functions.
         *
         *  If you select **Collapsed on load** in the element's Properties panel
         *  in the Editor, the `collapsed` property is set to `true` when the page loads.
         * @snippet [CollapsedMixin-collapsed.es6=Get an element's collapsed status]
         * @snippet [CollapsedMixin_toggle_collapsed.es6=Toggle an element's collapsed state]
         * @type {external:Boolean}
         * @default `false`
         * @see [collapse( )](#collapse-)
         * @see [expand( )](#expand-)
         * @see {@link $w.HiddenMixin.hide|hide( )}
         * @see {@link $w.HiddenMixin.show|show( )}
         * @see {@link $w.HiddenMixin.hidden|hidden}
         * @memberof $w.CollapsedMixin
         * @attr {external:Boolean} collapsed
         * @readonly
         */

    }, {
        key: 'expand',


        /**
         * @function expand
         * @syntax
         * function expand(): Promise&lt;void&gt;
         * @summary Expands the element and sets its `collapsed` property to `false`.
         * @description
         *  The `expand()` function returns a Promise that is resolved when the
         *  element's [`collapsed`](#collapsed) property has been set to `false`.
         *
         *  To learn about the behavior of an expanded element,
         *  see the [`collapsed`](#collapsed) property.
         *
         * @returns {Promise}
         * @fulfill {void} When the element's `collapsed` property has been set to `false`.
         * @snippet [CollapsedMixin-expand.es6=Expand an element]
         * @snippet [CollapsedMixin-expand_then.es6=Expand an element and log a message when done]
         * @snippet [CollapsedMixin_toggle_collapsed.es6=Toggle an element's collapsed state]
         * @see [expand( )](#expand)
         * @see [collapsed](#collapsed)
         * @see {@link $w.HiddenMixin.show|show( )}
         * @memberof $w.CollapsedMixin
         */
        value: function expand() {
            var _this2 = this;

            return new Promise(function (resolve) {
                var RMI = members._RMI.get(_this2);
                var compId = members._compId.get(_this2);

                if (_this2.collapsed) {
                    changeElementCollapsiblity(RMI, compId, false, resolve);
                } else {
                    resolve();
                }
            });
        }
    }, {
        key: 'collapsed',
        get: function get() {
            var RMI = members._RMI.get(this);
            var compId = members._compId.get(this);
            var props = RMI.getProps(compId);

            return Boolean(props && props.isCollapsed);
        }
    }]);

    return CollapsedMixin;
}();

exports.default = CollapsedMixin;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _effectValidation = __webpack_require__(231);

var _effectValidation2 = _interopRequireDefault(_effectValidation);

var _constants = __webpack_require__(91);

var _constants2 = _interopRequireDefault(_constants);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//TODO WEED-8265
// import isNil from 'lodash/isNil';
// import * as postMessage from '../../privates/postMessage';

/**
 * @mixin HiddenMixin
 * @summary Provides functionality for elements that can be hidden.
 *
 *  To learn about the behavior of a hidden element,
 *  see the [`hidden`](#hidden) property.
 * @memberof $w
 */

function changeElementVisibility(RMI, compId, isHidden, cb) {
  RMI.setProps(compId, { isHidden: isHidden }, cb);
}

//TODO WEED-8265
// function resetAnimationAndChangeElementVisibility(RMI, compId, isHidden, cb) {
//     postMessage.sendMessage(
//         postMessage.Intent.WIX_CODE_SITE_API,
//         postMessage.MessageTypes.RESET_BEHAVIORS,
//         {compId},
//         changeElementVisibility.bind(null, RMI, compId, isHidden, cb)
//     );
// }
//
// function shouldOverrideEditorPresets(effectName, effectOptions) {
//     return isNil(effectName) && isEmpty(effectOptions);
// }

var HiddenMixin = function () {
  function HiddenMixin() {
    _classCallCheck(this, HiddenMixin);
  }

  _createClass(HiddenMixin, [{
    key: 'hide',


    /**
     * @function hide
     * @syntax
     * function hide([effectName: Effect[, effectOptions: Object]]): Promise&lt;void&gt;
     * type Effect = "arc" | "bounce" | "drop" | "expand" | "fade"
     * | "flip" | "float" | "fly" | "fold" | "glide" | "reveal"
     * | "slide" | "spin" | "turn"
     * @summary Hides the element and sets its `hidden` property
     *  to `true`, using an effect if specified.
     * @description
     *  The `hide()` function hides the element and returns a Promise that is
     *  resolved when the effect is complete and the element's [`hidden`](#hidden)
     *  property has been set to `true`.
     *
     *  To learn about the behavior of a hidden element,
     *  see the [`hidden`](#hidden) property.
     *
     *  You can optionally apply an effect when hiding the element by providing
     *  an `effectName` value. You can also customize the effect by providing the
     *  optional `effectOptions` object.
     *
     *  Effects:
     *
     *  + [`"arc"`]($w.HiddenMixin.html#ArcEffectOptions)
     *  + [`"bounce"`]($w.HiddenMixin.html#BounceEffectOptions)
     *  + [`"drop"`]($w.HiddenMixin.html#DropEffectOptions)
     *  + [`"expand"`]($w.HiddenMixin.html#ExpandEffectOptions)
     *  + [`"fade"`]($w.HiddenMixin.html#FadeEffectOptions)
     *  + [`"flip"`]($w.HiddenMixin.html#FlipEffectOptions)
     *  + [`"float"`]($w.HiddenMixin.html#FloatEffectOptions)
     *  + [`"fly"`]($w.HiddenMixin.html#FlyEffectOptions)
     *  + [`"fold"`]($w.HiddenMixin.html#FoldEffectOptions)
     *  + [`"glide"`]($w.HiddenMixin.html#GlideEffectOptions)
     *  + [`"reveal"`]($w.HiddenMixin.html#RevealEffectOptions)
     *  + [`"slide"`]($w.HiddenMixin.html#SlideEffectOptions)
     *  + [`"spin"`]($w.HiddenMixin.html#SpinEffectOptions)
     *  + [`"turn"`]($w.HiddenMixin.html#TurnEffectOptions)
     *
     *
     *  You can also hide an element
     *  when the page loads by using the Properties panel in the Editor.
     * @param {external:String} [effectName] The name of the
     *  effect to play when hiding the item.
     * @param {external:Object} [effectOptions] The effect's options.
     * @returns {Promise}
     * @fulfill {void} When the effect is complete and the element's `hidden` property has been set to `true`.
     * @see [show( )](#show)
     * @see [hidden](#hidden)
     * @see [collapse( )]($w.CollapsedMixin.html#collapse)
     * @snippet [HiddenMixin-hide.es6=Hide an element with no effect]
     * @snippet [HiddenMixin-hide_animation.es6=Hide an element with the "fade" effect]
     * @snippet [HiddenMixin-FadeOptions-hide.es6=Hide an element with an effect and log message when the effect is done]
     * @snippet [HiddenMixin-hide_then.es6=Hide an element with an effect and log message when the effect is done]
     * @snippet [HiddenMixin_toggle_hidden.es6=Toggle an element's hidden state]
     * @memberof $w.HiddenMixin
     */
    value: function hide(effectName, effectOptions) {
      var _this = this;

      return new Promise(function (resolve) {
        var RMI = members._RMI.get(_this);
        var compId = members._compId.get(_this);
        if (_this.hidden) {
          return resolve();
        }
        //TODO WEED-8265
        // if (shouldOverrideEditorPresets(effectName, effectOptions)) {
        //     return resetAnimationAndChangeElementVisibility(RMI, compId, true, resolve);
        // }

        //TODO WEED-8265 - for phase 1.1 only
        if (!effectName && (0, _isEmpty2.default)(effectOptions)) {
          return changeElementVisibility(RMI, compId, true, resolve);
        }
        var functionData = _constants2.default.EFFECTS.HIDE;
        var isValid = _effectValidation2.default.validateEffect(effectName, effectOptions, 'hide', _this.id, functionData.deprecatedValues);
        if (!isValid) {
          return changeElementVisibility(RMI, compId, true, resolve);
        }

        var _effectValidation$bui = _effectValidation2.default.buildEffectObject(effectName, effectOptions, functionData),
            presetName = _effectValidation$bui.presetName,
            params = _effectValidation$bui.params;

        return RMI.executeAnimation(compId, presetName, params, changeElementVisibility.bind(null, RMI, compId, true, resolve));
      });
    }

    /**
     * @member hidden
     * @label property
     * @syntax
     * get hidden(): boolean
     * @summary Indicates if the element is visible or hidden.
     * @description
     *  If `hidden` is `true`, the element is not displayed on the page under
     *  any circumstances. A hidden element, unlike a
     *  [`collapsed`]($w.CollapsedMixin.html#collapsed) element, continues to
     *  take up the same space on the page as it did when it was visible.
     *
     *  If `hidden` is `false`, the element _may_ be displayed on the page.
     *
     *  However, an element whose `hidden` property is `false` will still not
     *  be displayed if:
     *
     *  + It is [collapsed]($w.CollapsedMixin.html#collapsed).
     *  + Its [parent element]($w.Node.html#parent) is hidden or collapsed.
     *  + It is a slide in a [Slideshow]($w.Slideshow.html) which is
     *    currently not being displayed.
     *
     *
     *  Even if the element will not be displayed due to the conditions
     *  mentioned above, if its `hidden` property is set to `false`, it will
     *  be displayed when the conditions no longer apply.
     *
     *  To determine if the element is actually visible, use the
     *  [`isVisible`](#isVisible) property.
     *
     *  To set the `hidden` property on an element, use the element's
     *  [`hide()`](#hide) or [`show()`](#show) functions.
     *
     *  If you select **Hidden on load** in the element's Properties panel
     *  in the Editor, the `hidden` property is set to `true` when the page loads.
     *
     *  @note An element's `hidden` property is not the same as its
     *   [isVisible](#isVisible) property. The `hidden` property
     *   indicates whether the element _should_ be displayed, while `isVisible`
     *   indicates if it is actually displayed.
     * @snippet [HiddenMixin-hidden.es6=Get an element's hidden status]
     * @snippet [HiddenMixin_toggle_hidden.es6=Toggle an element's hidden state]
     * @type {external:Boolean}
     * @default `false`
     * @see [hide( )](#hide)
     * @see [show( )](#show)
     * @see {@link $w.CollapsedMixin.collapse|collapse( )}
     * @see {@link $w.CollapsedMixin.expand|expand( )}
     * @see {@link $w.CollapsedMixin.collapsed|collapsed}
     * @see [rendered]($w.Element#rendered)
     * @memberof $w.HiddenMixin
     * @attr {external:Boolean} hidden
     * @readonly
     */

  }, {
    key: 'show',


    /**
     * @function show
     * @syntax
     * function show([effectName: Effect[, effectOptions: Object]]): Promise&lt;void&gt;
     * type Effect = "arc" | "bounce" | "drop" | "expand" | "fade"
     * | "flip" | "float" | "fly" | "fold" | "glide" | "reveal"
     * | "slide" | "spin" | "turn"
     * @summary Shows the element and sets its `hidden` property
     *  to `false`, using an effect if specified.
     * @description
     *  The `show()` function shows the element and returns a Promise that is
     *  resolved when the effect is complete and the element's [`hidden`](#hidden)
     *  property has been set to `false`.
     *
     *  You can optionally apply an effect when showing the element by providing
     *  an `effectName` value. You can also customize the effect by providing the
     *  optional `effectOptions` object.
     *
     *  Effects:
     *
     *  + [`"arc"`]($w.HiddenMixin.html#ArcEffectOptions)
     *  + [`"bounce"`]($w.HiddenMixin.html#BounceEffectOptions)
     *  + [`"drop"`]($w.HiddenMixin.html#DropEffectOptions)
     *  + [`"expand"`]($w.HiddenMixin.html#ExpandEffectOptions)
     *  + [`"fade"`]($w.HiddenMixin.html#FadeEffectOptions)
     *  + [`"flip"`]($w.HiddenMixin.html#FlipEffectOptions)
     *  + [`"float"`]($w.HiddenMixin.html#FloatEffectOptions)
     *  + [`"fly"`]($w.HiddenMixin.html#FlyEffectOptions)
     *  + [`"fold"`]($w.HiddenMixin.html#FoldEffectOptions)
     *  + [`"glide"`]($w.HiddenMixin.html#GlideEffectOptions)
     *  + [`"reveal"`]($w.HiddenMixin.html#RevealEffectOptions)
     *  + [`"slide"`]($w.HiddenMixin.html#SlideEffectOptions)
     *  + [`"spin"`]($w.HiddenMixin.html#SpinEffectOptions)
     *  + [`"turn"`]($w.HiddenMixin.html#TurnEffectOptions)
     * @param {external:String} [effectName] The name of the
     *  effect to play when showing the item.
     * @param {external:Object} [effectOptions] The effect's options.
     * @returns {Promise}
     * @fulfill {void} When the effect is complete and the element's `hidden` property has been set to `false`.
     * @see [hide( )](#hide)
     * @see [hidden](#hidden)
     * @see [expand( )]($w.CollapsedMixin.html#expand)
     * @snippet [HiddenMixin-show.es6=Show an element with no effect]
     * @snippet [HiddenMixin-show_animation.es6=Show an element with the "fade" effect]
     * @snippet [HiddenMixin-show_animation.es6=Show an element with the "fade" effect and custom options]
     * @snippet [HiddenMixin-FadeOptions.es6=Show an element with an effect and log message when the effect is done]
     * @snippet [HiddenMixin_toggle_hidden.es6=Toggle an element's hidden state]
     * @memberof $w.HiddenMixin
     */
    value: function show(effectName, effectOptions) {
      var _this2 = this;

      return new Promise(function (resolve) {
        var RMI = members._RMI.get(_this2);
        var compId = members._compId.get(_this2);

        if (!_this2.hidden) {
          return resolve();
        }

        //TODO WEED-8265
        // if (shouldOverrideEditorPresets(effectName, effectOptions)) {
        //     return resetAnimationAndChangeElementVisibility(RMI, compId, false, resolve);
        // }

        //TODO WEED-8265 - for phase 1.1 only
        if (!effectName && (0, _isEmpty2.default)(effectOptions)) {
          return changeElementVisibility(RMI, compId, false, resolve);
        }

        var functionData = _constants2.default.EFFECTS.SHOW;
        var isValid = _effectValidation2.default.validateEffect(effectName, effectOptions, 'show', _this2.id, functionData.deprecatedValues);
        if (!isValid) {
          return changeElementVisibility(RMI, compId, false, resolve);
        }

        var _effectValidation$bui2 = _effectValidation2.default.buildEffectObject(effectName, effectOptions, functionData),
            presetName = _effectValidation$bui2.presetName,
            params = _effectValidation$bui2.params;

        return RMI.executeAnimation(compId, presetName, params, changeElementVisibility.bind(null, RMI, compId, false, resolve));
      });
    }

    /**
     * @member isVisible
     * @label property
     * @syntax
     * get isVisible(): boolean
     * @summary Indicates if the element is actually visible.
     * @description
     *  If `isVisible` is `true`, the element is displayed on the page.
     *
     *  If `isVisible` is `false`, the element is not displayed on the page.
     *
     *  The value of the `isVisible` property is calculated based on the
     *  [`hidden`](#hidden), [`collapsed`](#collapsed), and [`rendered`]($w.Element#rendered)
     *  properties of the element and all of its ancestors. It will be `true`
     *  only if the conditions exist in the element's property values and the
     *  property values of its ancestors such that the element is actually
     *  displayed on the page.
     * @note An element's `isVisible` property is not the same as its
     *  [hidden]($w.Element.html#hidden) property. The `isVisible` property
     *  indicates whether the element is actually displayed, while `hidden`
     *  indicates if it _should_ be displayed.
     *
     *  The `isVisible` property of an element will remain `true` even if
     *  another element completely covers it so that a user cannot see it.
     * @snippet [HiddenMixin-isVisible.es6=Get whether an element is visible]
     * @type {external:Boolean}
     * @default `true`
     * @memberof $w.HiddenMixin
     * @attr {external:Boolean} visible
     * @see [hidden](#hidden)
     * @see [collapsed]($w.CollapsedMixin.html#collapsed)
     * @see [rendered]($w.Element.html#rendered)
     * @readonly
     */

  }, {
    key: 'hidden',
    get: function get() {
      var RMI = members._RMI.get(this);
      var compId = members._compId.get(this);
      var props = RMI.getProps(compId);
      return !!props.isHidden;
    }
  }, {
    key: 'isVisible',
    get: function get() {
      var RMI = members._RMI.get(this);
      var compId = members._compId.get(this);
      var parentId = compId;
      while (parentId) {
        var parentProps = RMI.getProps(parentId);
        var parent = RMI.getComp(parentId);
        var isDisplayed = parent ? parent.isDisplayed : true;
        if (parentProps && (parentProps.isHidden || parentProps.isCollapsed || !isDisplayed)) {
          return false;
        }
        parentId = RMI.getParent(parentId);
      }
      return true;
    }

    /**
     * @typedef {external:Object} $w.HiddenMixin~ArcEffectOptions
     * @summary An object used by the [`show()`](#show) and [`hide()`](#hide)
     *  functions for the `effectOptions` parameter when using the `"arc"` effect.
     * @description
     *  <table style="border-collapse: collapse;">
     *    <tr>
     *      <td><b>Key</b></td>
     *      <td><b>Valid Values</b></td>
     *      <td><b>Default</b></td>
     *    </tr>
     *    <tr>
     *      <td>`duration`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`1200`</td>
     *    </tr>
     *    <tr>
     *      <td>`delay`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`0`</td>
     *    </tr>
     *    <tr>
     *      <td>`direction`</td>
     *      <td>`left`, `right`</td>
     *      <td>`left`</td>
     *    </tr>
     *  </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:String} direction
     * @snippet [HiddenMixin-show-ArcOptions.es6=Show an element using the arc effect and options]
     * @see [show( )](#show)
     * @see [hide( )](#hide)
     */

    /**
     * @typedef {external:Object} $w.HiddenMixin~BounceEffectOptions
     * @summary An object used by the [`show()`](#show) and [`hide()`](#hide)
     *  functions for the `effectOptions` parameter when using the `"bounce"` effect.
     * @description
     *  <table style="border-collapse: collapse;">
     *    <tr>
     *      <td><b>Key</b></td>
     *      <td><b>Valid Values</b></td>
     *      <td><b>Default</b></td>
     *    </tr>
     *    <tr>
     *      <td>`duration`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`1200`</td>
     *    </tr>
     *    <tr>
     *      <td>`delay`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`0`</td>
     *    </tr>
     *    <tr>
     *      <td>`direction`</td>
     *      <td>`top left`, `top right`, `bottom right`, `bottom left`, `center`</td>
     *      <td>`top left`</td>
     *    </tr>
     *    <tr>
     *      <td>`intensity`</td>
     *      <td>`soft`, `medium`, `hard`</td>
     *      <td>`medium`</td>
     *    </tr>
     *  </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:String} direction
     * @property {external:String} intensity
     * @snippet [HiddenMixin-show-BounceOptions.es6=Show an element using the bounce effect and options]
     * @see [show( )](#show)
     * @see [hide( )](#hide)
     */

    /**
     * @typedef {external:Object} $w.HiddenMixin~DropEffectOptions
     * @summary An object used by the [`show()`](#show) and [`hide()`](#hide)
     *  functions for the `effectOptions` parameter when using the `"drop"` effect.
     * @description
     *  <table style="border-collapse: collapse;">
     *    <tr>
     *      <td><b>Key</b></td>
     *      <td><b>Valid Values</b></td>
     *      <td><b>Default</b></td>
     *    </tr>
     *    <tr>
     *      <td>`duration`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`1200`</td>
     *    </tr>
     *    <tr>
     *      <td>`delay`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`0`</td>
     *    </tr>
     *  </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @snippet [HiddenMixin-show-DropOptions.es6=Show an element using the drop effect and options]
     * @see [show( )](#show)
     * @see [hide( )](#hide)
     */

    /**
     * @typedef {external:Object} $w.HiddenMixin~ExpandEffectOptions
     * @summary An object used by the [`show()`](#show) and [`hide()`](#hide)
     *  functions for the `effectOptions` parameter when using the `"expand"` effect.
     * @description
     *  <table style="border-collapse: collapse;">
     *    <tr>
     *      <td><b>Key</b></td>
     *      <td><b>Valid Values</b></td>
     *      <td><b>Default</b></td>
     *    </tr>
     *    <tr>
     *      <td>`duration`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`1200`</td>
     *    </tr>
     *    <tr>
     *      <td>`delay`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`0`</td>
     *    </tr>
     *  </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @snippet [HiddenMixin-show-ExpandOptions.es6=Show an element using the expand effect and options]
     * @see [show( )](#show)
     * @see [hide( )](#hide)
     */

    /**
     * @typedef {external:Object} $w.HiddenMixin~FadeEffectOptions
     * @summary An object used by the [`show()`](#show) and [`hide()`](#hide)
     *  functions for the `effectOptions` parameter when using the `"fade"` effect.
     * @description
     *  <table style="border-collapse: collapse;">
     *    <tr>
     *      <td><b>Key</b></td>
     *      <td><b>Valid Values</b></td>
     *      <td><b>Default</b></td>
     *    </tr>
     *    <tr>
     *      <td>`duration`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`1200`</td>
     *    </tr>
     *    <tr>
     *      <td>`delay`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`0`</td>
     *    </tr>
     *  </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @snippet [HiddenMixin-show-FadeOptions.es6=Show an element using the fade effect and options]
     * @see [show( )](#show)
     * @see [hide( )](#hide)
     */

    /**
     * @typedef {external:Object} $w.HiddenMixin~FlipEffectOptions
     * @summary An object used by the [`show()`](#show) and [`hide()`](#hide)
     *  functions for the `effectOptions` parameter when using the `"flip"` effect.
     * @description
     *  <table style="border-collapse: collapse;">
     *    <tr>
     *      <td><b>Key</b></td>
     *      <td><b>Valid Values</b></td>
     *      <td><b>Default</b></td>
     *    </tr>
     *    <tr>
     *      <td>`duration`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`1200`</td>
     *    </tr>
     *    <tr>
     *      <td>`delay`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`0`</td>
     *    </tr>
     *    <tr>
     *      <td>`direction`</td>
     *      <td>`top`, `right`, `bottom`, `left`</td>
     *      <td>`right`</td>
     *    </tr>
     *  </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:String} direction
     * @snippet [HiddenMixin-show-FlipOptions.es6=Show an element using the flip effect and options]
     * @see [show( )](#show)
     * @see [hide( )](#hide)
     */

    /**
     * @typedef {external:Object} $w.HiddenMixin~FloatEffectOptions
     * @summary An object used by the [`show()`](#show) and [`hide()`](#hide)
     *  functions for the `effectOptions` parameter when using the `"float"` effect.
     * @description
     *  <table style="border-collapse: collapse;">
     *    <tr>
     *      <td><b>Key</b></td>
     *      <td><b>Valid Values</b></td>
     *      <td><b>Default</b></td>
     *    </tr>
     *    <tr>
     *      <td>`duration`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`1200`</td>
     *    </tr>
     *    <tr>
     *      <td>`delay`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`0`</td>
     *    </tr>
     *    <tr>
     *      <td>`direction`</td>
     *      <td>`top`, `right`, `bottom`, `left`</td>
     *      <td>`right`</td>
     *    </tr>
     *  </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:String} direction
     * @snippet [HiddenMixin-show-FloatOptions.es6=Show an element using the float effect and options]
     * @see [show( )](#show)
     * @see [hide( )](#hide)
     */

    /**
     * @typedef {external:Object} $w.HiddenMixin~FlyEffectOptions
     * @summary An object used by the [`show()`](#show) and [`hide()`](#hide)
     *  functions for the `effectOptions` parameter when using the `"fly"` effect.
     * @description
     *  <table style="border-collapse: collapse;">
     *    <tr>
     *      <td><b>Key</b></td>
     *      <td><b>Valid Values</b></td>
     *      <td><b>Default</b></td>
     *    </tr>
     *    <tr>
     *      <td>`duration`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`1200`</td>
     *    </tr>
     *    <tr>
     *      <td>`delay`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`0`</td>
     *    </tr>
     *    <tr>
     *      <td>`direction`</td>
     *      <td>`top`, `right`, `bottom`, `left`</td>
     *      <td>`right`</td>
     *    </tr>
     *  </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:String} direction
     * @snippet [HiddenMixin-show-FlyOptions.es6=Show an element using the fly effect and options]
     * @see [show( )](#show)
     * @see [hide( )](#hide)
     */

    /**
     * @typedef {external:Object} $w.HiddenMixin~FoldEffectOptions
     * @summary An object used by the [`show()`](#show) and [`hide()`](#hide)
     *  functions for the `effectOptions` parameter when using the `"fold"` effect.
     * @description
     *  <table style="border-collapse: collapse;">
     *    <tr>
     *      <td><b>Key</b></td>
     *      <td><b>Valid Values</b></td>
     *      <td><b>Default</b></td>
     *    </tr>
     *    <tr>
     *      <td>`duration`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`1200`</td>
     *    </tr>
     *    <tr>
     *      <td>`delay`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`0`</td>
     *    </tr>
     *    <tr>
     *      <td>`direction`</td>
     *      <td>`top`, `right`, `bottom`, `left`</td>
     *      <td>`left`</td>
     *    </tr>
     *  </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:String} direction
     * @snippet [HiddenMixin-show-FoldOptions.es6=Show an element using the fold effect and options]
     * @see [show( )](#show)
     * @see [hide( )](#hide)
     */

    /**
     * @typedef {external:Object} $w.HiddenMixin~GlideEffectOptions
     * @summary An object used by the [`show()`](#show) and [`hide()`](#hide)
     *  functions for the `effectOptions` parameter when using the `"glide"` effect.
     * @description
     *  <table style="border-collapse: collapse;">
     *    <tr>
     *      <td><b>Key</b></td>
     *      <td><b>Valid Values</b></td>
     *      <td><b>Default</b></td>
     *    </tr>
     *    <tr>
     *      <td>`duration`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`1200`</td>
     *    </tr>
     *    <tr>
     *      <td>`delay`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`0`</td>
     *    </tr>
     *    <tr>
     *      <td>`angle`</td>
     *      <td>`0`-`360` degrees</td>
     *      <td>`0`</td>
     *    </tr>
     *    <tr>
     *      <td>`distance`</td>
     *      <td>`0`-`300` pixels</td>
     *      <td>`0`</td>
     *    </tr>
     *  </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:Number} angle
     * @property {external:Number} distance
     * @snippet [HiddenMixin-show-GlideOptions.es6=Show an element using the glide effect and options]
     * @see [show( )](#show)
     * @see [hide( )](#hide)
     */

    /**
     * @typedef {external:Object} $w.HiddenMixin~RevealEffectOptions
     * @summary An object used by the [`show()`](#show) and [`hide()`](#hide)
     *  functions for the `effectOptions` parameter when using the `"reveal"` effect.
     * @description
     *  <table style="border-collapse: collapse;">
     *    <tr>
     *      <td><b>Key</b></td>
     *      <td><b>Valid Values</b></td>
     *      <td><b>Default</b></td>
     *    </tr>
     *    <tr>
     *      <td>`duration`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`1200`</td>
     *    </tr>
     *    <tr>
     *      <td>`delay`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`0`</td>
     *    </tr>
     *    <tr>
     *      <td>`direction`</td>
     *      <td>`top`, `right`, `bottom`, `left`</td>
     *      <td>`left`</td>
     *    </tr>
     *  </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:String} direction
     * @snippet [HiddenMixin-show-RevealOptions.es6=Show an element using the reveal effect and options]
     * @see [show( )](#show)
     * @see [hide( )](#hide)
     */

    /**
     * @typedef {external:Object} $w.HiddenMixin~SlideEffectOptions
     * @summary An object used by the [`show()`](#show) and [`hide()`](#hide)
     *  functions for the `effectOptions` parameter when using the `"slide"` effect.
     * @description
     *  <table style="border-collapse: collapse;">
     *    <tr>
     *      <td><b>Key</b></td>
     *      <td><b>Valid Values</b></td>
     *      <td><b>Default</b></td>
     *    </tr>
     *    <tr>
     *      <td>`duration`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`1200`</td>
     *    </tr>
     *    <tr>
     *      <td>`delay`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`0`</td>
     *    </tr>
     *    <tr>
     *      <td>`direction`</td>
     *      <td>`top`, `right`, `bottom`, `left`</td>
     *      <td>`left`</td>
     *    </tr>
     *  </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:String} direction
     * @snippet [HiddenMixin-show-SlideOptions.es6=Show an element using the slide effect and options]
     * @see [show( )](#show)
     * @see [hide( )](#hide)
     */

    /**
     * @typedef {external:Object} $w.HiddenMixin~SpinEffectOptions
     * @summary An object used by the [`show()`](#show) and [`hide()`](#hide)
     *  functions for the `effectOptions` parameter when using the `"spin"` effect.
     * @description
     *  <table style="border-collapse: collapse;">
     *    <tr>
     *      <td><b>Key</b></td>
     *      <td><b>Valid Values</b></td>
     *      <td><b>Default</b></td>
     *    </tr>
     *    <tr>
     *      <td>`duration`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`1200`</td>
     *    </tr>
     *    <tr>
     *      <td>`delay`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`0`</td>
     *    </tr>
     *    <tr>
     *      <td>`direction`</td>
     *      <td>`cw`, `ccw`</td>
     *      <td>`cw`</td>
     *    </tr>
     *    <tr>
     *      <td>`cycles`</td>
     *      <td>`1`-`15`</td>
     *      <td>`5`</td>
     *    </tr>
     *  </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:String} direction
     * @property {external:Number} cycles
     * @snippet [HiddenMixin-show-SpinOptions.es6=Show an element using the spin effect and options]
     * @see [show( )](#show)
     * @see [hide( )](#hide)
     */

    /**
     * @typedef {external:Object} $w.HiddenMixin~TurnEffectOptions
     * @summary An object used by the [`show()`](#show) and [`hide()`](#hide)
     *  functions for the `effectOptions` parameter when using the `"turn"` effect.
     * @description
     *  <table style="border-collapse: collapse;">
     *    <tr>
     *      <td><b>Key</b></td>
     *      <td><b>Valid Values</b></td>
     *      <td><b>Default</b></td>
     *    </tr>
     *    <tr>
     *      <td>`duration`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`1200`</td>
     *    </tr>
     *    <tr>
     *      <td>`delay`</td>
     *      <td>`0`-`4000` milliseconds</td>
     *      <td>`0`</td>
     *    </tr>
     *    <tr>
     *      <td>`direction`</td>
     *      <td>`right`, `left`</td>
     *      <td>`right`</td>
     *    </tr>
     *  </table>
     * @property {external:Number} duration
     * @property {external:Number} delay
     * @property {external:String} direction
     * @snippet [HiddenMixin-show-TurnOptions.es6=Show an element using the turn effect and options]
     * @see [show( )](#show)
     * @see [hide( )](#hide)
     */

  }]);

  return HiddenMixin;
}();

exports.default = HiddenMixin;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _validationsService = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @mixin ValidatableMixin
 * @summary Provides functionality for elements that can be validated.
 *
 * Certain input elements contain properties that are used in basic form
 * validation, such as [`required`]($w.RequiredMixin.html#required) and
 * [`maxlength`]($w.TextInputMixin.html#maxlength). More complex validation
 * logic is achieved using the properties and functions below.
 *
 * Basic validation of elements against the constraints set in the Editor or
 * programmatically is always peformed, regardless of any custom validation.
 *
 * However, sometimes more complex validation is needed, including validations
 * that depend on more than one element. This is typically achieved by adding
 * custom validation logic in an event handler that you set using the input
 * element's [`onCustomValidation()`](#onCustomValidation) function. Within that
 * handler, you call the `reject()` function to indicate that the element is
 * invalid. The element's validity is checked when the value of the element
 * changes either by user interaction or programmatically.
 *
 * Note that validations other than **required**, including custom validations,
 * are not run on input elements when they don't have a value.
 *
 * @memberof $w
 */
var ValidatableMixin = function () {
  function ValidatableMixin() {
    _classCallCheck(this, ValidatableMixin);
  }

  _createClass(ValidatableMixin, [{
    key: 'onCustomValidation',


    /**
     * @callback $w.Validator
     * @summary Function that runs when custom validation is checked.
     * @param {external:String|$w.UploadButton~File[]|external:Boolean} value The value of the element being validated.
     * @param {external:Function} reject A function that invalidates the element with the specified message.
     */

    /**
     * @function onCustomValidation
     * @syntax
     * function onCustomValidation(validator: Validator): void
     * callback Validator(value: string | File[] | boolean, reject: Function): void
     * @summary Adds an event handler that runs when the element's validation is checked.
     * @description
     *  The `onCustomValidation()` function allows you perform custom validation
     *  in addition to any basic validation that was defined in the Editor.
     *
     *  To invalidate the element, call the `reject()` function that is passed
     *  into the `validator` callback function and pass it a validation message.
     *
     *  The element's validity is checked when the value of the element
     *  changes either by user interaction or programmatically.
     *
     *  Note that validations other than **required**, including custom validations,
     *  are not run on input elements when they don't have a value.
     * @snippet [ValidatableMixin-onCustomValidation.es6=Set an element to invalid if its value is "evil"]
     * @param {$w.Validator} validator The name of the function or
     *  the function expression to run when the element's custom validation is checked.
     * @memberof $w.ValidatableMixin
     */
    value: function onCustomValidation(validator) {
      //eslint-disable-line jsdoc-events
      var RMI = members._RMI.get(this);
      var compId = members._compId.get(this);

      (0, _validationsService.onCustomValidation)(RMI, compId, validator);
    }

    /**
     * @function updateValidityIndication
     * @syntax
     * function updateValidityIndication(): void
     * @summary Updates the element's visual validity indication based on it's current validity state.
     * @description
     *  Many elements have a visual cue that indicates whether they are valid or
     *  not. For example, a text input that usually has a black outline might have
     *  a red outline when its value is not valid.
     * @snippet [ValidatableMixin-updateValidityIndication.es6=Update an element's validatity indicator]
     * @memberof $w.ValidatableMixin
     */

  }, {
    key: 'updateValidityIndication',
    value: function updateValidityIndication() {
      var RMI = members._RMI.get(this);
      var compId = members._compId.get(this);

      (0, _validationsService.showValidityIndication)(RMI, compId);
    }

    /**
     * @function resetValidityIndication
     * @syntax
     * function resetValidityIndication(): void
     * @summary Resets the element's visual validity indication.
     * @description
     *  Many elements have a visual cue that indicates whether they are valid or
     *  not. For example, a text input that usually has a black outline might have
     *  a red outline when its value is not valid.
     *
     *  The `resetValidityIndication()` function resets the validity indication
     *  of an element to show the element as valid. The actual validity state of
     *  the element is not affected. If the element was invalid, it will remain
     *  invalid. The validity indication will show the element as valid until
     *  the element's validity is checked when the value of the element
     *  changes either by user interaction or programmatically. At that point,
     *  the element's validity indication will show the element as invalid if
     *  its value is not valid.
     * @memberof $w.ValidatableMixin
     */

  }, {
    key: 'resetValidityIndication',
    value: function resetValidityIndication() {
      var RMI = members._RMI.get(this);
      var compId = members._compId.get(this);

      (0, _validationsService.hideValidityIndication)(RMI, compId);
    }
  }, {
    key: 'valid',


    /**
     * @member valid
     * @label property
     * @syntax get valid(): boolean
     * @summary Indicates if an input element's value is valid.
     * @description
     *  The `valid` property indicates if an element's value satisfies
     *  all conditions to pass a validation check. This includes basic validity
     *  conditions, such as whether the element has a value if it is [required]($w.RequiredMixin.html#required),
     *  and those specified in its [`onCustomValidation()`](#onCustomValidation)
     *  event handler, if you defined one.
     *
     *  Note that validations other than **required**, including custom validations,
     *  are not run on input elements when they don't have a value.
     * @snippet [ValidatableMixin-valid.es6=Get whether the element is valid]
     * @type {external:Boolean}
     * @see [onCustomValidation( )](#onCustomValidation)
     * @memberof $w.ValidatableMixin
     * @readonly
     */
    get: function get() {
      var compId = members._compId.get(this);

      return (0, _validationsService.isValid)(compId);
    }

    /**
     * @member validationMessage
     * @label property
     * @syntax
     * get validationMessage(): string
     * @summary Gets a message indicating why the element is invalid, or an
     *  empty string if the message is valid.
     * @description
     *  Set the value of the `validationMessage` property using the
     *  `reject()` function of the [`onCustomValidation()`](#onCustomValidation)
     *  event handler.
     * @snippet [ValidatableMixin-validationMessage.es6=Get the validation message]
     * @type {external:String}
     * @see [validity](#validity)
     * @memberof $w.ValidatableMixin
     * @readonly
     */

  }, {
    key: 'validationMessage',
    get: function get() {
      var compId = members._compId.get(this);

      return (0, _validationsService.getValidationMessage)(compId);
    }

    /**
     * @typedef {external:Object} $w.ValidatableMixin~ValidityState
     * @summary Contains detailed information about the validity states of an element.
     * @description This object is returned by an element's
     *  [`validity`](#validity) property.
     * @property {external:Boolean} customError - `true` if the element's custom
     *  validity message has been set to a non-empty string.
     * @property {external:Boolean} valid - `true` if the element meets all
     *  constraint validations.
     * @property {external:Boolean} valueMissing - `true` if the element's
     *  [`required`]($w.RequiredElement.html#required) property is `true`, but
     *  it does not contain a value.
     * @property {external:Boolean} typeMismatch - `true` if the element's value
     *  does not match its type when the type is email or url.
     * @property {external:Boolean} patternMismatch - `true` if the element's
     *  value does not match its pattern validation.
     * @property {external:Boolean} tooLong - `true` if the length of the
     *  element's value exceeds its [`maxlength`]($w.TextInputElement.html#maxlength)
     *  property.
     * @property {external:Boolean} tooShort - `true` if the length of the
     *  element's value is smaller than its minlength.
     * @property {external:Boolean} rangeUnderflow - `true` if the element's
     *  value is less than the its [`min`]($w.TextInput.html#min) property.
     * @property {external:Boolean} rangeOverflow - `true` if the element's
     *  value is more than the its [`max`]($w.TextInput.html#max) property.
     * @property {external:Boolean} fileNotUploaded - `true` if the element is
     *  an upload button that is required and a file has been selected but not
     *  uploaded.
     * @property {external:Boolean} stepMismatch
     * @property {external:Boolean} badInput - `true` if the element's value
     *  cannot be converted to a value
     * @snippet [ValidityState.es6=Get ValidityState info]
     * @see [validity](#validity)
     */

    /**
     * @member validity
     * @label property
     * @syntax
     * get validity(): ValidityState
     * @summary Gets a ValidityState object that contains
     *  detailed information about the validity states of the element.
     * @snippet [ValidityState.es6=Log ValidityState info]
     * @type {$w.ValidatableMixin~ValidityState}
     * @see [validationMessage](#validationMessage)
     * @memberof $w.ValidatableMixin
     * @readonly
     */

  }, {
    key: 'validity',
    get: function get() {
      var compId = members._compId.get(this);

      return (0, _validationsService.getValidity)(compId);
    }
  }]);

  return ValidatableMixin;
}();

exports.default = ValidatableMixin;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styleValidation = __webpack_require__(55);

var _styleService = __webpack_require__(57);

var _styleService2 = _interopRequireDefault(_styleService);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _styleConstants = __webpack_require__(48);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * @mixin BackgroundColorMixin
 * @summary Provides functionality for changing an element's background color.
 *
 * @memberof $w.StyleMixin
 */
var BackgroundColorMixin = function () {
  function BackgroundColorMixin() {
    _classCallCheck(this, BackgroundColorMixin);
  }

  _createClass(BackgroundColorMixin, [{
    key: 'backgroundColor',


    /**
     * @ignore
     */
    set: function set(backgroundColor) {
      var compNickname = members._compNickname.get(this);
      var opacitySupport = true;

      var validColor = (0, _styleValidation.validateColorAndPerformCastingIfNecessary)(backgroundColor, opacitySupport, _styleConstants.StyleProperties.BACKGROUND_COLOR, compNickname);
      if (!validColor) {
        return;
      }
      _styleService2.default.setStyle.call(this, _styleConstants.StyleProperties.BACKGROUND_COLOR, validColor);
    }

    /**
     * @member backgroundColor
     * @label property
     * @syntax
     * get backgroundColor(): string
     * set backgroundColor(rgbaColor: string): void
     * @summary Sets or gets the background color of an element.
     * @description
     *  The background color value is a string representing an rgbaColor in one
     *  of the following formats:
     *
     *  + `"red"` - One of [140 predefined color names](https://www.w3schools.com/colors/colors_names.asp).
     *  + `"#FF0000"` - A hexidecimal rgb color value.
     *  + `"rgb(255,0,0)"` - An rgb() function color value.
     *  + `"#FF000000"` - A hexidecimal rgba color value.
     *  + `"rgba(255,0,0,1.0)"` - An rgba() function color value.
     * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
     * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
     * @type {external:String}
     * @memberof $w.Style
     * @instance
     */
    ,
    get: function get() {
      return _styleService2.default.getStyleParamValue.call(this, _styleConstants.StyleProperties.BACKGROUND_COLOR);
    }
  }]);

  return BackgroundColorMixin;
}();

exports.default = BackgroundColorMixin;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styleValidation = __webpack_require__(55);

var _styleService = __webpack_require__(57);

var _styleService2 = _interopRequireDefault(_styleService);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _styleConstants = __webpack_require__(48);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * @mixin BorderColorMixin
 * @summary Provides functionality for changing an element's border color.
 *
 * @memberof $w.Style
 */
var BorderColorMixin = function () {
    function BorderColorMixin() {
        _classCallCheck(this, BorderColorMixin);
    }

    _createClass(BorderColorMixin, [{
        key: 'borderColor',


        /**
         * @ignore
         */
        set: function set(borderColor) {
            var compNickname = members._compNickname.get(this);
            var opacitySupport = true;

            var validColor = (0, _styleValidation.validateColorAndPerformCastingIfNecessary)(borderColor, opacitySupport, _styleConstants.StyleProperties.BORDER_COLOR, compNickname);
            if (!validColor) {
                return;
            }
            _styleService2.default.setStyle.call(this, _styleConstants.StyleProperties.BORDER_COLOR, validColor);
        }

        /**
         * @member borderColor
         * @label property
         * @syntax
         * get borderColor(): string
         * set borderColor(rgbaColor: string): void
         * @summary Sets or gets the border color of an element.
         * @description
         *  The border color value is a string representing an rgbaColor in one of
         *  the following formats:
         *
         *  + `"red"` - One of [140 predefined color names](https://www.w3schools.com/colors/colors_names.asp).
         *  + `"#FF0000"` - A hexidecimal rgb color value.
         *  + `"rgb(255,0,0)"` - An rgb() function color value.
         *  + `"#FF000000"` - A hexidecimal rgba color value.
         *  + `"rgba(255,0,0,1.0)"` - An rgba() function color value.
         * @snippet [BorderMixin-borderColor_set.es6=Set the border color]
         * @snippet [BorderMixin-borderColor_get.es6=Get the border color]
         * @type {external:String}
         * @memberof $w.Style
         * @instance
         */
        ,
        get: function get() {
            return _styleService2.default.getStyleParamValue.call(this, _styleConstants.StyleProperties.BORDER_COLOR);
        }
    }]);

    return BorderColorMixin;
}();

exports.default = BorderColorMixin;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styleValidation = __webpack_require__(55);

var _styleService = __webpack_require__(57);

var _styleService2 = _interopRequireDefault(_styleService);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _styleConstants = __webpack_require__(48);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * @mixin BorderRadiusMixin
 * @summary Provides functionality for changing an element's border radius.
 *
 * @memberof $w.Style
 */
var BorderRadiusMixin = function () {
    function BorderRadiusMixin() {
        _classCallCheck(this, BorderRadiusMixin);
    }

    _createClass(BorderRadiusMixin, [{
        key: 'borderRadius',


        /**
         * @ignore
         */
        set: function set(borderRadius) {
            var compNickname = members._compNickname.get(this);

            var isValidBorderRadius = (0, _styleValidation.validatePixel)(borderRadius, _styleConstants.StyleProperties.BORDER_RADIUS, compNickname, 'radius');
            if (!isValidBorderRadius) {
                return;
            }
            _styleService2.default.setStyle.call(this, _styleConstants.StyleProperties.BORDER_RADIUS, borderRadius);
        }

        /**
         * @member borderRadius
         * @label property
         * @syntax
         * get borderRadius(): string
         * set borderRadius(radius: string): void
         * @summary Sets or gets the border radius of an element.
         * @description
         *  The [border radius](https://www.w3schools.com/cssref/css3_pr_border-radius.asp)
         *  value is a string representing the element's border radius in pixels.
         *  For example, `"1px"`.
         * @snippet [BorderRadiusMixin-borderRadius_set.es6=Set the border radius]
         * @snippet [BorderRadiusMixin-borderRadius_get.es6=Get the border radius]
         * @type {external:String}
         * @memberof $w.Style
         * @instance
         */
        ,
        get: function get() {
            return _styleService2.default.getStyleParamValue.call(this, _styleConstants.StyleProperties.BORDER_RADIUS);
        }
    }]);

    return BorderRadiusMixin;
}();

exports.default = BorderRadiusMixin;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styleValidation = __webpack_require__(55);

var _styleService = __webpack_require__(57);

var _styleService2 = _interopRequireDefault(_styleService);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _styleConstants = __webpack_require__(48);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * @mixin BorderWidthMixin
 * @summary Provides functionality for changing an element's border width.
 *
 * @memberof $w.Style
 */
var BorderWidthMixin = function () {
    function BorderWidthMixin() {
        _classCallCheck(this, BorderWidthMixin);
    }

    _createClass(BorderWidthMixin, [{
        key: 'borderWidth',

        /**
         * @ignore
         */
        set: function set(width) {
            var compNickname = members._compNickname.get(this);

            var isValid = (0, _styleValidation.validatePixel)(width, _styleConstants.StyleProperties.BORDER_WIDTH, compNickname, 'width');
            if (!isValid) {
                return;
            }
            _styleService2.default.setStyle.call(this, _styleConstants.StyleProperties.BORDER_WIDTH, width);
        }

        /**
         * @member borderWidth
         * @label property
         * @syntax
         * get borderWidth(): string
         * set borderWidth(width: string): void
         * @summary Sets or gets the border width of an element.
         * @description
         *  The border width value is a string representing the element's border
         *  width in pixels. For example, `"1px"`.
         * @snippet [BorderMixin-borderWidth_set.es6=Set the border width]
         * @snippet [BorderMixin-borderWidth_get.es6=Get the border width]
         * @type {external:String}
         * @memberof $w.Style
         * @instance
         */
        ,
        get: function get() {
            return _styleService2.default.getStyleParamValue.call(this, _styleConstants.StyleProperties.BORDER_WIDTH);
        }
    }]);

    return BorderWidthMixin;
}();

exports.default = BorderWidthMixin;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styleValidation = __webpack_require__(55);

var _styleService = __webpack_require__(57);

var _styleService2 = _interopRequireDefault(_styleService);

var _privateMembers = __webpack_require__(0);

var members = _interopRequireWildcard(_privateMembers);

var _styleConstants = __webpack_require__(48);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * @mixin TextColorMixin
 * @summary Provides functionality for changing an element's text color.
 *
 * @memberof $w.Style
 */
var TextColorMixin = function () {
  function TextColorMixin() {
    _classCallCheck(this, TextColorMixin);
  }

  _createClass(TextColorMixin, [{
    key: 'color',


    /**
     * @ignore
     */
    set: function set(color) {
      var compNickname = members._compNickname.get(this);
      var opacitySupport = false;

      var validColor = (0, _styleValidation.validateColorAndPerformCastingIfNecessary)(color, opacitySupport, _styleConstants.StyleProperties.COLOR, compNickname);
      if (!validColor) {
        return;
      }
      _styleService2.default.setStyle.call(this, _styleConstants.StyleProperties.COLOR, validColor);
    }

    /**
     * @member color
     * @label property
     * @syntax
     * get color(): string
     * set color(rgbColor: string): void
     * @summary Sets or gets the text color of an element.
     * @description
     *  The text color value is a string representing an rgbColor in one
     *  of the following formats:
     *
     *  + `"red"` - One of [140 predefined color names](https://www.w3schools.com/colors/colors_names.asp).
     *  + `"#FF0000"` - A hexidecimal rgb color value.
     *  + `"rgb(255,0,0)"` - An rgb() function color value.
     * @snippet [TextColorMixin-color_set.es6=Set the text color]
     * @snippet [TextColorMixin-color_get.es6=Get the text color]
     * @type {external:String}
     * @memberof $w.Style
     * @instance
     */
    ,
    get: function get() {
      return _styleService2.default.getStyleParamValue.call(this, _styleConstants.StyleProperties.COLOR);
    }
  }]);

  return TextColorMixin;
}();

exports.default = TextColorMixin;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _postMessage = __webpack_require__(18);

var postMessage = _interopRequireWildcard(_postMessage);

var _get = __webpack_require__(3);

var _get2 = _interopRequireDefault(_get);

var _validation = __webpack_require__(1);

var _platformUtils = __webpack_require__(13);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _isObject = __webpack_require__(14);

var _isObject2 = _interopRequireDefault(_isObject);

var _isUndefined = __webpack_require__(30);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _errors = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @namespace wix-users
 * @summary The wix-users module contains functionality for working with your
 *  site's users.
 * @description
 *  There are three types of users:
 *
 *  + Visitor - A user who is not logged into your site.
 *  + Member - A user who is logged into your site.
 *  + Admin - The owner of the site.
 *
 *
 *  To use the Users API, import `wixUsers` from the `wix-users` module:
 *
 *    ``` javascript
 *    import wixUsers from 'wix-users';
 *    ```
 *
 * The APIs in `wix-users` can only be used in front-end code.
 *
 * @note
 *  The APIs in `wix-users` are only partially functional when previewing your site.
 *  View a published version of your site to see their complete functionality.
 *
 *  The APIs in `wix-users` can only be used once the page has loaded. Therefore,
 *  you must use them in code that is contained in or is called from the
 *  [onReady()]($w.html#onReady) event handler or any element event handler.
 */

/**
 * @class wix-users.User
 * @summary A site user.
 */

/**
 * @member id
 * @label property
 * @syntax get id(): String
 * @summary Gets the user's ID.
 * @type {external:String}
 * @memberof wix-users.User
 * @description
 * The unique ID of the user.
 * @note
 *  The APIs in `wix-users` are only partially functional when previewing your site.
 *  View a published version of your site to see their complete functionality.
 *
 *  The APIs in `wix-users` can only be used once the page has loaded. Therefore,
 *  you must use them in code that is contained in or is called from the
 *  [onReady()]($w.html#onReady) event handler or any element event handler.
 * @snippet [User-id.es6=Get the user's ID]
 * @snippet [Users-currentUser.es6=Get the current user's information]
 * @readonly
 */

/**
 * @member loggedIn
 * @label property
 * @syntax get loggedIn(): Boolean
 * @summary Indicates whether the user is logged in or not.
 * @type {external:Boolean}
 * @memberof wix-users.User
 * @description
 *  Gets one of the following:
 *  + `true` — The user is logged in.
 *  + `false` — The user is not logged in.
 *
 *
 * @note
 *  The APIs in `wix-users` are only partially functional when previewing your site.
 *  View a published version of your site to see their complete functionality.
 *
 *  The APIs in `wix-users` can only be used once the page has loaded. Therefore,
 *  you must use them in code that is contained in or is called from the
 *  [onReady()]($w.html#onReady) event handler or any element event handler.
 * @snippet [User-loggedIn.es6=Get whether the user is logged in or not]
 * @snippet [Users-currentUser.es6=Get the current user's information]
 * @readonly
 */

/**
 * @member role
 * @label property
 * @syntax get role(): String
 * @summary Gets the user's role.
 * @description
 *  Gets one of the following roles:
 *  + `"Admin"` — The owner of the site.
 *  + `"Member"` — A user who is logged in.
 *  + `"Visitor"` — A user who is not logged in.
 *
 *
 * @note
 *  The APIs in `wix-users` are only partially functional when previewing your site.
 *  View a published version of your site to see their complete functionality.
 *
 *  The APIs in `wix-users` can only be used once the page has loaded. Therefore,
 *  you must use them in code that is contained in or is called from the
 *  [onReady()]($w.html#onReady) event handler or any element event handler.
 * @type {external:String}
 * @memberof wix-users.User
 * @snippet [User-role.es6=Get the user's role]
 * @snippet [Users-currentUser.es6=Get the current user's information]
 * @readonly
 */

/**
 * @function getEmail
 * @summary Gets the email of the current user.
 * @syntax
 * function getEmail(): Promise&lt;String&gt;
 * @description
 * The `getEmail()` function returns a Promise that resolves to the email address
 * of the user that is logged in or rejects if the current user is not logged in.
 * @note
 *  The APIs in `wix-users` are only partially functional when previewing your site.
 *  View a published version of your site to see their complete functionality.
 *
 *  The APIs in `wix-users` can only be used once the page has loaded. Therefore,
 *  you must use them in code that is contained in or is called from the
 *  [onReady()]($w.html#onReady) event handler or any element event handler.
 * @returns {Promise}
 * @fulfill {external:String} The email address of the user that is logged in.
 * @reject {external:String} Message containing error that the current user is not logged in.
 * @snippet [User-getEmail.es6=Get the user's email address]
 * @snippet [Users-currentUser.es6=Get the current user's information]
 * @memberof wix-users.User
 * @instance
 */

function getEmail() {
    var _this = this;

    return new Promise(function (resolve, reject) {
        if (!_this.loggedIn) {
            reject(_errors.userErrors.NO_LOGGED_IN);
            return;
        }

        postMessage.sendMessage(postMessage.Intent.WIX_CODE_SITE_API, postMessage.MessageTypes.SM_CURRENT_USER_EMAIL, null, function (email, error) {
            if (error) {
                reject(error);
            } else {
                resolve(email);
            }
        });
    });
}

var UserRoles = {
    VISITOR: 'Visitor',
    MEMBER: 'Member',
    ADMIN: 'Admin'
};

var LoginStatus = {
    APPLICANT: 'APPLICANT',
    ACTIVE: 'ACTIVE'
};

var User = function User(memberData) {
    _classCallCheck(this, User);

    if (memberData.uid) {
        this.id = memberData.uid;
        this.loggedIn = true;
        this.role = memberData.permissions ? UserRoles.ADMIN : UserRoles.MEMBER;
    } else {
        var RGI = _platformUtils2.default.getRGI();
        this.id = (0, _get2.default)(RGI.getSessionInfo(), 'svSession');
        this.loggedIn = false;
        this.role = UserRoles.VISITOR;
    }
    if (memberData.instance) {
        this.instance = memberData.instance;
    }
    if (memberData.instanceId) {
        this.instanceId = memberData.instanceId;
    }
    this.getEmail = getEmail.bind(this);
};

var Users = function () {
    function Users(appDefId) {
        _classCallCheck(this, Users);

        this.appDefId = appDefId;
    }

    /**
     * @member currentUser
     * @label property
     * @syntax
     * get currentUser(): User
     * @summary Gets the current user viewing the site.
     * @description
     *  Gets a [`User`](wix-users.User.html) object containing information about
     *  the user currently viewing the site.
     * @note
     *  The APIs in `wix-users` are only partially functional when previewing your site.
     *  View a published version of your site to see their complete functionality.
     *
     *  The APIs in `wix-users` can only be used once the page has loaded. Therefore,
     *  you must use them in code that is contained in or is called from the
     *  [onReady()]($w.html#onReady) event handler or any element event handler.
     * @snippet [Users-currentUser.es6=Get the current user's information]
     * @type {wix-users.User}
     * @memberof wix-users
     * @readonly
     */


    _createClass(Users, [{
        key: 'promptLogin',


        /**
         * @typedef {external:Object} wix-users~LoginOptions
         * @summary An object used by the `promptLogin()` function to determine how the login dialog box appears.
         * @property {external:String} [mode] What type of login experience to present: `"login"` or `"signup"`. Defaults to the option chosen in the Member Signup Settings panel in the Editor.
         * @property {external:String} [lang] The two letter language code of the language to show the login form in. Defaults to `"en"` if the property doesn't exist or the given language is not one of the languages found in the Permissions tab of the Page Settings panel in the Editor.
         * @snippet [Users-promptLogin_options.es6=Prompt the current user to login]
         * @see [promptLogin( )](#promptLogin)
         */

        /**
         * @function promptLogin
         * @syntax
         * function promptLogin([options: LoginOptions]): Promise&lt;User&gt;
         * @summary Prompts the current site visitor to log in as a site member.
         * @description
         *  The `promptLogin()` function returns a Promise that resolves to the newly
         *  logged in user when the login has completed.
         *
         *  The `promptLogin()` function cannot be called before the page is ready.
         * @note
         *  The APIs in `wix-users` are only partially functional when previewing your site.
         *  View a published version of your site to see their complete functionality.
         *
         *  The APIs in `wix-users` can only be used once the page has loaded. Therefore,
         *  you must use them in code that is contained in or is called from the
         *  [onReady()]($w.html#onReady) event handler or any element event handler.
         * @param {wix-users~LoginOptions} options The options that determine how the login dialog box appears.
         * @returns {Promise}
         * @fulfill {wix-users.User} Information about the newly logged in user.
         * @reject {external:String} Message that the dialog was canceled, or any other reason the user failed to log in.
         * @snippet [Users-promptLogin.es6=Prompt the current user to login]
         * @snippet [Users-promptLogin_options.es6=Prompt the current user to login with given options]
         * @see [promptForgotPassword( )](#promptForgotPassword)
         * @memberof wix-users
         */
        value: function promptLogin(options) {
            return new Promise(function (resolve, reject) {
                var requestParams = { callOnCancel: true };
                var language = (0, _get2.default)(options, 'lang');
                var mode = (0, _get2.default)(options, 'mode');

                if (!(0, _validation.validate)('Users', 'promptLogin', options)) {
                    reject();
                    return;
                }

                if (mode) {
                    requestParams.mode = mode;
                }

                if (language) {
                    requestParams.language = language;
                }

                postMessage.sendMessage(postMessage.Intent.WIX_CODE_SITE_API, postMessage.MessageTypes.SM_REQUEST_LOGIN, requestParams, function (data, error) {
                    if (error) {
                        reject(error);
                    } else if (data && data.wasCancelled) {
                        reject(_errors.userErrors.CLOSE_DIALOG);
                    } else if (!data || !(0, _isObject2.default)(data.data)) {
                        reject(_errors.userErrors.NO_LOGGED_IN);
                    } else if (data.data.status === LoginStatus.APPLICANT) {
                        reject(_errors.userErrors.AWAITING_APPROVAL);
                    } else {
                        resolve(new User({
                            uid: data.data.id,
                            permissions: data.data.owner
                        }));
                    }
                });
            });
        }

        /**
         * @function logout
         * @syntax
         * function logout(): void
         * @summary Logs the current user out of the site.
         * @description
         *  The `logout()` function logs the current user out of the site.
         * @note
         *  The APIs in `wix-users` are only partially functional when previewing your site.
         *  View a published version of your site to see their complete functionality.
         *
         *  The APIs in `wix-users` can only be used once the page has loaded. Therefore,
         *  you must use them in code that is contained in or is called from the
         *  [onReady()]($w.html#onReady) event handler or any element event handler.
         * @snippet [Users-logout.es6=Log out the current user]
         * @memberof wix-users
         */

    }, {
        key: 'logout',
        value: function logout() {
            return new Promise(function (resolve, reject) {
                postMessage.sendMessage(postMessage.Intent.WIX_CODE_SITE_API, postMessage.MessageTypes.SM_LOGOUT, null, function (data, error) {
                    if (error) {
                        reject(error);
                    } else {
                        resolve();
                    }
                });
            });
        }

        /**
         * @function promptForgotPassword
         * @syntax
         * function promptForgotPassword([language: String]): Promise&lt;void&gt;
         * @summary Prompts the current site visitor with a password reset.
         * @description
         *  The `promptForgotPassword()` function returns a Promise that resolves when
         *  the user has sumbitted the forgot password form.
         *
         *  The `promptForgotPassword()` function cannot be called before the page is ready.
         * @note
         *  The APIs in `wix-users` are only partially functional when previewing your site.
         *  View a published version of your site to see their complete functionality.
         *
         *  The APIs in `wix-users` can only be used once the page has loaded. Therefore,
         *  you must use them in code that is contained in or is called from the
         *  [onReady()]($w.html#onReady) event handler or any element event handler.
         * @param {external:String} [language] The language of the reset password form. Defaults to `"English"` if not passed or the given language is not one of the languages found in the Permissions tab of the Page Settings panel in the Editor.
         * @returns {Promise}
         * @fulfill {void}
         * @reject {external:String} Message that the dialog was canceled, user is already logged in, or any other reason the password reset failed.
         * @snippet [Users-promptForgotPassword.es6=Prompt the user with a password reset]
         * @snippet [Users-promptForgotPassword_options.es6=Prompt the current user to login with given language]
         * @see [promptLogin( )](#promptLogin)
         * @memberof wix-users
         */

    }, {
        key: 'promptForgotPassword',
        value: function promptForgotPassword(language) {
            return new Promise(function (resolve, reject) {
                var requestParams = (0, _isUndefined2.default)(language) ? {} : { language: language };

                if (!(0, _validation.validate)('Users', 'promptForgotPassword', requestParams)) {
                    reject();
                    return;
                }

                postMessage.sendMessage(postMessage.Intent.WIX_CODE_SITE_API, postMessage.MessageTypes.SM_FORGOT_PASSWORD, requestParams, function (data, error) {
                    if (error) {
                        reject(error);
                    } else {
                        resolve();
                    }
                });
            });
        }

        /**
         * @callback $w.LoginHandler
         * @summary Function that runs when a user has logged in.
         * @param {wix-users.User} user The user that has logged in.
         */

        /**
         * @function onLogin
         * @syntax
         * function onLogin(handler: LoginHandler): void
         * callback LoginHandler(): void
         * @summary Sets the function that runs when a user logs in.
         * @description
         *  Use the `onLogin()` function for code you want to run after a user successfully
         *  logs into your site.
         *
         *  Usually, you want to call the `onLogin()` function in the **Site** tab of the
         *  code panel so that the `onLogin()` event handler will be run no matter which
         *  page on your site a user uses to log in.
         * @note
         *  The APIs in `wix-users` are only partially functional when previewing your site.
         *  View a published version of your site to see their complete functionality.
         *
         *  The APIs in `wix-users` can only be used once the page has loaded. Therefore,
         *  you must use them in code that is contained in or is called from the
         *  [onReady()]($w.html#onReady) event handler or any element event handler.
         * @param {$w.LoginHandler} handler The name of the function or the function expression to run when a user has logged in.
         * @snippet [Users-onLogin.es6=Run code when a user logs in]
         * @memberof wix-users
         *  @eventhandler
         *  @eventtype
         */

    }, {
        key: 'onLogin',
        value: function onLogin(callback) {
            var _this2 = this;

            if (!(0, _validation.validate)('Users', 'onLogin', { onLogin: callback })) {
                return;
            }
            var RGI = _platformUtils2.default.getRGI();
            RGI.addOnUserLoginCallback(function () {
                callback(_this2.currentUser);
            });
        }

        /**
         * @typedef {external:Object} wix-users~TransactionalEmailOptions
         * @summary An object used when sending a Transactional Email.
         * @property {external:Object} variables An object with `key:value` pairs where each
         *  `key` is a variable in the email template created in Transactional Emails and its
         *  corresponding `value` is the value to insert into the template in place of
         *  variable. The values must be strings.
         * @snippet [Users-emailUser_variables.es6=Send a transactional email to the currently logged-in member]
         * @see [emailUser( )](#emailUser)
         */

        /**
         * @function emailUser
         * @syntax
         * function emailUser(emailId: String, toUser: string, [options: TransactionalEmailOptions]): Promise&lt;void&gt;
         * @summary Sends a Transactional Email to the currently logged-in site member.
         * @description
         *  The `emailUser()` function sends a Transactional Email to the currently
         *  logged-in site member.
         *
         *  Before using the `emailUser()` function, you will need to set up at least one
         *  Transactional Email. To learn more about Transactional Emails,
         *  see [About Transactional Emails](https://support.wix.com/en/article/about-transactional-emails).
         *  To learn how to create a Transactional Email, see
         *  [Creating a Transactional Email](https://support.wix.com/en/article/creating-a-transactional-email).
         *
         *  Specify which email to send by passing the email's ID in the `emailId` parameter.
         *
         *  Specify which member the email is sent to by passing the member's user ID in the `toUser`
         *  parameter. You can only send the email to the currently logged-in
         *  member. You can get that member's ID using the [`id`](wix-users.User.html#id) property
         *  of the [`currentUser`](#currentUser).
         *
         *  If the specified Transactional Email contains [variables](https://support.wix.com/en/article/using-variables-to-add-personalized-text),
         *  you can pass values for those variables using the optional `options` parameter.
         *  You pass a [`TransactionalEmailOptions`](#TransactionalEmailOptions) object
         *  which contains the values to be inserted into your email in place of the variables
         *  defined in that email. The values passed must be stings. If the object you
         *  pass to the `options` parameter does not contain a `key:value` pair for a
         *  variable in your Transactional Email, the fallback value defined when creating
         *  your Transactional Email will be inserted in place of the variable.
         *
         *  Note that Transactional Emails generates a code snippet for each of your email
         *  templates. The generated code includes the email's ID and keys for all the
         *  email's variable names. You can copy and paste the snippet into your code.
         *  Then you will need to define values for the `toUser` property and for each
         *  variable key. To learn how to use the generated snippet in your code, see
         *  [How to Send a Transactional Email with Code](https://support.wix.com/en/article/how-to-send-a-transactional-email-with-code).
         * @snippet [Users-emailUser.es6=Send a Transactional Email to the currently logged-in member]
         * @snippet [Users-emailUser_variables.es6=Send a Transactional Email with variable values]
         * @param {external:String} emailId The Email ID of the Transactional Email to send.
         * @param {external:String} toUser The User ID of the currently signed-in member.
         * @param {wix-users~TransactionalEmailOptions} [options] Variable values to insert into the email.
         * @returns {Promise}
         * @fulfill {void} When the email is sent.
         * @reject {external:String} Error message.
         * @memberof wix-users
         */

    }, {
        key: 'emailUser',
        value: function emailUser(emailId, toUser, options) {
            return new Promise(function (resolve, reject) {
                if (!(0, _validation.validate)('CRM', 'emailUser', { emailId: emailId, userId: toUser, emailOptions: options })) {
                    reject();
                    return;
                }
                postMessage.sendMessage(postMessage.Intent.WIX_CODE_SITE_API, 'sendUserEmail', { emailId: emailId, contactId: toUser, options: options }, function (data, error) {
                    if (error) {
                        var status = error.status,
                            responseText = error.responseText;

                        var errorMessage = void 0;
                        try {
                            errorMessage = JSON.parse(responseText).message;
                        } catch (e) {/*do nothing */}
                        reject((errorMessage || 'unknown failure') + ' (' + (status || 0) + ')');
                    } else {
                        resolve();
                    }
                });
            });
        }
    }, {
        key: 'currentUser',
        get: function get() {
            var RGI = _platformUtils2.default.getRGI();
            var siteMemberData = RGI.getSiteMemberData(this.appDefId);

            return new User(siteMemberData);
        }
    }]);

    return Users;
}();

exports.default = Users;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _contextService = __webpack_require__(130);

var _reporter = __webpack_require__(10);

var _reporter2 = _interopRequireDefault(_reporter);

var _postMessage2 = __webpack_require__(18);

var _postMessage = _interopRequireWildcard(_postMessage2);

var _platformUtils = __webpack_require__(13);

var _platformUtils2 = _interopRequireDefault(_platformUtils);

var _viewMode = __webpack_require__(235);

var _viewMode2 = _interopRequireDefault(_viewMode);

var _urlUtils = __webpack_require__(24);

var urlUtils = _interopRequireWildcard(_urlUtils);

var _formFactor = __webpack_require__(92);

var _formFactor2 = _interopRequireDefault(_formFactor);

var _find = __webpack_require__(62);

var _find2 = _interopRequireDefault(_find);

var _has = __webpack_require__(85);

var _has2 = _interopRequireDefault(_has);

var _isUndefined = __webpack_require__(30);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _isNil = __webpack_require__(4);

var _isNil2 = _interopRequireDefault(_isNil);

var _validation = __webpack_require__(1);

var _utils = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WINDOW_COMP_ID = 'WINDOW';

/**
 * @namespace wix-window
 * @summary The wix-window module contains functionality that pertains to the
 *  current browser window.
 * @description
 *  To use the window module, import `wixWindow` from the `wix-window` module:
 *
 *    ``` javascript
 *    import wixWindow from 'wix-window';
 *    ```
 *
 *  The APIs in `wix-window` can only be used in front-end code.
 */

var Lightbox = function () {
    function Lightbox() {
        _classCallCheck(this, Lightbox);
    }

    _createClass(Lightbox, [{
        key: 'getContext',


        /**
         * @function getContext
         * @syntax
         * function getContext(): Object
         * @summary Returns the data object that was passed to a lightbox.
         * @description
         *  The `getContext()` function returns the data object passed when the lightbox
         *  was opened using the [`openLightbox()`](wix-window.html#openLightbox) function,
         *  if any data was passed. If the lightbox was opened another way,
         *  `getContext()` returns `undefined`.
         * @snippet [Lightbox-getContext.es6=Get the data that was passed to the lightbox]
         * @returns {external:Object} The data object that was passed to the lightbox.
         * @memberof wix-window.lightbox
         */
        value: function getContext() {
            return (0, _contextService.getLightboxContext)();
        }

        /**
         * @function close
         * @syntax
         * function close([data: Object]): void
         * @summary Closes the lightbox.
         * @description
         * The `close` function closes the lightbox and returns the given data to the
         * [`openLightbox()`](wix-window.html#openLightbox) function that was used to
         * open the lightbox.
         * @snippet [Lightbox-close.es6=Close the lightbox]
         * @snippet [Lightbox-close_options.es6=Close the lightbox and pass back data to the opening function]
         * @param {external:Object} [data] The data to pass back to [`openLightbox()`](wix-window.html#openLightbox) function.
         * @memberof wix-window.lightbox
         */

    }, {
        key: 'close',
        value: function close(returnedData) {
            var contextId = _platformUtils2.default.getContextId();
            var popups = _platformUtils2.default.getRMI('wix-window.lightbox.close').getSiteStructure().lightboxes;
            if (!(0, _find2.default)(popups, { id: contextId })) {
                _reporter2.default.reportSdkError('The current page is not a lightbox and therefore cannot be closed');
                return;
            }
            _postMessage.sendMessage(_postMessage.Intent.WIX_CODE_SITE_API, _postMessage.MessageTypes.CLOSE_LIGHTBOX, {
                id: contextId,
                returnedData: returnedData
            });
        }
    }]);

    return Lightbox;
}();

var RenderingContext = function () {
    function RenderingContext() {
        _classCallCheck(this, RenderingContext);
    }

    _createClass(RenderingContext, [{
        key: 'renderCycle',

        /**
         * @member renderCycle
         * @label property
         * @syntax
         * get renderCycle(): Number
         * @summary Gets the current cycle in the rendering process.
         * @description
         *  When possible, the rendering process is split in two in order to
         *  improve performance. The first cycle in the process happens server-side
         *  and the second cycle happens client-side. When not possible, all rendering
         *  happens client-side.
         *
         *  When the rendering is split, `renderCycle` returns `1` on the server
         *  and `2` on the client.
         *
         *  When all the rendering happens client-side, `renderCycle` returns `1`
         *  while the rendering process is still running.
         *
         *  In either case, after the client-side rendering has finished,
         *  `renderCycle` returns `NaN`.
         *
         *  Use the `renderCycle` property in your page's [`onReady()`]($w.html#onReady)
         *  event handler to control during which cycles your code runs.
         * @note
         *  Rendering will never occur server-side when previewing your site.
         * @snippet [Rendering-renderCycle.es6=Get the current cycle in the rendering process]
         * @snippet [Rendering-renderCycle_scenario.es6=Use rendering cycle number to selectively run code per cycle]
         * @type {external:Number}
         * @memberof wix-window.rendering
         * @readonly
         **/
        get: function get() {
            return Number(urlUtils.getQueryParameter("renderCycle")) || NaN;
        }

        /**
         * @member env
         * @label property
         * @syntax
         * get env(): String
         * @summary Gets the current environment the rendering process is running in.
         * @description
         *  When possible, the rendering process is split in two in order to
         *  improve performance. The first cycle in the process happens server-side
         *  and the second cycle happens client-side. When not possible, all rendering
         *  happens client-side.
         *
         *  The `env` property returns `"backend"` when rendering on the server
         *  and `"browser"` when rendering on the client.
         *
         *  Use the `env` property in your page's [`onReady()`]($w.html#onReady)
         *  event handler to control where your code runs during the rendering
         *  process.
         * @note
         *  Rendering will never occur server-side when previewing your site.
         * @snippet [Rendering-env.es6=Get the current cycle in the rendering process]
         * @snippet [Rendering-env_scenario.es6=Use rendering environment to selectively run code per environment]
         * @type {external:String}
         * @memberof wix-window.rendering
         * @readonly
         **/

    }, {
        key: 'env',
        get: function get() {
            return urlUtils.getQueryParameter("renderingEnv") || "browser";
        }
    }, {
        key: 'warmupData',
        get: function get() {
            var uw = urlUtils.getQueryParameter("userWarmup");
            return uw && uw['wix-code'];
        }
    }]);

    return RenderingContext;
}();

var Window = function () {
    function Window(appDefId) {
        _classCallCheck(this, Window);

        this.appDefId = appDefId;
    }

    /**
     * @namespace wix-window.rendering
     * @summary The Rendering API is used to control when code is run as a page is being loaded.
     * @description
     *  When possible, the rendering process that runs when your page loads is
     *  split in two in order to improve performance. The first cycle in the process
     *  happens server-side and the second cycle happens client-side. When not
     *  possible, all rendering happens client-side.
     *
     *  Use the Rendering API to track when and where your code is running to
     *  selectively run parts of your code in certain conditions.
     *
     *  To use the Rendering API, import `wixWindow` from the `wix-window` module:
     *
     *    ``` javascript
     *    import wixWindow from 'wix-window';
     *    ```
     *
     *  To learn more about the rendering process, see [About the Page Rendering Process](https://support.wix.com/en/article/about-the-page-rendering-process).
     */


    _createClass(Window, [{
        key: 'init',
        value: function init(params) {
            urlUtils.setQueryParameters(params);
        }

        /**
         * @typedef {external:Object} wix-window~WindowSizeInfo
         * @summary An object returned by the `getBoundingRect()` function that contains information about the window's size, the document's size, and the current scroll position.
         * @property {external:Object} window An object with `height` and `width` key:value pairs containing the size of the viewable area of the current browser window.
         * @property {external:Object} document An object with `height` and `width` key:value pairs containing the size of the actual body of the page, which may be larger or smaller than the current window.
         * @property {external:Object} scroll An object with `x` and `y` key:value pairs containing the scroll offset of the page within the window from the top-left corner.
         * @snippet [Window-getBoundingRect.es6=Get information about the window]
         * @see [getBoundingRect( )](#getBoundingRect)
         */

        /**
         * @function getBoundingRect
         * @syntax
         * function getBoundingRect(): Promise&lt;WindowSizeInfo&gt;
         * @summary Returns information about the window.
         * @description
         *  The `getBoundingRect()` function returns a Promise that resolves to an object
         *  containing information about the current window's size, the document's size,
         *  and the current scroll position.
         * @returns {Promise}
         * @fulfill {wix-window~WindowSizeInfo} An object containing information about the window's size, the document's size, and the current scroll position.
         * @snippet [Window-getBoundingRect.es6=Get information about the window]
         * @memberof wix-window
         */

    }, {
        key: 'getBoundingRect',
        value: function getBoundingRect() {
            return new Promise(function (resolve, reject) {
                _postMessage.sendMessage(_postMessage.Intent.WIX_CODE_SITE_API, _postMessage.MessageTypes.WINDOW_BOUNDING_RECT, {}, function (data, error) {
                    if (error) {
                        reject(error);
                    } else {
                        resolve(data);
                    }
                });
            });
        }

        /**
         * @function scrollTo
         * @syntax
         * function scrollTo(x: Number, y: Number): Promise&lt;void&gt;
         * @summary Scrolls the page to a specific location.
         * @description
         *  The `scrollTo()` function returns a Promise that resolves when the current
         *  page has been scrolled to the given location.
         *
         *  The `x` and `y` parameters determine the top-left pixel that will be
         *  displayed on screen after the scroll.
         *
         *  To scroll to a specific element on the page, see the `$w.Node`
         *  [`scrollTo()`]($w.Node.html) function.
         * @snippet [Window-scrollTo.es6=Scroll the page to a location]
         * @snippet [Window-scrollTo_then.es6=Scroll the page to a location and log message when done]
         * @param {external:Number} x The horizontal position, in pixels, to scroll to.
         * @param {external:Number} y The vertical position, in pixels, to scroll to.
         * @returns {Promise}
         * @fulfill {void} When the scroll is complete.
         * @memberof wix-window
         */

    }, {
        key: 'scrollTo',
        value: function scrollTo(x, y) {
            var validtionObj = {};
            if (!(0, _isNil2.default)(x)) {
                validtionObj.x = x;
            }
            if (!(0, _isNil2.default)(y)) {
                validtionObj.y = y;
            }
            return new Promise(function (resolve, reject) {
                if (!(0, _validation.validate)('Window', 'scrollTo', validtionObj)) {
                    reject({});
                    return;
                }
                var args = { x: x, y: y, scrollAnimation: true, requiresDom: { compId: WINDOW_COMP_ID } };
                _postMessage.sendMessage(_postMessage.Intent.WIX_CODE_SITE_API, _postMessage.MessageTypes.SCROLL_TO, args, function (data, err) {
                    if (err) {
                        reject(err);
                    } else {
                        resolve(data);
                    }
                });
            });
        }

        /**
         * @function scrollBy
         * @syntax
         * function scrollBy(x: Number, y: Number): Promise&lt;void&gt;
         * @summary Scrolls the page by a given number of pixels.
         * @description
         *  The `scrollBy()` function returns a Promise that resolves when the current
         *  page has been scrolled by the given number of pixels,
         *
         *  The `x` and `y` parameters determine the number of horizontal and vertical
         *  pixels to scroll the current page. Negative numbers scroll up or to the
         *  left and positive numbers scroll down or to the right.
         * @snippet [Window-scrollBy.es6=Scroll the page by a given number of pixels]
         * @snippet [Window-scrollBy_then.es6=Scroll the page by a given number of pixels and log message when done]
         * @param {external:Number} x The horizontal offset, in pixels, to scroll by.
         * @param {external:Number} y The vertical offset, in pixels, to scroll by.
         * @returns {Promise}
         * @fulfill {void} When the scroll is complete.
         * @memberof wix-window
         */

    }, {
        key: 'scrollBy',
        value: function scrollBy(x, y) {
            if ((0, _isNil2.default)(x)) {
                x = 0;
            }
            if ((0, _isNil2.default)(y)) {
                y = 0;
            }
            return new Promise(function (resolve, reject) {
                var args = { x: x, y: y, requiresDom: { compId: WINDOW_COMP_ID } };
                if (!(0, _validation.validate)('Window', 'scrollBy', { x: x, y: y })) {
                    reject({});
                    return;
                }
                _postMessage.sendMessage(_postMessage.Intent.WIX_CODE_SITE_API, _postMessage.MessageTypes.SCROLL_BY, args, function (data, err) {
                    if (err) {
                        reject(err);
                    }
                    resolve(data);
                });
            });
        }

        /**
         * @function getRouterData
         * @syntax
         * function getRouterData(): Object
         * @summary Returns the data that a router passed to the page in its response.
         * @returns {external:Object} The data returned by the router.
         * @description
         *  When you create a router and define its functionality in its [router()](wix-router.html#router)
         *  function, you can choose to send data along with the router's [response](wix-router.WixRouterResponse.html).
         *  That data is retrieved in the code of the page that was routed to using the
         *  `getRouterData()` function.
         *
         *  If you call the `getRouterData()` function from a non-router page or a router
         *  page that wasn't sent any data, the function returns `null`.
         * @memberof wix-window
         * @snippet [Window-getRouterData.es6=Get the data passed by a router]
         * @see [router( )](wix-router.html#router)
         * @see [WixRouterResponse](wix-router.WixRouterResponse.html)
         */

    }, {
        key: 'getRouterData',
        value: function getRouterData() {
            return self.routerData || null;
        }

        /**
         * @function getCurrentGeolocation
         * @syntax
         * function getCurrentGeolocation(): Promise&lt;Object&gt;
         * @summary Returns the current geolocation of the user.
         * @description
         *  The `getCurrentGeolocation()` function returns a Promise that resolves to an
         *  object containing the current geolocation of the user.
         *
         *  The object contains the following key:value pairs:
         *  + `"timestamp"` - The geolocation timestamp representing the date and time at which the location was retrieved.
         *  + `"coords"` - An object that defines the location.
         *    + `"latitude"` - The position's latitude in decimal degrees.
         *    + `"longitude"` - The position's longitude in decimal degrees.
         *    + `"altitude"` - The position's altitude in metres, relative to sea level. This value may be null if the browser cannot provide the data.
         *    + `"accuracy"` - The accuracy in meters of the latitude and longitude properties.
         *    + `"altitudeAccuracy"` - The accuracy in meters of the altitude property. This value may be null.
         *    + `"heading"` - The direction in degrees in which the device is traveling. It indicates how far off from heading true north the device is. If `speed` is `0`, the heading is `NaN`. This value may be null if the browser cannot provide the data.
         *    + `"speed"` - The velocity in meters per second of the device. This value may be null if the browser cannot provide the data.
         *
         *
         * @note
         *  The `getCurrentGeolocation()` function has the following limitiations:
         *  + On Chrome, the function will only work on HTTPS sites.
         *  + On Chrome, Firefox, and Safari, the function will only work if the user
         *    approves a popup.
         * @snippet [Window-getCurrentGeolocation.es6=Get the geolocation data]
         * @returns {Promise}
         * @fulfill {external:Object} The coordinates and timestamp of the current location.
         * @reject {String} The user blocked the geolocation popup.
         * @memberof wix-window
         */

    }, {
        key: 'getCurrentGeolocation',
        value: function getCurrentGeolocation() {
            return new Promise(function (resolve, reject) {
                _postMessage.sendMessage(_postMessage.Intent.WIX_CODE_SITE_API, _postMessage.MessageTypes.GET_CURRENT_GEOLOCATION, null, function (data, error) {
                    if (error) {
                        reject(error);
                    } else {
                        resolve(data);
                    }
                });
            });
        }

        /**
         * @function openLightbox
         * @syntax
         * function openLightbox(name: String, [data: Object]): Promise&lt;Object&gt;
         * @summary Opens a lightbox and optionally passes it the given data.
         * @description
         *  The `openLightbox()` function returns a Promise which is resolved when the
         *  lightbox closes. If the lightbox is closed programmatically using its
         *  [`close()`](wix-window.lightbox.html#close) function, and the
         *  [`close()`](wix-window.lightbox.html#close) function was invoked
         *  with a data parameter, then the Promise resolves to that data object.
         *
         *  If you send a data object to the lightbox, use the [`getContext()`](#getContext)
         *  function in the lightbox's code to access the received data.
         * @note
         *  Use the name of the lightbox and not the lightbox's ID when calling
         *  `openLightbox()`.
         * @snippet [Window-openLightbox.es6=Open a lightbox]
         * @snippet [Window-openLightbox_options.es6=Open a lightbox and send it data]
         * @snippet [Window-openLightbox_then.es6=Open a lightbox and receive data when it is closed]
         * @snippet [Window-openLightbox_options_then.es6=Open a lightbox, send it data, and receive data back when it is closed]
         * @param {external:String} name The name of the lightbox to open.
         * @param {external:Object} [data] The data to pass to the lightbox.
         * @returns {external:Promise}
         * @fulfill {external:Object} The returned data from the lightbox.
         * @reject {external:Error} The error that caused the rejection.
         * @memberof wix-window
         */

    }, {
        key: 'openLightbox',
        value: function openLightbox(name, data) {
            return new Promise(function (resolve, reject) {
                var isValid = (0, _validation.validate)('Lightbox', 'name', { name: name });
                if (!isValid) {
                    return reject('Lightbox title is not a valid input');
                }
                var popups = _platformUtils2.default.getRMI('wix-window.openLightbox').getSiteStructure().lightboxes;
                var popupInfo = (0, _find2.default)(popups, { name: name });

                if (!(0, _has2.default)(popupInfo, 'id')) {
                    return reject('There is no lightbox with the title "' + name + '".');
                }
                var message = { id: popupInfo.id };
                if (!(0, _isUndefined2.default)(data)) {
                    message.context = data;
                }
                _postMessage.sendMessage(_postMessage.Intent.WIX_CODE_SITE_API, _postMessage.MessageTypes.OPEN_LIGHTBOX, message, function (data, err) {
                    if (err) {
                        reject(err);
                    } else {
                        resolve(data);
                    }
                });
            });
        }

        /**
         * @typedef {external:Object} wix-window~AddPaymentInfoEvent
         * @summary An object used when sending an AddPaymentInfo track event.
         * @property {external:String} option Describes option information on a checkout page, such as selected payment method.
         * @snippet [Window-trackEvent-AddPaymentInfo.es6=Send an AddPaymentInfo trackEvent]
         * @see [trackEvent( )](#trackEvent)
         */

        /**
         * @typedef {external:Object} wix-window~AddProductImpressionEvent
         * @summary An object used when sending an AddProductImpression track event.
         * @property {external:Object[]} contents Product information.
         * @property {external:String} [contents[].id] - Product ID.
         * @property {external:String} [contents[].sku] - Stock keeping unit code.
         * @property {external:String} contents[].name - Product name.
         * @property {external:String} [contents[].category] - Category of the page or product.
         * @property {external:Number} [contents[].price] - Product price.
         * @property {external:String} [contents[].currency] - Currency code.
         * @property {external:String} [contents[].brand] - Brand name of the product.
         * @property {external:String} [contents[].variant] - Variant of the product.
         * @property {external:String} [contents[].list] - List or collection the product is in.
         * @property {external:String} [contents[].position] - Product's position in a list or collection.
         * @snippet [Window-trackEvent-AddProductImpression.es6=Send an AddProductImpression trackEvent]
         * @see [trackEvent( )](#trackEvent)
         */

        /**
         * @typedef {external:Object} wix-window~AddToCartEvent
         * @summary An object used when sending an AddToCart track event.
         * @property {external:String} [id] - Product ID.
         * @property {external:String} [sku] - Stock keeping unit code.
         * @property {external:String} name - Product name.
         * @property {external:Number} [price] - Product price.
         * @property {external:String} [currency] - Currency code.
         * @property {external:String} [category] - Category of the page or product.
         * @property {external:String} [brand] - Brand name of the product.
         * @property {external:String} [variant] - Variant of the product.
         * @property {external:String} [position] - Product's position in a list or collection.
         * @property {external:Number} [quantity] - Product quantity.
         * @snippet [Window-trackEvent-AddToCart.es6=Send an AddToCart trackEvent]
         * @see [trackEvent( )](#trackEvent)
         */

        /**
         * @typedef {external:Object} wix-window~ClickProductEvent
         * @summary An object used when sending a ClickProduct track event.
         * @property {external:String} [id] - Product ID.
         * @property {external:String} [sku] - Stock keeping unit code.
         * @property {external:String} name - Product name.
         * @property {external:Number} [price] - Product price.
         * @property {external:String} [currency] - Currency code.
         * @property {external:String} [category] - Category of the page or product.
         * @property {external:String} [brand] - Brand name of the product.
         * @property {external:String} [variant] - Variant of the product.
         * @property {external:String} [list] - List or collection the product is in.
         * @property {external:String} [position] - Product's position in a list or collection.
         * @snippet [Window-trackEvent-ClickProduct.es6=Send a ClickProduct trackEvent]
         * @see [trackEvent( )](#trackEvent)
         */

        /**
         * @typedef {external:Object} wix-window~CustomEvent
         * @summary An object used when sending a CustomEvent track event.
         * @description
         *  The object contains on required property, `event`, and any number of
         *  custom properties.
         * @property {external:String} event - Product ID.
         * @snippet [Window-trackEvent-CustomEvent.es6=Send a CustomEvent trackEvent]
         * @see [trackEvent( )](#trackEvent)
         */

        /**
         * @typedef {external:Object} wix-window~InitiateCheckoutEvent
         * @summary An object used when sending an InitiateCheckout track event.
         * @property {external:Object[]} contents Product information.
         * @property {external:String} [contents[].id] - Product ID.
         * @property {external:String} [contents[].sku] - Stock keeping unit code.
         * @property {external:String} contents[].name - Product name.
         * @property {external:String} [contents[].category] - Category of the page or product.
         * @property {external:Number} [contents[].price] - Product price.
         * @property {external:String} [contents[].currency] - Currency code.
         * @property {external:String} [contents[].brand] - Brand name of the product.
         * @property {external:String} [contents[].variant] - Variant of the product.
         * @property {external:Number} [contents[].quantity] - Product quantity.
         * @snippet [Window-trackEvent-InitiateCheckout.es6=Send an InitiateCheckout trackEvent]
         * @see [trackEvent( )](#trackEvent)
         */

        /**
         * @typedef {external:Object} wix-window~PurchaseEvent
         * @summary An object used when sending a Purchase track event.
         * @property {external:String} [id] - Product ID.
         * @property {external:String} [affiliation] - Name of the store where the event occurred.
         * @property {external:Number} [revenue] - Total amount of the purchase including shipping, taxes, etc.
         * @property {external:Number} [tax] - Total tax charge.
         * @property {external:Number} [shipping] - Total shipping charge.
         * @property {external:String} [coupon] - Coupon code applied to the transaction.
         * @property {external:Object[]} contents Product information.
         * @property {external:String} [contents[].id] - Product ID.
         * @property {external:String} contents[].name - Product name.
         * @property {external:String} [contents[].category] - Category of the page or product.
         * @property {external:Number} [contents[].price] - Product price.
         * @property {external:String} [contents[].currency] - Currency code.
         * @property {external:String} [contents[].brand] - Brand name of the product.
         * @property {external:String} [contents[].variant] - Variant of the product.
         * @property {external:Number} [contents[].quantity] - Product quantity.
         * @snippet [Window-trackEvent-Purchase.es6=Send a Purchase trackEvent]
         * @see [trackEvent( )](#trackEvent)
         */

        /**
         * @typedef {external:Object} wix-window~RemoveFromCartEvent
         * @summary An object used when sending a RemoveFromCart track event.
         * @property {external:String} [id] - Product ID.
         * @property {external:String} name - Product name.
         * @property {external:Number} [price] - Product price.
         * @property {external:String} [currency] - Currency code.
         * @property {external:String} [category] - Category of the page or product.
         * @property {external:String} [brand] - Brand name of the product.
         * @property {external:String} [variant] - Variant of the product.
         * @property {external:String} [position] - Product's position in a list or collection.
         * @property {external:Number} [quantity] - Product quantity.
         * @snippet [Window-trackEvent-RemoveFromCart.es6=Send a RemoveFromCart trackEvent]
         * @see [trackEvent( )](#trackEvent)
         */

        /**
         * @typedef {external:Object} wix-window~ViewContentEvent
         * @summary An object used when sending a ViewContent track event.
         * @property {external:String} [id] - Product ID.
         * @property {external:String} [sku] - Stock keeping unit code.
         * @property {external:String} name - Product name.
         * @property {external:Number} [price] - Product price.
         * @property {external:String} [currency] - Currency code.
         * @property {external:String} [category] - Category of the page or product.
         * @property {external:String} [brand] - Brand name of the product.
         * @property {external:String} [variant] - Variant of the product.
         * @property {external:String} [list] - List or collection the product is in.
         * @property {external:String} [position] - Product's position in a list or collection.
         * @snippet [Window-trackEvent-ViewContent.es6=Send a ViewContent trackEvent]
         * @see [trackEvent( )](#trackEvent)
         */

        /**
         * @function trackEvent
         * @syntax
         * function trackEvent(eventName: TrackEvent, parameters: Object): void
         * type TrackEvent = "AddPaymentInfo" | "AddProductImpression"
         * | "AddToCart" | "ClickProduct" | "CustomEvent"
         * | "InitiateCheckout" | "Lead" | "Purchase" | "RemoveFromCart"
         * | "ViewContent"
         * @summary Sends a tracking event to external analytics tools.
         * @description
         *  The `trackEvent()` function sends an event to analytics tools connected
         *  to your site. It can send events to Google Analytics and Facebook Pixel.
         *  To learn how to connect analytics tools to your site, see
         *  [About Tracking Tools & Analytics](https://support.wix.com/en/article/about-tracking-tools-analytics).
         *
         *  The following events and parameters are available:
         *
         *  + `"AddProductImpression"` - [parameters](#AddProductImpressionEvent) - When a user views a product. (Google Analytics only)
         *  + `"ClickProduct"` - [parameters](#ClickProductEvent) - When a user clicks on a product. (Google Analytics only)
         *  + `"ViewContent"` - [parameters](#ViewContentEvent) - When a key page is viewed.
         *  + `"AddToCart"` - [parameters](#AddToCartEvent) - When a user adds a product to the shopping cart.
         *  + `"RemoveFromCart"` - [parameters](#RemoveFromCartEvent) - When a user removes a product from the shopping cart. (Google Analytics only)
         *  + `"InitiateCheckout"` - [parameters](#InitiateCheckoutEvent) - When a user starts the checkout process.
         *  + `"AddPaymentInfo"` - [parameters](#AddPaymentInfoEvent) - When a user saves payment information.
         *  + `"Purchase"` - [parameters](#PurchaseEvent) - When the checkout process is complete.
         *  + `"Lead"` - When a user subscribes to a newsletter or submits a contact form.
         *  + `"CustomEvent"` - [parameters](#CustomEvent) - When a user performs an event not listed above.
         *
         *
         * @note
         *  The `trackEvent()` function does not work when previewing your site. It
         *  only runs on published versions of your site.
         * @snippet [Window-trackEvent-ViewContent.es6=Send a trackEvent with parameters]
         * @snippet [Window-trackEvent-Lead.es6=Send a trackEvent that doesn't take any parameters]
         * @param {external:String} eventName The name of the event.
         * @param {external:Object} parameters The event's parameters.
         * @memberof wix-window
         */

    }, {
        key: 'trackEvent',
        value: function trackEvent(eventName, data, options) {
            var validtionObj = { data: data, options: options };
            if (!(0, _isNil2.default)(eventName)) {
                validtionObj.eventName = eventName;
            }
            if (!(0, _validation.validate)('trackEvent', 'trackEvent', validtionObj, true)) {
                return;
            }

            var message = { eventName: eventName };
            if (!(0, _isNil2.default)(data)) {
                message.params = data;
            }
            if (!(0, _isNil2.default)(options)) {
                message.options = options;
            }
            _postMessage.sendMessage(_postMessage.Intent.WIX_CODE_SITE_API, _postMessage.MessageTypes.TRACK_EVENT, message);
        }

        /*
         * @function openModal
         * @syntax placeholder
         * @summary placeholder
         * @description placeholder
         */

    }, {
        key: 'openModal',
        value: function openModal(url, options) {
            return new Promise(function (resolve, reject) {
                var isValid = (0, _validation.validate)('modal', 'openModal', { url: url, options: options }, true);
                if (!isValid) {
                    return reject('Modal arguments are not defined correctly');
                }

                var modalProtocol = urlUtils.parseUrl(url).protocol;
                var RGI = _platformUtils2.default.getRGI();
                var siteUrl = urlUtils.getUrlFromRGI(RGI);
                var siteProtocol = urlUtils.parseUrl(siteUrl).protocol;

                if (modalProtocol === 'http' && siteProtocol === 'https') {
                    return reject('Mix protocol is not allowed. Modal url protocol is ' + modalProtocol + ', and the page is ' + siteProtocol);
                }

                var width = options.width,
                    height = options.height,
                    theme = options.theme;

                _postMessage.sendMessage(_postMessage.Intent.WIX_CODE_SITE_API, _postMessage.MessageTypes.OPEN_MODAL, {
                    url: url,
                    width: width,
                    height: height,
                    theme: theme
                }, function (data, error) {
                    if (error) {
                        reject(error);
                    } else {
                        resolve(data);
                    }
                });
            });
        }
    }, {
        key: 'postMessage',
        value: function postMessage(payload, target) {
            if (!(0, _validation.validate)('Window', 'postMessage', { payload: payload, target: target })) {
                return;
            }
            _postMessage.sendMessage(_postMessage.Intent.WIX_CODE_SITE_API, _postMessage.MessageTypes.SEND_MESSAGE_TO_PARENT, payload);
        }
    }, {
        key: 'rendering',
        get: function get() {
            return new RenderingContext();
        }

        /**
         * @namespace wix-window.lightbox
         * @summary A <a href="https://support.wix.com/en/article/about-lightboxes" target="_blank">lightbox</a> pops up on your site to grab your visitor's attention.
         * @description
         *  To use the Lightbox API, import `wixWindow` from the `wix-window` module:
         *
         *    ``` javascript
         *    import wixWindow from 'wix-window';
         *    ```
         *
         * The APIs in `wix-window.lightbox` can only be used in front-end code.
         */

    }, {
        key: 'lightbox',
        get: function get() {
            return new Lightbox();
        }

        /**
         * @member viewMode
         * @label property
         * @syntax
         * get viewMode(): "Preview" | "Site"
         * @summary Gets which mode the site is currently being viewed in.
         * @description
         *  The `viewMode` property gets either:
         *
         *  + `"Preview"` - When previewing the site using the **Preview** button in the Editor.
         *  + `"Site"` - When viewing the published site.
         * @snippet [Window-viewMode.es6=Get a window's view mode]
         * @type {external:String}
         * @memberof wix-window
         * @readonly
         */

    }, {
        key: 'viewMode',
        get: function get() {
            return (0, _utils.capitalize)(_viewMode2.default.getViewMode());
        }

        /**
         * @member formFactor
         * @label property
         * @syntax
         * get formFactor(): "Desktop" | "Mobile"
         * @summary Gets what kind of device is being used to view the page.
         * @description
         *  The `formFactor` property gets either:
         *
         *  + `"Desktop"` - When viewed in a desktop browser.
         *  + `"Mobile"`  - When viewed in a mobile browser.
         * @snippet [Window-formFactor.es6=Get a device's form factor]
         * @type {external:String}
         * @memberof wix-window
         * @readonly
         */

    }, {
        key: 'formFactor',
        get: function get() {
            return (0, _utils.capitalize)(_formFactor2.default.getDeviceType());
        }

        /**
         * @member locale
         * @label property
         * @syntax
         * get locale(): String
         * @summary Gets the locale of the current environment.
         * @description
         *  A locale, also known as an IETF language tag, is an abbreviated code
         *  that defines the user's language, country, and other aspects of the user
         *  interface such as number format and date format.
         *
         *  Some common locales include:
         *  + `"en"` - English
         *  + `"es"` - Spanish
         *  + `"de"` - German
         *  + `"ja"` - Japanese
         *  + `"fr"` - French
         *  + `"it"` - Italian
         * @snippet [Window-locale.es6=Get an environment's locale]
         * @type {external:String}
         * @memberof wix-window
         * @readonly
         */

    }, {
        key: 'locale',
        get: function get() {
            return urlUtils.getQueryParameter("locale");
        }

        /**
         * @member referrer
         * @label property
         * @syntax
         * get referrer(): String
         * @summary Gets the HTTP referrer header field.
         * @description
         *  The `referrer` is the address of the previous web page that the user was
         *  on before arriving at the current page, typically by clicking a link.
         * @snippet [Window-referrer.es6=Get the referrer information]
         * @type {external:String}
         * @memberof wix-window
         * @readonly
         **/

    }, {
        key: 'referrer',
        get: function get() {
            return urlUtils.getQueryParameter("referrer");
        }
    }]);

    return Window;
}();

exports.default = Window;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isFunction = __webpack_require__(29);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isArray = __webpack_require__(6);

var _isArray2 = _interopRequireDefault(_isArray);

var _without = __webpack_require__(201);

var _without2 = _interopRequireDefault(_without);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isString = __webpack_require__(36);

var _isString2 = _interopRequireDefault(_isString);

var _find = __webpack_require__(62);

var _find2 = _interopRequireDefault(_find);

var _ui = __webpack_require__(95);

var ui = _interopRequireWildcard(_ui);

var _document = __webpack_require__(210);

var _document2 = _interopRequireDefault(_document);

var _componentsBatchFunctions = __webpack_require__(93);

var _componentsBatchFunctions2 = _interopRequireDefault(_componentsBatchFunctions);

var _utils = __webpack_require__(9);

var _readyManager = __webpack_require__(131);

var _wixSelectorUtils = __webpack_require__(236);

var _wixSelectorUtils2 = _interopRequireDefault(_wixSelectorUtils);

var _HiddenCollapsedElement = __webpack_require__(138);

var _HiddenCollapsedElement2 = _interopRequireDefault(_HiddenCollapsedElement);

var _assign = __webpack_require__(11);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WixSelector = function () {
  function WixSelector() {
    _classCallCheck(this, WixSelector);
  }

  _createClass(WixSelector, [{
    key: 'initialize',
    value: function initialize(RMI, contextId, emitter) {
      this.RMI = RMI;
      this.contextId = contextId;
      this.emitter = emitter;
    }
  }, {
    key: 'scoped$W',
    value: function scoped$W(controllerId, logName) {
      var _this = this;

      var $w = function $w(selector) {
        return _this.$w.call(_this, controllerId, logName, selector, false);
      };
      $w.scoped = function (selector) {
        return _this.$w.call(_this, controllerId, logName, selector, true);
      };

      return $w;
    }
  }, {
    key: '$w',
    value: function $w(controllerId, logName, compSelector, onlyNestedScope) {
      var _this2 = this;

      if ((0, _isFunction2.default)(compSelector)) {
        (0, _readyManager.onReady)(compSelector, logName);
        return;
      }

      if (!(0, _isString2.default)(compSelector)) {
        throw new Error("The value passed to the element selector function (usually $w), must be of type string");
      }

      if (!this.RMI) {
        throw new Error("The element selector function (usually $w) cannot be used before the page is ready");
      }

      var scopedRMI = this.RMI.getScopedRMI(controllerId);
      var wixComps = [];

      var isCompName = function isCompName(compSelector) {
        return compSelector.trim().indexOf('#') === 0;
      };
      var isRole = function isRole(compSelector) {
        return compSelector.trim().indexOf('@') === 0;
      };
      var isType = function isType(compSelector) {
        return _utils.types.getPotentialViewerTypes(compSelector).length > 0 || compSelector === 'PageContent';
      };
      var getType = function getType(compSelector) {
        return compSelector === 'PageContent' ? 'Page' : compSelector;
      };
      var isMulti = function isMulti(compSelector) {
        return compSelector.indexOf(',') > -1;
      };
      var isDocument = function isDocument(compSelector) {
        return compSelector === 'Document';
      };
      var selector = compSelector.trim().substr(1);

      switch (true) {
        case isDocument(compSelector):
          var cIds = scopedRMI.getCompIdsFromRole(selector, onlyNestedScope);
          return new _document2.default(scopedRMI, cIds[0], this.contextId, this, controllerId, undefined, { compType: 'Document' }, this.emitter);
        case isType(compSelector):
          var type = getType(compSelector);
          var comps = _wixSelectorUtils2.default.getCompsForType(_utils.types, scopedRMI, type, onlyNestedScope);
          comps.forEach(function (comp) {
            wixComps.push(_this2.getInstance(scopedRMI, comp.type, comp.id, controllerId));
          });
          return _componentsBatchFunctions2.default.expose(wixComps);
        case isMulti(compSelector):
          var selectors = compSelector.split(',');
          var selectedComps = [];
          selectors.forEach(function (comp) {
            if (isCompName(comp)) {
              var sel = comp.trim().substr(1);
              var id = scopedRMI.getCompIdsFromRole(sel, onlyNestedScope)[0];
              var component = _this2.getInstance(scopedRMI, scopedRMI.getType(id), id, controllerId);
              if (!(0, _isArray2.default)(component)) {
                var isCompInArr = (0, _find2.default)(selectedComps, { id: id });
                if (!isCompInArr) {
                  selectedComps.push({
                    id: id,
                    type: scopedRMI.getType(id)
                  });
                }
              }
            } else if (isType(comp.trim())) {
              var _type = getType(comp.trim());
              var _comps = _wixSelectorUtils2.default.getCompsForType(_utils.types, scopedRMI, _type);
              _comps.forEach(function (comp) {
                var isCompInArr = (0, _find2.default)(selectedComps, { id: comp.id });
                if (!isCompInArr) {
                  selectedComps.push(comp);
                }
              });
            }
          });
          selectedComps.forEach(function (comp) {
            wixComps.push(_this2.getInstance(scopedRMI, comp.type, comp.id, controllerId));
          });
          return _componentsBatchFunctions2.default.expose((0, _without2.default)(wixComps, undefined));
        case isCompName(compSelector):
          var ids = scopedRMI.getCompIdsFromRole(selector, onlyNestedScope);
          return !(0, _isEmpty2.default)(ids) ? this.getInstance(scopedRMI, scopedRMI.getType(ids[0]), ids[0], controllerId) : [];
        case isRole(compSelector):
          var compIds = scopedRMI.getCompIdsFromRole(selector, onlyNestedScope);
          compIds.forEach(function (compId) {
            wixComps.push(_this2.getInstance(scopedRMI, scopedRMI.getType(compId), compId, controllerId, selector));
          });
          return _componentsBatchFunctions2.default.expose(wixComps);
        default:
          return [];
      }
    }
  }, {
    key: 'getInstance',
    value: function getInstance(scopedRMI, viewerType, compId, controllerId, role) {
      var compType = _wixSelectorUtils2.default.getSdkConstructorName(_utils.types, scopedRMI, compId);
      var Clazz = ui[compType] || _HiddenCollapsedElement2.default;

      return viewerType ? new Clazz(scopedRMI, compId, this.contextId, this, controllerId, role, { compType: compType, viewerType: viewerType }, this.emitter) : [];
    }
  }, {
    key: 'getScopedSelector',
    value: function getScopedSelector(compId, scopedContext, scopedController) {
      var contextId = scopedContext || this.contextId;
      var controllerId = scopedController || contextId;
      var scopedRMI = this.RMI.getScopedRMIByCompId(compId);
      var $w = void 0;

      if (scopedRMI === this.RMI) {
        $w = this.scoped$W(controllerId);
      } else {
        var scopedSelector = new this.constructor();
        scopedSelector.initialize(scopedRMI, contextId, this.emitter);
        $w = scopedSelector.scoped$W(controllerId);
      }

      (0, _assign2.default)($w, this.emitter.createScopedEmitter(controllerId));

      return $w;
    }
  }, {
    key: 'getScopedSelectorForDisplayedOnlyComp',
    value: function getScopedSelectorForDisplayedOnlyComp(repeaterCompId, itemId, scopedContext, scopedController) {
      var contextId = scopedContext || this.contextId;
      var controllerId = scopedController || contextId;
      var scopedRMI = this.RMI.getScopedRMIForRepeaterItem(repeaterCompId, itemId);

      var scopedSelector = new this.constructor();
      scopedSelector.initialize(scopedRMI, contextId, this.emitter);
      var $w = scopedSelector.scoped$W(controllerId);
      (0, _assign2.default)($w, this.emitter.createScopedEmitter(controllerId));

      return $w;
    }
  }]);

  return WixSelector;
}();

exports.default = WixSelector;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(45),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(356),
    hashDelete = __webpack_require__(357),
    hashGet = __webpack_require__(358),
    hashHas = __webpack_require__(359),
    hashSet = __webpack_require__(360);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(45),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 294 */
/***/ (function(module, exports) {

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

module.exports = addMapEntry;


/***/ }),
/* 295 */
/***/ (function(module, exports) {

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

module.exports = addSetEntry;


/***/ }),
/* 296 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 297 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(159);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(42);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(44),
    keys = __webpack_require__(31);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(44),
    keysIn = __webpack_require__(124);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 302 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),
/* 303 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

module.exports = baseDelay;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(42);

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(42);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(343);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 307 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 308 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(69),
    arrayIncludes = __webpack_require__(104),
    arrayIncludesWith = __webpack_require__(105),
    arrayMap = __webpack_require__(34),
    baseUnary = __webpack_require__(75),
    cacheHas = __webpack_require__(76);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(21),
    isObjectLike = __webpack_require__(17);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(21),
    isObjectLike = __webpack_require__(17);

/** `Object#toString` result references. */
var dateTag = '[object Date]';

/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */
function baseIsDate(value) {
  return isObjectLike(value) && baseGetTag(value) == dateTag;
}

module.exports = baseIsDate;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(101),
    equalArrays = __webpack_require__(169),
    equalByTag = __webpack_require__(348),
    equalObjects = __webpack_require__(349),
    getTag = __webpack_require__(79),
    isArray = __webpack_require__(6),
    isBuffer = __webpack_require__(63),
    isTypedArray = __webpack_require__(89);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(101),
    baseIsEqual = __webpack_require__(157);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 314 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(29),
    isMasked = __webpack_require__(367),
    isObject = __webpack_require__(14),
    toSource = __webpack_require__(184);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(21),
    isLength = __webpack_require__(121),
    isObjectLike = __webpack_require__(17);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14),
    isPrototype = __webpack_require__(59),
    nativeKeysIn = __webpack_require__(381);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(42),
    isArrayLike = __webpack_require__(22);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(313),
    getMatchData = __webpack_require__(352),
    matchesStrictComparable = __webpack_require__(178);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(157),
    get = __webpack_require__(3),
    hasIn = __webpack_require__(187),
    isKey = __webpack_require__(116),
    isStrictComparable = __webpack_require__(176),
    matchesStrictComparable = __webpack_require__(178),
    toKey = __webpack_require__(52);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(158),
    hasIn = __webpack_require__(187);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(74);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var baseUnset = __webpack_require__(111),
    isIndex = __webpack_require__(58);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
  var length = array ? indexes.length : 0,
      lastIndex = length - 1;

  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (isIndex(index)) {
        splice.call(array, index, 1);
      } else {
        baseUnset(array, index);
      }
    }
  }
  return array;
}

module.exports = basePullAt;


/***/ }),
/* 324 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(402),
    defineProperty = __webpack_require__(168),
    identity = __webpack_require__(86);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 326 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(42);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 328 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(119);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(86);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(19);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(126)(module)))

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(112);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var addMapEntry = __webpack_require__(294),
    arrayReduce = __webpack_require__(107),
    mapToArray = __webpack_require__(177);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

module.exports = cloneMap;


/***/ }),
/* 334 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var addSetEntry = __webpack_require__(295),
    arrayReduce = __webpack_require__(107),
    setToArray = __webpack_require__(82);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

module.exports = cloneSet;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(50);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(112);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(44),
    getSymbols = __webpack_require__(115);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(44),
    getSymbolsIn = __webpack_require__(174);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(19);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(296),
    baseAggregator = __webpack_require__(299),
    baseIteratee = __webpack_require__(16),
    isArray = __webpack_require__(6);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(22);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 343 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(16),
    isArrayLike = __webpack_require__(22),
    keys = __webpack_require__(31);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var LodashWrapper = __webpack_require__(98),
    flatRest = __webpack_require__(113),
    getData = __webpack_require__(172),
    getFuncName = __webpack_require__(173),
    isArray = __webpack_require__(6),
    isLaziable = __webpack_require__(366);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) &&
            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && isLaziable(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

module.exports = createFlow;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(145),
    noop = __webpack_require__(192),
    setToArray = __webpack_require__(82);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(123);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(50),
    Uint8Array = __webpack_require__(146),
    eq = __webpack_require__(61),
    equalArrays = __webpack_require__(169),
    mapToArray = __webpack_require__(177),
    setToArray = __webpack_require__(82);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(171);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(160);

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

module.exports = escapeHtmlChar;


/***/ }),
/* 351 */
/***/ (function(module, exports) {

/** Used to escape characters for inclusion in compiled string literals. */
var stringEscapes = {
  '\\': '\\',
  "'": "'",
  '\n': 'n',
  '\r': 'r',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

/**
 * Used by `_.template` to escape characters for inclusion in compiled string literals.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
function escapeStringChar(chr) {
  return '\\' + stringEscapes[chr];
}

module.exports = escapeStringChar;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(176),
    keys = __webpack_require__(31);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(50);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 354 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 355 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(81);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 357 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(81);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(81);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(81);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 361 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(112),
    cloneDataView = __webpack_require__(332),
    cloneMap = __webpack_require__(333),
    cloneRegExp = __webpack_require__(334),
    cloneSet = __webpack_require__(335),
    cloneSymbol = __webpack_require__(336),
    cloneTypedArray = __webpack_require__(337);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(73),
    getPrototype = __webpack_require__(78),
    isPrototype = __webpack_require__(59);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(50),
    isArguments = __webpack_require__(87),
    isArray = __webpack_require__(6);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 365 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(97),
    getData = __webpack_require__(172),
    getFuncName = __webpack_require__(173),
    lodash = __webpack_require__(430);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(340);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 368 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(71);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(71);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(71);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(71);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(292),
    ListCache = __webpack_require__(68),
    Map = __webpack_require__(99);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(77);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(77);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(77);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(77);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(415);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(147);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(180);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 381 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 382 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(74),
    baseSlice = __webpack_require__(326);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 384 */
/***/ (function(module, exports) {

/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;

module.exports = reEscape;


/***/ }),
/* 385 */
/***/ (function(module, exports) {

/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;

module.exports = reEvaluate;


/***/ }),
/* 386 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 387 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 388 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 389 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(68);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 391 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 392 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 393 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(68),
    Map = __webpack_require__(99),
    MapCache = __webpack_require__(100);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 395 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var asciiSize = __webpack_require__(298),
    hasUnicode = __webpack_require__(355),
    unicodeSize = __webpack_require__(399);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

module.exports = stringSize;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(378);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(160);

/** Used to map HTML entities to characters. */
var htmlUnescapes = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'"
};

/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */
var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

module.exports = unescapeHtmlChar;


/***/ }),
/* 399 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

module.exports = unicodeSize;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(97),
    LodashWrapper = __webpack_require__(98),
    copyArray = __webpack_require__(165);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(102),
    baseRest = __webpack_require__(43),
    isError = __webpack_require__(120);

/**
 * Attempts to invoke `func`, returning either the result or the caught error
 * object. Any additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Function} func The function to attempt.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {*} Returns the `func` result or error object.
 * @example
 *
 * // Avoid throwing errors for invalid selectors.
 * var elements = _.attempt(function(selector) {
 *   return document.querySelectorAll(selector);
 * }, '>_>');
 *
 * if (_.isError(elements)) {
 *   elements = [];
 * }
 */
var attempt = baseRest(function(func, args) {
  try {
    return apply(func, undefined, args);
  } catch (e) {
    return isError(e) ? e : new Error(e);
  }
});

module.exports = attempt;


/***/ }),
/* 402 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(72),
    createAggregator = __webpack_require__(341);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */
var countBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    ++result[key];
  } else {
    baseAssignValue(result, key, 1);
  }
});

module.exports = countBy;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var baseDelay = __webpack_require__(303),
    baseRest = __webpack_require__(43);

/**
 * Defers invoking the `func` until the current call stack has cleared. Any
 * additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to defer.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.defer(function(text) {
 *   console.log(text);
 * }, 'deferred');
 * // => Logs 'deferred' after one millisecond.
 */
var defer = baseRest(function(func, args) {
  return baseDelay(func, 1, args);
});

module.exports = defer;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(152),
    baseFlatten = __webpack_require__(154),
    baseRest = __webpack_require__(43),
    isArrayLikeObject = __webpack_require__(119);

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

module.exports = difference;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(302),
    baseToString = __webpack_require__(162),
    toInteger = __webpack_require__(90),
    toString = __webpack_require__(47);

/**
 * Checks if `string` ends with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=string.length] The position to search up to.
 * @returns {boolean} Returns `true` if `string` ends with `target`,
 *  else `false`.
 * @example
 *
 * _.endsWith('abc', 'c');
 * // => true
 *
 * _.endsWith('abc', 'b');
 * // => false
 *
 * _.endsWith('abc', 'b', 2);
 * // => true
 */
function endsWith(string, target, position) {
  string = toString(string);
  target = baseToString(target);

  var length = string.length;
  position = position === undefined
    ? length
    : baseClamp(toInteger(position), 0, length);

  var end = position;
  position -= target.length;
  return position >= 0 && string.slice(position, end) == target;
}

module.exports = endsWith;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(188);


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(154);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(34),
    baseIntersection = __webpack_require__(309),
    baseRest = __webpack_require__(43),
    castArrayLikeObject = __webpack_require__(329);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(21),
    isObjectLike = __webpack_require__(17);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsDate = __webpack_require__(311),
    baseUnary = __webpack_require__(75),
    nodeUtil = __webpack_require__(179);

/* Node.js helper references. */
var nodeIsDate = nodeUtil && nodeUtil.isDate;

/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */
var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

module.exports = isDate;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(90);

/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == toInteger(value);
}

module.exports = isInteger;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var isNumber = __webpack_require__(122);

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

module.exports = isNaN;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(72),
    baseForOwn = __webpack_require__(108),
    baseIteratee = __webpack_require__(16);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(100);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 416 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

module.exports = negate;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(19),
    toString = __webpack_require__(47);

/** Used to match leading and trailing whitespace. */
var reTrimStart = /^\s+/;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeParseInt = root.parseInt;

/**
 * Converts `string` to an integer of the specified radix. If `radix` is
 * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
 * hexadecimal, in which case a `radix` of `16` is used.
 *
 * **Note:** This method aligns with the
 * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category String
 * @param {string} string The string to convert.
 * @param {number} [radix=10] The radix to interpret `value` by.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.parseInt('08');
 * // => 8
 *
 * _.map(['6', '08', '10'], _.parseInt);
 * // => [6, 8, 10]
 */
function parseInt(string, radix, guard) {
  if (guard || radix == null) {
    radix = 0;
  } else if (radix) {
    radix = +radix;
  }
  return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
}

module.exports = parseInt;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(321),
    flatRest = __webpack_require__(113);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(159),
    basePropertyDeep = __webpack_require__(322),
    isKey = __webpack_require__(116),
    toKey = __webpack_require__(52);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(16),
    basePullAt = __webpack_require__(323);

/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
  var result = [];
  if (!(array && array.length)) {
    return result;
  }
  var index = -1,
      indexes = [],
      length = array.length;

  predicate = baseIteratee(predicate, 3);
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result.push(value);
      indexes.push(index);
    }
  }
  basePullAt(array, indexes);
  return result;
}

module.exports = remove;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(109),
    getTag = __webpack_require__(79),
    isArrayLike = __webpack_require__(22),
    isString = __webpack_require__(36),
    stringSize = __webpack_require__(396);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (isArrayLike(collection)) {
    return isString(collection) ? stringSize(collection) : collection.length;
  }
  var tag = getTag(collection);
  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }
  return baseKeys(collection).length;
}

module.exports = size;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(150),
    baseIteratee = __webpack_require__(16),
    baseSome = __webpack_require__(327),
    isArray = __webpack_require__(6),
    isIterateeCall = __webpack_require__(80);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 423 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(186),
    reEscape = __webpack_require__(384),
    reEvaluate = __webpack_require__(385),
    reInterpolate = __webpack_require__(182);

/**
 * By default, the template delimiters used by lodash are like those in
 * embedded Ruby (ERB) as well as ES2015 template strings. Change the
 * following template settings to use alternative delimiters.
 *
 * @static
 * @memberOf _
 * @type {Object}
 */
var templateSettings = {

  /**
   * Used to detect `data` property values to be HTML-escaped.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'escape': reEscape,

  /**
   * Used to detect code to be evaluated.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'evaluate': reEvaluate,

  /**
   * Used to detect `data` property values to inject.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'interpolate': reInterpolate,

  /**
   * Used to reference the data object in the template text.
   *
   * @memberOf _.templateSettings
   * @type {string}
   */
  'variable': '',

  /**
   * Used to import variables into the compiled template.
   *
   * @memberOf _.templateSettings
   * @type {Object}
   */
  'imports': {

    /**
     * A reference to the `lodash` function.
     *
     * @memberOf _.templateSettings.imports
     * @type {Function}
     */
    '_': { 'escape': escape }
  }
};

module.exports = templateSettings;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14),
    isSymbol = __webpack_require__(88);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(47),
    unescapeHtmlChar = __webpack_require__(398);

/** Used to match HTML entities and HTML characters. */
var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
    reHasEscapedHtml = RegExp(reEscapedHtml.source);

/**
 * The inverse of `_.escape`; this method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped. To unescape additional
 * HTML entities use a third-party library like [_he_](https://mths.be/he).
 *
 * @static
 * @memberOf _
 * @since 0.6.0
 * @category String
 * @param {string} [string=''] The string to unescape.
 * @returns {string} Returns the unescaped string.
 * @example
 *
 * _.unescape('fred, barney, &amp; pebbles');
 * // => 'fred, barney, & pebbles'
 */
function unescape(string) {
  string = toString(string);
  return (string && reHasEscapedHtml.test(string))
    ? string.replace(reEscapedHtml, unescapeHtmlChar)
    : string;
}

module.exports = unescape;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(163);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(47);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var baseUnset = __webpack_require__(111);

/**
 * Removes the property at `path` of `object`.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
 * _.unset(object, 'a[0].b.c');
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 *
 * _.unset(object, ['a', '0', 'b', 'c']);
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 */
function unset(object, path) {
  return object == null ? true : baseUnset(object, path);
}

module.exports = unset;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(97),
    LodashWrapper = __webpack_require__(98),
    baseLodash = __webpack_require__(110),
    isArray = __webpack_require__(6),
    isObjectLike = __webpack_require__(17),
    wrapperClone = __webpack_require__(400);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 431 */
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),
/* 432 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(202);


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// wix.min.js